module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 268);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return del; });
/* unused harmony export getParseDomain */
// 操作cookie
function set(c_name, value, expiredays, beforeDomain) {
  let exdate;
  const domain = getParseDomain(beforeDomain);
  // expiredays 可以是Number类型的过期天数
  // 也可以是String类型的日期字符串
  // 还可以是Date类型的
  if (expiredays && expiredays instanceof Date) {
    // expiredays是Date类型
    exdate = expiredays;
  } else if (expiredays && isDate(expiredays)) {
    // expiredays是日期字符串
    exdate = new Date(expiredays).toUTCString();
  } else {
    // expiredays为Nubmer类型或者未设置
    const newDate = new Date();
    expiredays = !expiredays || expiredays != Number(expiredays) ? 1 : expiredays;
    newDate.setDate(newDate.getDate() + expiredays);
    exdate = newDate.toUTCString();
  }
  document.cookie = `${c_name}=${escape(value)};expires=${exdate};path=/;domain=${domain}`;
}
function get(c_name) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(`${c_name}=`);
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      let c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}
function del(name) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cval = get(name);
  const domain = getParseDomain();
  if (cval != null) {
    document.cookie = `${name}=${cval};expires=${exp.toUTCString()};path=/;domain=${domain}`;
  }
}
// 获取设置cookie的domain（和后端设置逻辑保持统一）
function getParseDomain(beforeDomain) {
  const hostname = location.hostname.toLocaleLowerCase();
  let domain = beforeDomain || hostname;
  const reWenjuan = /.wenjuan.com$/;
  const reLocalhost = /^(192.168.)|^(127.0.0.)/;
  if (reWenjuan.test(domain)) {
    domain = ".wenjuan.com";
  } else if (reLocalhost.test(domain)) {
    // domain = domain;
  } else if (domain == "localhost") {
    domain = hostname;
  } else {
    domain = `.${domain}`;
  }
  return domain;
}

// 验证字符串str是否为日期格式的字符串
function isDate(str) {
  const reg = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
  if (!str) return false;
  if (reg.test(str) && RegExp.$2 <= 12 && RegExp.$3 <= 31 && RegExp.$4 <= 23 && RegExp.$5 <= 59 && RegExp.$6 <= 59) {
    return true;
  }
  return false;
}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/button");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/message");

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hideMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isNotEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return distinguishUserAgentUtils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return loadJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return urlDelP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataURLtoFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return downloadGenerateQRCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserAgentInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isWxMiniApp; });
/* unused harmony export insertHTML */
// 获取url链接中的参数
function getQueryString(name) {
  let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
  const r = source.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

// 手机打*号
function hideMobile(mobile) {
  if (!mobile) return "";
  return `${mobile.substr(0, 3)}****${mobile.substr(-4)}`;
}

// 判断变量是否为空
function isNotEmpty(obj) {
  if (typeof obj === "undefined" || obj == null) {
    return false;
  }
  if (typeof obj === "function") {
    return true;
  }
  if (obj.constructor == Number) {
    if (obj) {
      return true;
    }
    return false;
  }
  if (typeof obj === "string") {
    if (obj !== "") {
      return true;
    }
    return false;
  }
  return Object.keys(obj).length > 0;
}

// 区分浏览器类型
function distinguishUserAgentUtils(userAgent) {
  if (typeof window !== "undefined") {
    var _window, _window$navigator, _window2;
    const ua = userAgent || ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent.toLowerCase());
    const isTouTiaoMiniApp = ua.includes("toutiaomicroapp");
    const isQQMiniApp = ua.includes("qq") && ua.includes("miniprogram") && !ua.includes("micromessenger");
    const isBaiduMiniApp = ua.includes("baiduboxapp") && ua.includes("swan");
    const isWeixinMiniApp = ua.includes("micromessenger") && ua.includes("miniprogram");
    return {
      isEdge: ua.includes("Edge"),
      isFF: ua.includes("Firefox"),
      isOpera: ua.includes("Opera"),
      isBB: ua.includes("BlackBerry"),
      isChrome: ua.includes("Chrome"),
      isMaxthon: ua.includes("Maxthon"),
      isFeishu: ua.includes("Lark/"),
      isIos: /(iPhone|iPad|iPod|iOS)/i.test(ua),
      isSafari: ua.includes("Safari") && !ua.includes("Chrome"),
      isIE: !!window.ActiveXObject || "ActiveXObject" in window,
      isMobile: /(iPad|iPhone|iPod|Opera Mini|Android.*Mobile|NetFront|PSP|BlackBerry|Windows Phone)/gi.test(ua),
      isWeixin: ua.match(/MicroMessenger/i) === "micromessenger",
      isWeibo: ua.match(/WeiBo/i) === "weibo",
      isWxwork: ua.match(/wxwork/i) === "wxwork",
      isQQ: ua.match(/QQ/i) === "qq",
      isIosApp: ua.includes("wenjuan/") && /(iPhone|iPad|iPod|iOS)/i.test(ua),
      isApp: ua.includes("wenjuan/") || ua.includes("android_app/"),
      isTeacherApp: ua.includes("campusteacher/") || ua.includes("campusstudent/"),
      isHarmony: ua.includes("harmony_wenjuanwrap"),
      isAndroidApp: ua.includes("android_app/"),
      isAndroid: (ua.match(/android/i) === "android" || ua.match(/adr/i) === "adr") && ua !== "android_app/1.0.0",
      // ios android 客户端
      isNative: ua.match(/android_app\//i) === "android_app/" || ua.match(/wenjuan\//i) === "wenjuan/",
      isBaiying: ua.includes("baiying"),
      isDingding: ua.includes("DingTalk"),
      isTencentWemeet: ua.includes("tencent_wemeet"),
      isMac: /macintosh|mac os x/i.test(ua),
      isPWA: (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.matchMedia("(display-mode: minimal-ui)").matches,
      isUc: ua.includes("ucbrowser"),
      isCloudpay: ua.includes("unionpay"),
      isDingTalk: ua.includes("dingtalk"),
      isTencentMeeting: ua.includes("tencent_wemeet"),
      isQuark: ua.includes("quark"),
      isTouTiaoMiniApp,
      isQQMiniApp,
      isBaiduMiniApp,
      isWeixinMiniApp,
      isMiniApp: isTouTiaoMiniApp || isQQMiniApp || isBaiduMiniApp || isWeixinMiniApp
    };
  }
  return {};
}

// js中动态加载script，并在load后触发cb
function loadJS(url, callback) {
  const script = document.createElement("script");
  const fn = callback || function () {};
  script.type = "text/javascript";
  // IE
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        script.onreadystatechange = null;
        fn();
      }
    };
  } else {
    // 其他浏览器
    script.onload = function () {
      fn();
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

// 删除URL上某个参数
function urlDelP(url, name) {
  const urlArr = url.split("?");
  if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
    const query = urlArr[1];
    const obj = {};
    const arr = query.split("&");
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    const querys = JSON.stringify(obj).replace(/[\"\{\}]/g, "").replace(/\:/g, "=").replace(/\,/g, "&");
    let searchs = "";
    if (querys) {
      searchs = `?${querys}`;
    }
    const urlte = urlArr[0] + searchs;
    return urlte;
  }
  return url;
}
/**
 * 将base64转换为文件
 * @param {String} dataUrl 图片地址
 * @param {String} imgType 图片类型 传png,jpg等 而不是image/png
 * @return blob文件
 */
function dataURLtoFile(dataUrl, imgType) {
  var _arr$;
  // 替换base64图片的图片类型
  if (imgType) {
    const types = dataUrl.match(/data:image[^;]*;base64,/gi);
    types.forEach(type => {
      dataUrl = dataUrl.replace(new RegExp(`${type}`, "g"), `data:image/${imgType};base64,`);
    });
  }
  const arr = dataUrl.split(",");
  const reg = (_arr$ = arr[0]) === null || _arr$ === void 0 ? void 0 : _arr$.match(/:(.*?);/);
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: reg ? reg[1] : ""
  });
}

// 前端生成二维码-下载二维码
function downloadGenerateQRCode(url) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "图片";
  if (window.navigator.msSaveOrOpenBlob) {
    // ie
    const bstr = atob(url.split(",")[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const blob = new Blob([u8arr]);
    window.navigator.msSaveOrOpenBlob(blob, `${name}.png`);
  } else {
    // 非ie
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", `${name}.png`);
    a.click();
  }
}
function getUserAgentInfo() {
  const {
    userAgent
  } = navigator;
  let version;
  if (/opera/i.test(userAgent) || /OPR/i.test(userAgent)) {
    version = getVersion(userAgent, "OPR/(\\d+\\.+\\d+)");
    return ["Opera", version];
  }
  if (/compatible/i.test(userAgent) && /MSIE/i.test(userAgent)) {
    version = getVersion(userAgent, "MSIE (\\d+\\.+\\d+)");
    return ["IE", version];
  }
  if (/Edg/i.test(userAgent)) {
    version = getVersion(userAgent, "Edg/(\\d+\\.+\\d+)");
    return ["Edge", version];
  }
  if (/Firefox/i.test(userAgent)) {
    version = getVersion(userAgent, "Firefox/(\\d+\\.+\\d+)");
    return ["Firefox", version];
  }
  if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) {
    version = getVersion(userAgent, "Version/(\\d+\\.+\\d+)");
    return ["Safari", version];
  }
  if (/Chrome/i.test(userAgent) && /Safari/i.test(userAgent)) {
    version = getVersion(userAgent, "Chrome/(\\d+\\.+\\d+)");
    return ["Chrome", version];
  }
  if (userAgent.includes("Trident") || userAgent.includes("MSIE")) {
    return ["IE", "any"];
  }
}
function getVersion(userAgent, reg) {
  const reBrowser = new RegExp(reg);
  reBrowser.test(userAgent);
  return parseInt(RegExp.$1);
}

// 判断是否是小程序环境
function isWxMiniApp() {
  try {
    var _window3, _window3$navigator, _window3$navigator$us;
    const ua = (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$navigator = _window3.navigator) === null || _window3$navigator === void 0 ? void 0 : (_window3$navigator$us = _window3$navigator.userAgent) === null || _window3$navigator$us === void 0 ? void 0 : _window3$navigator$us.toLowerCase();
    const uaIsWxMiniApp = ua.includes("micromessenger") && ua.includes("miniprogram");
    if (uaIsWxMiniApp) return true;
    const appname = getQueryString("appname");
    if (appname === "wj-miniapp") return true;
    if (window.__wxjs_environment === "miniprogram") return true;
  } catch (error) {}
}

// insert HTML
function insertHTML(html, editor) {
  if (window.getSelection) {
    // IE9 and non-IE
    const sel = window.getSelection();
    if (editor && sel.focusNode !== editor && sel.focusNode.parentNode !== editor) {
      editor.innerHTML += html;
      return;
    }
    if (sel.getRangeAt && sel.rangeCount) {
      let range = sel.getRangeAt(0);
      range.deleteContents();
      const el = document.createElement("div");
      el.innerHTML = html;
      const frag = document.createDocumentFragment();
      let node = el.firstChild;
      let lastNode;
      while (node) {
        lastNode = frag.appendChild(node);
        node = el.firstChild;
      }
      range.insertNode(frag);

      // Preserve the selection
      if (lastNode) {
        range = range.cloneRange();
        range.setStartAfter(lastNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  } else if (document.selection && document.selection.type !== "Control") {
    // IE < 9
    document.selection.createRange().pasteHTML(html);
  }
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return msgTemplateMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return editorStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return messageStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return aiSourceMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return titleIconMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fileTypeMapping; });
const msgTemplateMapping = {
  text_content: "TextContent",
  image_content: "uploadImage",
  recreate: "CreateProject",
  recover: "Recover",
  more_question: "CreateQuestion",
  ai_result_check_content: "CheckContent",
  ai_result_create_project: "CreateProject",
  ai_result_create_question: "CreateQuestion",
  ai_result_extend_options: "ExtendQuestionOptions",
  ai_result_create_project_from_image: "CreateProject",
  ai_result_create_project_from_link: "CreateProject",
  ai_result_create_project_from_text: "CreateProject",
  ai_result_create_question_from_image: "CreateQuestion",
  ai_result_create_question_from_link: "CreateQuestion",
  ai_result_create_question_from_text: "CreateQuestion",
  ai_result_create_project_text: "TextResult",
  ai_result_create_question_text: "TextResult",
  // 修改模板
  ai_result_edit_template: "TextResult"
};
const editorStatus = {
  INPUTTING: "inputting",
  WAITING: "waiting",
  CHOOSING: "choosing",
  UPLOAD: "upload",
  DISABLED: "disabled"
};
const messageStatus = {
  INIT: "init",
  SUCCESS: "success",
  WAITING: "waiting",
  WARNING: "warning",
  INTERRUPT: "interrupt"
};

// ai创建来源枚举值
// 1：ai创建、模板修改、m站默认创建
// 2：文本创建-上传Word
// 5：文本创建-上传Excel
// 6：文本创建-上传PDF
// 7：文本创建-直接输入/粘贴文本
// 3：拍照创建
// 4：链接创建

const aiSourceMap = {
  m_create_project: 1,
  create_project: 1,
  edit_template: 1,
  create_from_text_by_word: 2,
  create_from_text_by_excel: 5,
  create_from_text_by_pdf: 6,
  create_project_from_text: 7,
  create_project_from_image: 3,
  create_project_from_link: 4
};
const titleIconMapping = {
  doc: "wenwen-ai/word",
  docx: "wenwen-ai/word",
  xls: "wenwen-ai/xls",
  xlsx: "wenwen-ai/xls",
  pdf: "wenwen-ai/pdf"
};
const fileTypeMapping = {
  doc: "word",
  docx: "word",
  xls: "excel",
  xlsx: "excel",
  pdf: "pdf"
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dialog");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/button.css");

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg-icon/index.vue?vue&type=template&id=2ea9bd34&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", {
    staticClass: "svg-icon",
    domProps: { innerHTML: _vm._s(_vm.icon) }
  })
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./src/components/svg-icon/index.vue?vue&type=template&id=2ea9bd34&scoped=true&

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg-icon/index.vue?vue&type=script&lang=js&
var svg_iconvue_type_script_lang_js_ = __webpack_require__(23);

// CONCATENATED MODULE: ./src/components/svg-icon/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_svg_iconvue_type_script_lang_js_ = (svg_iconvue_type_script_lang_js_["a" /* default */]); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/svg-icon/index.vue?vue&type=style&index=0&id=2ea9bd34&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/svg-icon/index.vue?vue&type=style&index=0&id=2ea9bd34&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/components/svg-icon/index.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  components_svg_iconvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9bd34",
  null
  
)

/* harmony default export */ var svg_icon = __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCreateProjectUrl", function() { return isCreateProjectUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isUsedPWASignature", function() { return isUsedPWASignature; });
/* harmony import */ var _tools_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/**
 * @description: 项目在 pwa 中访问时，创建项目的接口应带有 pwa 标记，方便后端统计项目创建方式
 */



// 创建项目相关接口
const createProjectUrl = ["/edit/ajax/survey_copy/",
// 复制模板
"/edit/api/create/",
// 空白创建
"/edit/api/copy/",
// 复制已有项目
"/edit/api/textproject/",
// 文本创建
"/edit/api/ref/" // 引用收藏的模板创建
];

// 判断 url 是否为创建项目接口
function isCreateProjectUrl(url) {
  return createProjectUrl.some(item => url.includes(item));
}

// 判断是否使用 pwa 的签名
function isUsedPWASignature(url) {
  const {
    isPWA
  } = Object(_tools_js__WEBPACK_IMPORTED_MODULE_0__[/* distinguishUserAgentUtils */ "b"])();
  if (isPWA && isCreateProjectUrl(url)) {
    return true;
  }
  return false;
}

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(1);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/toast/toast.vue?vue&type=template&id=6b75ee91&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "w-toast-pop" } }, [
    !_vm.type
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.visible,
                expression: "visible"
              }
            ],
            staticClass: "w-toast",
            class: _vm.customClass
          },
          [
            _c("span", { staticClass: "w-toast-text" }, [
              _vm._v(_vm._s(_vm.message))
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.type
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.visible,
                expression: "visible"
              }
            ],
            staticClass: "img-save-notice w-toast",
            class: _vm.customClass
          },
          [
            _c("svg-icon", {
              attrs: { width: "30", height: "30", "icon-name": "success" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.message))])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/toast/toast.vue?vue&type=template&id=6b75ee91&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/toast/toast.vue?vue&type=script&lang=js&
/* harmony default export */ var toastvue_type_script_lang_js_ = ({
  name: "Toast",
  props: {
    type: {
      type: Boolean,
      default: false
    },
    message: String,
    className: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "middle"
    }
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    customClass() {
      const classes = [];
      switch (this.position) {
        case "top":
          classes.push("is-placetop");
          break;
        case "bottom":
          classes.push("is-placebottom");
          break;
        default:
          classes.push("is-placemiddle");
      }
      console.log(this.position);
      classes.push(this.className);
      return classes.join(" ");
    }
  }
});
// CONCATENATED MODULE: ./packages/toast/toast.vue?vue&type=script&lang=js&
 /* harmony default export */ var toast_toastvue_type_script_lang_js_ = (toastvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/toast/toast.vue?vue&type=style&index=0&id=6b75ee91&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/toast/toast.vue?vue&type=style&index=0&id=6b75ee91&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/toast/toast.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  toast_toastvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "6b75ee91",
  null
  
)

/* harmony default export */ var toast = (component.exports);
// CONCATENATED MODULE: ./packages/toast/index.js


let activeToastMessage = "";
const Toast = {};
const ToastConstructor = external_vue_default.a.extend(toast);
const toastPool = [];
const getAnInstance = () => {
  if (toastPool.length > 0) {
    const instance = toastPool[0];
    toastPool.splice(0, 1);
    return instance;
  }
  return new ToastConstructor({
    el: document.createElement("div")
  });
};
const returnAnInstance = instance => {
  if (instance) {
    toastPool.push(instance);
  }
};
const removeDom = event => {
  if (event.target.parentNode) {
    event.target.parentNode.removeChild(event.target);
  }
};
ToastConstructor.prototype.close = function () {
  this.visible = false;
  this.$el.addEventListener("transitionend", removeDom);
  this.closed = true;
  activeToastMessage = "";
  returnAnInstance(this);
};
/* harmony default export */ var packages_toast = __webpack_exports__["a"] = ({
  success(options) {
    return this.show(options, "success");
  },
  show() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    const duration = options.duration || 3000;
    const currentToastMessage = typeof options === "string" ? options : options.message;
    // 正显示toast并且提示文案相同时return
    if (activeToastMessage === currentToastMessage) return;
    // 执行show时，关闭之前的toast
    const instance = getAnInstance();
    instance.close();
    instance.closed = false;
    activeToastMessage = currentToastMessage;
    clearTimeout(instance.timer);
    clearTimeout(instance.delayTimer);
    instance.message = currentToastMessage;
    instance.custom = options.custom;
    instance.position = options.position || "middle";
    instance.className = options.className || "";
    instance.callback = options.callback;
    instance.delay = options.delay || 0;
    instance.type = type;
    document.body.appendChild(instance.$el);
    external_vue_default.a.nextTick(function () {
      // delay show toast
      if (instance.delay > 0) {
        instance.delayTimer = setTimeout(() => {
          if (instance.closed) return;
          instance.visible = true;
        }, instance.delay);
      } else {
        instance.visible = true;
      }
      instance.visible = true;
      instance.$el.removeEventListener("transitionend", removeDom);
      if (duration !== -1) {
        instance.timer = setTimeout(() => {
          instance.close();
        }, duration);
      }
    });
    return instance;
  }
});

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/message.css");

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dialog.css");

/***/ }),
/* 17 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/button.css"
var button_css_ = __webpack_require__(8);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/button"
var button_ = __webpack_require__(3);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: external "@microsoft/fetch-event-source"
var fetch_event_source_ = __webpack_require__(196);

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/constant.js
var constant = __webpack_require__(6);

// EXTERNAL MODULE: ./src/http/wenwen-ai/index.js
var wenwen_ai = __webpack_require__(40);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/base/chat/index.vue?vue&type=template&id=d7bae3f6&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wenwen-ai-chat-block-wrapper" }, [
    _c(
      "div",
      {
        class: [
          "wenwen-ai-chat-block",
          `wenwen-ai-chat-block-${_vm.type || "intro"}`,
          `wenwen-ai-chat-block-theme-${_vm.backgroundTheme}`,
          { "wenwen-ai-chat-block-loading": _vm.isLoading },
          { "wenwen-ai-chat-block-auto": _vm.isBlockWidthAuto }
        ]
      },
      [
        _vm.isLoading
          ? _c("div", { staticClass: "chat-block-loading" }, [
              _c("i", { staticClass: "loading-circle loading-circle-1" }),
              _vm._v(" "),
              _c("i", { staticClass: "loading-circle loading-circle-2" }),
              _vm._v(" "),
              _c("i", { staticClass: "loading-circle loading-circle-3" })
            ])
          : [
              _vm.title
                ? _c(
                    "div",
                    {
                      class: [
                        "chat-title",
                        _vm.status ? `chat-title-status-${_vm.status}` : ""
                      ]
                    },
                    [
                      _vm.status === "waiting"
                        ? _c("img", {
                            staticClass: "chat-status-icon",
                            attrs: {
                              src:
                                "https://s1.wenjuan.com/assets/images/business/wenwen-ai/waiting.gif",
                              alt: ""
                            }
                          })
                        : _vm.status
                        ? _c("SvgIcon", {
                            staticClass: "chat-status-icon",
                            attrs: { name: "wenwen-ai/" + _vm.status }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type !== "user"
                        ? _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.title) }
                          })
                        : _vm.isRichText(_vm.title)
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.formatterTitle(_vm.title))
                            }
                          })
                        : _c(
                            "span",
                            [
                              _vm.titleIcon
                                ? _c("SvgIcon", {
                                    staticClass: "chat-title-icon",
                                    class: `chat-status-${_vm.status}`,
                                    attrs: { name: _vm.titleIcon }
                                  })
                                : _vm._e(),
                              _vm._v(_vm._s(_vm.title))
                            ],
                            1
                          )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chat-content" },
                [_vm._t("content")],
                2
              ),
              _vm._v(" "),
              _vm.description
                ? _c("div", { staticClass: "chat-description" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.description) +
                        "\n            "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.imageUrl
                ? _c(
                    "div",
                    {
                      class: [
                        "chat-image-wrap",
                        { "image-loading": _vm.imageLoading }
                      ]
                    },
                    [
                      _c("wd-image", {
                        ref: "image",
                        staticClass: "chat-image",
                        attrs: {
                          src: _vm.imageUrl,
                          "preview-src-list": [_vm.imageUrl]
                        },
                        on: { load: _vm.onload }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.btnlist.length > 0
                ? _c(
                    "div",
                    {
                      class: [
                        "chat-buttons",
                        `chat-buttons-${_vm.buttonInline ? "inline" : "block"}`,
                        `chat-buttons-len-${
                          _vm.btnlist.length % 2 === 1 ? "odd" : "even"
                        }`
                      ]
                    },
                    _vm._l(_vm.btnlist, function(button, index) {
                      return _c(
                        "wdButton",
                        {
                          key: index,
                          class: [
                            `chat-buttons-${_vm.buttonType}`,
                            {
                              "chat-buttons-primary": button.isPrimary
                            }
                          ],
                          attrs: {
                            size:
                              _vm.platform === "mobile" ? "tertiary" : "small",
                            type: _vm.buttonType
                          },
                          on: {
                            click: function($event) {
                              return _vm.buttonClickHandler(button)
                            }
                          }
                        },
                        [_vm._v(_vm._s(button.label))]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default")
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/chat/index.vue?vue&type=template&id=d7bae3f6&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/image.css"
var image_css_ = __webpack_require__(218);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/image"
var image_ = __webpack_require__(197);
var image_default = /*#__PURE__*/__webpack_require__.n(image_);

// EXTERNAL MODULE: ./src/components/svg-icon/index.vue + 5 modules
var svg_icon = __webpack_require__(11);

// EXTERNAL MODULE: ./src/assets/js/event-bus.js
var event_bus = __webpack_require__(24);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/base/chat/index.vue?vue&type=script&lang=js&






/* harmony default export */ var chatvue_type_script_lang_js_ = ({
  name: "WenwenAiChat",
  components: {
    SvgIcon: svg_icon["a" /* default */],
    wdButton: button_default.a,
    wdImage: image_default.a
  },
  props: {
    // user: 用户
    // system: ai
    // warning: 黄色底
    type: {
      type: String,
      default: ""
    },
    // theme 背景色
    theme: {
      type: String,
      default: ""
    },
    // success / warning / waiting / AI
    status: {
      type: String,
      default: ""
    },
    // title svg icon name
    titleIcon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    imageUrl: {
      type: String,
      default: ""
    },
    // true: 一个按钮占整行；两个按钮时各占一半；三个按钮时第三个占整行；
    // false: 所有按钮都是占整行
    buttonInline: {
      type: Boolean,
      default: false
    },
    // { label: "结束", value: "finish"}
    buttonList: {
      type: Array,
      default: () => []
    },
    // 手动开启loading和关闭loading open / close / -
    loadingManual: {
      type: String,
      default: ""
    },
    // 是否自动触发滚动到底部
    autoScrollToBottom: {
      type: Boolean,
      default: true
    },
    // 按钮类型
    buttonType: {
      type: String,
      default: "info"
    },
    // 涉及到1：按钮大小，PC 30，移动36像素
    platform: {
      type: String,
      default: "PC"
    }
  },
  data() {
    return {
      isLoading: false,
      loadingTimer: null,
      // 图片加载动画
      imageLoading: false,
      btnlist: [],
      btnInline: true
    };
  },
  computed: {
    isBlockWidthAuto() {
      // 只有 title 或 content 的时候，宽度自适应
      // 有 description 或 button 的时候，宽度100%
      return !(this.description || this.btnlist.length > 0);
    },
    backgroundTheme() {
      const ThemeObj = {
        user: "blue",
        system: "white",
        warning: "yellow"
      };
      return this.theme ? this.theme : ThemeObj[this.type];
    }
  },
  watch: {
    loadingManual(value) {
      if (!value) return;
      this.loadingManualHandler();
    },
    imageUrl: {
      handler(newImageUrl, oldImagUrl) {
        if (newImageUrl && !oldImagUrl) {
          this.imageLoading = true;
        }
      },
      immediate: true
    },
    buttonList: {
      handler(val) {
        var _this$$parent;
        if (((_this$$parent = this.$parent) === null || _this$$parent === void 0 ? void 0 : _this$$parent.$parent.platform) == "mobile") {
          this.btnlist = val.filter(item => item.value != "restart");
        } else {
          this.btnlist = val;
        }
      },
      immediate: true
    }
  },
  created() {
    this.initLoadingHandler();
  },
  destroyed() {
    clearTimeout(this.loadingTimer);
  },
  methods: {
    // 图片加载完之后 触发滚动条滚动到底部
    onload() {
      this.imageLoading = false;
      if (this.autoScrollToBottom) {
        event_bus["a" /* EventBus */].$emit("wenwenAIChatScrollToBottom");
      }
    },
    initLoadingHandler() {
      // 未设置手动控制 loading 时，system 类型的消息默认会有 0.5s 的 loading 动画（用户输入没有这个逻辑）
      if (this.type === "system" && !this.loadingManual) {
        this.isLoading = true;
        // loading Dom 加载完触发滚动条滚动到底部
        this.autoScrollToBottom && this.$nextTick(() => {
          event_bus["a" /* EventBus */].$emit("wenwenAIChatScrollToBottom");
        });
        this.loadingTimer = setTimeout(() => {
          this.isLoading = false;
          // loading 结束触发滚动条滚动到底部
          this.autoScrollToBottom && this.$nextTick(() => {
            event_bus["a" /* EventBus */].$emit("wenwenAIChatScrollToBottom");
          });
        }, 800);
      }
      if (this.loadingManual) {
        this.loadingManualHandler();
      }
    },
    // 手动控制 loaidng 的开启关闭
    loadingManualHandler() {
      this.isLoading = this.loadingManual === "open";

      // isLoading 更新后触发滚动条滚动到底部
      this.autoScrollToBottom && this.$nextTick(() => {
        // console.log("自动滑动到底部");
        event_bus["a" /* EventBus */].$emit("wenwenAIChatScrollToBottom");
      });
    },
    buttonClickHandler(data, type) {
      this.$emit("select", data);
    },
    formatterTitle(title) {
      return title.replace(/\n/g, "<br>");
    },
    isRichText(title) {
      return /\n/.test(title);
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/chat/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var base_chatvue_type_script_lang_js_ = (chatvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/base/chat/index.vue?vue&type=style&index=0&id=d7bae3f6&prod&lang=scss&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/chat/index.vue?vue&type=style&index=0&id=d7bae3f6&prod&lang=scss&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/chat/index.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  base_chatvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var chat = (component.exports);
// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/tools.js
var tools = __webpack_require__(127);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/js/message.mixin.js








/* harmony default export */ var message_mixin = __webpack_exports__["a"] = ({
  components: {
    WenwenAiChat: chat,
    "wd-button": button_default.a
  },
  props: {
    projectId: {
      type: String,
      default: ""
    },
    shortId: {
      type: String,
      default: ""
    },
    platform: {
      type: String,
      default: "PC"
    },
    pageName: {
      type: String,
      default: "home"
    },
    pType: {
      type: Number,
      default: 0
    },
    conversationId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      operationList: Object.freeze({
        // 已于问问ai3.0隐藏
        close: {
          label: "关闭",
          value: "close"
        },
        // 已于问问ai3.0隐藏
        otherTask: {
          label: "进行其他任务",
          value: "restart"
        },
        advise: {
          label: "提修改意见",
          value: "prepare_requirements"
        },
        recreate: {
          label: "重新生成",
          value: "retry"
        },
        recover: {
          label: "恢复",
          value: "recover"
        },
        recheck: {
          label: "重新检查",
          value: "check_content"
        },
        createMore: {
          label: "再来一些",
          value: "more_question"
        },
        createMoreOption: {
          label: "再来一些",
          value: "extend_options"
        },
        gotoEditPage: {
          label: "前往编辑",
          value: "goto_edit_page"
        },
        previewAnswerPage: {
          label: "预览答题",
          value: "preview_answer_page"
        },
        gotoOldTextProjectPage: {
          label: "前往旧版",
          value: "goto_old_text_project_page"
        },
        retry: {
          label: "再试一次",
          value: "retry_check_project_limit"
        },
        focusInput: {
          label: "直接输入/粘贴文本",
          value: "focus_input"
        },
        uploadWordExcel: {
          label: "上传 Word / Excel / PDF",
          value: "upload_text"
        },
        viewNow: {
          label: "立即查看",
          value: "view_now"
        },
        createProject: {
          label: `${this.messageInfo.conversationType === "edit_template" ? "引用此" : "创建此"}${Object(tools["c" /* getSceneName */])(this.pType)}`,
          value: "create_project_from_topic"
        },
        createQuestion: {
          label: "导入此题目",
          value: "create_question"
        },
        closeTask: {
          label: "结束任务",
          value: "close"
        }
      }),
      timeInstance: null
    };
  },
  computed: {
    messageStatus() {
      const {
        status
      } = this.messageInfo;
      return [constant["d" /* messageStatus */].WARNING, constant["d" /* messageStatus */].INTERRUPT].indexOf(status) > -1 ? constant["d" /* messageStatus */].WARNING : status;
    },
    loadingManual() {
      const {
        status,
        isHistory
      } = this.messageInfo;
      if (isHistory) {
        return "close";
      }
      if (status === constant["d" /* messageStatus */].INIT) {
        return "open";
      }
      return "";
    },
    isHistoryOrReplied() {
      const {
        hasReplied,
        isHistory
      } = this.messageInfo || {};
      return hasReplied || isHistory;
    },
    autoScrollToBottom() {
      var _this$messageInfo;
      return !((_this$messageInfo = this.messageInfo) !== null && _this$messageInfo !== void 0 && _this$messageInfo.isHistory);
    },
    isPcEditPage() {
      return this.platform === "PC" && this.pageName === "edit";
    }
  },
  watch: {
    isHistoryOrReplied: {
      handler(newVal, oldVal) {
        if (!newVal && oldVal) {
          // 中断之后，isHistoryOrReplied 为 false，需要更新输入框的状态；
          this.updateInputData();
        }
      }
    },
    "messageInfo.status": {
      handler() {
        // 历史数据或者已回复消息不需要更新输入框的状态；
        if (this.isHistoryOrReplied) {
          return;
        }
        this.updateInputData();
      },
      immediate: true
    }
  },
  destroyed() {
    this.timeInstance && clearTimeout(this.timeInstance);
  },
  methods: {
    // 轮询获取问问AI生成问卷的结果
    getCommandResult() {
      this.timeInstance && clearTimeout(this.timeInstance);
      if (this.messageInfo.status !== constant["d" /* messageStatus */].WAITING) {
        return;
      }
      this.timeInstance = setTimeout(() => {
        Object(wenwen_ai["c" /* httpGetChatResult */])({
          result_id: this.messageInfo.chatResultId
        }).then(res => {
          const {
            status_code: statusCode,
            data,
            error_code: errCode
          } = res || {};
          if (statusCode === 1) {
            const status = data === null || data === void 0 ? void 0 : data.status;
            if (status === 0) {
              this.getCommandResult();
            } else if (status === 1) {
              this.handleChatResult(data);
            } else {
              this.$emit("updateMessage", {
                errorType: status === 2 ? "audit" : "",
                status: constant["d" /* messageStatus */].WARNING,
                content: (data === null || data === void 0 ? void 0 : data.message) || "出错啦"
              });
            }
          } else {
            this.$emit("updateMessage", {
              status: constant["d" /* messageStatus */].WARNING,
              content: errCode === 10005 ? "出错啦，已超过负荷，请重新发起对话" : (res === null || res === void 0 ? void 0 : res.err_msg) || "出错啦",
              errorType: errCode === 10005 ? "overload" : ""
            });
          }
        });
      }, 2000);
    },
    getStreamResult() {
      try {
        const response = Object(fetch_event_source_["fetchEventSource"])(`/ai/api/stream/result?result_id=${this.messageInfo.chatResultId}&conversation_id=${this.conversationId}`, {
          method: "GET",
          openWhenHidden: true,
          // 页面退至后台保持连接
          onmessage: event => {
            const data = JSON.parse(event.data || "{}") || {};
            const {
              content_type: contentType,
              content
            } = data;
            if (contentType === "1") {
              // 正常返回结果
              const preResult = this.messageInfo.originalResult || "";
              this.$emit("updateMessage", {
                originalResult: preResult + content
              });
            } else if (contentType === "3") {
              // 结束
              this.$emit("updateMessage", {
                status: constant["d" /* messageStatus */].SUCCESS,
                content
              });
            } else {
              // 出错处理
              this.$emit("updateMessage", {
                status: constant["d" /* messageStatus */].WARNING,
                originalResult: "",
                content
              });
            }
            event_bus["a" /* EventBus */].$emit("wenwenAIChatScrollToBottom");
          },
          onclose: () => {
            console.log("close");
          },
          onerror: err => {
            console.log("onerror");
            this.$emit("updateMessage", {
              status: constant["d" /* messageStatus */].WARNING,
              content: err || "出错啦"
            });
            response.close();
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    handleChatResult(chatResult) {
      console.log("mixin chatResult----------", chatResult);
    },
    handleSelect(item) {
      const {
        value
      } = item;
      const {
        conversationId,
        conversationType,
        chatResultId
      } = this.messageInfo;
      switch (value) {
        case "create_project_from_topic":
        case "create_question":
        case "recover":
          // 历史记录中的消息，需要加上conversationId、chatResultId、conversationType；
          this.$emit("select", {
            ...item,
            conversationId,
            conversationType,
            chatResultId
          });
          break;
        default:
          this.$emit("select", item);
          break;
      }
    },
    updateInputData() {
      var _this$btnList, _this$btnList2;
      // 消息类型为start时，输入框显示介绍页选项；
      if (this.messageInfo.messageType === "start") {
        this.$emit("updateInputData");
        return;
      }
      let inputStatus = constant["b" /* editorStatus */].WAITING;
      let placeholder = "请稍等";
      if (!this.hideMenu && ((_this$btnList = this.btnList) === null || _this$btnList === void 0 ? void 0 : _this$btnList.length) > 0) {
        inputStatus = constant["b" /* editorStatus */].CHOOSING;
        placeholder = "请选择";
      } else if (this.messageInfo.errorType === "audit" || this.messageInfo.status === "" || this.messageInfo.status === constant["d" /* messageStatus */].WARNING && ((_this$btnList2 = this.btnList) === null || _this$btnList2 === void 0 ? void 0 : _this$btnList2.length) === 0) {
        inputStatus = constant["b" /* editorStatus */].INPUTTING;
        placeholder = "请输入";
      }
      this.$emit("updateInputData", {
        status: inputStatus,
        placeholder,
        menuList: this.btnList || [],
        hideMenu: this.hideMenu,
        isRichText: this.isRichText || false,
        maxLength: this.maxLength || 200
      });
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SvgIcon",
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      icon: null
    };
  },
  watch: {
    name: {
      async handler() {
        this.icon = await this.getIcon();
      },
      immediate: true
    }
  },
  methods: {
    async getIcon() {
      if (process.env.VITE) {
        const url = `/src/assets/image/icons/svg/${this.name}.svg?raw`;
        const module = await __webpack_require__(65)(url);
        return module.default;
      }
      return __webpack_require__(66)(`./${this.name}.svg`);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(41)))

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

const EventBus = new vue__WEBPACK_IMPORTED_MODULE_0___default.a();

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HTTP_STATUS_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTTP_RESPONSE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REDIRECT_LOGIN_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAGE_ERROR; });
/* unused harmony export HTTP_CLIENT_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGIN_ERROR; });
// 状态错误码
const HTTP_STATUS_CODE = {
  400: '错误请求',
  401: '未授权，请重新登录',
  403: '拒绝访问',
  404: '未找到该资源',
  405: '请求方法未允许',
  408: '请求超时',
  500: '系统开小差了，请稍后再试',
  501: '网络未实现',
  502: '服务繁忙，请稍后再试',
  503: '服务不可用',
  504: '网络超时',
  505: 'http版本不支持该请求',
  default: '连不上服务器，请稍后再试'
};
// 返回错误码
const HTTP_RESPONSE_ERROR = {
  10006: '验证码发送太频繁，请稍后再试',
  10007: '手机号不匹配',
  10042: '该Email已被占用',
  10043: '验证失败超三次，请重新发送验证码',
  10015: '操作失败，请重新尝试',
  10022: '签名错误',
  10025: '查询超时，请稍后重试',
  20001: '缺少参数',
  20002: '签名appkey与secret不匹配',
  20003: '签名错误',
  20004: '用户不存在',
  20005: '项目类型错误',
  20006: '项目创建数超过每日限制',
  20007: '项目标题为空',
  20008: '项目不存在',
  20009: '用户和项目创建者不匹配',
  20010: '题目不存在',
  20011: '参数值异常',
  20012: '选项图片上传错误',
  20013: '编辑锁定中',
  20014: '文件不存在',
  20015: '手机号未绑定',
  20016: '访问终端不支持',
  20017: '答卷已领取过红包',
  20018: '红包应用不可用',
  20019: '红包领取校验码错误',
  20020: '获取用户信息失败',
  20021: '信息发送太频繁',
  20022: '手机号或验证码为空',
  20023: '验证码错误',
  20024: '手机号不匹配',
  20025: '用户名为空',
  20026: '密码为空',
  20027: '用户名和密码不匹配',
  20028: '手机号为空',
  20029: '手机号已被占用',
  20030: '发送验证码失败',
  20031: '账号被冻结',
  20032: 'qq授权失败',
  20033: '手机号匹配正则未通过',
  20034: '题目不存在',
  20035: '没有复活卡可减',
  20040: '红包不存在',
  20041: '红包审核未通过',
  20042: '红包领取微信token错误',
  20043: '红包领取未知异常',
  20044: '已经答过该题',
  20045: '小程序获取用户信息失败',
  20046: '订单不存在',
  20047: '订单已支付',
  20048: '红包消费记录创建失败',
  20049: '应用不存在',
  20050: '下载报表失败',
  20051: '余额不足',
  20052: 'unionid不存在',
  20053: '小程序授权失败',
  30001: '绑定手机号等检查到已有绑定需要合并账号',
  30002: '项目包含敏感词',
  30004: '项目最低得分不能低于-2000000',
  30005: '项目总分不能超过2000000',
  30006: '随机抽题禁止删除',
  30007: '打乱顺序禁止删除',
  30070: '按题型随机抽题禁止删除',
  50002: '未知错误'
};
const REDIRECT_LOGIN_ERROR = {
  10001: '未登录',
  40403: '未登录',
  40502: '无权限访问'
};
const PAGE_ERROR = {
  10002: 'un-auth',
  // '10003': 'un-auth',
  10004: 'not-found'
};
// 客户端error
const HTTP_CLIENT_ERROR = {
  ECONNABORTED: '请求超时，请检查网络后重试'
};
const LOGIN_ERROR = {
  10001: '认证失败',
  10002: '发送太频繁',
  10003: '发送验证码失败',
  10006: '信息发送太频繁'
};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = require("blueimp-md5");

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui/lib/message");

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return httpPostConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return httpGetChatHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return httpGetChatResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEncryptedPreviewUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return httpPostImportQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return httpGetImportQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return httpPostBindChatToProject; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(138);


let request = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装,启用business自带的http封装", "color:red;");
  request = _index__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"];
} else {
  console.log("加载外部传入的http封装");
  console.log(request);
}

/** 创建对话
 * 创建对话
 * POST /ai/api/create_chat
 * 接口ID：142604410
 * 接口地址：https://app.apifox.com/link/project/1623754/apis/api-142604410
 */
function httpPostConversation(postData) {
  return request.post(`/ai/api/create_chat`, {
    ...postData,
    unInterceptors: true,
    __UPLOAD_FORMDATA__: true
  });
}

/* 聊天记录列表
 * GET /ai/api/chat_history
 * 接口ID：142605862
 * 接口地址：https://app.apifox.com/link/project/1623754/apis/api-142605862
 */
function httpGetChatHistory(param) {
  return request.get("/ai/api/chat_history", param);
}

/* 轮询获取gpt返回结果
 * GET /ai/api/result
 * 接口ID：142607821
 * 接口地址：https://app.apifox.com/link/project/1623754/apis/api-142607821
 */
function httpGetChatResult(param) {
  return request.get("/ai/api/result", param);
}

/**
 * 获取服务器时间
 * @returns
 */
function getEncryptedPreviewUrl(params) {
  return request.get("/preview/get_encrypted_preview_url/", params);
}

/**
 * @method 导入题目
 */
function httpPostImportQuestion(params) {
  return request.post("/edit/api/textproject/", params);
}

/**
 * @method 导入题目
 */
function httpGetImportQuestion(fingerprint, importType) {
  return request.get("/edit/api/textproject/", {
    fingerprint,
    import_type: importType
  });
}

/**
 * 绑定对话到项目
 */
function httpPostBindChatToProject(projectId, conversationId) {
  return request.post(`/ai/api/bind_project`, {
    project_id: projectId,
    conversation_id: conversationId,
    __UPLOAD_FORMDATA__: true
  });
}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

module.exports = require("uuid");

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = 65;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./enterprise-icon.svg": 67,
	"./header/desktop.svg": 68,
	"./header/phone.svg": 69,
	"./header/right-arrow.svg": 70,
	"./header/weixin.svg": 71,
	"./help-icon.svg": 72,
	"./import-contact/delete-icon.svg": 73,
	"./import-contact/expand-icon.svg": 74,
	"./import-contact/role-icon.svg": 75,
	"./import-contact/search-icon.svg": 76,
	"./preview-refresh.svg": 77,
	"./sms-email-share/contact-icon.svg": 78,
	"./sms-email-share/excel-icon.svg": 79,
	"./sms-email-share/history-icon.svg": 80,
	"./sms-email-share/link-icon.svg": 81,
	"./sms-email-share/link.svg": 82,
	"./sms-email-share/name-icon.svg": 83,
	"./sms-email-share/name.svg": 84,
	"./sms-email-share/triangle.svg": 85,
	"./sms-email-share/upload-icon.svg": 86,
	"./video-player/back.svg": 87,
	"./video-player/loading.svg": 88,
	"./video-player/muted.svg": 89,
	"./video-player/no-muted.svg": 90,
	"./video-player/player.svg": 91,
	"./warning-icon.svg": 92,
	"./warning.svg": 93,
	"./wenwen-ai/AI-create.svg": 94,
	"./wenwen-ai/AI-question.svg": 95,
	"./wenwen-ai/AI.svg": 96,
	"./wenwen-ai/Check-content.svg": 97,
	"./wenwen-ai/Edit-project.svg": 98,
	"./wenwen-ai/Link-create.svg": 99,
	"./wenwen-ai/Photo-create.svg": 100,
	"./wenwen-ai/Text-create.svg": 101,
	"./wenwen-ai/arrow-right.svg": 102,
	"./wenwen-ai/clear.svg": 103,
	"./wenwen-ai/close.svg": 104,
	"./wenwen-ai/collapse.svg": 105,
	"./wenwen-ai/file.svg": 106,
	"./wenwen-ai/history-loading.svg": 107,
	"./wenwen-ai/more.svg": 108,
	"./wenwen-ai/pdf.svg": 109,
	"./wenwen-ai/photo.svg": 110,
	"./wenwen-ai/send-solid.svg": 111,
	"./wenwen-ai/success.svg": 112,
	"./wenwen-ai/take-photo.svg": 113,
	"./wenwen-ai/tool.svg": 114,
	"./wenwen-ai/waiting.svg": 115,
	"./wenwen-ai/warning.svg": 116,
	"./wenwen-ai/word.svg": 117,
	"./wenwen-ai/xls.svg": 118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"66\" height=\"20\" viewBox=\"0 0 66 20\"><defs><clipPath id=\"master_svg0_169_5055\"><rect x=\"0\" y=\"0\" width=\"66\" height=\"20\" rx=\"0\"></rect></clipPath><linearGradient x1=\"1\" y1=\"1\" x2=\"-0.469696968793869\" y2=\"-0.6499999761581421\" id=\"master_svg1_1_1992\"><stop offset=\"0%\" stop-color=\"#E7B56C\" stop-opacity=\"1\"></stop><stop offset=\"100%\" stop-color=\"#F6E5A6\" stop-opacity=\"1\"></stop></linearGradient></defs><g clip-path=\"url(#master_svg0_169_5055)\"><g><path d=\"M10,9.09495e-13L56,9.09495e-13C61.5228,9.09495e-13,66,4.47715,66,10C66,15.5228,61.5228,20,56,20L10,20C4.47715,20,0,15.5228,0,10C0,4.47715,4.47715,9.09495e-13,10,9.09495e-13\" fill-rule=\"evenodd\" fill=\"url(#master_svg1_1_1992)\" fill-opacity=\"1\"></path></g><g><path d=\"M28.000000442504884,5.191999931335449C26.728000442504882,6.727999931335449,25.036000442504882,8.047999931335449,22.94800044250488,9.16399993133545L22.336000442504883,8.05999993133545C24.436000442504884,7.027999931335449,26.188000442504883,5.73199993133545,27.580000442504883,4.171999931335449L28.420000442504882,4.171999931335449C29.932000442504883,5.815999931335449,31.66000044250488,7.111999931335449,33.628000442504884,8.047999931335449L33.00400044250488,9.15199993133545Q30.070000442504885,7.639999931335449,28.000000442504884,5.191999931335449ZM52.64800044250488,15.271999931335449C53.512000442504885,14.803999931335449,54.256000442504885,14.21599993133545,54.88000044250488,13.51999993133545C55.45600044250488,14.239999931335449,56.164000442504886,14.82799993133545,57.01600044250488,15.259999931335448L57.58000044250488,14.26399993133545C56.80000044250488,13.867999931335449,56.140000442504885,13.303999931335449,55.588000442504885,12.58399993133545C56.308000442504884,11.479999931335449,56.78800044250488,10.12399993133545,57.052000442504884,8.53999993133545L57.052000442504884,7.567999931335449L52.67200044250488,7.567999931335449L52.67200044250488,5.971999931335449C54.37600044250488,5.899999931335449,55.91200044250488,5.659999931335449,57.304000442504886,5.251999931335449L56.75200044250488,4.231997531335449C55.240000442504886,4.711997931335449,53.536000442504886,4.963997931335449,51.628000442504884,4.999997931335449L51.628000442504884,9.65599993133545C51.58000044250488,11.647999931335448,51.268000442504885,13.21999993133545,50.66800044250488,14.34799993133545L51.44800044250488,15.175999931335449C52.21600044250488,13.807999931335448,52.62400044250488,11.95999993133545,52.67200044250488,9.65599993133545L52.67200044250488,8.647999931335448L52.94800044250488,8.647999931335448C53.18800044250489,10.18399993133545,53.60800044250488,11.479999931335449,54.22000044250488,12.547999931335449C53.64400044250488,13.21999993133545,52.94800044250488,13.79599993133545,52.10800044250488,14.26399993133545L52.64800044250488,15.271999931335449ZM45.35200044250488,14.803999931335449L45.35200044250488,13.68797993133545L41.84800044250488,13.68797993133545L41.84800044250488,4.2559843313354495L40.70800044250488,4.2559843313354495L40.70800044250488,13.68797993133545L39.268000442504885,13.68797993133545L39.268000442504885,4.2559843313354495L38.128000442504884,4.2559843313354495L38.128000442504884,13.68797993133545L34.64800044250488,13.68797993133545L34.64800044250488,14.803999931335449L45.35200044250488,14.803999931335449ZM50.60800044250488,15.18799993133545L50.60800044250488,9.919989931335449L48.304000442504886,9.919989931335449C48.31600044250489,9.60799993133545,48.32800044250489,9.28399993133545,48.32800044250489,8.947999931335449L48.32800044250489,8.49198993133545L51.02800044250488,8.49198993133545L51.02800044250488,7.37599993133545L50.45200044250488,7.37599993133545L50.45200044250488,4.2919949313354495L49.33600044250488,4.2919949313354495L49.33600044250488,7.37599993133545L48.32800044250489,7.37599993133545L48.32800044250489,4.531994931335449L47.21200044250489,4.531994931335449L47.21200044250489,8.947999931335449C47.20000044250489,11.39599993133545,46.936000442504884,13.17199993133545,46.43200044250489,14.29999993133545L47.296000442504884,15.043999931335449C47.77600044250488,14.10799993133545,48.10000044250488,12.76399993133545,48.244000442504884,11.01198993133545L49.49200044250488,11.01198993133545L49.49200044250488,15.18799993133545L50.60800044250488,15.18799993133545ZM36.448000442504885,12.23598993133545L37.49200044250488,11.97198993133545C37.012000442504885,9.90798993133545,36.47200044250488,8.071989931335448,35.860000442504884,6.463989931335449L34.88800044250488,6.775989931335449C35.512000442504885,8.52798993133545,36.04000044250488,10.35198993133545,36.448000442504885,12.23598993133545ZM43.33600044250488,12.18797993133545C44.05600044250488,10.63997993133545,44.64400044250488,8.83997993133545,45.10000044250488,6.775979931335449L44.09200044250488,6.487979931335449C43.58800044250488,8.647979931335449,42.988000442504884,10.43597993133545,42.31600044250489,11.827979931335449L43.33600044250488,12.18797993133545ZM32.95600044250488,13.700029931335449L32.95600044250488,14.803999931335449L22.90002644250488,14.803999931335449L22.90002644250488,13.700029931335449L24.628030442504883,13.700029931335449L24.628030442504883,9.12802993133545L25.756030442504883,9.12802993133545L25.756030442504883,13.700029931335449L27.77203044250488,13.700029931335449L27.77203044250488,7.40002993133545L28.912030442504882,7.40002993133545L28.912030442504882,9.96802993133545L32.092030442504885,9.96802993133545L32.092030442504885,11.06002993133545L28.912030442504882,11.06002993133545L28.912030442504882,13.700029931335449L32.95600044250488,13.700029931335449ZM54.92800044250488,11.54000993133545C54.49600044250488,10.724009931335448,54.18400044250488,9.752009931335449,53.96800044250489,8.648009931335448L55.960000442504885,8.648009931335448C55.768000442504885,9.72800993133545,55.420000442504886,10.688009931335449,54.92800044250488,11.54000993133545Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g><path d=\"M15.36933,5C15.57347,5.0000226626,15.76071,5.106426,15.85531,5.276175L17.9376,8.42522C18.0426,8.61379,18.013199999999998,8.84357,17.863500000000002,9.00338L12.41188,14.82509C12.30777,14.93627,12.15767,15,11.999939999999999,15C11.84221,15,11.69212,14.93627,11.588000000000001,14.82509L6.136415,9.00338C5.9867657,8.84354,5.9573779,8.61375,6.062472,8.42522L8.14476,5.276175C8.23936,5.106426,8.4266,5.000022667,8.63074,5L15.36933,5ZM9.588239999999999,7.35297Q9.5303,7.35297,9.47348,7.364269999999999Q9.41665,7.37557,9.36313,7.397740000000001Q9.3096,7.41991,9.26143,7.4521Q9.21326,7.48429,9.17229,7.525259999999999Q9.13132,7.5662199999999995,9.09913,7.6144Q9.06695,7.6625700000000005,9.04478,7.7160899999999994Q9.0226,7.76962,9.0113,7.82644Q9,7.8832699999999996,9,7.9412Q9,7.999140000000001,9.0113,8.055959999999999Q9.0226,8.11278,9.04478,8.16631Q9.06695,8.21984,9.09913,8.26801Q9.13132,8.31618,9.17229,8.35715Q9.21326,8.398109999999999,9.26143,8.430299999999999Q9.3096,8.462489999999999,9.36313,8.48466Q9.41665,8.50683,9.47348,8.51813Q9.5303,8.529440000000001,9.588239999999999,8.529440000000001L14.41176,8.529440000000001Q14.4697,8.529440000000001,14.52652,8.51813Q14.58335,8.50683,14.63687,8.48466Q14.6904,8.462489999999999,14.73857,8.430299999999999Q14.78674,8.398109999999999,14.82771,8.35715Q14.86868,8.31618,14.90086,8.26801Q14.93305,8.21984,14.95522,8.16631Q14.97739,8.11278,14.9887,8.055959999999999Q15,7.999140000000001,15,7.9412Q15,7.8832699999999996,14.9887,7.82644Q14.97739,7.76962,14.95522,7.7160899999999994Q14.93305,7.6625700000000005,14.90086,7.6144Q14.86868,7.5662199999999995,14.82771,7.525259999999999Q14.78674,7.48429,14.73857,7.4521Q14.6904,7.41991,14.63687,7.397740000000001Q14.58335,7.37557,14.52652,7.364269999999999Q14.4697,7.35297,14.41176,7.35297L9.588239999999999,7.35297Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"15\" height=\"14.25\" viewBox=\"0 0 15 14.25\"><path d=\"M11.25 12.75h-7.5v1.5h7.5v-1.5zM.744 11.25h13.512a.755.755 0 0 0 .744-.755V.755A.749.749 0 0 0 14.256 0H.744A.755.755 0 0 0 0 .755v9.74a.749.749 0 0 0 .744.755zm8.79-5.65H8V2.9a.4.4 0 0 0-.4-.4h-.2a.4.4 0 0 0-.4.4v2.7H5.466a.4.4 0 0 0-.283.683l2.034 2.034a.4.4 0 0 0 .566 0l2.034-2.034a.4.4 0 0 0-.283-.683z\" fill-rule=\"evenodd\" fill=\"currentColor\"></path></svg>"

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"10\" height=\"14\" viewBox=\"0 0 10 14\"><g><path d=\"M9,0C9.55229,0,10,0.447715,10,1L10,13C10,13.5523,9.55229,14,9,14L1,14C0.447715,14,0,13.5523,0,13L0,1C0,0.447715,0.447715,0,1,0L9,0ZM8.8002,1.20001L1.2002,1.20001L1.2002,9L8.8002,9L8.8002,1.20001ZM8.8002,10.2L1.2002,10.2L1.2002,12.8L8.8002,12.8L8.8002,10.2ZM5.1001,10.65Q5.02623,10.65,4.95378,10.6644Q4.88133,10.6788,4.81308,10.7071Q4.74484,10.7354,4.68342,10.7764Q4.622,10.8174,4.56977,10.8697Q4.51753,10.9219,4.4765,10.9833Q4.43546,11.0447,4.40719,11.113Q4.37892,11.1812,4.36451,11.2537Q4.3501,11.3261,4.3501,11.4Q4.3501,11.4739,4.36451,11.5463Q4.37892,11.6188,4.40719,11.687Q4.43546,11.7553,4.4765,11.8167Q4.51753,11.8781,4.56977,11.9303Q4.622,11.9826,4.68342,12.0236Q4.74484,12.0646,4.81308,12.0929Q4.88133,12.1212,4.95378,12.1356Q5.02623,12.15,5.1001,12.15Q5.17397,12.15,5.24642,12.1356Q5.31886,12.1212,5.38711,12.0929Q5.45536,12.0646,5.51678,12.0236Q5.57819,11.9826,5.63043,11.9303Q5.68266,11.8781,5.7237,11.8167Q5.76474,11.7553,5.79301,11.687Q5.82128,11.6188,5.83569,11.5463Q5.8501,11.4739,5.8501,11.4Q5.8501,11.3261,5.83569,11.2537Q5.82128,11.1812,5.79301,11.113Q5.76474,11.0447,5.7237,10.9833Q5.68266,10.9219,5.63043,10.8697Q5.57819,10.8174,5.51677,10.7764Q5.45536,10.7354,5.38711,10.7071Q5.31886,10.6788,5.24642,10.6644Q5.17397,10.65,5.1001,10.65Z\" fill-rule=\"evenodd\" fill=\"currentColor\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"a\"><rect width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#a)\"><path d=\"M6.556 10.314a.614.614 0 0 1-.88 0 .622.622 0 0 1 0-.867L8.065 7 5.676 4.553a.622.622 0 0 1 0-.867.614.614 0 0 1 .88 0L9.324 6.52A.62.62 0 0 1 9.499 7a.62.62 0 0 1-.175.479l-2.768 2.835z\" fill-rule=\"evenodd\" fill=\"#333\"></path></g></svg>"

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"14\" height=\"12\" viewBox=\"0 0 14 12\"><path d=\"M5.12 0c2.328 0 4.42 1.41 5.043 3.369l.06.211.14.021c1.909.325 3.423 1.788 3.616 3.548l.016.19.005.19c0 .967-.466 1.92-1.312 2.739l-.198.181.232.8a.598.598 0 0 1-.058.473l-.056.079-.07.07a.552.552 0 0 1-.539.097l-.086-.04-1.058-.598-.09.024a5.78 5.78 0 0 1-.887.162l-.155.01-.156.003c-1.673 0-3.176-.846-3.93-2.146l-.099-.18-.022-.045-.16.011-.236.006a5.03 5.03 0 0 1-.885-.082l-.633-.127-1.42.735-.081.034-.084.02-.086.007a.556.556 0 0 1-.37-.143.594.594 0 0 1-.187-.526l.022-.097.327-1.018-.19-.163C.658 7.027.141 6.08.025 5.04l-.019-.225L0 4.587C0 2.044 2.308 0 5.12 0zM1.127 4.587c0-1.872 1.78-3.422 3.993-3.422l.21.004c1.665.074 3.128 1.025 3.669 2.315l.03.08-.156.019c-2.114.3-3.746 1.946-3.746 3.947l.008.233c.005.078.013.155.024.233l.001.012h-.155a7.416 7.416 0 0 1-.711-.072q-.198-.034-.716-.168l-1.092.68.23-1.15-.2-.156c-.93-.733-1.39-1.586-1.39-2.555zm1.707-1.414c0-.411.378-.71.806-.71.408 0 .687.287.687.71 0 .42-.28.71-.687.71-.426 0-.806-.302-.806-.71zm3.098 0c0-.411.376-.71.804-.71.41 0 .69.287.69.71 0 .42-.283.71-.69.71-.426 0-.803-.302-.804-.71zm.323 4.356c0-1.547 1.474-2.834 3.313-2.834 1.8 0 3.305 1.317 3.305 2.834 0 .733-.454 1.515-1.306 2.197q.001-.002.154 1.056l-.963-.624-.35.087-.281.06c-.213.042-.38.059-.56.059-1.838 0-3.312-1.287-3.312-2.835zm1.457-1.057c0-.317.292-.62.599-.62.397 0 .711.28.711.62 0 .34-.313.618-.711.618-.307 0-.599-.3-.599-.618zm2.468 0c0-.316.29-.62.595-.62.397 0 .714.28.714.62 0 .34-.317.618-.714.618-.305 0-.595-.301-.595-.618z\" fill-rule=\"evenodd\" fill=\"currentColor\"></path></svg>"

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_169_5073\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_169_5073)\"><g><path d=\"M6.999986494140625,12.833371752929688C3.778236494140625,12.833371752929688,1.166656494140625,10.221751752929688,1.166656494140625,7.000001752929688C1.166656494140625,3.7782517529296875,3.778236494140625,1.1666717529296875,6.999986494140625,1.1666717529296875C10.221736494140625,1.1666717529296875,12.833356494140626,3.7782517529296875,12.833356494140626,7.000001752929688C12.833356494140626,10.221751752929688,10.221736494140625,12.833371752929688,6.999986494140625,12.833371752929688ZM6.999986494140625,11.666671752929688C9.577316494140625,11.666671752929688,11.666656494140625,9.577331752929688,11.666656494140625,7.000001752929688C11.666656494140625,4.422671752929688,9.577316494140625,2.3333417529296874,6.999986494140625,2.3333417529296874C4.422656494140625,2.3333417529296874,2.333326494140625,4.422671752929688,2.333326494140625,7.000001752929688C2.333326494140625,9.577331752929688,4.422656494140625,11.666671752929688,6.999986494140625,11.666671752929688ZM6.416656494140625,8.750001752929688L7.583326494140625,8.750001752929688L7.583326494140625,9.916671752929688L6.416656494140625,9.916671752929688L6.416656494140625,8.750001752929688ZM7.583326494140625,7.790421752929688L7.583326494140625,8.166671752929688L6.416656494140625,8.166671752929688L6.416656494140625,7.2916717529296875C6.416656494140625,6.969501752929688,6.677826494140625,6.708341752929687,6.999986494140625,6.708341752929687C7.460906494140625,6.708311752929688,7.842776494140625,6.3507217529296875,7.873046494140625,5.890801752929687C7.903316494140625,5.430871752929687,7.571606494140625,5.026331752929687,7.114666494140625,4.9658917529296875C6.657726494140625,4.905461752929687,6.232246494140625,5.209861752929688,6.141906494140625,5.661841752929687L4.997406494140625,5.432591752929688C5.193686494140625,4.451561752929687,6.071756494140625,3.7571717529296875,7.071616494140625,3.7922717529296874C8.071466494140626,3.8273617529296877,8.898686494140625,4.581621752929688,9.025696494140625,5.573991752929688C9.152706494140624,6.566371752929688,8.542106494140626,7.504641752929688,7.583326494140625,7.790421752929688Z\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><g style=\"mix-blend-mode:passthrough\"><path d=\"M7,14Q7.17184,14,7.34347,13.9916Q7.51511,13.9831,7.68612,13.9663Q7.85713,13.9494,8.02711,13.9242Q8.19709,13.899,8.36563,13.8655Q8.53417,13.832,8.70086,13.7902Q8.86755,13.7485,9.03199,13.6986Q9.19643,13.6487,9.35823,13.5908Q9.52002,13.5329,9.67878,13.4672Q9.83754,13.4014,9.99288,13.3279Q10.1482,13.2545,10.2998,13.1734Q10.4513,13.0924,10.5987,13.0041Q10.7461,12.9158,10.889,12.8203Q11.0319,12.7248,11.1699,12.6225Q11.3079,12.5201,11.4408,12.4111Q11.5736,12.3021,11.7009,12.1867Q11.8282,12.0713,11.9497,11.9497Q12.0713,11.8282,12.1867,11.7009Q12.3021,11.5736,12.4111,11.4408Q12.5201,11.3079,12.6225,11.1699Q12.7248,11.0319,12.8203,10.889Q12.9158,10.7461,13.0041,10.5987Q13.0924,10.4513,13.1734,10.2998Q13.2545,10.1482,13.3279,9.99288Q13.4014,9.83754,13.4672,9.67878Q13.5329,9.52002,13.5908,9.35823Q13.6487,9.19643,13.6986,9.03199Q13.7485,8.86755,13.7902,8.70086Q13.832,8.53417,13.8655,8.36563Q13.899,8.19709,13.9242,8.02711Q13.9494,7.85713,13.9663,7.68612Q13.9831,7.51511,13.9916,7.34347Q14,7.17184,14,7Q14,6.82816,13.9916,6.65653Q13.9831,6.48489,13.9663,6.31388Q13.9494,6.14287,13.9242,5.97289Q13.899,5.80291,13.8655,5.63437Q13.832,5.46583,13.7902,5.29914Q13.7485,5.13245,13.6986,4.96801Q13.6487,4.80357,13.5908,4.64177Q13.5329,4.47998,13.4672,4.32122Q13.4014,4.16246,13.3279,4.00711Q13.2545,3.85177,13.1734,3.70022Q13.0924,3.54867,13.0041,3.40128Q12.9158,3.25389,12.8203,3.11101Q12.7248,2.96813,12.6225,2.8301Q12.5201,2.69208,12.4111,2.55925Q12.3021,2.42641,12.1867,2.29909Q12.0713,2.17176,11.9497,2.05025Q11.8282,1.92874,11.7009,1.81334Q11.5736,1.69794,11.4408,1.58893Q11.3079,1.47991,11.1699,1.37755Q11.0319,1.27518,10.889,1.17971Q10.7461,1.08424,10.5987,0.9959Q10.4513,0.907556,10.2998,0.826551Q10.1482,0.745546,9.99288,0.672075Q9.83754,0.598604,9.67878,0.532843Q9.52002,0.467083,9.35823,0.409191Q9.19643,0.3513,9.03199,0.301418Q8.86755,0.251535,8.70086,0.209781Q8.53417,0.168027,8.36563,0.134503Q8.19709,0.100979,8.02711,0.0757644Q7.85713,0.0505502,7.68612,0.0337069Q7.51511,0.0168636,7.34347,0.0084318Q7.17184,0,7,0Q6.82816,0,6.65653,0.0084318Q6.48489,0.0168636,6.31388,0.0337069Q6.14287,0.0505502,5.97289,0.0757644Q5.80291,0.100979,5.63437,0.134503Q5.46583,0.168027,5.29914,0.209781Q5.13245,0.251535,4.96801,0.301418Q4.80357,0.3513,4.64177,0.409191Q4.47998,0.467083,4.32122,0.532843Q4.16246,0.598604,4.00711,0.672075Q3.85177,0.745546,3.70022,0.826551Q3.54867,0.907556,3.40128,0.995899Q3.25389,1.08424,3.11101,1.17971Q2.96813,1.27518,2.8301,1.37755Q2.69208,1.47991,2.55925,1.58893Q2.42641,1.69794,2.29909,1.81334Q2.17176,1.92874,2.05025,2.05025Q1.92874,2.17176,1.81334,2.29909Q1.69794,2.42641,1.58893,2.55925Q1.47991,2.69208,1.37755,2.8301Q1.27518,2.96813,1.17971,3.11101Q1.08424,3.25389,0.9959,3.40128Q0.907556,3.54867,0.826551,3.70022Q0.745546,3.85177,0.672075,4.00711Q0.598604,4.16246,0.532843,4.32122Q0.467083,4.47998,0.409191,4.64177Q0.3513,4.80357,0.301418,4.96801Q0.251535,5.13245,0.209781,5.29914Q0.168027,5.46583,0.134503,5.63437Q0.100979,5.80291,0.0757644,5.97289Q0.0505502,6.14287,0.0337069,6.31388Q0.0168636,6.48489,0.0084318,6.65653Q0,6.82816,0,7Q0,7.17184,0.0084318,7.34347Q0.0168636,7.51511,0.0337069,7.68612Q0.0505502,7.85713,0.0757644,8.02711Q0.100979,8.19709,0.134503,8.36563Q0.168027,8.53417,0.209781,8.70086Q0.251535,8.86755,0.301418,9.03199Q0.3513,9.19643,0.409191,9.35823Q0.467083,9.52002,0.532843,9.67878Q0.598604,9.83754,0.672075,9.99288Q0.745546,10.1482,0.826551,10.2998Q0.907556,10.4513,0.995899,10.5987Q1.08424,10.7461,1.17971,10.889Q1.27518,11.0319,1.37755,11.1699Q1.47991,11.3079,1.58893,11.4408Q1.69794,11.5736,1.81334,11.7009Q1.92874,11.8282,2.05025,11.9497Q2.17176,12.0713,2.29909,12.1867Q2.42641,12.3021,2.55925,12.4111Q2.69208,12.5201,2.8301,12.6225Q2.96813,12.7248,3.11101,12.8203Q3.25389,12.9158,3.40128,13.0041Q3.54867,13.0924,3.70022,13.1734Q3.85177,13.2545,4.00711,13.3279Q4.16246,13.4014,4.32122,13.4672Q4.47998,13.5329,4.64177,13.5908Q4.80357,13.6487,4.96801,13.6986Q5.13245,13.7485,5.29914,13.7902Q5.46583,13.832,5.63437,13.8655Q5.80291,13.899,5.97289,13.9242Q6.14287,13.9494,6.31388,13.9663Q6.48489,13.9831,6.65653,13.9916Q6.82816,14,7,14ZM9.45093,4.54907C9.68298,4.78112,9.68298,5.15735,9.45093,5.3894L7.84033,7L9.451,8.61067C9.68305,8.84272,9.68305,9.21894,9.451,9.45099C9.21895,9.68305,8.84272,9.68305,8.61067,9.45099L7,7.84033L5.38933,9.45099C5.15728,9.68305,4.78105,9.68305,4.549,9.45099C4.31695,9.21894,4.31695,8.84272,4.549,8.61067L6.15967,7L4.54907,5.3894C4.31702,5.15735,4.31702,4.78112,4.54907,4.54907C4.78112,4.31702,5.15735,4.31702,5.3894,4.54907L7,6.15967L8.6106,4.54907C8.84265,4.31702,9.21888,4.31702,9.45093,4.54907Z\" fill-rule=\"evenodd\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\"><g style=\"mix-blend-mode:passthrough\" transform=\"matrix(0,1,-1,0,18,-18)\"><g><rect x=\"18\" y=\"0\" width=\"18\" height=\"18\" rx=\"0\" fill=\"#FFFFFF\" fill-opacity=\"0.009999999776482582\"></rect></g><g><path d=\"M25,7L29,9.5L25,12L25,7Z\" fill=\"#666666\" fill-opacity=\"1\"></path><path d=\"M24,12L24,7Q24,6.9015086,24.019215,6.80491Q24.038429999999998,6.708311,24.076121,6.617317Q24.113812,6.526322,24.16853,6.44443Q24.223249,6.362537,24.292893,6.292893Q24.362537,6.223249,24.44443,6.16853Q24.526322,6.113812,24.617317,6.076121Q24.708311,6.03843,24.80491,6.019215Q24.9015086,6,25,6Q25.286796,6,25.529999,6.1520019999999995L29.53,8.652Q29.61352,8.7042,29.68525,8.77169Q29.75698,8.83918,29.81417,8.91937Q29.87136,8.99956,29.9118,9.08937Q29.95224,9.17917,29.97439,9.27514Q29.99654,9.37111,29.99954,9.46956Q30.00253,9.568,29.98627,9.665140000000001Q29.97,9.76228,29.9351,9.854379999999999Q29.900199999999998,9.946480000000001,29.848,10.03Q29.72569,10.22569,29.53,10.347999999999999L25.529999,12.847999999999999Q25.446478,12.9002,25.354379,12.9351Q25.262279,12.97001,25.16514,12.986270000000001Q25.0680012,13.00253,24.9695554,12.99954Q24.87111,12.99654,24.775141,12.97439Q24.679171,12.95224,24.589367,12.9118Q24.499562,12.87136,24.419374,12.81417Q24.339185,12.75698,24.271693,12.68525Q24.204202,12.613520000000001,24.152002,12.530000000000001Q24,12.2868,24,12ZM26,12L25,12L24.470001,11.152000000000001L28.47,8.652L29,9.5L28.47,10.347999999999999L24.470001,7.8479980000000005L25,7L26,7L26,12Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><g><path d=\"M8,0C12.416,0,16,3.584,16,8C16,12.416,12.416,16,8,16C3.584,16,0,12.416,0,8C0,3.584,3.584,0,8,0ZM3.2184,10.7328C4.3928,12.4848,6.156,13.6,8.128,13.6C10.0992,13.6,11.8632,12.4856,13.0368,10.7328C11.7054,9.48848,9.95036,8.79745,8.128,8.8C6.30537,8.79724,4.55001,9.48829,3.2184,10.7328ZM8,7.2C9.32548,7.2,10.4,6.12548,10.4,4.8C10.4,3.47452,9.32548,2.4,8,2.4C6.67452,2.4,5.6,3.47452,5.6,4.8C5.6,6.12548,6.67452,7.2,8,7.2Z\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><defs><clipPath id=\"master_svg0_95_06837/1_24458\"><rect x=\"0\" y=\"0\" width=\"24\" height=\"24\" rx=\"0\"></rect></clipPath></defs><g style=\"mix-blend-mode:passthrough\" clip-path=\"url(#master_svg0_95_06837/1_24458)\"><g style=\"mix-blend-mode:passthrough\"><path d=\"M14.84759,15.7002Q14.44664,16.028,13.99569,16.282600000000002Q13.54473,16.537100000000002,13.05698,16.711100000000002Q12.569230000000001,16.8851,12.058959999999999,16.973399999999998Q11.548680000000001,17.061700000000002,11.03083,17.061700000000002Q10.88278,17.061700000000002,10.73491,17.0544Q10.58704,17.0471,10.43971,17.032600000000002Q10.29237,17.0181,10.14593,16.9964Q9.99948,16.9747,9.85427,16.9458Q9.70907,16.9169,9.56546,16.8809Q9.42185,16.845,9.28017,16.802Q9.1385,16.759,8.99911,16.7091Q8.85971,16.6592,8.72293,16.602600000000002Q8.58615,16.5459,8.45232,16.482599999999998Q8.318480000000001,16.4193,8.18792,16.3495Q8.05735,16.2798,7.93036,16.2036Q7.803380000000001,16.127499999999998,7.68028,16.045299999999997Q7.55718,15.963,7.43827,15.8748Q7.31936,15.7866,7.20491,15.6927Q7.09047,15.5988,6.98077,15.4994Q6.87108,15.4,6.7663899999999995,15.2953Q6.6617,15.1906,6.5622799999999994,15.0809Q6.46286,14.97119,6.36894,14.85675Q6.27501,14.74231,6.18682,14.62339Q6.09863,14.50448,6.01638,14.38138Q5.934127,14.25828,5.858015,14.1313Q5.781902,14.00431,5.712113,13.87374Q5.642323,13.74318,5.579024,13.60934Q5.515725,13.47551,5.45907,13.33873Q5.402414,13.20195,5.352538,13.06256Q5.302662,12.92316,5.259686,12.78149Q5.216709,12.63982,5.180736,12.4962Q5.144764,12.35259,5.115881,12.20739Q5.0869979,12.06218,5.0652746,11.91574Q5.0435514,11.76929,5.0290401,11.62196Q5.0145288,11.47462,5.0072644,11.32675Q5,11.17888,5,11.03083Q5,10.88278,5.0072644,10.73491Q5.0145288,10.58704,5.0290401,10.43971Q5.0435514,10.29237,5.0652746,10.14593Q5.0869979,9.99948,5.115881,9.85427Q5.144764,9.70907,5.180736,9.56546Q5.216709,9.42185,5.259686,9.28017Q5.302662,9.1385,5.352538,8.99911Q5.402414,8.85971,5.45907,8.72293Q5.515725,8.58615,5.579024,8.45232Q5.642323,8.318480000000001,5.712113,8.18792Q5.781902,8.05735,5.858015,7.93036Q5.934127,7.803380000000001,6.01638,7.68028Q6.09863,7.55718,6.18682,7.43827Q6.27501,7.31936,6.36894,7.20491Q6.46286,7.09047,6.5622799999999994,6.98077Q6.6617,6.87108,6.7663899999999995,6.7663899999999995Q6.87108,6.6617,6.98077,6.5622799999999994Q7.09047,6.46286,7.20491,6.36894Q7.31936,6.27501,7.43827,6.18682Q7.55718,6.09863,7.68028,6.01638Q7.803380000000001,5.934127,7.93036,5.858015Q8.05735,5.781902,8.18792,5.712113Q8.318480000000001,5.642323,8.45232,5.579024Q8.58615,5.515725,8.72293,5.45907Q8.85971,5.402414,8.99911,5.352538Q9.1385,5.302662,9.28017,5.259686Q9.42185,5.216709,9.56546,5.180736Q9.70907,5.144764,9.85427,5.115881Q9.99948,5.0869979,10.14592,5.0652746Q10.29237,5.0435514,10.43971,5.0290401Q10.58704,5.0145288,10.73491,5.0072644Q10.88278,5,11.03083,5Q11.17888,5,11.32675,5.0072644Q11.47462,5.0145288,11.62196,5.0290401Q11.76929,5.0435514,11.91574,5.0652746Q12.06218,5.0869979,12.20739,5.115881Q12.35259,5.144764,12.4962,5.180736Q12.63981,5.216709,12.78149,5.259686Q12.92316,5.302662,13.06256,5.352538Q13.20195,5.402414,13.33873,5.45907Q13.47551,5.515725,13.60934,5.579024Q13.74318,5.642323,13.87374,5.712113Q14.00431,5.781902,14.1313,5.858015Q14.25828,5.934127,14.38138,6.01638Q14.50448,6.09863,14.62339,6.18682Q14.74231,6.27501,14.85675,6.36894Q14.97119,6.46286,15.0809,6.5622799999999994Q15.1906,6.6617,15.2953,6.7663899999999995Q15.4,6.87108,15.4994,6.98077Q15.5988,7.09047,15.6927,7.20491Q15.7866,7.31936,15.8748,7.43827Q15.963,7.55718,16.045299999999997,7.68028Q16.127499999999998,7.803380000000001,16.2036,7.93036Q16.2798,8.05735,16.349600000000002,8.18792Q16.4193,8.318480000000001,16.482599999999998,8.45232Q16.5459,8.58615,16.602600000000002,8.72293Q16.6592,8.85971,16.7091,8.99911Q16.759,9.1385,16.802,9.28017Q16.845,9.42185,16.8809,9.56546Q16.9169,9.70907,16.9458,9.85427Q16.9747,9.99948,16.9964,10.14592Q17.0181,10.29237,17.032600000000002,10.43971Q17.0471,10.58704,17.0544,10.73491Q17.061700000000002,10.88278,17.061700000000002,11.03083Q17.061700000000002,11.548639999999999,16.973399999999998,12.058869999999999Q16.8851,12.569099999999999,16.711199999999998,13.05682Q16.5372,13.54453,16.2827,13.99546Q16.028100000000002,14.44638,15.7005,14.84732L18.8234,17.9703C19.0589,18.2058,19.0589,18.587600000000002,18.8234,18.8231C18.614,19.0325,18.289099999999998,19.055799999999998,18.054000000000002,18.892899999999997L17.9705,18.8231L14.84759,15.7002ZM15.8554,11.030719999999999Q15.8554,11.14916,15.8496,11.26746Q15.8438,11.38575,15.8322,11.50362Q15.8205,11.62149,15.8032,11.73865Q15.7858,11.8558,15.7627,11.971969999999999Q15.7396,12.08813,15.7108,12.20302Q15.682,12.317910000000001,15.6476,12.43125Q15.6133,12.54459,15.5734,12.6561Q15.5335,12.76762,15.4881,12.877040000000001Q15.4428,12.986460000000001,15.3922,13.09353Q15.3415,13.2006,15.2857,13.30505Q15.2299,13.4095,15.169,13.51109Q15.1081,13.61268,15.0423,13.71116Q14.97648,13.80964,14.90593,13.90477Q14.83537,13.9999,14.76024,14.09146Q14.6851,14.18301,14.60556,14.27077Q14.52602,14.35852,14.44227,14.44227Q14.35852,14.52602,14.27077,14.60556Q14.18301,14.6851,14.09146,14.76024Q13.9999,14.83537,13.90477,14.90593Q13.80964,14.97648,13.71116,15.0423Q13.61268,15.1081,13.51109,15.169Q13.4095,15.2299,13.30505,15.2857Q13.2006,15.3415,13.09353,15.3922Q12.986460000000001,15.4428,12.877040000000001,15.4881Q12.76762,15.5335,12.6561,15.5734Q12.54459,15.6133,12.43125,15.6476Q12.317910000000001,15.682,12.20302,15.7108Q12.08813,15.7396,11.971969999999999,15.7627Q11.8558,15.7858,11.73865,15.8032Q11.62149,15.8205,11.50362,15.8322Q11.38575,15.8438,11.26746,15.8496Q11.14916,15.8554,11.030719999999999,15.8554Q10.912279999999999,15.8554,10.79399,15.8496Q10.67569,15.8438,10.55782,15.8322Q10.43995,15.8205,10.322790000000001,15.8032Q10.205639999999999,15.7858,10.08947,15.7627Q9.97331,15.7396,9.858419999999999,15.7108Q9.74353,15.682,9.630189999999999,15.6476Q9.51685,15.6133,9.405339999999999,15.5734Q9.29382,15.5335,9.1844,15.4881Q9.07498,15.4428,8.96791,15.3922Q8.86084,15.3415,8.75639,15.2857Q8.65193,15.2299,8.55035,15.169Q8.44876,15.1081,8.35028,15.0423Q8.2518,14.97648,8.15667,14.90593Q8.06154,14.83537,7.96998,14.76024Q7.87843,14.6851,7.79067,14.60556Q7.702920000000001,14.52602,7.61917,14.44227Q7.53542,14.35852,7.4558800000000005,14.27077Q7.37634,14.18301,7.3012,14.09146Q7.22607,13.9999,7.15551,13.90477Q7.084960000000001,13.80964,7.019159999999999,13.71116Q6.95336,13.61268,6.89247,13.51109Q6.83158,13.4095,6.77575,13.30505Q6.7199100000000005,13.2006,6.66927,13.09353Q6.61863,12.986460000000001,6.57331,12.877040000000001Q6.52799,12.76762,6.48808,12.6561Q6.44818,12.54459,6.4138,12.43125Q6.37942,12.317910000000001,6.35064,12.20302Q6.3218700000000005,12.08813,6.29876,11.971969999999999Q6.27565,11.8558,6.2582699999999996,11.73865Q6.2409,11.62149,6.22929,11.50362Q6.21768,11.38575,6.21187,11.26746Q6.20605,11.14916,6.20605,11.030719999999999Q6.20605,10.912279999999999,6.21187,10.79399Q6.21768,10.67569,6.22929,10.55782Q6.2409,10.43995,6.2582699999999996,10.322790000000001Q6.27565,10.205639999999999,6.29876,10.08947Q6.3218700000000005,9.97331,6.35064,9.858419999999999Q6.37942,9.74353,6.4138,9.630189999999999Q6.44818,9.51685,6.48808,9.405339999999999Q6.52799,9.29382,6.57331,9.1844Q6.61863,9.07498,6.66927,8.96791Q6.7199100000000005,8.86084,6.77575,8.75639Q6.83158,8.65193,6.89247,8.55035Q6.95336,8.44876,7.019159999999999,8.35028Q7.084960000000001,8.2518,7.15551,8.15667Q7.22607,8.06154,7.3012,7.96998Q7.37634,7.87843,7.4558800000000005,7.79067Q7.53542,7.702920000000001,7.61917,7.61917Q7.702920000000001,7.53542,7.79067,7.4558800000000005Q7.87843,7.37634,7.96999,7.3012Q8.06154,7.22607,8.15667,7.15551Q8.2518,7.084960000000001,8.35028,7.019159999999999Q8.44876,6.95336,8.55035,6.89247Q8.65193,6.83158,8.75639,6.77575Q8.86084,6.7199100000000005,8.96791,6.66927Q9.07498,6.61863,9.1844,6.57331Q9.29382,6.52799,9.405339999999999,6.48808Q9.51685,6.44818,9.630189999999999,6.4138Q9.74353,6.37942,9.858419999999999,6.35064Q9.97331,6.3218700000000005,10.08947,6.29876Q10.205639999999999,6.27565,10.322790000000001,6.2582699999999996Q10.43995,6.2409,10.55782,6.22929Q10.67569,6.21768,10.793980000000001,6.21187Q10.912279999999999,6.20605,11.030719999999999,6.20605Q11.14916,6.20605,11.26746,6.21187Q11.38575,6.21768,11.50362,6.22929Q11.62149,6.2409,11.73865,6.2582699999999996Q11.8558,6.27565,11.971969999999999,6.29876Q12.08813,6.3218700000000005,12.20302,6.35064Q12.317910000000001,6.37942,12.43125,6.4138Q12.54459,6.44818,12.6561,6.48808Q12.76762,6.52799,12.877040000000001,6.57331Q12.986460000000001,6.61863,13.09353,6.66927Q13.2006,6.7199100000000005,13.30505,6.77575Q13.4095,6.83158,13.51109,6.89247Q13.61268,6.95336,13.71116,7.019159999999999Q13.80964,7.084960000000001,13.90477,7.15551Q13.9999,7.22607,14.09146,7.3012Q14.18301,7.37634,14.27077,7.4558800000000005Q14.35852,7.53542,14.44227,7.61917Q14.52602,7.702920000000001,14.60556,7.79067Q14.6851,7.87843,14.76024,7.96999Q14.83537,8.06154,14.90593,8.15667Q14.97648,8.2518,15.0423,8.35028Q15.1081,8.44876,15.169,8.55035Q15.2299,8.65193,15.2857,8.75639Q15.3415,8.86084,15.3922,8.96791Q15.4428,9.07498,15.4881,9.1844Q15.5335,9.29382,15.5734,9.405339999999999Q15.6133,9.51685,15.6476,9.630189999999999Q15.682,9.74353,15.7108,9.858419999999999Q15.7396,9.97331,15.7627,10.08947Q15.7858,10.205639999999999,15.8032,10.322790000000001Q15.8205,10.43995,15.8322,10.55782Q15.8438,10.67569,15.8496,10.793980000000001Q15.8554,10.912279999999999,15.8554,11.030719999999999Z\" fill-rule=\"evenodd\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><path fill=\"currentColor\" d=\"M13.148 9.281a.462.462 0 0 0-.61.23 6.097 6.097 0 0 1-5.54 3.567 6.091 6.091 0 0 1-5.953-4.836l1.023 1.023a.461.461 0 0 0 .653-.653L.782 6.675a.55.55 0 0 0-.07-.059C.7 6.61.687 6.604.676 6.596l-.044-.023c-.015-.006-.031-.01-.046-.015-.012-.004-.025-.01-.04-.013a.457.457 0 0 0-.086-.009H.454a.441.441 0 0 0-.086.01.258.258 0 0 0-.04.012c-.014.004-.03.007-.045.015a.335.335 0 0 0-.044.023c-.011.008-.024.011-.035.02a.448.448 0 0 0-.127.128c-.008.01-.013.024-.019.035l-.023.043c-.006.015-.01.031-.015.048-.004.012-.01.025-.01.04A.498.498 0 0 0 0 7c0 3.86 3.143 7 7.004 7a7.024 7.024 0 0 0 6.38-4.108.467.467 0 0 0-.236-.61zm.57-1.854a.515.515 0 0 0 .043-.023c.011-.008.024-.011.035-.02a.448.448 0 0 0 .127-.128c.008-.01.013-.024.019-.035l.023-.043c.006-.015.01-.031.015-.048.004-.012.01-.025.01-.04.006-.029.01-.06.01-.09 0-3.86-3.143-7-7.004-7a7.01 7.01 0 0 0-6.41 4.176.462.462 0 0 0 .844.373A6.092 6.092 0 0 1 6.998.924a6.091 6.091 0 0 1 5.953 4.836l-1.023-1.023a.461.461 0 1 0-.653.653l1.94 1.939a.55.55 0 0 0 .072.058c.01.008.024.013.035.02l.043.024c.015.006.031.01.046.015.013.003.025.009.04.01a.499.499 0 0 0 .182 0c.015-.001.028-.007.04-.01.013-.01.028-.013.044-.019z\"></path></svg>"

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_1_2048\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_1_2048)\"><g><path d=\"M11.66667,12.83338701171875L3.5,12.83338701171875C2.533502,12.83338701171875,1.75,12.04988701171875,1.75,11.08335701171875L1.75,2.91668701171875C1.75,1.95018901171875,2.533502,1.16668701171875,3.5,1.16668701171875L11.66667,1.16668701171875C11.9888,1.16668701171875,12.25,1.42785401171875,12.25,1.75002001171875L12.25,12.24998701171875C12.25,12.57218701171875,11.9888,12.83338701171875,11.66667,12.83338701171875ZM11.08333,11.66668701171875L11.08333,10.50001701171875L3.5,10.50001701171875C3.17783,10.50001701171875,2.91667,10.76118701171875,2.91667,11.08335701171875C2.91667,11.40548701171875,3.17783,11.66668701171875,3.5,11.66668701171875L11.08333,11.66668701171875ZM2.91667,9.43251701171875C3.09925,9.36835701171875,3.29583,9.33335701171875,3.5,9.33335701171875L11.08333,9.33335701171875L11.08333,2.33335701171875L3.5,2.33335701171875C3.17783,2.33335701171875,2.91667,2.59451701171875,2.91667,2.91668701171875L2.91667,9.43251701171875ZM7,5.83335701171875C6.35567,5.83335701171875,5.83333,5.31101701171875,5.83333,4.66668701171875C5.83333,4.02235701171875,6.35567,3.50001701171875,7,3.50001701171875C7.64433,3.50001701171875,8.16667,4.02235701171875,8.16667,4.66668701171875C8.16667,5.31101701171875,7.64433,5.83335701171875,7,5.83335701171875ZM5.25,8.16668701171875C5.25,7.20018701171875,6.0335,6.41668701171875,7,6.41668701171875C7.9665,6.41668701171875,8.75,7.20018701171875,8.75,8.16668701171875L5.25,8.16668701171875Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_1_2050\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_1_2050)\"><g><path d=\"M1.6678046953124999,1.678273828125L9.0003076953125,0.631189168125C9.1760576953125,0.605952628125,9.3333876953125,0.742340828125,9.3333876953125,0.919938828125L9.3333876953125,13.080073828125C9.3333576953125,13.257373828125,9.1764476953125,13.393673828125,9.0008876953125,13.368873828125L1.6672206953125,12.321773828125C1.3797306953125,12.280773828125,1.1661376953125,12.034673828125,1.1661376953125,11.744273828125L1.1661376953125,2.255773828125C1.1661404768625,1.965383828125,1.3797336953125,1.719213828125,1.6678046953124999,1.678273828125L1.6678046953124999,1.678273828125ZM2.3333876953125,2.762103828125L2.3333876953125,11.237973828125L8.1667176953125,12.071473828125L8.1667176953125,1.928523828125L2.3333876953125,2.762103828125ZM9.9167176953125,11.083373828125L11.6667376953125,11.083373828125L11.6667376953125,2.916693828125L9.9167176953125,2.916693828125L9.9167176953125,1.750023828125L12.2500376953125,1.750023828125C12.5722376953125,1.750023828125,12.8333376953125,2.011193828125,12.8333376953125,2.333353828125L12.8333376953125,11.666673828125C12.8333376953125,11.988873828125,12.5722376953125,12.249973828125,12.2500376953125,12.249973828125L9.9167176953125,12.249973828125L9.9167176953125,11.083373828125ZM5.9500576953125,7.000023828125L7.5833876953125,9.333353828125L6.1833876953125,9.333353828125L5.2500576953125,7.999853828125L4.3167176953125,9.333353828125L2.9167176953125002,9.333353828125L4.5500576953125,7.000023828125L2.9167176953125002,4.666693828125L4.3167176953125,4.666693828125L5.2500576953125,6.000193828125L6.1833876953125,4.666693828125L7.5833876953125,4.666693828125L5.9500576953125,7.000023828125Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><defs><clipPath id=\"master_svg0_169_5075\"><rect x=\"0\" y=\"0\" width=\"16\" height=\"16\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_169_5075)\"><g><path d=\"M10.66667,1.333343505859375L14,4.666013505859375L14,14.006043505859376C14,14.370643505859375,13.7033,14.666643505859374,13.338,14.666643505859374L2.662,14.666643505859374C2.2966670000000002,14.666643505859374,2,14.363343505859374,2,14.005343505859376L2,1.994677505859375C2,1.629343505859375,2.2966670000000002,1.333343505859375,2.662,1.333343505859375L10.66667,1.333343505859375ZM8.66667,6.000013505859375L7.33333,6.000013505859375L7.33333,10.000013505859375L10.66667,10.000013505859375L10.66667,8.666673505859375L8.66667,8.666673505859375L8.66667,6.000013505859375Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_169_5119\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_169_5119)\"><g><path d=\"M7.61821984375,4.7308184765625L8.443639843749999,5.5562384765625C10.03846984375,7.1509084765625,10.03846984375,9.7365584765625,8.443639843749999,11.3311884765625L8.23713984375,11.5371884765625C6.64224984375,13.1308884765625,4.057459843749999,13.1304884765625,2.46312984375,11.5361884765625C0.86879884375,9.9418184765625,0.86835184375,7.3570384765625,2.46213984375,5.7621484765625L3.28754984375,6.5875684765625C2.14002384375,7.7251184765625,2.13597684375,9.5787984765625,3.27852984375,10.7213484765625C4.42106984375,11.8638884765625,6.27474984375,11.8598884765625,7.41229984375,10.7123184765625L7.61879984375,10.5058184765625C8.75741984375,9.3668584765625,8.75741984375,7.5206084765625,7.61879984375,6.3816484765625L6.79338984375,5.5562384765625L7.61879984375,4.7313984765625L7.61821984375,4.7308184765625ZM11.53708984375,8.2372384765625L10.71221984375,7.4124084765625C11.85978984375,6.2748584765625,11.86378984375,4.4211784765625,10.72124984375,3.2786284765625C9.57869984375,2.1360774765625,7.72501984375,2.1401254765625,6.58746984375,3.2876484765625L6.38096984375,3.4941484765625C5.2423498437500005,4.6331084765625,5.2423498437500005,6.4793584765625,6.38096984375,7.6183184765625L7.20637984375,8.443738476562501L6.38096984375,9.2685684765625L5.55612984375,8.443738476562501C3.96129984375,6.8490584765625,3.96129984375,4.2634084765625,5.55612984375,2.6687384765625L5.76262984375,2.4628184765625C7.35758984375,0.8694274765625001,9.94204984375,0.8700584765625,11.53618984375,2.4642284765625C13.13038984375,4.0583984765625,13.13098984375,6.6428684765625,11.53758984375,8.2378184765625L11.53708984375,8.2372384765625Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_1_18792\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_1_18792)\"><g><path d=\"M7.61821984375,4.7308184765625L8.443639843749999,5.5562384765625C10.03846984375,7.1509084765625,10.03846984375,9.7365584765625,8.443639843749999,11.3311884765625L8.23713984375,11.5371884765625C6.64224984375,13.1308884765625,4.057459843749999,13.1304884765625,2.46312984375,11.5361884765625C0.86879884375,9.9418184765625,0.86835184375,7.3570384765625,2.46213984375,5.7621484765625L3.28754984375,6.5875684765625C2.14002384375,7.7251184765625,2.13597684375,9.5787984765625,3.27852984375,10.7213484765625C4.42106984375,11.8638884765625,6.27474984375,11.8598884765625,7.41229984375,10.7123184765625L7.61879984375,10.5058184765625C8.75741984375,9.3668584765625,8.75741984375,7.5206084765625,7.61879984375,6.3816484765625L6.79338984375,5.5562384765625L7.61879984375,4.7313984765625L7.61821984375,4.7308184765625ZM11.53708984375,8.2372384765625L10.71221984375,7.4124084765625C11.85978984375,6.2748584765625,11.86378984375,4.4211784765625,10.72124984375,3.2786284765625C9.57869984375,2.1360774765625,7.72501984375,2.1401254765625,6.58746984375,3.2876484765625L6.38096984375,3.4941484765625C5.2423498437500005,4.6331084765625,5.2423498437500005,6.4793584765625,6.38096984375,7.6183184765625L7.20637984375,8.443738476562501L6.38096984375,9.2685684765625L5.55612984375,8.443738476562501C3.96129984375,6.8490584765625,3.96129984375,4.2634084765625,5.55612984375,2.6687384765625L5.76262984375,2.4628184765625C7.35758984375,0.8694274765625001,9.94204984375,0.8700584765625,11.53618984375,2.4642284765625C13.13038984375,4.0583984765625,13.13098984375,6.6428684765625,11.53758984375,8.2378184765625L11.53708984375,8.2372384765625Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_169_5111\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_169_5111)\"><g><path d=\"M11.083418046875,4.08331298828125L14.000048046875,4.08331298828125L14.000048046875,5.24998298828125L11.083418046875,5.24998298828125L11.083418046875,4.08331298828125ZM9.916748046875,6.99998298828125L14.000048046875,6.99998298828125L14.000048046875,8.16664298828125L9.916748046875,8.16664298828125L9.916748046875,6.99998298828125ZM11.666748046875,9.91664298828125L14.000048046875,9.91664298828125L14.000048046875,11.08331298828125L11.666748046875,11.08331298828125L11.666748046875,9.91664298828125ZM1.166748046875,12.83331298828125C1.166748046875,10.25598298828125,3.256088046875,8.16664298828125,5.833418046875,8.16664298828125C8.410748046875,8.16664298828125,10.500078046875,10.25598298828125,10.500078046875,12.83331298828125L9.333418046875,12.83331298828125C9.333418046875,10.90031298828125,7.766408046875,9.33331298828125,5.833418046875,9.33331298828125C3.900418046875,9.33331298828125,2.333418046875,10.90031298828125,2.333418046875,12.83331298828125L1.166748046875,12.83331298828125ZM5.833418046875,7.58331298828125C3.899668046875,7.58331298828125,2.333418046875,6.01706298828125,2.333418046875,4.08331298828125C2.333418046875,2.14956298828125,3.899668046875,0.58331298828125,5.833418046875,0.58331298828125C7.767168046875,0.58331298828125,9.333418046875,2.14956298828125,9.333418046875,4.08331298828125C9.333418046875,6.01706298828125,7.767168046875,7.58331298828125,5.833418046875,7.58331298828125ZM5.833418046875,6.41664298828125C7.122578046875,6.41664298828125,8.166748046875,5.37248298828125,8.166748046875,4.08331298828125C8.166748046875,2.79414298828125,7.122578046875,1.74998298828125,5.833418046875,1.74998298828125C4.5442480468749995,1.74998298828125,3.500078046875,2.79414298828125,3.500078046875,4.08331298828125C3.500078046875,5.37248298828125,4.5442480468749995,6.41664298828125,5.833418046875,6.41664298828125Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_1_18784\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_1_18784)\"><g><path d=\"M11.083418046875,4.08331298828125L14.000048046875,4.08331298828125L14.000048046875,5.24998298828125L11.083418046875,5.24998298828125L11.083418046875,4.08331298828125ZM9.916748046875,6.99998298828125L14.000048046875,6.99998298828125L14.000048046875,8.16664298828125L9.916748046875,8.16664298828125L9.916748046875,6.99998298828125ZM11.666748046875,9.91664298828125L14.000048046875,9.91664298828125L14.000048046875,11.08331298828125L11.666748046875,11.08331298828125L11.666748046875,9.91664298828125ZM1.166748046875,12.83331298828125C1.166748046875,10.25598298828125,3.256088046875,8.16664298828125,5.833418046875,8.16664298828125C8.410748046875,8.16664298828125,10.500078046875,10.25598298828125,10.500078046875,12.83331298828125L9.333418046875,12.83331298828125C9.333418046875,10.90031298828125,7.766408046875,9.33331298828125,5.833418046875,9.33331298828125C3.900418046875,9.33331298828125,2.333418046875,10.90031298828125,2.333418046875,12.83331298828125L1.166748046875,12.83331298828125ZM5.833418046875,7.58331298828125C3.899668046875,7.58331298828125,2.333418046875,6.01706298828125,2.333418046875,4.08331298828125C2.333418046875,2.14956298828125,3.899668046875,0.58331298828125,5.833418046875,0.58331298828125C7.767168046875,0.58331298828125,9.333418046875,2.14956298828125,9.333418046875,4.08331298828125C9.333418046875,6.01706298828125,7.767168046875,7.58331298828125,5.833418046875,7.58331298828125ZM5.833418046875,6.41664298828125C7.122578046875,6.41664298828125,8.166748046875,5.37248298828125,8.166748046875,4.08331298828125C8.166748046875,2.79414298828125,7.122578046875,1.74998298828125,5.833418046875,1.74998298828125C4.5442480468749995,1.74998298828125,3.500078046875,2.79414298828125,3.500078046875,4.08331298828125C3.500078046875,5.37248298828125,4.5442480468749995,6.41664298828125,5.833418046875,6.41664298828125Z\" fill=\"#666666\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"8\" height=\"5\" viewBox=\"0 0 8 5\"><g><path d=\"M1.04031,0C0.621059,0,0.387973,0.484966,0.649878,0.812348L3.60957,4.51196C3.80973,4.76216,4.19027,4.76216,4.39043,4.51196L7.35012,0.812348C7.61203,0.484966,7.37894,0,6.95969,0L1.04031,0Z\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"30\" height=\"23.75\" viewBox=\"0 0 30 23.75\"><g><path d=\"M29.9999,13.6104C29.9999,17.5218,26.8643,20.712,22.9986,20.712L22.4351,20.712C21.7447,20.712,21.1851,20.1524,21.1851,19.462C21.1851,18.7717,21.7447,18.212,22.4351,18.212L22.9986,18.212C25.4739,18.212,27.4999,16.1507,27.4999,13.6042C27.5111,11.335,25.8925,9.40665,23.7018,9.06454L23.0672,8.96363C22.8403,8.92754,22.6276,8.82958,22.4527,8.68051L22.3623,8.60346C22.1903,8.45688,22.0613,8.26642,21.9889,8.05234L21.7797,7.43317C20.7827,4.47809,18.0577,2.49912,15,2.5C11.9415,2.5,9.21554,4.47931,8.21969,7.4319L8.01173,8.05034C7.9396,8.26483,7.81059,8.45572,7.63847,8.60264L7.54801,8.67987C7.37296,8.8293,7.16005,8.92749,6.93275,8.96363L6.29446,9.06513C4.10739,9.40667,2.48891,11.3351,2.50007,13.6095C2.5028,16.155,4.52203,18.2093,7.00142,18.212L7.37188,18.212C8.06223,18.212,8.62188,18.7717,8.62188,19.462C8.62188,20.1524,8.06223,20.712,7.37188,20.712L7.00004,20.712C3.13099,20.7077,0.00426413,17.5267,0.0000876603,13.6169C-0.0170164,10.1337,2.47069,7.15445,5.86107,6.60266C7.20722,2.65472,10.8742,0,14.9996,0C19.1248,-0.00118385,22.7912,2.65363,24.1378,6.60249C27.5304,7.15593,30.017,10.1344,29.9999,13.6104ZM16.25,14.4822L17.6517,15.8839C18.1398,16.372,18.9313,16.372,19.4194,15.8839C19.9076,15.3957,19.9076,14.6043,19.4194,14.1161L15.8839,10.5806C15.3957,10.0924,14.6043,10.0924,14.1161,10.5806L10.5806,14.1161C10.0924,14.6043,10.0924,15.3957,10.5806,15.8839C11.0688,16.372,11.8602,16.372,12.3484,15.8839L13.75,14.4822L13.75,22.75C13.75,23.3023,14.1977,23.75,14.75,23.75L15.25,23.75C15.8023,23.75,16.25,23.3023,16.25,22.75L16.25,14.4822Z\" fill-rule=\"evenodd\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14.000022888183594\" height=\"12.220413208007812\" viewBox=\"0 0 14.000022888183594 12.220413208007812\"><g><path d=\"M0.000023365,6.11256L0,6.10714L0.000023365,6.10174L0.000023365,6.09093Q0.000023365,5.95013,0.0626569,5.82403Q0.12529,5.69793,0.237482,5.61285L5.66874,0.181593Q5.71192,0.138414,5.76269,0.104488Q5.81346,0.0705633,5.86988,0.047195Q5.9263,0.0238266,5.98619,0.0119133Q6.04608,0,6.10714,0Q6.16821,0,6.2281,0.0119133Q6.28799,0.0238266,6.34441,0.047195Q6.40082,0.0705633,6.4516,0.104488Q6.50237,0.138414,6.54555,0.181593Q6.63275,0.268798,6.67995,0.382737Q6.72714,0.496675,6.72714,0.62Q6.72714,0.743327,6.67995,0.857264Q6.63275,0.971201,6.54555,1.0584L2.11302,5.49093L13.4,5.49093Q13.4591,5.49093,13.5171,5.50246Q13.575,5.51399,13.6296,5.5366Q13.6842,5.55922,13.7333,5.59205Q13.7825,5.62488,13.8243,5.66667Q13.866,5.70845,13.8989,5.75759Q13.9317,5.80673,13.9543,5.86132Q13.9769,5.91592,13.9885,5.97388Q14,6.03184,14,6.09093L14,6.12676Q14,6.18586,13.9885,6.24382Q13.9769,6.30177,13.9543,6.35637Q13.9317,6.41097,13.8989,6.4601Q13.866,6.50924,13.8243,6.55103Q13.7825,6.59281,13.7333,6.62564Q13.6842,6.65847,13.6296,6.68109Q13.575,6.7037,13.5171,6.71523Q13.4591,6.72676,13.4,6.72676L2.12522,6.72676L6.5605,11.162Q6.6477,11.2492,6.6949,11.3632Q6.74209,11.4771,6.74209,11.6004Q6.74209,11.7238,6.6949,11.8377Q6.6477,11.9516,6.5605,12.0388Q6.47329,12.126,6.35935,12.1732Q6.24542,12.2204,6.12209,12.2204Q5.99876,12.2204,5.88483,12.1732Q5.77089,12.126,5.68368,12.0388L0.277606,6.63277Q0.213799,6.59212,0.162081,6.53689Q0.110364,6.48167,0.073976,6.41533Q0.0375876,6.349,0.0188055,6.27571Q0.000023365,6.20242,0.000023365,6.12676L0.000023365,6.11256Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"32.666664123535156\" height=\"32.666664123535156\" viewBox=\"0 0 32.666664123535156 32.666664123535156\"><g><path d=\"M0,16.3333C0,25.354,7.31268,32.6667,16.3333,32.6667C25.354,32.6667,32.6667,25.354,32.6667,16.3333C32.6667,15.2058,32.5524,14.1049,32.3348,13.0416C32.226,12.51,32.0914,11.9877,31.9324,11.4763C31.6699,10.6325,30.7234,10.2547,29.9095,10.5989C29.2991,10.8571,29.019,11.559,29.2224,12.1898Q29.453,12.9049,29.6011,13.639Q29.8667,14.9557,29.8667,16.3333Q29.8667,21.939,25.9028,25.9028Q21.939,29.8667,16.3333,29.8667Q10.7276,29.8667,6.76382,25.9028Q2.8,21.939,2.8,16.3333Q2.8,10.7276,6.76382,6.76382Q10.7276,2.8,16.3333,2.8Q19.0885,2.8,21.6003,3.86237Q22.2589,4.14095,22.8768,4.48188C23.4544,4.80059,24.1902,4.66071,24.5617,4.11555C25.0603,3.38405,24.8697,2.37733,24.091,1.95628C23.6368,1.71072,23.1698,1.48605,22.691,1.28355C20.7369,0.457043,18.5885,0,16.3333,0C7.31268,0,0,7.31268,0,16.3333Z\" fill=\"currentColor\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"100%\" height=\"100%\" viewBox=\"0 0 24 24\"><defs><clipPath id=\"a\"><rect width=\"24\" height=\"24\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#a)\"><path d=\"M24 12q0 .295-.015.589-.014.294-.043.587-.029.293-.072.585-.043.291-.1.58-.058.289-.13.575-.071.285-.157.567-.085.282-.184.56-.1.277-.212.55-.113.271-.24.538-.125.266-.264.526t-.29.512q-.152.253-.315.498-.164.245-.34.481-.175.237-.362.465-.187.227-.385.446-.197.218-.406.426-.208.209-.426.406-.219.198-.446.385-.228.187-.465.363-.236.175-.481.339-.245.163-.498.315-.252.151-.512.29-.26.139-.526.265-.267.126-.539.239-.272.112-.55.212-.277.099-.559.184-.282.086-.567.157-.286.072-.575.13-.289.057-.58.1-.292.043-.585.072-.293.03-.587.043Q12.295 24 12 24t-.589-.015q-.294-.014-.587-.043-.293-.029-.585-.072-.291-.043-.58-.1-.289-.058-.575-.13-.286-.071-.567-.157-.282-.085-.56-.184-.277-.1-.55-.212-.271-.113-.538-.24-.266-.125-.526-.264t-.512-.29q-.253-.152-.498-.315-.245-.164-.481-.34-.237-.175-.465-.362-.227-.187-.446-.385-.218-.197-.426-.406-.209-.208-.406-.426-.198-.219-.385-.446-.187-.228-.362-.465-.176-.236-.34-.481-.163-.245-.315-.498-.151-.252-.29-.512-.139-.26-.265-.526-.126-.267-.239-.539-.112-.272-.212-.55-.099-.277-.184-.559-.086-.282-.157-.567-.072-.286-.13-.575-.057-.289-.1-.58-.043-.292-.072-.585-.03-.293-.044-.587Q0 12.295 0 12t.014-.589q.015-.294.044-.587.029-.293.072-.585.043-.291.1-.58.058-.289.13-.575.071-.286.157-.567.085-.282.184-.56.1-.277.212-.55.113-.271.24-.538.125-.266.264-.526t.29-.512q.152-.253.315-.498.164-.245.34-.481.175-.237.362-.465.187-.227.385-.446.197-.218.406-.426.208-.209.426-.406.219-.198.446-.385.228-.187.465-.362.236-.176.481-.34.245-.163.498-.315.252-.151.512-.29.26-.139.526-.265.267-.126.539-.239.272-.112.55-.212.277-.099.559-.184.281-.086.567-.157.286-.072.575-.13.289-.057.58-.1.292-.043.585-.072.293-.03.587-.044Q11.705 0 12 0t.589.014q.294.015.587.044.293.029.585.072.291.043.58.1.289.058.575.13.285.071.567.157.282.085.56.184.277.1.55.212.271.113.538.24.266.125.526.264t.512.29q.253.152.498.315.245.164.481.34.237.175.465.362.227.187.446.385.218.197.426.406.209.208.406.426.198.219.385.446.187.228.363.465.175.236.339.481.163.245.315.498.151.252.29.512.139.26.265.526.126.267.239.539.112.272.212.55.099.277.184.559.086.281.157.567.072.286.13.575.057.289.1.58.043.292.072.585.03.293.043.587.015.294.015.589z\" fill=\"#F7F8FA\"></path><path d=\"M8.562 7.63l8.136-2.582A1 1 0 0 1 18 6v9.101h-.003q.018.262-.078.532-.07.2-.2.389t-.309.354q-.179.165-.397.295-.218.13-.46.219-.093.033-.188.06-.096.027-.192.047-.096.019-.192.031-.097.012-.193.017-.095.004-.19.001-.093-.003-.185-.013-.091-.01-.18-.029-.088-.018-.171-.043-.084-.025-.163-.058-.078-.032-.151-.071-.073-.04-.14-.085-.066-.045-.125-.097-.059-.05-.11-.108-.051-.056-.095-.118-.043-.062-.077-.128t-.06-.135q-.072-.197-.07-.412.004-.216.08-.434.072-.2.201-.389.13-.189.309-.354.18-.165.397-.295.218-.13.46-.219.177-.064.36-.102.181-.039.363-.05.182-.012.357.003t.338.057V7.94l-7.936 2.454v6.529c.127.74-.553 1.57-1.52 1.921-1.046.38-2.126.053-2.411-.729-.286-.781.33-1.723 1.377-2.102.478-.174.983-.2 1.418-.102V8.584a1 1 0 0 1 .697-.953z\" fill-rule=\"evenodd\" fill=\"#333\"></path><path d=\"M19.289 18.374L5.854 4.94a1 1 0 1 0-1.415 1.415l13.435 13.435a1 1 0 1 0 1.415-1.415z\" fill=\"#F7F8FA\"></path><path d=\"M18.996 18.803a.5.5 0 0 1-.707.707L4.854 6.075a.5.5 0 0 1 .707-.707l13.435 13.435z\" fill=\"#333\"></path></g></svg>"

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"100%\" height=\"100%\" viewBox=\"0 0 24 24\"><defs><clipPath id=\"a\"><rect width=\"24\" height=\"24\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#a)\"><path d=\"M24 12q0 .295-.015.589-.014.294-.043.587-.029.293-.072.585-.043.291-.1.58-.058.289-.13.575-.071.285-.157.567-.085.282-.184.56-.1.277-.212.55-.113.271-.24.538-.125.266-.264.526t-.29.512q-.152.253-.315.498-.164.245-.34.481-.175.237-.362.465-.187.227-.385.446-.197.218-.406.426-.208.209-.426.406-.219.198-.446.385-.228.187-.465.363-.236.175-.481.339-.245.163-.498.315-.252.151-.512.29-.26.139-.526.265-.267.126-.539.239-.272.112-.55.212-.277.099-.559.184-.282.086-.567.157-.286.072-.575.13-.289.057-.58.1-.292.043-.585.072-.293.03-.587.043Q12.295 24 12 24t-.589-.015q-.294-.014-.587-.043-.293-.029-.585-.072-.291-.043-.58-.1-.289-.058-.575-.13-.286-.071-.567-.157-.282-.085-.56-.184-.277-.1-.55-.212-.271-.113-.538-.24-.266-.125-.526-.264t-.512-.29q-.253-.152-.498-.315-.245-.164-.481-.34-.237-.175-.465-.362-.227-.187-.446-.385-.218-.197-.426-.406-.209-.208-.406-.426-.198-.219-.385-.446-.187-.228-.362-.465-.176-.236-.34-.481-.163-.245-.315-.498-.151-.252-.29-.512-.139-.26-.265-.526-.126-.267-.239-.539-.112-.272-.212-.55-.099-.277-.184-.559-.086-.282-.157-.567-.072-.286-.13-.575-.057-.289-.1-.58-.043-.292-.072-.585-.03-.293-.044-.587Q0 12.295 0 12t.014-.589q.015-.294.044-.587.029-.293.072-.585.043-.291.1-.58.058-.289.13-.575.071-.286.157-.567.085-.282.184-.56.1-.277.212-.55.113-.271.24-.538.125-.266.264-.526t.29-.512q.152-.253.315-.498.164-.245.34-.481.175-.237.362-.465.187-.227.385-.446.197-.218.406-.426.208-.209.426-.406.219-.198.446-.385.228-.187.465-.362.236-.176.481-.34.245-.163.498-.315.252-.151.512-.29.26-.139.526-.265.267-.126.539-.239.272-.112.55-.212.277-.099.559-.184.281-.086.567-.157.286-.072.575-.13.289-.057.58-.1.292-.043.585-.072.293-.03.587-.044Q11.705 0 12 0t.589.014q.294.015.587.044.293.029.585.072.291.043.58.1.289.058.575.13.285.071.567.157.282.085.56.184.277.1.55.212.271.113.538.24.266.125.526.264t.512.29q.253.152.498.315.245.164.481.34.237.175.465.362.227.187.446.385.218.197.426.406.209.208.406.426.198.219.385.446.187.228.363.465.175.236.339.481.163.245.315.498.151.252.29.512.139.26.265.526.126.267.239.539.112.272.212.55.099.277.184.559.086.281.157.567.072.286.13.575.057.289.1.58.043.292.072.585.03.293.043.587.015.294.015.589z\" fill=\"#F7F8FA\"></path><path d=\"M8.562 7.629l8.135-2.583A1 1 0 0 1 18 5.999V15.1h-.003q.018.262-.077.532-.071.2-.2.389-.13.188-.31.353-.178.165-.396.296-.218.13-.46.219-.094.033-.189.06-.095.027-.191.046-.096.02-.193.032-.096.012-.192.017-.096.004-.19.001t-.185-.013q-.092-.01-.18-.029-.088-.018-.172-.043-.084-.026-.162-.058-.079-.032-.152-.071-.073-.04-.139-.085-.066-.045-.125-.097-.06-.051-.11-.108-.052-.056-.095-.118-.043-.062-.078-.128-.034-.066-.06-.135-.071-.197-.069-.413.003-.215.08-.433.071-.2.2-.389.13-.189.31-.354.179-.165.397-.295.218-.131.46-.219.176-.064.359-.102.182-.039.364-.05.182-.012.357.003t.338.057V7.938L9 10.392v6.529c.127.74-.553 1.57-1.52 1.921-1.045.38-2.125.053-2.41-.729-.286-.781.33-1.723 1.377-2.102.478-.174.983-.2 1.417-.102V8.582a1 1 0 0 1 .698-.953z\" fill-rule=\"evenodd\" fill=\"#333\"></path></g></svg>"

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"100%\" height=\"100%\" viewBox=\"0 0 56 56\"><defs><clipPath id=\"master_svg0_1_5326\"><rect x=\"0\" y=\"0\" width=\"56\" height=\"56\" rx=\"28\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_1_5326)\"><rect x=\"0\" y=\"0\" width=\"56\" height=\"56\" rx=\"28\" fill=\"#FFFFFF\" fill-opacity=\"1\"></rect><g><path d=\"M27.6084421875,17.62763L37.3425921875,24.1171C40.1133921875,25.9643,40.1133921875,30.0357,37.3425921875,31.8829L27.6084421875,38.3724C25.2825021875,39.923,22.1669921875,38.2556,22.1669921875,35.4602L22.1669921875,20.53981C22.1669921875,17.74438,25.2825021875,16.07701,27.6084421875,17.62763\" fill=\"#333333\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><defs><clipPath id=\"master_svg0_169_5611\"><rect x=\"0\" y=\"0\" width=\"16\" height=\"16\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_169_5611)\"><g><path d=\"M8.000013505859375,14.66661298828125C4.3180135058593745,14.66661298828125,1.333343505859375,11.68201298828125,1.333343505859375,7.99998298828125C1.333343505859375,4.3179829882812495,4.3180135058593745,1.33331298828125,8.000013505859375,1.33331298828125C11.682043505859374,1.33331298828125,14.666643505859374,4.3179829882812495,14.666643505859374,7.99998298828125C14.666643505859374,11.68201298828125,11.682043505859374,14.66661298828125,8.000013505859375,14.66661298828125ZM8.000013505859375,13.33331298828125C10.945533505859375,13.33331298828125,13.333343505859375,10.94550298828125,13.333343505859375,7.99998298828125C13.333343505859375,5.05446298828125,10.945533505859375,2.66664298828125,8.000013505859375,2.66664298828125C5.054493505859375,2.66664298828125,2.666673505859375,5.05446298828125,2.666673505859375,7.99998298828125C2.666673505859375,10.94550298828125,5.054493505859375,13.33331298828125,8.000013505859375,13.33331298828125ZM7.333343505859375,4.66664298828125L8.666673505859375,4.66664298828125L8.666673505859375,5.99998298828125L7.333343505859375,5.99998298828125L7.333343505859375,4.66664298828125ZM7.333343505859375,7.33331298828125L8.666673505859375,7.33331298828125L8.666673505859375,11.33331298828125L7.333343505859375,11.33331298828125L7.333343505859375,7.33331298828125Z\" fill=\"#FFBE3A\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\"><g><path d=\"M18,35.9996C15.5917,36.0151,13.2057,35.5373,10.9891,34.5957C6.6624,32.779,3.22096,29.3376,1.40434,25.0109C0.462658,22.7943,-0.0151469,20.4083,0.000365978,18C-0.0151469,15.5917,0.462658,13.2057,1.40434,10.9891C3.22096,6.6624,6.6624,3.22095,10.9891,1.40434C13.2057,0.462654,15.5917,-0.0151482,18,0.000366211C20.4083,-0.0151482,22.7943,0.462654,25.0109,1.40434C29.3376,3.22095,32.779,6.6624,34.5957,10.9891C35.5373,13.2057,36.0151,15.5917,35.9996,18C36.0151,20.4083,35.5373,22.7943,34.5957,25.0109C32.779,29.3376,29.3376,32.779,25.0109,34.5957C22.7943,35.5373,20.4083,36.0151,18,35.9996ZM16.5,20.5L16.5,11.5Q16.5,11.4263,16.5072,11.353Q16.5144,11.2796,16.5288,11.2074Q16.5432,11.1351,16.5646,11.0646Q16.586,10.9941,16.6142,10.926Q16.6424,10.8579,16.6771,10.7929Q16.7119,10.7279,16.7528,10.6666Q16.7937,10.6054,16.8405,10.5484Q16.8872,10.4914,16.9393,10.4393Q16.9914,10.3872,17.0484,10.3405Q17.1054,10.2937,17.1666,10.2528Q17.2279,10.2119,17.2929,10.1771Q17.3579,10.1424,17.426,10.1142Q17.4941,10.086,17.5646,10.0646Q17.6351,10.0432,17.7074,10.0288Q17.7796,10.0144,17.853,10.0072Q17.9263,10,18,10Q18.0737,10,18.147,10.0072Q18.2204,10.0144,18.2926,10.0288Q18.3649,10.0432,18.4354,10.0646Q18.5059,10.086,18.574,10.1142Q18.6421,10.1424,18.7071,10.1771Q18.7721,10.2119,18.8334,10.2528Q18.8946,10.2937,18.9516,10.3405Q19.0086,10.3872,19.0607,10.4393Q19.1128,10.4914,19.1595,10.5484Q19.2063,10.6054,19.2472,10.6666Q19.2881,10.7279,19.3229,10.7929Q19.3576,10.8579,19.3858,10.926Q19.414,10.9941,19.4354,11.0646Q19.4568,11.1351,19.4712,11.2074Q19.4856,11.2796,19.4928,11.353Q19.5,11.4263,19.5,11.5L19.5,20.5Q19.5,20.5737,19.4928,20.647Q19.4856,20.7204,19.4712,20.7927Q19.4568,20.8649,19.4354,20.9354Q19.414,21.006,19.3858,21.074Q19.3576,21.1421,19.3229,21.2071Q19.2881,21.2721,19.2472,21.3334Q19.2063,21.3946,19.1595,21.4516Q19.1128,21.5086,19.0607,21.5607Q19.0086,21.6128,18.9516,21.6595Q18.8946,21.7063,18.8334,21.7472Q18.7721,21.7882,18.7071,21.8229Q18.6421,21.8576,18.574,21.8858Q18.5059,21.914,18.4354,21.9354Q18.3649,21.9568,18.2926,21.9712Q18.2204,21.9856,18.147,21.9928Q18.0737,22,18,22Q17.9263,22,17.853,21.9928Q17.7796,21.9856,17.7074,21.9712Q17.6351,21.9568,17.5646,21.9354Q17.4941,21.914,17.426,21.8858Q17.3579,21.8576,17.2929,21.8229Q17.2279,21.7882,17.1666,21.7472Q17.1054,21.7063,17.0484,21.6595Q16.9914,21.6128,16.9393,21.5607Q16.8872,21.5086,16.8405,21.4516Q16.7937,21.3946,16.7528,21.3334Q16.7119,21.2721,16.6771,21.2071Q16.6424,21.1421,16.6142,21.074Q16.586,21.006,16.5646,20.9354Q16.5432,20.8649,16.5288,20.7927Q16.5144,20.7204,16.5072,20.647Q16.5,20.5737,16.5,20.5ZM18,24Q17.9018,24,17.804,24.0096Q17.7062,24.0193,17.6098,24.0384Q17.5135,24.0576,17.4194,24.0861Q17.3254,24.1146,17.2346,24.1522Q17.1439,24.1898,17.0572,24.2362Q16.9706,24.2825,16.8889,24.3371Q16.8072,24.3916,16.7312,24.454Q16.6553,24.5163,16.5858,24.5858Q16.5163,24.6553,16.454,24.7312Q16.3916,24.8072,16.3371,24.8889Q16.2825,24.9706,16.2362,25.0572Q16.1898,25.1439,16.1522,25.2346Q16.1146,25.3254,16.0861,25.4194Q16.0576,25.5135,16.0384,25.6098Q16.0193,25.7062,16.0096,25.804Q16,25.9018,16,26Q16,26.0983,16.0096,26.196Q16.0193,26.2938,16.0384,26.3902Q16.0576,26.4866,16.0861,26.5806Q16.1146,26.6746,16.1522,26.7654Q16.1898,26.8561,16.2362,26.9428Q16.2825,27.0294,16.3371,27.1111Q16.3916,27.1928,16.454,27.2688Q16.5163,27.3447,16.5858,27.4142Q16.6553,27.4837,16.7312,27.546Q16.8072,27.6084,16.8889,27.6629Q16.9706,27.7175,17.0572,27.7638Q17.1439,27.8102,17.2346,27.8478Q17.3254,27.8854,17.4194,27.9139Q17.5135,27.9424,17.6098,27.9616Q17.7062,27.9807,17.804,27.9904Q17.9017,28,18,28Q18.0983,28,18.196,27.9904Q18.2938,27.9807,18.3902,27.9616Q18.4865,27.9424,18.5806,27.9139Q18.6746,27.8854,18.7654,27.8478Q18.8561,27.8102,18.9428,27.7638Q19.0294,27.7175,19.1111,27.6629Q19.1928,27.6084,19.2688,27.546Q19.3447,27.4837,19.4142,27.4142Q19.4837,27.3447,19.546,27.2688Q19.6084,27.1928,19.6629,27.1111Q19.7175,27.0294,19.7638,26.9428Q19.8102,26.8561,19.8478,26.7654Q19.8854,26.6746,19.9139,26.5806Q19.9424,26.4866,19.9616,26.3902Q19.9807,26.2938,19.9904,26.196Q20,26.0983,20,26Q20,25.9018,19.9904,25.804Q19.9807,25.7062,19.9616,25.6098Q19.9424,25.5135,19.9139,25.4194Q19.8854,25.3254,19.8478,25.2346Q19.8102,25.1439,19.7638,25.0572Q19.7175,24.9706,19.6629,24.8889Q19.6084,24.8072,19.546,24.7312Q19.4837,24.6553,19.4142,24.5858Q19.3447,24.5163,19.2688,24.454Q19.1928,24.3916,19.1111,24.3371Q19.0294,24.2825,18.9428,24.2362Q18.8561,24.1898,18.7654,24.1522Q18.6746,24.1146,18.5806,24.0861Q18.4866,24.0576,18.3902,24.0384Q18.2938,24.0193,18.196,24.0096Q18.0983,24,18,24Z\" fill-rule=\"evenodd\" fill=\"#FFBE3A\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\"><defs><clipPath id=\"master_svg0_18_4461\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_18_4461)\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\" fill=\"#8274FF\" fill-opacity=\"1\"></rect><g><g transform=\"matrix(0.9396926164627075,0.3420201539993286,-0.3420201539993286,0.9396926164627075,4.975543387961807,-5.73272241865925)\"><path d=\"M19.74371337890625,11.24249267578125L28.257093378906248,11.24249267578125C28.80941337890625,11.24249267578125,29.25711337890625,11.69020767578125,29.25711337890625,12.24249267578125L29.25711337890625,15.20146267578125L29.25711337890625,22.55929267578125C29.25711337890625,23.11159267578125,28.80941337890625,23.55929267578125,28.257093378906248,23.55929267578125L19.74371337890625,23.55929267578125C19.19142837890625,23.55929267578125,18.74371337890625,23.11159267578125,18.74371337890625,22.55929267578125L18.74371337890625,12.24249267578125C18.74371337890625,11.69020767578125,19.19142837890625,11.24249267578125,19.74371337890625,11.24249267578125\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"0.501960813999176\"></path></g><g transform=\"matrix(-0.9396926164627075,0.3420201539993286,0.3420201539993286,0.9396926164627075,33.61963452742202,-5.928048842921271)\"><path d=\"M20.00750732421875,9.49969482421875L31.09880732421875,9.49969482421875C31.65110732421875,9.49969482421875,32.098807324218754,9.94740982421875,32.098807324218754,10.49969482421875L32.098807324218754,13.83128482421875L32.098807324218754,21.975794824218752C32.098807324218754,22.52799482421875,31.65110732421875,22.975794824218752,31.09880732421875,22.975794824218752L20.00750732421875,22.975794824218752C19.45522232421875,22.975794824218752,19.00750732421875,22.52799482421875,19.00750732421875,21.975794824218752L19.00750732421875,10.49969482421875C19.00750732421875,9.94740982421875,19.45522232421875,9.49969482421875,20.00750732421875,9.49969482421875\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"0.501960813999176\"></path></g><g><path d=\"M11.6363525390625,9L18.6694125390625,9L24.3636525390625,9C24.915952539062502,9,25.3636525390625,9.447715,25.3636525390625,10L25.3636525390625,15.923079999999999L25.3636525390625,26C25.3636525390625,26.5523,24.915952539062502,27,24.3636525390625,27L11.6363525390625,27C11.0840675390625,27,10.6363525390625,26.5523,10.6363525390625,26L10.6363525390625,10C10.6363525390625,9.447715,11.0840675390625,9,11.6363525390625,9\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g><path d=\"M13.909072875976562,14.181852382812501L13.909072875976562,13.6363973828125Q13.909072875976562,13.5826743828125,13.919553675976562,13.5299843828125Q13.930034375976563,13.4772933828125,13.950593175976563,13.4276603828125Q13.971151875976563,13.3780273828125,14.000998575976563,13.3333583828125Q14.030844875976562,13.2886903828125,14.068832875976563,13.2507023828125Q14.106820875976563,13.2127143828125,14.151488875976563,13.1828680828125Q14.196157875976562,13.1530213828125,14.245790875976562,13.1324626828125Q14.295423875976562,13.1119038828125,14.348114875976563,13.1014231828125Q14.400804875976563,13.0909423828125,14.454527875976563,13.0909423828125L21.545432875976562,13.0909423828125Q21.59916287597656,13.0909423828125,21.651852875976562,13.1014231828125Q21.704542875976564,13.1119038828125,21.754172875976565,13.1324626828125Q21.80380287597656,13.1530213828125,21.84847287597656,13.1828680828125Q21.89314287597656,13.2127143828125,21.931132875976562,13.2507023828125Q21.969122875976563,13.2886903828125,21.998962875976563,13.3333583828125Q22.028812875976563,13.3780273828125,22.049372875976562,13.4276603828125Q22.069932875976562,13.4772933828125,22.080412875976563,13.5299843828125Q22.090892875976564,13.5826743828125,22.090892875976564,13.6363973828125L22.090892875976564,14.181852382812501Q22.090892875976564,14.2355723828125,22.080412875976563,14.2882623828125Q22.069932875976562,14.3409523828125,22.049372875976562,14.3905923828125Q22.028812875976563,14.4402223828125,21.998962875976563,14.4848923828125Q21.969122875976563,14.5295623828125,21.931132875976562,14.5675423828125Q21.89314287597656,14.6055323828125,21.84847287597656,14.6353823828125Q21.80380287597656,14.6652223828125,21.754172875976565,14.6857823828125Q21.704542875976564,14.7063423828125,21.651852875976562,14.7168223828125Q21.59916287597656,14.7273023828125,21.545432875976562,14.7273023828125L14.454527875976563,14.7273023828125Q14.400804875976563,14.7273023828125,14.348114875976563,14.7168223828125Q14.295423875976562,14.7063423828125,14.245790875976562,14.6857823828125Q14.196157875976562,14.6652223828125,14.151488875976563,14.6353823828125Q14.106820875976563,14.6055323828125,14.068832875976563,14.5675423828125Q14.030844875976562,14.5295623828125,14.000998575976563,14.4848923828125Q13.971151875976563,14.4402223828125,13.950593175976563,14.3905923828125Q13.930034375976563,14.3409523828125,13.919553675976562,14.2882623828125Q13.909072875976562,14.2355723828125,13.909072875976562,14.181852382812501ZM13.909072875976562,18.2727923828125L13.909072875976562,17.727342382812502Q13.909072875976562,17.6736123828125,13.919553675976562,17.620922382812502Q13.930034375976563,17.5682323828125,13.950593175976563,17.5186023828125Q13.971151875976563,17.4689723828125,14.000998575976563,17.4243023828125Q14.030844875976562,17.3796323828125,14.068832875976563,17.341642382812502Q14.106820875976563,17.3036623828125,14.151488875976563,17.2738123828125Q14.196157875976562,17.243962382812498,14.245790875976562,17.223402382812502Q14.295423875976562,17.2028423828125,14.348114875976563,17.1923623828125Q14.400804875976563,17.1818823828125,14.454527875976563,17.1818823828125L21.545432875976562,17.1818823828125Q21.59916287597656,17.1818823828125,21.651852875976562,17.1923623828125Q21.704542875976564,17.2028423828125,21.754172875976565,17.223402382812502Q21.80380287597656,17.243962382812498,21.84847287597656,17.2738123828125Q21.89314287597656,17.3036623828125,21.931132875976562,17.341642382812502Q21.969122875976563,17.3796323828125,21.998962875976563,17.4243023828125Q22.028812875976563,17.4689723828125,22.049372875976562,17.5186023828125Q22.069932875976562,17.5682323828125,22.080412875976563,17.620922382812502Q22.090892875976564,17.6736123828125,22.090892875976564,17.727342382812502L22.090892875976564,18.2727923828125Q22.090892875976564,18.3265123828125,22.080412875976563,18.3792023828125Q22.069932875976562,18.4318923828125,22.049372875976562,18.4815323828125Q22.028812875976563,18.5311623828125,21.998962875976563,18.5758323828125Q21.969122875976563,18.6205023828125,21.931132875976562,18.6584923828125Q21.89314287597656,18.6964723828125,21.84847287597656,18.726322382812498Q21.80380287597656,18.7561723828125,21.754172875976565,18.7767323828125Q21.704542875976564,18.7972823828125,21.651852875976562,18.8077723828125Q21.59916287597656,18.8182523828125,21.545432875976562,18.8182523828125L14.454527875976563,18.8182523828125Q14.400804875976563,18.8182523828125,14.348114875976563,18.8077723828125Q14.295423875976562,18.7972823828125,14.245790875976562,18.7767323828125Q14.196157875976562,18.7561723828125,14.151488875976563,18.726322382812498Q14.106820875976563,18.6964723828125,14.068832875976563,18.6584923828125Q14.030844875976562,18.6205023828125,14.000998575976563,18.5758323828125Q13.971151875976563,18.5311623828125,13.950593175976563,18.4815323828125Q13.930034375976563,18.4318923828125,13.919553675976562,18.3792023828125Q13.909072875976562,18.3265123828125,13.909072875976562,18.2727923828125ZM13.909072875976562,22.3635523828125L13.909072875976562,21.818102382812498Q13.909072875976562,21.7643723828125,13.919553675976562,21.711682382812498Q13.930034375976563,21.6589923828125,13.950593175976563,21.6093623828125Q13.971151875976563,21.5597323828125,14.000998575976563,21.515062382812502Q14.030844875976562,21.4703923828125,14.068832875976563,21.432402382812498Q14.106820875976563,21.3944123828125,14.151488875976563,21.3645723828125Q14.196157875976562,21.3347223828125,14.245790875976562,21.314162382812498Q14.295423875976562,21.2936023828125,14.348114875976563,21.2831223828125Q14.400804875976563,21.2726423828125,14.454527875976563,21.2726423828125L18.272712875976563,21.2726423828125Q18.326432875976565,21.2726423828125,18.379122875976563,21.2831223828125Q18.43181287597656,21.2936023828125,18.481442875976562,21.314162382812498Q18.531082875976562,21.3347223828125,18.575742875976562,21.3645723828125Q18.620412875976562,21.3944123828125,18.658402875976563,21.432402382812498Q18.696392875976564,21.4703923828125,18.726232875976564,21.515062382812502Q18.756082875976563,21.5597323828125,18.776642875976563,21.6093623828125Q18.797202875976563,21.6589923828125,18.80768287597656,21.711682382812498Q18.81816287597656,21.7643723828125,18.81816287597656,21.818102382812498L18.81816287597656,22.3635523828125Q18.81816287597656,22.4172723828125,18.80768287597656,22.4699623828125Q18.797202875976563,22.522652382812502,18.776642875976563,22.5722923828125Q18.756082875976563,22.6219223828125,18.726232875976564,22.6665923828125Q18.696392875976564,22.7112623828125,18.658402875976563,22.7492523828125Q18.620412875976562,22.787232382812498,18.575742875976562,22.8170823828125Q18.531082875976562,22.8469323828125,18.481442875976562,22.8674823828125Q18.43181287597656,22.8880423828125,18.379122875976563,22.8985223828125Q18.326432875976565,22.9090023828125,18.272712875976563,22.9090123828125L14.454527875976563,22.9090123828125Q14.400804875976563,22.9090023828125,14.348114875976563,22.8985223828125Q14.295423875976562,22.8880423828125,14.245790875976562,22.8674823828125Q14.196157875976562,22.8469323828125,14.151488875976563,22.8170823828125Q14.106820875976563,22.787232382812498,14.068832875976563,22.7492523828125Q14.030844875976562,22.7112623828125,14.000998575976563,22.6665923828125Q13.971151875976563,22.6219223828125,13.950593175976563,22.5722923828125Q13.930034375976563,22.522652382812502,13.919553675976562,22.4699623828125Q13.909072875976562,22.4172723828125,13.909072875976562,22.3635523828125Z\" fill=\"#C1BAFF\" fill-opacity=\"0.5\"></path></g></g></g></svg>"

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\"><defs><clipPath id=\"master_svg0_838_55942\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_838_55942)\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\" fill=\"#0AB8B9\" fill-opacity=\"1\"></rect><g><g transform=\"matrix(0.8660253882408142,0.5,-0.5,0.8660253882408142,4.291879641405103,-6.35064187745229)\"><path d=\"M18.12969892578125,20.35343505859375C18.13072892578125,21.13433505859375,18.76349892578125,21.76703505859375,19.54437892578125,21.76813505859375L24.055198925781248,21.76743505859375C24.83619892578125,21.76683505859375,25.46919892578125,21.13383505859375,25.46989892578125,20.352835058593747L25.46989892578125,19.60493505859375L25.51779892578125,19.58003505859375C26.76149892578125,18.938235058593747,27.79849892578125,17.95803505859375,28.50919892578125,16.75253505859375C29.23459892578125,15.50373505859375,29.61219892578125,14.08345505859375,29.60299892578125,12.63932505859375C29.60449892578125,8.32868505859375,26.11039892578125,4.83343505859375,21.79977892578125,4.83343505859375C17.48912892578125,4.83343505859375,13.99508455578125,8.32868505859375,13.99657301478125,12.63932505859375C13.98709603578125,14.08348505859375,14.36477092578125,15.50383505859375,15.09030892578125,16.75253505859375C15.80140892578125,17.957935058593748,16.83827892578125,18.938235058593747,18.08170892578125,19.58063505859375L18.12969892578125,19.605535058593752L18.12969892578125,20.35343505859375ZM17.01516892578125,11.42535505859375Q17.29536892578125,10.38899505859375,18.17015892578125,9.773905058593751Q18.338028925781252,9.65587505859375,18.38717892578125,9.45864505859375Q18.438448925781252,9.25293505859375,18.333528925781252,9.071205058593751Q18.22568892578125,8.884425058593749,18.01938892578125,8.83136505859375Q17.80452892578125,8.77609505859375,17.62199892578125,8.900785058593751Q16.40686892578125,9.730835058593751,16.02126892578125,11.15559505859375Q15.63567892578125,12.58035505859375,16.26634892578125,13.90990505859375Q16.36159892578125,14.11072505859375,16.57625892578125,14.17021505859375Q16.78116892578125,14.22702505859375,16.96833892578125,14.11896505859375Q17.14879892578125,14.01476505859375,17.20842892578125,13.81469505859375Q17.26628892578125,13.62051505859375,17.18077892578125,13.43403505859375Q16.73494892578125,12.46182505859375,17.01516892578125,11.42535505859375Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g transform=\"matrix(0.8660253882408142,0.5,-0.5,0.8660253882408142,11.240813198181058,-2.434561444501014)\"><path d=\"M10.163452148403126,19.75845336910625L17.504080595703126,19.75845336910625L17.504080595703126,21.85580181640625L10.163452148403126,21.85580181640625L10.163452148403126,19.75845336910625ZM10.163543700703125,22.38016181640625L17.504180595703126,22.38016181640625L17.504180595703126,23.95317181640625L10.163543700703125,23.95317181640625L10.163543700703125,22.38016181640625ZM10.163452148403126,24.92959181640625C10.163452148403126,25.29702181640625,10.364952595703125,25.63486181640625,10.688246595703125,25.809461816406248L12.761940595703125,26.92943181640625C13.332640595703126,27.23765181640625,14.017370595703126,27.24998181640625,14.598790595703125,26.96251181640625L16.947300595703126,25.80132181640625C17.288280595703124,25.63273181640625,17.504080595703126,25.28529181640625,17.504080595703126,24.90491181640625L17.504080595703126,24.477351816406248L10.163452148403126,24.477351816406248L10.163452148403126,24.92959181640625Z\" fill=\"#A5E9CC\" fill-opacity=\"1\"></path></g><g><path d=\"M23.694829355468748,21Q24.25563935546875,21,24.343669355468748,21.537985L25.48810935546875,28.52201L24.23607935546875,28.52201L23.90349935546875,26.34725L20.66906935546875,26.34725L19.79850935546875,28.52201L18.50408935546875,28.52201L21.389649355468748,21.459733Q21.58201935546875,21,22.090659355468752,21L23.694829355468748,21ZM22.38083935546875,22.09879L21.109239355468752,25.24519L23.73395935546875,25.24519L23.25465935546875,22.09879L22.38083935546875,22.09879ZM27.32051935546875,21L28.50408935546875,21L27.581369355468752,28.52201L26.40105935546875,28.52201L27.32051935546875,21Z\" fill=\"#FFBE3A\" fill-opacity=\"1\"></path></g></g></g></svg>"

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"24\" height=\"14\" viewBox=\"0 0 24 14\"><defs><linearGradient x1=\"0\" y1=\"0.5\" x2=\"1\" y2=\"0.5\" id=\"master_svg0_1_04581\"><stop offset=\"0%\" stop-color=\"#2672FF\" stop-opacity=\"1\"></stop><stop offset=\"100%\" stop-color=\"#8B58F2\" stop-opacity=\"1\"></stop></linearGradient><linearGradient x1=\"-0.18621504306793213\" y1=\"0.5\" x2=\"1.1379362344741821\" y2=\"0.5204562544822693\" id=\"master_svg1_1_04582\"><stop offset=\"0%\" stop-color=\"#2672FF\" stop-opacity=\"1\"></stop><stop offset=\"100%\" stop-color=\"#8B58F2\" stop-opacity=\"1\"></stop></linearGradient></defs><g><path d=\"M0 4C2.452636981645965e-16 1.7908610006768262 1.7908610006768266 0 4 0L23 0C23.552284749830793 0 24 0.44771525016920666 24 1L24 10C24 12.209138999323173 22.209138999323173 14 20 14L1 14C0.44771525016920666 14 0 13.552284749830793 0 13Z\" fill=\"#4C545F\" fill-opacity=\"1\"></path><path d=\"M0 4C2.452636981645965e-16 1.7908610006768262 1.7908610006768266 0 4 0L23 0C23.552284749830793 0 24 0.44771525016920666 24 1L24 10C24 12.209138999323173 22.209138999323173 14 20 14L1 14C0.44771525016920666 14 0 13.552284749830793 0 13Z\" fill=\"url(#master_svg0_1_04581)\" fill-opacity=\"1\"></path><path d=\"M0 4C2.452636981645965e-16 1.7908610006768262 1.7908610006768266 0 4 0L23 0C23.552284749830793 0 24 0.44771525016920666 24 1L24 10C24 12.209138999323173 22.209138999323173 14 20 14L1 14C0.44771525016920666 14 0 13.552284749830793 0 13Z\" fill=\"url(#master_svg1_1_04582)\" fill-opacity=\"1\"></path><g><g><path d=\"M12.190740953674316,3.239013671875Q12.751550953674316,3.239013671875,12.839580953674316,3.776998671875L13.984020953674317,10.761023671875L12.731990953674316,10.761023671875L12.399420953674316,8.586263671874999L9.164980953674316,8.586263671874999L8.294430953674317,10.761023671875L7.000000953674316,10.761023671875L9.885560953674316,3.698746671875Q10.077930953674317,3.239013671875,10.586570953674316,3.239013671875L12.190740953674316,3.239013671875ZM10.876750953674316,4.337803671875L9.605150953674316,7.484203671875L12.229870953674316,7.484203671875L11.750570953674316,4.337803671875L10.876750953674316,4.337803671875ZM15.816430953674317,3.239013671875L17.000000953674316,3.239013671875L16.077270953674315,10.761023671875L14.896970953674316,10.761023671875L15.816430953674317,3.239013671875Z\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g></g></g></svg>"

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\"><defs><clipPath id=\"master_svg0_18_9152\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\"></rect></clipPath><clipPath id=\"master_svg1_18_9152/802_00666\"><rect x=\"17.6055908203125\" y=\"17.37066650390625\" width=\"12.000000953674316\" height=\"12.000001907348633\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_18_9152)\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\" fill=\"#5C6BFD\" fill-opacity=\"1\"></rect><g><g><path d=\"M10.00543212890625,10.00006103515625L10.00543212890625,25.00006103515625C10.00543212890625,26.10466103515625,10.90086212890625,27.00006103515625,12.00543212890625,27.00006103515625L17.50543212890625,27.00006103515625L21.25543212890625,27.00006103515625L26.00543212890625,21.461461035156248L26.00543212890625,14.92316103515625L26.00543212890625,10.00006103515625C26.00543212890625,8.89549203515625,25.110032128906248,8.00006103515625,24.00543212890625,8.00006103515625L18.187252128906252,8.00006103515625L12.00543212890625,8.00006103515625C10.90086212890625,8.00006103515625,10.00543212890625,8.89549203515625,10.00543212890625,10.00006103515625Z\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g><path d=\"M11.50543212890625,13.50006103515625L11.50543212890625,10.50006103515625C11.50543212890625,9.94777603515625,11.95314712890625,9.50006103515625,12.50543212890625,9.50006103515625L23.50543212890625,9.50006103515625C24.057732128906252,9.50006103515625,24.50543212890625,9.94777603515625,24.50543212890625,10.50006103515625L24.50543212890625,13.50006103515625C24.50543212890625,14.05234103515625,24.057732128906252,14.50006103515625,23.50543212890625,14.50006103515625L12.50543212890625,14.50006103515625C11.95314712890625,14.50006103515625,11.50543212890625,14.05234103515625,11.50543212890625,13.50006103515625Z\" fill=\"#D3E1F9\" fill-opacity=\"1\"></path></g><g><path d=\"M11.50543212890625,17.909246453125L11.50543212890625,17.909246453125Q11.50543212890625,17.828662453125,11.52115322890625,17.749626453125Q11.53687442890625,17.670591453125,11.56771252890625,17.596141453125Q11.59855062890625,17.521691453125,11.64332112890625,17.454688453125Q11.68809112890625,17.387685453125002,11.74507212890625,17.330704453125Q11.80205312890625,17.273723453125,11.86905612890625,17.228953453125Q11.93605912890625,17.184182953125,12.01050912890625,17.153344853125Q12.08495912890625,17.122506753125,12.163995128906251,17.106785553125Q12.24303012890625,17.091064453125,12.32361412890625,17.091064453125L18.187252128906252,17.091064453125Q18.26783212890625,17.091064453125,18.34687212890625,17.106785553125Q18.42590212890625,17.122506753125,18.50035212890625,17.153344853125Q18.57480212890625,17.184182953125,18.64180212890625,17.228953453125Q18.70881212890625,17.273723453125,18.76579212890625,17.330704453125Q18.82277212890625,17.387685453125002,18.86754212890625,17.454688453125Q18.91231212890625,17.521691453125,18.94315212890625,17.596141453125Q18.97399212890625,17.670591453125,18.98971212890625,17.749627453125Q19.00543212890625,17.828662453125,19.00543212890625,17.909246453125L19.00543212890625,17.909246453125Q19.00543212890625,17.989830453125,18.98971212890625,18.068865453125Q18.97399212890625,18.147904453125,18.94315212890625,18.222354453125Q18.91231212890625,18.296804453125,18.86754212890625,18.363804453125Q18.82277212890625,18.430804453125,18.76579212890625,18.487784453125Q18.70881212890625,18.544774453125,18.64180212890625,18.589544453125Q18.57480212890625,18.634314453125,18.50035212890625,18.665144453125Q18.42590212890625,18.695984453125,18.34687212890625,18.711704453125Q18.26783212890625,18.727424453125,18.187252128906252,18.727424453125L12.32361412890625,18.727424453125Q12.24303012890625,18.727424453125,12.16399412890625,18.711704453125Q12.08495912890625,18.695984453125,12.01050912890625,18.665144453125Q11.93605912890625,18.634314453125,11.86905612890625,18.589544453125Q11.80205312890625,18.544774453125,11.74507212890625,18.487784453125Q11.68809112890625,18.430804453125,11.64332112890625,18.363804453125Q11.59855062890625,18.296804453125,11.56771252890625,18.222354453125Q11.53687442890625,18.147904453125,11.52115322890625,18.068865453125Q11.50543212890625,17.989830453125,11.50543212890625,17.909246453125ZM11.50543212890625,21.318304453125002L11.50543212890625,21.318304453125002Q11.50543212890625,21.237724453125,11.52115322890625,21.158684453124998Q11.53687442890625,21.079644453125,11.56771252890625,21.005194453125Q11.59855062890625,20.930744453125,11.64332112890625,20.863744453125Q11.68809112890625,20.796744453125,11.74507212890625,20.739764453124998Q11.80205312890625,20.682784453125,11.86905612890625,20.638014453125Q11.93605912890625,20.593244453125,12.01050912890625,20.562404453125Q12.08495912890625,20.531564453125,12.163995128906251,20.515844453125Q12.24303012890625,20.500124453125,12.32361412890625,20.500124453125L15.596342128906251,20.500124453125Q15.67692212890625,20.500124453125,15.755962128906251,20.515844453125Q15.83499212890625,20.531564453125,15.90944212890625,20.562404453125Q15.98389212890625,20.593244453125,16.05090212890625,20.638014453125Q16.117902128906252,20.682784453125,16.17488212890625,20.739764453124998Q16.23186212890625,20.796744453125,16.27663212890625,20.863744453125Q16.32140212890625,20.930744453125,16.352242128906248,21.005194453125Q16.38308212890625,21.079644453125,16.39880212890625,21.158684453124998Q16.41452212890625,21.237724453125,16.41452212890625,21.318304453125002L16.41452212890625,21.318304453125002Q16.41452212890625,21.398884453125,16.39880212890625,21.477924453125Q16.38308212890625,21.556954453125,16.352242128906248,21.631404453125Q16.32140212890625,21.705854453125,16.27663212890625,21.772864453125Q16.23186212890625,21.839864453125,16.17488212890625,21.896844453125Q16.117902128906252,21.953824453125,16.05090212890625,21.998594453125Q15.98389212890625,22.043364453125,15.90944212890625,22.074204453125Q15.83499212890625,22.105044453125,15.755962128906251,22.120764453125Q15.67692212890625,22.136484453125,15.596342128906251,22.136484453125L12.32361412890625,22.136484453125Q12.24303012890625,22.136484453125,12.16399412890625,22.120764453125Q12.08495912890625,22.105044453125,12.01050912890625,22.074204453125Q11.93605912890625,22.043364453125,11.86905612890625,21.998594453125Q11.80205312890625,21.953824453125,11.74507212890625,21.896844453125Q11.68809112890625,21.839864453125,11.64332112890625,21.772864453125Q11.59855062890625,21.705854453125,11.56771252890625,21.631404453125Q11.53687442890625,21.556954453125,11.52115322890625,21.477924453125Q11.50543212890625,21.398884453125,11.50543212890625,21.318304453125002Z\" fill=\"#AFC6F0\" fill-opacity=\"1\"></path></g><g transform=\"matrix(0.9961947202682495,0.08715573698282242,-0.08715560287237167,0.9961947202682495,1.5809451093568896,-1.4683279977880375)\" clip-path=\"url(#master_svg1_18_9152/802_00666)\"><g transform=\"matrix(0.7071067690849304,0.7071067690849304,-0.7071067690849304,0.7071067690849304,24.45071434024794,-10.619821721276821)\"><rect x=\"25.04461669921875\" y=\"24.2047119140625\" width=\"3.818181276321411\" height=\"1.3090907335281372\" rx=\"0.6545453667640686\" fill=\"#FFD773\" fill-opacity=\"1\"></rect></g><g><path d=\"M19.61767560546875,25.49801C21.30395560546875,27.1854,24.039005605468752,27.18582,25.72580560546875,25.49896C27.41261560546875,23.81209,27.41209560546875,21.07704,25.72464560546875,19.39082C24.038365605468748,17.70343,21.30331560546875,17.703006,19.61651560546875,19.38987C17.92970360546875,21.07674,17.93022360546875,23.81178,19.61767560546875,25.49801Z\" fill=\"#FFD773\" fill-opacity=\"1\"></path></g><g><path d=\"M20.50610089453125,24.6101925C21.70183189453125,25.8067125,23.64122189453125,25.8070125,24.83732189453125,24.6108725C26.03342189453125,23.4147325,26.03305189453125,21.4753325,24.83650189453125,20.2796455C23.64065189453125,19.0838385,21.70183189453125,19.0838725,20.50602489453125,20.2797215C19.31021789453125,21.4755725,19.31025189453125,23.414392499999998,20.50610089453125,24.6101925Z\" fill=\"#75A4FC\" fill-opacity=\"1\"></path></g><g transform=\"matrix(0.17364811897277832,0.9848077297210693,0.984807550907135,-0.1736483871936798,-1.217051444506069,1.4504367333738628)\"><path d=\"M24.14547544921875,22.10667962890625C24.11148544921875,22.10667962890625,24.07633544921875,22.09964962890625,24.04468544921875,22.08323962890625C23.91226544921875,22.01995962890625,23.78453344921875,21.94260962890625,23.66500244921875,21.85471962890625C23.26304944921875,21.55823962890625,22.97008044921875,21.15159862890625,22.81773664921875,20.67816162890625C22.77789294921875,20.55511462890625,22.84586154921875,20.42269292890625,22.96890844921875,20.38402082890625C23.09195544921875,20.34417712890625,23.22437744921875,20.41214572890625,23.26304944921875,20.53519262890625C23.38492444921875,20.91487962890625,23.61929944921875,21.24066062890625,23.94156544921875,21.47737962890625C24.03765544921875,21.54768962890625,24.13961544921875,21.60979962890625,24.24625544921875,21.66018962890625C24.36343544921875,21.71643962890625,24.41265544921875,21.85589962890625,24.35640544921875,21.973079628906248C24.31656544921875,22.05745962890625,24.23218544921875,22.10667962890625,24.14547544921875,22.10667962890625Z\" fill=\"#E6EFFF\" fill-opacity=\"1\"></path></g></g></g></g></svg>"

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\"><defs><clipPath id=\"master_svg0_802_02625\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_802_02625)\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\" fill=\"#FF841F\" fill-opacity=\"1\"></rect><g><g><path d=\"M9.99993896484375,14.177581035156251L9.99993896484375,17.00006103515625L9.99993896484375,24.00006103515625C9.99993896484375,25.65696103515625,11.34308896484375,27.00006103515625,12.99993896484375,27.00006103515625L22.99993896484375,27.00006103515625C24.65683896484375,27.00006103515625,25.99993896484375,25.65696103515625,25.99993896484375,24.00006103515625L25.99993896484375,11.00006103515625C25.99993896484375,9.34321103515625,24.65683896484375,8.00006103515625,22.99993896484375,8.00006103515625L17.99993896484375,8.00006103515625L16.188318964843752,8.00006103515625C15.39443896484375,8.00006103515625,14.63292896484375,8.31472903515625,14.07061896484375,8.87512703515625L10.88223796484375,12.05265103515625C10.31741496484375,12.615551035156251,9.99993896484375,13.380161035156249,9.99993896484375,14.177581035156251Z\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g transform=\"matrix(-1,0,0,-1,31.9998779296875,28.0001220703125)\"><path d=\"M15.99993896484375,20.00006103515625L16.22832496484375,20.00006103515625C16.76183096484375,20.00006103515625,17.27322896484375,19.786901035156248,17.64879896484375,19.40799103515625L18.04876896484375,19.00445103515625L20.03069896484375,17.02643103515625L21.41211896484375,15.65437103515625C21.79626896484375,15.27282103515625,22.00930896484375,14.75181803515625,22.00255896484375,14.21042303515625L21.99993896484375,14.00006103515625L17.99995896484375,14.00006103515625C16.89538496484375,14.00006103515625,15.99993896484375,14.89299103515625,15.99993896484375,15.99756103515625L15.99993896484375,16.50006103515625L15.99993896484375,20.00006103515625Z\" fill=\"#FFDDC1\" fill-opacity=\"1\"></path></g><g transform=\"matrix(0.7071067690849304,-0.7071067690849304,0.7071067690849304,0.7071067690849304,-11.380867237512575,19.268417533054162)\"><path d=\"M17.767105515625,24.97326134765625C17.502436215625,25.17332134765625,17.502436215625,25.57094134765625,17.767105515625,25.77100134765625L19.617763515625,27.16987134765625C19.791403515625,27.30112134765625,20.003113515625,27.37213134765625,20.220763515625,27.37213134765625L30.435203515625,27.37213134765625C30.987503515625,27.37213134765625,31.435203515625,26.92441134765625,31.435203515625,26.37213134765625L31.435203515625,24.37213134765625C31.435203515625,23.81984634765625,30.987503515625,23.37213134765625,30.435203515625,23.37213134765625L20.220763515625,23.37213134765625C20.003113515625,23.37213134765625,19.791403515625,23.44314304765625,19.617763515625,23.57438734765625L17.767105515625,24.97326134765625Z\" fill=\"#FCBF28\" fill-opacity=\"1\"></path></g><g><path d=\"M12.000030517578125,17.2501220703125L12.000030517578125,16.7501220703125C12.000030517578125,16.3359080703125,12.335816517578126,16.0001220703125,12.750030517578125,16.0001220703125L19.250030517578125,16.0001220703125C19.664240517578126,16.0001220703125,20.000030517578125,16.3359080703125,20.000030517578125,16.7501220703125L20.000030517578125,17.2501220703125C20.000030517578125,17.6643320703125,19.664240517578126,18.0001220703125,19.250030517578125,18.0001220703125L12.750030517578125,18.0001220703125C12.335816517578126,18.0001220703125,12.000030517578125,17.6643320703125,12.000030517578125,17.2501220703125ZM12.000030517578125,21.2500620703125L12.000030517578125,20.7500620703125C12.000030517578125,20.335852070312498,12.335816517578126,20.0000620703125,12.750030517578125,20.0000620703125L16.250030517578125,20.0000620703125C16.664240517578126,20.0000620703125,17.000030517578125,20.335852070312498,17.000030517578125,20.7500620703125L17.000030517578125,21.2500620703125C17.000030517578125,21.6642720703125,16.664240517578126,22.0000620703125,16.250030517578125,22.0000620703125L12.750030517578125,22.0000620703125C12.335816517578126,22.0000620703125,12.000030517578125,21.6642720703125,12.000030517578125,21.2500620703125Z\" fill=\"#FF841F\" fill-opacity=\"0.30000001192092896\"></path></g></g></g></svg>"

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\"><defs><clipPath id=\"master_svg0_18_4475\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\"></rect></clipPath><clipPath id=\"master_svg1_18_4475/1_26632\"><rect x=\"1.6363525390625\" y=\"1.63623046875\" width=\"32.727272033691406\" height=\"32.727272033691406\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_18_4475)\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\" fill=\"#3F82FF\" fill-opacity=\"1\"></rect><g clip-path=\"url(#master_svg1_18_4475/1_26632)\"><g><path d=\"M15.988026955566406,12.822704776611328C15.756546955566407,13.126624776611328,15.779706955566407,13.562614776611328,16.057506955566407,13.840154776611328L17.632266955566408,15.414694776611327L19.861566955566406,13.185174776611328Q20.501366955566404,12.545304776611328,21.406066955566406,12.545304776611328Q22.310766955566407,12.545304776611328,22.95056695556641,13.185164776611328Q23.533566955566407,13.768274776611328,23.585966955566406,14.590834776611327Q23.637866955566405,15.404844776611327,23.144566955566404,16.05268477661133L23.113366955566406,16.09362477661133L22.986466955566407,16.238674776611326L20.721666955566405,18.50366477661133L22.158766955566406,19.94056477661133C22.306166955566404,20.08796477661133,22.502966955566407,20.167764776611328,22.707166955566407,20.167764776611328C22.911466955566404,20.167764776611328,23.108266955566407,20.08796477661133,23.255666955566404,19.94056477661133L26.054166955566405,17.142664776611326L26.229366955566405,16.958794776611327C27.079766955566406,16.021424776611326,27.545366955566408,14.818084776611329,27.545366955566408,13.543824776611327C27.545366955566408,12.184594776611329,27.015566955566406,10.906054776611327,26.054166955566405,9.945184776611327C25.092866955566407,8.983983776611328,23.814366955566406,8.454364776611328,22.45506695556641,8.454364776611328L22.203366955566405,8.460459716611329L21.950966955566408,8.478956576611328C20.779166955566406,8.593736776611328,19.695766955566405,9.105339776611329,18.85596695556641,9.945204776611329L16.057476955566408,12.743304776611328L15.988026955566406,12.822704776611328ZM15.413816955566407,17.633324776611328L13.594896955566405,19.452364776611326L13.558936955566406,19.488364776611327L13.432076955566405,19.633464776611326L13.400906955566406,19.674364776611327Q12.907656955566406,20.32216477661133,12.959496955566406,21.13616477661133Q13.011886955566407,21.95866477661133,13.594946955566407,22.541864776611327Q14.234786955566406,23.181664776611328,15.139406955566407,23.181664776611328Q16.043906955566406,23.181664776611328,16.683896955566404,22.54176477661133L18.503066955566407,20.72246477661133L19.940166955566404,22.159364776611326C20.217966955566407,22.436964776611326,20.241066955566406,22.872964776611326,20.009666955566406,23.17686477661133L19.940166955566404,23.256264776611328L17.141706955566406,26.05436477661133C16.180666955566405,27.015764776611327,14.901966955566406,27.54536477661133,13.542366955566406,27.54536477661133C12.182776955566407,27.54536477661133,10.904076955566406,27.015764776611327,9.942816955566407,26.05436477661133C8.015176955566407,24.126764776611328,7.960101955566406,21.024864776611327,9.777596955566406,19.02976477661133L9.942826955566407,18.85666477661133L12.741996955566407,16.05852477661133C13.045016955566407,15.75557477661133,13.536426955566405,15.75557477661133,13.838986955566407,16.058584776611326L15.413816955566407,17.633324776611328Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g><path d=\"M20.73118373046875,14.492964234375C20.96430373046875,14.259832534375,21.34200373046875,14.259832534375,21.57514373046875,14.492962234375C21.788863730468748,14.706692234375,21.806673730468752,15.042078234375,21.62857373046875,15.275937234375L21.57514373046875,15.337035234375L15.95065373046875,20.961445234375C15.83719473046875,21.074875234375,15.68581173046875,21.136295234374998,15.52867673046875,21.136295234374998C15.37150873046875,21.136295234374998,15.22012373046875,21.074875234375,15.10666973046875,20.961435234375C14.89296873046875,20.747725234375,14.87516033046875,20.412355234375,15.05324573046875,20.178485234375L15.10667173046875,20.117385234375L20.73118373046875,14.492964234375Z\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g></g></g></svg>"

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\"><defs><clipPath id=\"master_svg0_18_4468\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\"></rect></clipPath><clipPath id=\"master_svg1_18_4468/1_26601\"><rect x=\"1.6363525390625\" y=\"1.63623046875\" width=\"32.727272033691406\" height=\"32.727272033691406\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_18_4468)\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\" fill=\"#FF6D56\" fill-opacity=\"1\"></rect><g clip-path=\"url(#master_svg1_18_4468/1_26601)\"><g><path d=\"M13.3543701171875,11.184137617187499L22.645610117187502,11.184137617187499L22.3899301171875,10.3659556171875C22.2120301171875,9.7966706171875,21.6848001171875,9.4090576171875,21.0883701171875,9.4090576171875L14.9116201171875,9.4090576171875C14.3151811171875,9.4090576171875,13.7879531171875,9.7966706171875,13.6100521171875,10.3659556171875L13.3543701171875,11.184137617187499Z\" fill=\"#FFFFFF\" fill-opacity=\"0.699999988079071\"></path></g><g><path d=\"M27.545417364501954,13.0907376171875C27.545417364501954,11.8634696171875,26.59091736450195,10.9090576171875,25.363617364501952,10.9090576171875L10.636337364501953,10.9090576171875C9.409060364501952,10.9090576171875,8.454517364501953,11.8634696171875,8.454517364501953,13.0907376171875L8.454517364501953,23.727057617187498C8.454517364501953,24.954357617187497,9.409060364501952,25.9091576171875,10.636337364501953,25.9091576171875L25.363617364501952,25.9091576171875C26.59091736450195,25.9091576171875,27.545417364501954,24.954357617187497,27.545417364501954,23.727057617187498L27.545417364501954,13.0907376171875ZM17.999967364501956,22.499957617187498C20.259317364501953,22.499957617187498,22.090917364501955,20.6683676171875,22.090917364501955,18.4090276171875C22.090917364501955,16.1496776171875,20.259317364501953,14.3181176171875,17.999967364501956,14.3181176171875C15.740627364501954,14.3181176171875,13.909057364501953,16.1496776171875,13.909057364501953,18.4090276171875C13.909057364501953,20.6683676171875,15.740627364501954,22.499957617187498,17.999967364501956,22.499957617187498Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g><path d=\"M20.45456119140625,18.408895703125Q20.45456119140625,18.529475703125,20.44274119140625,18.649475703125Q20.43092119140625,18.769485703125,20.40740119140625,18.887745703125Q20.38387119140625,19.006015703125,20.34887119140625,19.121405703125Q20.31386119140625,19.236795703125,20.26772119140625,19.348205703125Q20.221571191406248,19.459605703125,20.16473119140625,19.565955703125Q20.10789119140625,19.672305703125,20.04089119140625,19.772565703125Q19.97390119140625,19.872825703125,19.89740119140625,19.966035703125Q19.82091119140625,20.059255703125,19.735641191406252,20.144515703125002Q19.65038119140625,20.229785703125,19.55716119140625,20.306275703125Q19.46395119140625,20.382775703125,19.36369119140625,20.449775703125Q19.26343119140625,20.516765703125,19.15708119140625,20.573605703125Q19.05073119140625,20.630445703124998,18.93933119140625,20.676595703125Q18.82792119140625,20.722735703125,18.71253119140625,20.757745703125Q18.59714119140625,20.792745703125,18.47887119140625,20.816275703125Q18.36061119140625,20.839795703125,18.24060119140625,20.851615703125Q18.12060119140625,20.863435703125,18.00002119140625,20.863435703125Q17.87943119140625,20.863435703125,17.75943119140625,20.851615703125Q17.63942119140625,20.839795703125,17.52116119140625,20.816275703125Q17.40289119140625,20.792745703125,17.28750119140625,20.757745703125Q17.172111191406252,20.722735703125,17.06070119140625,20.676595703125Q16.94930119140625,20.630445703124998,16.84295119140625,20.573605703125Q16.73660119140625,20.516765703125,16.63634119140625,20.449765703125Q16.53608219140625,20.382775703125,16.44286919140625,20.306275703125Q16.34965719140625,20.229785703125,16.26439119140625,20.144515703125002Q16.17912519140625,20.059255703125,16.10262719140625,19.966035703125Q16.02612919140625,19.872825703125,15.95913619140625,19.772565703125Q15.89214419140625,19.672305703125,15.83530119140625,19.565955703125Q15.77845819140625,19.459605703125,15.73231219140625,19.348205703125Q15.68616719140625,19.236795703125,15.65116319140625,19.121405703125Q15.61615939140625,19.006015703125,15.59263459140625,18.887745703125Q15.56910979140625,18.769485703125,15.55729049140625,18.649475703125Q15.54547119140625,18.529475703125,15.54547119140625,18.408895703125Q15.54547119140625,18.288305703125,15.55729049140625,18.168305703125Q15.56910979140625,18.048295703125,15.59263459140625,17.930035703125Q15.61615939140625,17.811765703125,15.65116319140625,17.696375703125Q15.68616719140625,17.580985703125002,15.73231219140625,17.469575703125Q15.77845819140625,17.358175703125,15.83530119140625,17.251825703125Q15.89214419140625,17.145475703125,15.95913619140625,17.045215703125Q16.02612919140625,16.944956703125,16.10262719140625,16.851743703125Q16.17912519140625,16.758531703125,16.26439119140625,16.673265703125Q16.34965719140625,16.587999703125,16.44286919140625,16.511501703125Q16.53608219140625,16.435003703125,16.63634119140625,16.368010703125Q16.73661119140625,16.301018703125,16.84295119140625,16.244175703125Q16.94930119140625,16.187332703125,17.06070119140625,16.141186703125Q17.172111191406252,16.095041703125,17.28750119140625,16.060037703125Q17.40289119140625,16.025033903125,17.52116119140625,16.001509103125Q17.63942119140625,15.977984303125,17.75943119140625,15.966165003125Q17.87943119140625,15.954345703125,18.00002119140625,15.954345703125Q18.12060119140625,15.954345703125,18.24060119140625,15.966165003125Q18.36061119140625,15.977984303125,18.47887119140625,16.001509103125Q18.59714119140625,16.025033903125,18.71253119140625,16.060037703125Q18.82792119140625,16.095041703125,18.93933119140625,16.141186703125Q19.05073119140625,16.187332703125,19.15708119140625,16.244175703125Q19.26343119140625,16.301018703125,19.36369119140625,16.368010703125Q19.46395119140625,16.435003703125,19.55716119140625,16.511501703125Q19.65038119140625,16.587999703125,19.735641191406252,16.673265703125Q19.82091119140625,16.758531703125,19.89740119140625,16.851743703125Q19.97390119140625,16.944956703125,20.04090119140625,17.045215703125Q20.10789119140625,17.145485703125,20.16473119140625,17.251825703125Q20.221571191406248,17.358175703125,20.26772119140625,17.469575703125Q20.31386119140625,17.580985703125002,20.34887119140625,17.696375703125Q20.38387119140625,17.811765703125,20.40740119140625,17.930035703125Q20.43092119140625,18.048295703125,20.44274119140625,18.168305703125Q20.45456119140625,18.288305703125,20.45456119140625,18.408895703125Z\" fill=\"#FFFFFF\" fill-opacity=\"0.699999988079071\"></path></g></g></g></svg>"

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\"><defs><clipPath id=\"master_svg0_18_4454\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\"></rect></clipPath><clipPath id=\"master_svg1_18_4454/1_26597\"><rect x=\"7.5\" y=\"11.25\" width=\"9\" height=\"9\" rx=\"1.0555554628372192\"></rect></clipPath><clipPath id=\"master_svg2_18_4454/1_26591\"><rect x=\"19.5\" y=\"15.75\" width=\"9\" height=\"9\" rx=\"1.0555554628372192\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_18_4454)\"><rect x=\"0\" y=\"0\" width=\"36\" height=\"36\" rx=\"8\" fill=\"#6F99F8\" fill-opacity=\"1\"></rect><g><g transform=\"matrix(-1,0,0,1,51,0)\"><path d=\"M25.851472,12.398530000000001L29.70711,8.542893C29.89464,8.355357,30.149,8.25,30.41421,8.25L39.3,8.25C39.9627,8.25,40.5,8.787258,40.5,9.45L40.5,13.25L40.5,26.55C40.5,27.2127,39.9627,27.75,39.3,27.75L26.7,27.75C26.037258,27.75,25.5,27.2127,25.5,26.55L25.5,13.247060000000001C25.5,12.928799999999999,25.626428,12.62357,25.851472,12.398530000000001\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g clip-path=\"url(#master_svg1_18_4454/1_26597)\"><rect x=\"7.5\" y=\"11.25\" width=\"9\" height=\"9\" rx=\"1.0555554628372192\" fill=\"#2672FF\" fill-opacity=\"1\"></rect><g><path d=\"M8.83331298828125,13.37493896484375L9.71984498828125,13.37493896484375L10.61981298828125,16.98732896484375L10.64667298828125,16.98732896484375L11.59365298828125,13.37493896484375L12.40630298828125,13.37493896484375L13.35328298828125,16.98732896484375L13.38015298828125,16.98732896484375L14.28011298828125,13.37493896484375L15.16664298828125,13.37493896484375L13.78312298828125,18.12493896484375L12.95031298828125,18.12493896484375L12.01677298828125,14.55245896484375L11.98990298828125,14.55245896484375L11.04964298828125,18.12493896484375L10.21012298828125,18.12493896484375L8.83331298828125,13.37493896484375Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g></g><g clip-path=\"url(#master_svg2_18_4454/1_26591)\"><rect x=\"19.5\" y=\"15.75\" width=\"9\" height=\"9\" rx=\"1.0555554628372192\" fill=\"#00BF6F\" fill-opacity=\"1\"></rect><g><path d=\"M21.50344,17.625L22.65138,17.625L24,19.47794L25.34862,17.625L26.49656,17.625L24.56193,20.16176L26.625,22.875L25.47706,22.875L24,20.84559L22.52294,22.875L21.375,22.875L23.42202,20.16176L21.50344,17.625Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g></g></g></g></svg>"

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><defs><clipPath id=\"master_svg0_3_16811\"><rect x=\"0\" y=\"0\" width=\"14\" height=\"14\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_3_16811)\"><g transform=\"matrix(0,-1,1,0,-5.000158309936523,15.999902725219727)\"><path d=\"M5.685418207641602,11.555760517578126C5.438002807641602,11.314272517578125,5.438002807641602,10.917784517578125,5.685418207641602,10.676294517578125C5.926247207641602,10.441232517578126,6.311906207641601,10.441232517578126,6.5527322076416015,10.676294517578125L8.999872207641602,13.064830517578125L11.447012207641603,10.676294517578125C11.687842207641602,10.441232517578126,12.073492207641602,10.441232517578126,12.314322207641602,10.676294517578125C12.5617422076416,10.917784517578125,12.5617422076416,11.314272517578125,12.314322207641602,11.555760517578126L9.478472207641602,14.323700517578125C9.346532207641602,14.452480517578124,9.171122207641602,14.510710517578126,8.999872207641602,14.498380517578125C8.828622207641601,14.510710517578126,8.653212207641602,14.452480517578124,8.521272207641601,14.323700517578125L5.685418207641602,11.555760517578126Z\" fill-rule=\"evenodd\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"52\" height=\"24\" viewBox=\"0 0 52 24\"><defs><clipPath id=\"master_svg0_18_6807\"><rect x=\"0\" y=\"0\" width=\"24\" height=\"24\" rx=\"0\"></rect></clipPath></defs><g><g clip-path=\"url(#master_svg0_18_6807)\"><g><path d=\"M14,6C14,5.447715,13.55228,5,13,5L11,5C10.44772,5,10,5.447715,10,6L10,8L7,8C6.447715,8,6,8.44772,6,9C6,9.55228,6.447715,10,7,10L17,10C17.552300000000002,10,18,9.55228,18,9C18,8.44772,17.552300000000002,8,17,8L14,8L14,6ZM17.1095,11.875969999999999C17.0469,11.37554,16.621499999999997,11,16.1172,11L7.88278,11C7.3784600000000005,11,6.953058,11.37554,6.890504,11.875969999999999L6.140504,17.875999999999998C6.135361,17.917099999999998,6.132782,17.9585,6.132782,18C6.132782,18.552300000000002,6.580497,19,7.13278,19L16.9294,18.9981L16.991300000000003,18.9923C17.5393,18.9238,17.928,18.424,17.8595,17.875999999999998L17.1095,11.875969999999999ZM10.1,15C10.431370000000001,15,10.7,15.2015,10.7,15.45L10.7,17.5C10.69966,17.5,10.69937,17.5031,10.69884,17.5088C10.69262,17.575499999999998,10.65301,17.9999,10.1,17.9999C9.548490000000001,17.9999,9.50759,17.575,9.50121,17.508699999999997C9.50065,17.5028,9.500350000000001,17.4998,9.5,17.5L9.5,15.45C9.5,15.2015,9.76863,15,10.1,15ZM14.49999,15.45C14.49999,15.2015,14.23136,15,13.899989999999999,15C13.56862,15,13.299990000000001,15.2015,13.299990000000001,15.45L13.299990000000001,17.5Q13.299990000000001,18,13.899989999999999,18Q14.49998,18,14.49998,17.5L14.49999,15.45Z\" fill-rule=\"evenodd\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g></g><g><path d=\"M25.96,5.744L25.246,6.444C26.142,7.088,26.842,7.69,27.36,8.264L28.073999999999998,7.55C27.5,6.948,26.8,6.346,25.96,5.744ZM25.526,9.104L24.798000000000002,9.804C25.764,10.532,26.52,11.232,27.052,11.876L27.78,11.162C27.164,10.476,26.422,9.79,25.526,9.104ZM26.912,12.996C26.38,14.648,25.736,16.258,24.994,17.826L25.918,18.232C26.618,16.706,27.234,15.082,27.794,13.346L26.912,12.996ZM32.26,5.561999999999999L32.26,6.444L28.634,6.444L28.634,7.284L32.26,7.284L32.26,8.208L29.208,8.208L29.208,9.02L32.26,9.02L32.26,9.972000000000001L28.186,9.972000000000001L28.186,10.812L37.356,10.812L37.356,9.972000000000001L33.24,9.972000000000001L33.24,9.02L36.432,9.02L36.432,8.208L33.24,8.208L33.24,7.284L36.964,7.284L36.964,6.444L33.24,6.444L33.24,5.561999999999999L32.26,5.561999999999999ZM30.412,14.368L35.13,14.368L35.13,15.362L30.412,15.362L30.412,14.368ZM35.13,13.584L30.412,13.584L30.412,12.548L35.13,12.548L35.13,13.584ZM30.412,16.131999999999998L35.13,16.131999999999998L35.13,16.958C35.13,17.294,34.976,17.462,34.696,17.462L33.394,17.42L33.646,18.316L34.99,18.316C35.732,18.316,36.11,17.924,36.11,17.168L36.11,11.722L29.46,11.722L29.46,18.4L30.412,18.4L30.412,16.131999999999998ZM40.212,12.702L40.212,13.654L44.482,13.654L44.482,16.972L39.036,16.972L39.036,17.938000000000002L50.978,17.938000000000002L50.978,16.972L45.504000000000005,16.972L45.504000000000005,13.654L49.802,13.654L49.802,12.702L40.212,12.702ZM46.302,8.768L45.769999999999996,9.565999999999999C47.128,10.182,48.458,11.022,49.745999999999995,12.086L50.32,11.232C49.116,10.266,47.772,9.440000000000001,46.302,8.768ZM43.376000000000005,8.866C42.354,9.804,41.066,10.56,39.498,11.134L39.932,12.058C41.556,11.4,42.914,10.574,44.006,9.594000000000001L43.376000000000005,8.866ZM45.056,5.478L43.964,5.646C44.174,6.038,44.370000000000005,6.472,44.552,6.948L39.064,6.948L39.064,9.748000000000001L40.086,9.748000000000001L40.086,7.886L49.928,7.886L49.928,9.762L50.95,9.762L50.95,6.948L45.588,6.948C45.42,6.402,45.238,5.912,45.056,5.478Z\" fill=\"#999999\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"8\" height=\"8\" viewBox=\"0 0 8 8\"><polygon fill=\"#AAA\" points=\"7.018 8 8 7.018 4.99 3.992 8 .982 7.018 0 4.008 3.01 .982 0 0 .982 3.026 3.992 0 7.018 .982 8 4.008 4.974\"></polygon></svg>"

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><defs><clipPath id=\"master_svg0_18_6603\"><rect x=\"0\" y=\"0\" width=\"24\" height=\"24\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_18_6603)\"><g><path d=\"M24,12Q24,12.2946,23.9855,12.5888Q23.9711,12.883,23.9422,13.1762Q23.9133,13.4694,23.8701,13.7608Q23.8269,14.0522,23.7694,14.3411Q23.712,14.63,23.6404,14.9158Q23.5688,15.2015,23.4833,15.4834Q23.3978,15.7653,23.2985,16.0427Q23.1993,16.32,23.0866,16.5922Q22.9738,16.8644,22.8479,17.1307Q22.7219,17.397,22.5831,17.6568Q22.4442,17.9166,22.2927,18.1692Q22.1413,18.4219,21.9776,18.6668Q21.814,18.9118,21.6385,19.1484Q21.463,19.385,21.2761,19.6127Q21.0892,19.8404,20.8914,20.0587Q20.6936,20.277,20.4853,20.4853Q20.277,20.6936,20.0587,20.8914Q19.8404,21.0892,19.6127,21.2761Q19.385,21.463,19.1484,21.6385Q18.9118,21.814,18.6668,21.9776Q18.4219,22.1413,18.1692,22.2927Q17.9166,22.4442,17.6568,22.5831Q17.397,22.7219,17.1307,22.8479Q16.8644,22.9738,16.5922,23.0866Q16.32,23.1993,16.0427,23.2985Q15.7653,23.3978,15.4834,23.4833Q15.2015,23.5688,14.9158,23.6404Q14.63,23.712,14.3411,23.7694Q14.0522,23.8269,13.7608,23.8701Q13.4694,23.9133,13.1762,23.9422Q12.883,23.9711,12.5888,23.9855Q12.2946,24,12,24Q11.7054,24,11.4112,23.9855Q11.117,23.9711,10.8238,23.9422Q10.5306,23.9133,10.2392,23.8701Q9.94784,23.8269,9.65892,23.7694Q9.36999,23.712,9.08424,23.6404Q8.79848,23.5688,8.51658,23.4833Q8.23468,23.3978,7.95732,23.2985Q7.67996,23.1993,7.4078,23.0866Q7.13564,22.9738,6.86934,22.8479Q6.60304,22.7219,6.34324,22.5831Q6.08344,22.4442,5.83077,22.2927Q5.57809,22.1413,5.33316,21.9776Q5.08822,21.814,4.85161,21.6385Q4.615,21.463,4.38728,21.2761Q4.15956,21.0892,3.94129,20.8914Q3.72302,20.6936,3.51472,20.4853Q3.30642,20.277,3.10859,20.0587Q2.91076,19.8404,2.72387,19.6127Q2.53699,19.385,2.36151,19.1484Q2.18603,18.9118,2.02236,18.6668Q1.8587,18.4219,1.70726,18.1692Q1.55581,17.9166,1.41694,17.6568Q1.27808,17.397,1.15213,17.1307Q1.02618,16.8644,0.913446,16.5922Q0.800713,16.32,0.701471,16.0427Q0.602229,15.7653,0.516716,15.4834Q0.431203,15.2015,0.359625,14.9158Q0.288047,14.63,0.230577,14.3411Q0.173106,14.0522,0.129882,13.7608Q0.0866575,13.4694,0.0577833,13.1762Q0.028909,12.883,0.0144545,12.5888Q0,12.2946,0,12Q0,11.7054,0.0144545,11.4112Q0.028909,11.117,0.0577833,10.8238Q0.0866575,10.5306,0.129882,10.2392Q0.173106,9.94784,0.230577,9.65892Q0.288047,9.36999,0.359625,9.08424Q0.431203,8.79848,0.516716,8.51658Q0.602229,8.23468,0.701471,7.95732Q0.800713,7.67996,0.913446,7.4078Q1.02618,7.13564,1.15213,6.86934Q1.27808,6.60304,1.41694,6.34324Q1.55581,6.08344,1.70726,5.83077Q1.8587,5.57809,2.02236,5.33316Q2.18603,5.08822,2.36151,4.85161Q2.53699,4.615,2.72387,4.38728Q2.91076,4.15956,3.10859,3.94129Q3.30642,3.72302,3.51472,3.51472Q3.72302,3.30642,3.94129,3.10859Q4.15956,2.91076,4.38728,2.72387Q4.615,2.53699,4.85161,2.36151Q5.08822,2.18603,5.33316,2.02236Q5.57809,1.8587,5.83077,1.70726Q6.08344,1.55581,6.34324,1.41694Q6.60304,1.27808,6.86934,1.15213Q7.13564,1.02618,7.4078,0.913446Q7.67996,0.800713,7.95732,0.701471Q8.23468,0.602229,8.51658,0.516716Q8.79848,0.431203,9.08424,0.359625Q9.36999,0.288047,9.65892,0.230577Q9.94784,0.173106,10.2392,0.129882Q10.5306,0.0866575,10.8238,0.0577833Q11.117,0.028909,11.4112,0.0144545Q11.7054,0,12,0Q12.2946,0,12.5888,0.0144545Q12.883,0.028909,13.1762,0.0577833Q13.4694,0.0866575,13.7608,0.129882Q14.0522,0.173106,14.3411,0.230577Q14.63,0.288047,14.9158,0.359625Q15.2015,0.431203,15.4834,0.516716Q15.7653,0.602229,16.0427,0.701471Q16.32,0.800713,16.5922,0.913446Q16.8644,1.02618,17.1307,1.15213Q17.397,1.27808,17.6568,1.41694Q17.9166,1.55581,18.1692,1.70726Q18.4219,1.8587,18.6668,2.02236Q18.9118,2.18603,19.1484,2.36151Q19.385,2.53699,19.6127,2.72387Q19.8404,2.91076,20.0587,3.10859Q20.277,3.30642,20.4853,3.51472Q20.6936,3.72302,20.8914,3.94129Q21.0892,4.15956,21.2761,4.38728Q21.463,4.615,21.6385,4.85161Q21.814,5.08822,21.9776,5.33316Q22.1413,5.57809,22.2927,5.83077Q22.4442,6.08344,22.5831,6.34324Q22.7219,6.60304,22.8479,6.86934Q22.9738,7.13564,23.0866,7.4078Q23.1993,7.67996,23.2985,7.95732Q23.3978,8.23468,23.4833,8.51658Q23.5688,8.79848,23.6404,9.08424Q23.712,9.36999,23.7694,9.65892Q23.8269,9.94784,23.8701,10.2392Q23.9133,10.5306,23.9422,10.8238Q23.9711,11.117,23.9855,11.4112Q24,11.7054,24,12Z\" fill=\"#F5F6FA\" fill-opacity=\"1\"></path><path d=\"M24,12Q24,12.2946,23.9855,12.5888Q23.9711,12.883,23.9422,13.1762Q23.9133,13.4694,23.8701,13.7608Q23.8269,14.0522,23.7694,14.3411Q23.712,14.63,23.6404,14.9158Q23.5688,15.2015,23.4833,15.4834Q23.3978,15.7653,23.2985,16.0427Q23.1993,16.32,23.0866,16.5922Q22.9738,16.8644,22.8479,17.1307Q22.7219,17.397,22.5831,17.6568Q22.4442,17.9166,22.2927,18.1692Q22.1413,18.4219,21.9776,18.6668Q21.814,18.9118,21.6385,19.1484Q21.463,19.385,21.2761,19.6127Q21.0892,19.8404,20.8914,20.0587Q20.6936,20.277,20.4853,20.4853Q20.277,20.6936,20.0587,20.8914Q19.8404,21.0892,19.6127,21.2761Q19.385,21.463,19.1484,21.6385Q18.9118,21.814,18.6668,21.9776Q18.4219,22.1413,18.1692,22.2927Q17.9166,22.4442,17.6568,22.5831Q17.397,22.7219,17.1307,22.8479Q16.8644,22.9738,16.5922,23.0866Q16.32,23.1993,16.0427,23.2985Q15.7653,23.3978,15.4834,23.4833Q15.2015,23.5688,14.9158,23.6404Q14.63,23.712,14.3411,23.7694Q14.0522,23.8269,13.7608,23.8701Q13.4694,23.9133,13.1762,23.9422Q12.883,23.9711,12.5888,23.9855Q12.2946,24,12,24Q11.7054,24,11.4112,23.9855Q11.117,23.9711,10.8238,23.9422Q10.5306,23.9133,10.2392,23.8701Q9.94784,23.8269,9.65892,23.7694Q9.36999,23.712,9.08424,23.6404Q8.79848,23.5688,8.51658,23.4833Q8.23468,23.3978,7.95732,23.2985Q7.67996,23.1993,7.4078,23.0866Q7.13564,22.9738,6.86934,22.8479Q6.60304,22.7219,6.34324,22.5831Q6.08344,22.4442,5.83077,22.2927Q5.57809,22.1413,5.33316,21.9776Q5.08822,21.814,4.85161,21.6385Q4.615,21.463,4.38728,21.2761Q4.15956,21.0892,3.94129,20.8914Q3.72302,20.6936,3.51472,20.4853Q3.30642,20.277,3.10859,20.0587Q2.91076,19.8404,2.72387,19.6127Q2.53699,19.385,2.36151,19.1484Q2.18603,18.9118,2.02236,18.6668Q1.8587,18.4219,1.70726,18.1692Q1.55581,17.9166,1.41694,17.6568Q1.27808,17.397,1.15213,17.1307Q1.02618,16.8644,0.913446,16.5922Q0.800713,16.32,0.701471,16.0427Q0.602229,15.7653,0.516716,15.4834Q0.431203,15.2015,0.359625,14.9158Q0.288047,14.63,0.230577,14.3411Q0.173106,14.0522,0.129882,13.7608Q0.0866575,13.4694,0.0577833,13.1762Q0.028909,12.883,0.0144545,12.5888Q0,12.2946,0,12Q0,11.7054,0.0144545,11.4112Q0.028909,11.117,0.0577833,10.8238Q0.0866575,10.5306,0.129882,10.2392Q0.173106,9.94784,0.230577,9.65892Q0.288047,9.36999,0.359625,9.08424Q0.431203,8.79848,0.516716,8.51658Q0.602229,8.23468,0.701471,7.95732Q0.800713,7.67996,0.913446,7.4078Q1.02618,7.13564,1.15213,6.86934Q1.27808,6.60304,1.41694,6.34324Q1.55581,6.08344,1.70726,5.83077Q1.8587,5.57809,2.02236,5.33316Q2.18603,5.08822,2.36151,4.85161Q2.53699,4.615,2.72387,4.38728Q2.91076,4.15956,3.10859,3.94129Q3.30642,3.72302,3.51472,3.51472Q3.72302,3.30642,3.94129,3.10859Q4.15956,2.91076,4.38728,2.72387Q4.615,2.53699,4.85161,2.36151Q5.08822,2.18603,5.33316,2.02236Q5.57809,1.8587,5.83077,1.70726Q6.08344,1.55581,6.34324,1.41694Q6.60304,1.27808,6.86934,1.15213Q7.13564,1.02618,7.4078,0.913446Q7.67996,0.800713,7.95732,0.701471Q8.23468,0.602229,8.51658,0.516716Q8.79848,0.431203,9.08424,0.359625Q9.36999,0.288047,9.65892,0.230577Q9.94784,0.173106,10.2392,0.129882Q10.5306,0.0866575,10.8238,0.0577833Q11.117,0.028909,11.4112,0.0144545Q11.7054,0,12,0Q12.2946,0,12.5888,0.0144545Q12.883,0.028909,13.1762,0.0577833Q13.4694,0.0866575,13.7608,0.129882Q14.0522,0.173106,14.3411,0.230577Q14.63,0.288047,14.9158,0.359625Q15.2015,0.431203,15.4834,0.516716Q15.7653,0.602229,16.0427,0.701471Q16.32,0.800713,16.5922,0.913446Q16.8644,1.02618,17.1307,1.15213Q17.397,1.27808,17.6568,1.41694Q17.9166,1.55581,18.1692,1.70726Q18.4219,1.8587,18.6668,2.02236Q18.9118,2.18603,19.1484,2.36151Q19.385,2.53699,19.6127,2.72387Q19.8404,2.91076,20.0587,3.10859Q20.277,3.30642,20.4853,3.51472Q20.6936,3.72302,20.8914,3.94129Q21.0892,4.15956,21.2761,4.38728Q21.463,4.615,21.6385,4.85161Q21.814,5.08822,21.9776,5.33316Q22.1413,5.57809,22.2927,5.83077Q22.4442,6.08344,22.5831,6.34324Q22.7219,6.60304,22.8479,6.86934Q22.9738,7.13564,23.0866,7.4078Q23.1993,7.67996,23.2985,7.95732Q23.3978,8.23468,23.4833,8.51658Q23.5688,8.79848,23.6404,9.08424Q23.712,9.36999,23.7694,9.65892Q23.8269,9.94784,23.8701,10.2392Q23.9133,10.5306,23.9422,10.8238Q23.9711,11.117,23.9855,11.4112Q24,11.7054,24,12Z\" fill=\"#E5E7F1\" fill-opacity=\"0.3499999940395355\"></path></g><g transform=\"matrix(1,0,0,-1,0,28.764892578125)\"><path d=\"M8.32422028125,15.9039862890625C7.97614428125,15.5559062890625,7.97614438125,14.9915682890625,8.32422028125,14.6434922890625C8.67229628125,14.2954159890625,9.23663828125,14.2954159890625,9.58471828125,14.6434922890625L12.00048828125,17.0592662890625L14.41625828125,14.6434922890625C14.76433828125,14.2954159890625,15.32867828125,14.2954159890625,15.676758281249999,14.6434922890625C16.02482828125,14.9915682890625,16.02482828125,15.5559062890625,15.676758281249999,15.9039862890625L12.69460828125,18.8861362890625C12.50431828125,19.0764262890625,12.249388281249999,19.1626862890625,12.00048828125,19.1449162890625C11.751588281250001,19.1626862890625,11.49665828125,19.0764262890625,11.30636828125,18.8861362890625L8.32422028125,15.9039862890625Z\" fill-rule=\"evenodd\" fill=\"#333333\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><g><g><path d=\"M12.14802,2L16.7143,6.57657L16.7143,16.857100000000003C16.7143,17.488300000000002,16.2026,18,15.5714,18L4.14286,18C3.511675,18,3,17.488300000000002,3,16.857100000000003L3,3.1428599999999998C3,2.511675,3.511675,2,4.14286,2L12.14802,2ZM12.37143,4.16535L14.7718,6.57153L12.37143,6.57153L12.37143,4.16535ZM11,3.37134L11,7.02857Q11,7.08614,11.0096,7.14291Q11,7.19968,11,7.25725Q11,7.32478,11.01318,7.39102Q11.02635,7.45726,11.0522,7.51966Q11.07804,7.58206,11.11556,7.63821Q11.15308,7.69436,11.20084,7.74212Q11.2486,7.78988,11.30475,7.8274Q11.36091,7.86492,11.4233,7.89076Q11.4857,7.91661,11.55194,7.92979Q11.61818,7.94296,11.68571,7.94296L15.3428,7.94296L15.3428,16.628500000000003L4.37134,16.628500000000003L4.37134,3.37134L11,3.37134Z\" fill-rule=\"evenodd\" fill=\"#333333\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><defs><clipPath id=\"master_svg0_248_45569\"><rect x=\"0\" y=\"0\" width=\"24\" height=\"24\" rx=\"0\"></rect></clipPath></defs><g clip-path=\"url(#master_svg0_248_45569)\"><g><path d=\"M12,19Q12.17184,19,12.34347,18.9916Q12.51511,18.9831,12.686119999999999,18.9663Q12.85713,18.9494,13.02711,18.9242Q13.19709,18.899,13.36563,18.8655Q13.53417,18.832,13.70086,18.7902Q13.86755,18.7485,14.03199,18.6986Q14.19643,18.648699999999998,14.35823,18.5908Q14.52002,18.532899999999998,14.67878,18.4672Q14.83754,18.401400000000002,14.99288,18.3279Q15.1482,18.2545,15.2998,18.1734Q15.4513,18.092399999999998,15.5987,18.0041Q15.7461,17.9158,15.889,17.8203Q16.0319,17.724800000000002,16.1699,17.622500000000002Q16.3079,17.5201,16.4408,17.411099999999998Q16.5736,17.3021,16.7009,17.186700000000002Q16.828200000000002,17.0713,16.9497,16.9497Q17.0713,16.828200000000002,17.186700000000002,16.7009Q17.3021,16.5736,17.411099999999998,16.4408Q17.5201,16.3079,17.622500000000002,16.1699Q17.724800000000002,16.0319,17.8203,15.889Q17.9158,15.7461,18.0041,15.5987Q18.092399999999998,15.4513,18.1734,15.2998Q18.2545,15.1482,18.3279,14.99288Q18.401400000000002,14.83754,18.4672,14.67878Q18.532899999999998,14.52002,18.5908,14.35823Q18.648699999999998,14.19643,18.6986,14.03199Q18.7485,13.86755,18.7902,13.70086Q18.832,13.53417,18.8655,13.36563Q18.899,13.19709,18.9242,13.02711Q18.9494,12.85713,18.9663,12.686119999999999Q18.9831,12.51511,18.9916,12.34347Q19,12.17184,19,12Q19,11.82816,18.9916,11.65653Q18.9831,11.48489,18.9663,11.313880000000001Q18.9494,11.14287,18.9242,10.97289Q18.899,10.80291,18.8655,10.63437Q18.832,10.46583,18.7902,10.299140000000001Q18.7485,10.13245,18.6986,9.96801Q18.648699999999998,9.80357,18.5908,9.641770000000001Q18.532899999999998,9.479980000000001,18.4672,9.32122Q18.401400000000002,9.16246,18.3279,9.00711Q18.2545,8.85177,18.1734,8.70022Q18.092399999999998,8.54867,18.0041,8.40128Q17.9158,8.25389,17.8203,8.11101Q17.724800000000002,7.96813,17.622500000000002,7.8301Q17.5201,7.69208,17.411099999999998,7.5592500000000005Q17.3021,7.426410000000001,17.186700000000002,7.29909Q17.0713,7.17176,16.9497,7.05025Q16.828200000000002,6.9287399999999995,16.7009,6.81334Q16.5736,6.69794,16.4408,6.5889299999999995Q16.3079,6.47991,16.1699,6.37755Q16.0319,6.27518,15.889,6.17971Q15.7461,6.08424,15.5987,5.9959Q15.4513,5.907556,15.2998,5.826551Q15.1482,5.745546,14.99288,5.6720749999999995Q14.83754,5.598604,14.67878,5.532843Q14.52002,5.467083,14.35823,5.409191Q14.19643,5.3513,14.03199,5.301418Q13.86755,5.251535,13.70086,5.2097809999999996Q13.53417,5.168027,13.36563,5.134503Q13.19709,5.100979,13.02711,5.0757644Q12.85713,5.0505502,12.686119999999999,5.0337069Q12.51511,5.0168636,12.34347,5.0084318Q12.17184,5,12,5Q11.82816,5,11.65653,5.0084318Q11.48489,5.0168636,11.313880000000001,5.0337069Q11.14287,5.0505502,10.97289,5.0757644Q10.80291,5.100979,10.63437,5.134503Q10.46583,5.168027,10.299140000000001,5.2097809999999996Q10.13245,5.251535,9.96801,5.301418Q9.80357,5.3513,9.641770000000001,5.409191Q9.479980000000001,5.467083,9.32122,5.532843Q9.16246,5.598604,9.00711,5.6720749999999995Q8.85177,5.745546,8.70022,5.826551Q8.54867,5.907556,8.40128,5.995899Q8.25389,6.08424,8.11101,6.17971Q7.96813,6.27518,7.8301,6.37755Q7.69208,6.47991,7.5592500000000005,6.5889299999999995Q7.426410000000001,6.69794,7.29909,6.81334Q7.17176,6.9287399999999995,7.05025,7.05025Q6.9287399999999995,7.17176,6.81334,7.29909Q6.69794,7.426410000000001,6.5889299999999995,7.5592500000000005Q6.47991,7.69208,6.37755,7.8301Q6.27518,7.96813,6.17971,8.11101Q6.08424,8.25389,5.9959,8.40128Q5.907556,8.54867,5.826551,8.70022Q5.745546,8.85177,5.6720749999999995,9.00711Q5.598604,9.16246,5.532843,9.32122Q5.467083,9.479980000000001,5.409191,9.641770000000001Q5.3513,9.80357,5.301418,9.96801Q5.251535,10.13245,5.2097809999999996,10.299140000000001Q5.168027,10.46583,5.134503,10.63437Q5.100979,10.80291,5.0757644,10.97289Q5.0505502,11.14287,5.0337069,11.313880000000001Q5.0168636,11.48489,5.0084318,11.65653Q5,11.82816,5,12Q5,12.17184,5.0084318,12.34347Q5.0168636,12.51511,5.0337069,12.686119999999999Q5.0505502,12.85713,5.0757644,13.02711Q5.100979,13.19709,5.134503,13.36563Q5.168027,13.53417,5.2097809999999996,13.70086Q5.251535,13.86755,5.301418,14.03199Q5.3513,14.19643,5.409191,14.35823Q5.467083,14.52002,5.532843,14.67878Q5.598604,14.83754,5.6720749999999995,14.99288Q5.745546,15.1482,5.826551,15.2998Q5.907556,15.4513,5.995899,15.5987Q6.08424,15.7461,6.17971,15.889Q6.27518,16.0319,6.37755,16.1699Q6.47991,16.3079,6.5889299999999995,16.4408Q6.69794,16.5736,6.81334,16.7009Q6.9287399999999995,16.828200000000002,7.05025,16.9497Q7.17176,17.0713,7.29909,17.186700000000002Q7.426410000000001,17.3021,7.5592500000000005,17.411099999999998Q7.69208,17.5201,7.8301,17.622500000000002Q7.96813,17.724800000000002,8.11101,17.8203Q8.25389,17.9158,8.40128,18.0041Q8.54867,18.092399999999998,8.70022,18.1734Q8.85177,18.2545,9.00711,18.3279Q9.16246,18.401400000000002,9.32122,18.4672Q9.479980000000001,18.532899999999998,9.641770000000001,18.5908Q9.80357,18.648699999999998,9.96801,18.6986Q10.13245,18.7485,10.299140000000001,18.7902Q10.46583,18.832,10.63437,18.8655Q10.80291,18.899,10.97289,18.9242Q11.14287,18.9494,11.313880000000001,18.9663Q11.48489,18.9831,11.65653,18.9916Q11.82816,19,12,19ZM11.99995,17.8Q12.142330000000001,17.8,12.28454,17.793Q12.42675,17.786,12.56845,17.772Q12.710149999999999,17.7581,12.85099,17.7372Q12.99183,17.7163,13.13147,17.688499999999998Q13.27112,17.6607,13.40924,17.6261Q13.54735,17.5915,13.6836,17.5502Q13.81985,17.5089,13.95391,17.460900000000002Q14.08797,17.4129,14.21951,17.3585Q14.35106,17.304000000000002,14.47977,17.2431Q14.60848,17.1822,14.73405,17.115099999999998Q14.85962,17.048000000000002,14.98174,16.974800000000002Q15.1039,16.901600000000002,15.2223,16.822499999999998Q15.3406,16.7434,15.455,16.6586Q15.5694,16.573700000000002,15.6794,16.4834Q15.7895,16.3931,15.895,16.2975Q16.000500000000002,16.2018,16.1012,16.1012Q16.2018,16.000500000000002,16.2975,15.895Q16.3931,15.7895,16.4834,15.6794Q16.573700000000002,15.5694,16.6586,15.455Q16.7434,15.3406,16.822499999999998,15.2223Q16.901600000000002,15.1039,16.974800000000002,14.98174Q17.048000000000002,14.85962,17.115099999999998,14.73405Q17.1822,14.60848,17.2431,14.47977Q17.304000000000002,14.35106,17.3585,14.21951Q17.4129,14.08797,17.460900000000002,13.95391Q17.5089,13.81985,17.5502,13.6836Q17.5915,13.54735,17.6261,13.40924Q17.6607,13.27112,17.688499999999998,13.13147Q17.7163,12.99183,17.7372,12.85099Q17.7581,12.710149999999999,17.772,12.56845Q17.786,12.42675,17.793,12.28454Q17.8,12.142330000000001,17.8,11.99995Q17.8,11.857569999999999,17.793,11.71536Q17.786,11.57315,17.772,11.43145Q17.7581,11.289760000000001,17.7372,11.14891Q17.7163,11.00807,17.688499999999998,10.86843Q17.6607,10.72878,17.6261,10.59067Q17.5915,10.452549999999999,17.5502,10.3163Q17.5089,10.18005,17.460900000000002,10.04599Q17.4129,9.91193,17.3585,9.78039Q17.304000000000002,9.64884,17.2431,9.52013Q17.1822,9.39142,17.115099999999998,9.26585Q17.048000000000002,9.14028,16.974800000000002,9.01816Q16.901600000000002,8.89603,16.822499999999998,8.77764Q16.7434,8.65926,16.6586,8.54489Q16.573700000000002,8.430530000000001,16.4834,8.32047Q16.3931,8.21041,16.2975,8.10491Q16.2018,7.99941,16.1012,7.8987300000000005Q16.000500000000002,7.79805,15.895,7.70243Q15.7895,7.60682,15.6794,7.51649Q15.5694,7.426159999999999,15.455,7.34135Q15.3406,7.25653,15.2223,7.17743Q15.1039,7.09832,14.98174,7.02513Q14.85962,6.95193,14.73405,6.88481Q14.60848,6.81769,14.47977,6.75681Q14.35106,6.69594,14.21951,6.64145Q14.08797,6.5869599999999995,13.95391,6.539Q13.81985,6.49103,13.6836,6.4497Q13.54735,6.40837,13.40924,6.37377Q13.27112,6.33917,13.13147,6.3114Q12.99183,6.28362,12.85099,6.2627299999999995Q12.710149999999999,6.24184,12.56845,6.22788Q12.42675,6.21392,12.28454,6.2069399999999995Q12.142330000000001,6.19995,11.99995,6.19995Q11.857569999999999,6.19995,11.71536,6.2069399999999995Q11.57315,6.21392,11.43145,6.22788Q11.289760000000001,6.24184,11.14891,6.2627299999999995Q11.00807,6.28362,10.86843,6.3114Q10.72878,6.33917,10.59067,6.37377Q10.452549999999999,6.40837,10.3163,6.4497Q10.18005,6.49103,10.04599,6.539Q9.91193,6.5869599999999995,9.78039,6.64145Q9.64884,6.69594,9.52013,6.75681Q9.39142,6.81769,9.26585,6.88481Q9.14028,6.95193,9.01816,7.02513Q8.89603,7.09832,8.77764,7.17743Q8.65926,7.25653,8.54489,7.34135Q8.430530000000001,7.426159999999999,8.32047,7.51649Q8.21041,7.60682,8.10491,7.70243Q7.99941,7.79805,7.8987300000000005,7.8987300000000005Q7.79805,7.99941,7.70243,8.10491Q7.60682,8.21041,7.51649,8.32047Q7.426159999999999,8.430530000000001,7.34135,8.54489Q7.25653,8.65926,7.17743,8.77764Q7.09832,8.89603,7.02513,9.01816Q6.95193,9.14028,6.88481,9.26585Q6.81769,9.39142,6.75681,9.52013Q6.69594,9.64884,6.64145,9.78039Q6.5869599999999995,9.91193,6.539,10.04599Q6.49103,10.18005,6.4497,10.3163Q6.40837,10.452549999999999,6.37377,10.59067Q6.33917,10.72878,6.3114,10.86843Q6.28362,11.00807,6.2627299999999995,11.14891Q6.24184,11.289760000000001,6.22788,11.43145Q6.21392,11.57315,6.2069399999999995,11.71536Q6.19995,11.857569999999999,6.19995,11.99995Q6.19995,12.142330000000001,6.2069399999999995,12.28454Q6.21392,12.42675,6.22788,12.56845Q6.24184,12.710149999999999,6.2627299999999995,12.85099Q6.28362,12.99183,6.3114,13.13147Q6.33917,13.27112,6.37377,13.40924Q6.40837,13.54735,6.4497,13.6836Q6.49103,13.81985,6.539,13.95391Q6.5869599999999995,14.08797,6.64145,14.21951Q6.69594,14.35106,6.75681,14.47977Q6.81769,14.60848,6.88481,14.73405Q6.95193,14.85962,7.02513,14.98174Q7.09832,15.1039,7.17743,15.2223Q7.25653,15.3406,7.34135,15.455Q7.426159999999999,15.5694,7.51649,15.6794Q7.60682,15.7895,7.70243,15.895Q7.79805,16.000500000000002,7.8987300000000005,16.1012Q7.99941,16.2018,8.10491,16.2975Q8.21041,16.3931,8.32047,16.4834Q8.430530000000001,16.573700000000002,8.54489,16.6586Q8.65926,16.7434,8.77764,16.822499999999998Q8.89603,16.901600000000002,9.01816,16.974800000000002Q9.14028,17.048000000000002,9.26585,17.115099999999998Q9.39142,17.1822,9.52013,17.2431Q9.64884,17.304000000000002,9.78039,17.3585Q9.91193,17.4129,10.04599,17.460900000000002Q10.18005,17.5089,10.3163,17.5502Q10.452549999999999,17.5915,10.59067,17.6261Q10.72878,17.6607,10.86843,17.688499999999998Q11.00807,17.7163,11.14891,17.7372Q11.289760000000001,17.7581,11.43145,17.772Q11.57315,17.786,11.71536,17.793Q11.857569999999999,17.8,11.99995,17.8Z\" fill-rule=\"evenodd\" fill=\"#AAAAAA\" fill-opacity=\"1\"></path></g><g><path d=\"M19,12Q19,11.82816,18.99157,11.65653Q18.98314,11.48489,18.96629,11.313880000000001Q18.94945,11.14287,18.92423,10.97289Q18.89902,10.80291,18.8655,10.63437Q18.83197,10.46583,18.790219999999998,10.299140000000001Q18.74846,10.13245,18.69858,9.96801Q18.648699999999998,9.80357,18.59081,9.641770000000001Q18.53292,9.479980000000001,18.46716,9.32122Q18.4014,9.16246,18.32792,9.00711Q18.25445,8.85177,18.17345,8.70022Q18.09244,8.54867,18.0041,8.40128Q17.91576,8.25389,17.82029,8.11101Q17.72482,7.96813,17.62245,7.8301Q17.52009,7.69208,17.41107,7.5592500000000005Q17.30206,7.426410000000001,17.18666,7.29909Q17.07126,7.17176,16.94975,7.05025Q16.82824,6.9287399999999995,16.70091,6.81334Q16.57359,6.69794,16.44075,6.5889299999999995Q16.30792,6.47991,16.16989,6.37755Q16.031869999999998,6.27518,15.88899,6.17971Q15.74611,6.08424,15.59872,5.9959Q15.45133,5.907556,15.29978,5.826551Q15.14823,5.745546,14.99289,5.6720749999999995Q14.83754,5.598604,14.67878,5.532843Q14.52002,5.467083,14.358229999999999,5.409191Q14.19643,5.3513,14.03199,5.301418Q13.86755,5.251535,13.70086,5.2097809999999996Q13.53417,5.168027,13.36563,5.134503Q13.19709,5.100979,13.02711,5.0757644Q12.857133,5.0505502,12.68612,5.0337069Q12.515107,5.0168636,12.343474,5.0084318Q12.17184,5,12,5L12,6.19995Q12.142381,6.19995,12.284591,6.2069399999999995Q12.426801,6.2139299999999995,12.568496,6.22788Q12.710192,6.24184,12.851032,6.2627299999999995Q12.991872,6.2836300000000005,13.13152,6.3114Q13.27116,6.33918,13.40928,6.37378Q13.54739,6.40838,13.68364,6.44971Q13.819890000000001,6.49104,13.95395,6.53901Q14.08801,6.5869800000000005,14.21955,6.64146Q14.35109,6.69595,14.479800000000001,6.75683Q14.608509999999999,6.8177,14.73408,6.8848199999999995Q14.85965,6.9519400000000005,14.981770000000001,7.02514Q15.1039,7.09834,15.22228,7.17744Q15.34067,7.25655,15.45503,7.34136Q15.56939,7.4261800000000004,15.67945,7.51651Q15.78952,7.60683,15.89501,7.70245Q16.00051,7.79807,16.10119,7.89875Q16.20187,7.99943,16.29748,8.10493Q16.3931,8.21042,16.48343,8.32049Q16.57375,8.43055,16.65857,8.54491Q16.743380000000002,8.65927,16.822490000000002,8.777660000000001Q16.90159,8.89604,16.97479,9.01817Q17.04798,9.14029,17.115099999999998,9.26586Q17.18222,9.39143,17.2431,9.52014Q17.30397,9.64885,17.35846,9.7804Q17.41294,9.911940000000001,17.46091,10.046Q17.50888,10.180060000000001,17.55021,10.31631Q17.591540000000002,10.45256,17.62613,10.59067Q17.66073,10.72879,17.68851,10.86843Q17.71628,11.00808,17.737180000000002,11.14892Q17.75807,11.289760000000001,17.77202,11.43145Q17.785980000000002,11.57315,17.79296,11.71536Q17.79995,11.857569999999999,17.79995,11.99995L17.79995,12L19,12Z\" fill-rule=\"evenodd\" fill=\"#2672FF\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"10\" height=\"2\" viewBox=\"0 0 10 2\"><g><path d=\"M2,1Q2,1.09849,1.98079,1.19509Q1.96157,1.29169,1.92388,1.38268Q1.88619,1.47368,1.83147,1.55557Q1.77675,1.63746,1.70711,1.70711Q1.63746,1.77675,1.55557,1.83147Q1.47368,1.88619,1.38268,1.92388Q1.29169,1.96157,1.19509,1.98079Q1.09849,2,1,2Q0.901509,2,0.80491,1.98079Q0.708311,1.96157,0.617316,1.92388Q0.526322,1.88619,0.44443,1.83147Q0.362537,1.77675,0.292893,1.70711Q0.223249,1.63746,0.16853,1.55557Q0.113811,1.47368,0.0761205,1.38268Q0.0384294,1.29169,0.0192147,1.19509Q0,1.09849,0,1Q0,0.901509,0.0192147,0.80491Q0.0384294,0.708311,0.0761205,0.617316Q0.113811,0.526322,0.16853,0.44443Q0.223249,0.362537,0.292893,0.292893Q0.362537,0.223249,0.44443,0.16853Q0.526322,0.113811,0.617316,0.0761205Q0.708311,0.0384294,0.80491,0.0192147Q0.901509,0,1,0Q1.09849,0,1.19509,0.0192147Q1.29169,0.0384294,1.38268,0.0761205Q1.47368,0.113811,1.55557,0.16853Q1.63746,0.223249,1.70711,0.292893Q1.77675,0.362537,1.83147,0.44443Q1.88619,0.526322,1.92388,0.617316Q1.96157,0.708311,1.98079,0.80491Q2,0.901509,2,1ZM6,1Q6,1.09849,5.98078,1.19509Q5.96157,1.29169,5.92388,1.38268Q5.88619,1.47368,5.83147,1.55557Q5.77675,1.63746,5.70711,1.70711Q5.63746,1.77675,5.55557,1.83147Q5.47368,1.88619,5.38268,1.92388Q5.29169,1.96157,5.19509,1.98079Q5.09849,2,5,2Q4.90151,2,4.80491,1.98079Q4.70831,1.96157,4.61732,1.92388Q4.52632,1.88619,4.44443,1.83147Q4.36254,1.77675,4.29289,1.70711Q4.22325,1.63746,4.16853,1.55557Q4.11381,1.47368,4.07612,1.38268Q4.03843,1.29169,4.01921,1.19509Q4,1.09849,4,1Q4,0.901509,4.01921,0.80491Q4.03843,0.708311,4.07612,0.617316Q4.11381,0.526322,4.16853,0.44443Q4.22325,0.362537,4.29289,0.292893Q4.36254,0.223249,4.44443,0.16853Q4.52632,0.113811,4.61732,0.0761205Q4.70831,0.0384294,4.80491,0.0192147Q4.90151,0,5,0Q5.09849,0,5.19509,0.0192147Q5.29169,0.0384294,5.38268,0.0761205Q5.47368,0.113811,5.55557,0.16853Q5.63746,0.223249,5.70711,0.292893Q5.77675,0.362537,5.83147,0.44443Q5.88619,0.526322,5.92388,0.617316Q5.96157,0.708311,5.98078,0.80491Q6,0.901509,6,1ZM10,1Q10,1.09849,9.98078,1.19509Q9.96157,1.29169,9.92388,1.38268Q9.88619,1.47368,9.83147,1.55557Q9.77675,1.63746,9.70711,1.70711Q9.63746,1.77675,9.55557,1.83147Q9.47368,1.88619,9.38268,1.92388Q9.29169,1.96157,9.19509,1.98079Q9.09849,2,9,2Q8.90151,2,8.80491,1.98079Q8.70831,1.96157,8.61732,1.92388Q8.52632,1.88619,8.44443,1.83147Q8.36254,1.77675,8.29289,1.70711Q8.22325,1.63746,8.16853,1.55557Q8.11381,1.47368,8.07612,1.38268Q8.03843,1.29169,8.01921,1.19509Q8,1.09849,8,1Q8,0.901509,8.01921,0.80491Q8.03843,0.708311,8.07612,0.617316Q8.11381,0.526322,8.16853,0.44443Q8.22325,0.362537,8.29289,0.292893Q8.36254,0.223249,8.44443,0.16853Q8.52632,0.113811,8.61732,0.0761205Q8.70831,0.0384294,8.80491,0.0192147Q8.90151,0,9,0Q9.09849,0,9.19509,0.0192147Q9.29169,0.0384294,9.38268,0.0761205Q9.47368,0.113811,9.55557,0.16853Q9.63746,0.223249,9.70711,0.292893Q9.77675,0.362537,9.83147,0.44443Q9.88619,0.526322,9.92388,0.617316Q9.96157,0.708311,9.98078,0.80491Q10,0.901509,10,1Z\" fill=\"#D8D8D8\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"16.470703125\" height=\"20\" viewBox=\"0 0 16.470703125 20\"><g><g><path d=\"M2.35294,-1.33717e-13L10.1644,-1.33717e-13C10.8105,-1.33717e-13,11.4282,0.265681,11.8725,0.734719L15.8258,4.90759C16.2398,5.34465,16.4706,5.92378,16.4706,6.52582L16.4706,17.6471C16.4706,18.9466,15.4171,20,14.1176,20L2.35294,20C1.05345,20,0,18.9466,0,17.6471L0,2.35294C0,1.05345,1.05345,-1.33717e-13,2.35294,-1.33717e-13Z\" fill-rule=\"evenodd\" fill=\"#E94848\" fill-opacity=\"1\"></path></g><g><path d=\"M6.562211792755127,6.359347927551269C6.559441792755127,5.77749192755127,7.0261117927551275,5.3021122375512695,7.607921792755127,5.2941179275512695C8.189731792755126,5.3021122375512695,8.656391792755127,5.77749192755127,8.653621792755127,6.359347927551269C8.653621792755127,7.0341479275512695,8.330201792755126,7.904767927551269,8.051721792755128,8.77551792755127C8.446331792755128,9.523027927551269,8.958761792755126,10.20210792755127,9.569311792755126,10.78666792755127C10.294001792755127,10.53734792755127,11.242471792755126,10.300337927551269,11.895331792755126,10.300337927551269C12.476671792755127,10.30825792755127,12.943201792755127,10.78283792755127,12.941171792755126,11.36422792755127C12.941171792755126,11.94914792755127,12.469281792755128,12.429457927551269,11.895331792755126,12.429457927551269C11.081961792755127,12.429457927551269,10.092171792755128,12.05855792755127,9.408671792755127,11.49811792755127C8.472381792755126,11.72416792755127,7.500911792755127,12.10229792755127,6.575591792755127,12.473197927551269C6.173121792755127,13.24416792755127,5.721961792755128,14.08803792755127,5.340091792755127,14.55377792755127C5.142461792755127,14.76523792755127,4.864811792755127,14.88353792755127,4.575401792755127,14.87960792755127C4.001323792755127,14.87960792755127,3.529433061155127,14.39807792755127,3.529433061155127,13.81436792755127C3.527600122755127,13.52080792755127,3.644308792755127,13.23891792755127,3.853122792755127,13.03256792755127C4.372095792755127,12.60575792755127,5.236831792755127,12.317507927551269,6.205891792755127,11.930957927551269C6.678851792755127,10.989717927551268,7.048551792755127,9.87579792755127,7.376791792755126,8.83516792755127C6.958531792755127,7.987557927551269,6.562211792755127,7.085247927551269,6.562211792755127,6.359347927551269ZM8.026161792755126,6.35813792755127C8.026161792755126,6.11978592755127,7.842521792755127,5.93252792755127,7.607911792755127,5.93252792755127L7.607911792755127,5.933731927551269C7.373171792755127,5.933731927551269,7.189651792755127,6.11991992755127,7.189651792755127,6.359347927551269C7.189651792755127,6.6937279275512696,7.403661792755127,7.284667927551269,7.663821792755127,7.89994792755127C7.858431792755127,7.2676779275512695,8.026161792755126,6.67781792755127,8.026161792755126,6.35813792755127ZM8.872511792755127,10.982487927551269C8.462651792755127,10.55369792755127,8.099061792755126,10.08295792755127,7.7877517927551265,9.57804792755127L7.7877517927551265,9.57684792755127C7.568791792755127,10.25525792755127,7.337931792755127,10.944767927551268,7.048481792755127,11.607397927551268C7.646771792755127,11.37639792755127,8.252291792755127,11.15503792755127,8.872511792755127,10.982487927551269ZM12.313731792755126,11.36543792755127C12.313731792755126,11.125877927551269,12.130081792755126,10.93982792755127,11.895471792755126,10.93982792755127L11.895341792755127,10.938757927551269C11.503971792755127,10.938757927551269,10.833851792755127,11.09431792755127,10.218581792755128,11.271807927551269C10.754801792755128,11.574637927551269,11.423581792755126,11.791047927551269,11.895341792755127,11.791047927551269C12.130081792755126,11.791047927551269,12.313731792755126,11.60378792755127,12.313731792755126,11.36543792755127ZM4.863301792755127,14.13057792755127C5.067681792755127,13.880047927551269,5.359541792755127,13.38153792755127,5.653801792755127,12.846517927551268C5.046951792755127,13.092097927551269,4.513133792755127,13.32442792755127,4.267557792755127,13.51770792755127C4.196933792755127,13.60049792755127,4.157743792755127,13.705637927551269,4.156940792755127,13.81437792755127C4.154635792755127,13.92666792755127,4.197719792755127,14.03514792755127,4.276444792755127,14.11525792755127C4.355169792755127,14.195367927551269,4.4628797927551265,14.24033792755127,4.575191792755127,14.239987927551269C4.682101792755127,14.244157927551269,4.786111792755127,14.204657927551269,4.863301792755127,14.13057792755127Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g><path d=\"M15.58118585510254,4.25974L12.308265855102539,0.931819C11.838675855102538,0.45438,11.23988085510254,0.129982,10.588235855102539,0L10.588235855102539,3.7352C10.588235855102539,4.92108,11.533623855102539,5.88235,12.69989585510254,5.88235L16.470585855102538,5.88235C16.32802585510254,5.26801,16.020065855102537,4.70616,15.58118585510254,4.25974Z\" fill=\"#000000\" fill-opacity=\"0.10000000149011612\"></path></g></g></svg>"

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><g><g><path d=\"M18,4.28574330078125C18,3.65455830078125,17.488300000000002,3.14288330078125,16.857100000000003,3.14288330078125L3.1428599999999998,3.14288330078125C2.511675,3.14288330078125,2,3.65455830078125,2,4.28574330078125L2,15.71428330078125C2,16.34548330078125,2.511675,16.85718330078125,3.1428599999999998,16.85718330078125L16.857100000000003,16.85718330078125C17.488300000000002,16.85718330078125,18,16.34548330078125,18,15.71428330078125L18,4.28574330078125ZM3.3714399999999998,4.51431330078125L16.6286,4.51431330078125L16.6286,15.48578330078125L3.3714399999999998,15.48578330078125L3.3714399999999998,14.13368330078125L5.85134,12.36230330078125L7.26812,13.77908330078125C7.47924,13.99028330078125,7.81734,14.00328330078125,8.04405,13.80898330078125L11.78277,10.60459330078125L16.628500000000003,14.12688330078125L16.628500000000003,12.43151330078125L12.4443,9.389443300781249C12.0163,9.07824330078125,11.43056,9.10161330078125,11.02867,9.44594330078125L7.71418,12.28573330078125L6.68448,11.25602330078125C6.28944,10.86098330078125,5.66669,10.80944330078125,5.21208,11.13416330078125L3.3714399999999998,12.44891330078125L3.3714399999999998,4.51431330078125ZM6.57132,8.85718330078125Q6.62747,8.85718330078125,6.68334,8.85168330078125Q6.73922,8.846183300781249,6.79428,8.83522330078125Q6.84935,8.82427330078125,6.90308,8.80797330078125Q6.95681,8.79167330078125,7.00868,8.77019330078125Q7.06055,8.74870330078125,7.11006,8.72223330078125Q7.15958,8.69577330078125,7.20626,8.66458330078125Q7.25294,8.63338330078125,7.29634,8.597773300781249Q7.33975,8.562153300781251,7.37945,8.522453300781251Q7.41915,8.482753300781251,7.45476,8.43935330078125Q7.49038,8.395953300781251,7.52157,8.34926330078125Q7.55277,8.30258330078125,7.57923,8.25306330078125Q7.6057,8.20355330078125,7.62718,8.15168330078125Q7.64867,8.09981330078125,7.66497,8.04608330078125Q7.68127,7.99235330078125,7.69222,7.93729330078125Q7.70317,7.88222330078125,7.70868,7.82635330078125Q7.71418,7.77047330078125,7.71418,7.71433330078125Q7.71418,7.65818330078125,7.70868,7.60231330078125Q7.70317,7.54643330078125,7.69222,7.49137330078125Q7.68127,7.43630330078125,7.66497,7.38257330078125Q7.64867,7.32884330078125,7.62719,7.27697330078125Q7.6057,7.22510330078125,7.57923,7.17559330078125Q7.55277,7.1260733007812505,7.52157,7.07939330078125Q7.49038,7.03271330078125,7.45476,6.98931330078125Q7.41915,6.94590330078125,7.37945,6.90620330078125Q7.33975,6.86650330078125,7.29634,6.83089330078125Q7.25294,6.7952733007812505,7.20626,6.76407330078125Q7.15958,6.73288330078125,7.11006,6.70642330078125Q7.06055,6.67995330078125,7.00868,6.65846330078125Q6.9568,6.6369833007812495,6.90308,6.62068330078125Q6.84935,6.60438330078125,6.79428,6.59343330078125Q6.73922,6.58248330078125,6.68334,6.576973300781249Q6.62747,6.57147330078125,6.57132,6.57147330078125Q6.51518,6.57147330078125,6.4593,6.576973300781249Q6.40343,6.58248330078125,6.34836,6.59343330078125Q6.2933,6.60438330078125,6.23957,6.62068330078125Q6.18584,6.6369833007812495,6.13397,6.65846330078125Q6.0821,6.67995330078125,6.03258,6.70642330078125Q5.98307,6.73288330078125,5.936389999999999,6.76407330078125Q5.8896999999999995,6.7952733007812505,5.846299999999999,6.83089330078125Q5.8029,6.86650330078125,5.763199999999999,6.90620330078125Q5.7235,6.94590330078125,5.68788,6.98931330078125Q5.65227,7.03271330078125,5.62107,7.07939330078125Q5.58988,7.1260733007812505,5.56341,7.17559330078125Q5.53695,7.22510330078125,5.51546,7.27697330078125Q5.4939800000000005,7.32884330078125,5.477679999999999,7.38257330078125Q5.46138,7.43630330078125,5.45043,7.49137330078125Q5.43947,7.54643330078125,5.43397,7.60231330078125Q5.42847,7.65818330078125,5.42847,7.71433330078125Q5.42847,7.77047330078125,5.43397,7.82635330078125Q5.43947,7.88222330078125,5.45043,7.93729330078125Q5.46138,7.99235330078125,5.477679999999999,8.04608330078125Q5.4939800000000005,8.09981330078125,5.51546,8.15168330078125Q5.53695,8.20355330078125,5.56341,8.25306330078125Q5.58988,8.30258330078125,5.62107,8.34926330078125Q5.65227,8.395953300781251,5.68788,8.43935330078125Q5.7235,8.482753300781251,5.763199999999999,8.522453300781251Q5.8029,8.562153300781251,5.846299999999999,8.597773300781249Q5.8896999999999995,8.63338330078125,5.936389999999999,8.66458330078125Q5.98307,8.69577330078125,6.03258,8.72223330078125Q6.0821,8.74870330078125,6.13397,8.77019330078125Q6.18584,8.79167330078125,6.23957,8.80797330078125Q6.2933,8.82427330078125,6.34836,8.83522330078125Q6.40343,8.846183300781249,6.4593,8.85168330078125Q6.51518,8.85718330078125,6.57132,8.85718330078125Z\" fill-rule=\"evenodd\" fill=\"#333333\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14.001220703125\" height=\"12.0006103515625\" viewBox=\"0 0 14.001220703125 12.0006103515625\"><g><path d=\"M9.2949,11.8839L5.69362,9.80934L3.719,11.6696C3.16318,12.1933,2.25054,11.7992,2.25054,11.0356L2.25054,9.00107L9.36525,3.50195L1.98882,7.84424L0.304124,6.39895C-0.193235,5.97227,-0.0591159,5.16987,0.549968,4.92813L12.807,0.0633736C13.4947,-0.209545,14.188,0.444798,13.9553,1.14706L10.5566,11.4031C10.3831,11.9267,9.77285,12.1593,9.2949,11.8839Z\" fill-rule=\"evenodd\" fill=\"currentColor\" fill-opacity=\"1\"></path></g></svg>"

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#00BF6F\" cx=\"9\" cy=\"9\" r=\"9\"></circle><path d=\"M13.898 7.5l-5.234 5.104a1.157 1.157 0 0 1-1.589 0l-2.622-2.546a1.05 1.05 0 0 1-.327-.773c0-.598.5-1.088 1.12-1.088.306 0 .589.12.795.316l1.828 1.773 4.45-4.33c.208-.196.48-.316.795-.316.62 0 1.121.49 1.121 1.088-.01.294-.13.566-.337.773z\" fill=\"#FFF\"></path></g></svg>"

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><g><g><path d=\"M12.5885,2.5C13.0883,2.5,13.5302,2.824857,13.6793,3.301971L14.1079,4.6734C14.1195,4.71075,14.1292,4.74824,14.1369,4.785769999999999L16.857100000000003,4.785769999999999C17.488300000000002,4.785769999999999,18,5.29744,18,5.9286200000000004L18,16.2143C18,16.8455,17.488300000000002,17.3572,16.857100000000003,17.3572L3.1428599999999998,17.3572C2.511675,17.3572,2,16.8455,2,16.2143L2,5.9286200000000004C2,5.29744,2.511675,4.785769999999999,3.1428599999999998,4.785769999999999L5.86341,4.785769999999999C5.8711400000000005,4.74789,5.8808,4.71039,5.89235,4.6734L6.32093,3.301971C6.47002,2.824857,6.91189,2.5,7.41176,2.5L12.5885,2.5ZM12.4197,3.7572L7.57966,3.7572L7.29395,4.67149L12.7054,4.67149L12.4197,3.7572ZM3.37134,6.15723L16.628500000000003,6.15723L16.628500000000003,15.9858L3.37134,15.9858L3.37134,6.15723ZM10.0001,14.5Q10.16854,14.5,10.33616,14.4835Q10.50379,14.4669,10.66899,14.4341Q10.83418,14.4012,10.99537,14.3523Q11.15655,14.3034,11.31216,14.239Q11.46778,14.1745,11.61632,14.0951Q11.76487,14.0157,11.90491,13.9221Q12.045,13.8286,12.1752,13.7217Q12.3054,13.6149,12.4245,13.4958Q12.5436,13.3767,12.6504,13.2465Q12.7573,13.1163,12.8509,12.9762Q12.9444,12.8362,13.0238,12.6876Q13.1032,12.5391,13.1677,12.38345Q13.2321,12.22784,13.281,12.06666Q13.3299,11.90547,13.3628,11.74028Q13.3957,11.57508,13.4122,11.40745Q13.4287,11.23983,13.4287,11.07139Q13.4287,10.90296,13.4122,10.73533Q13.3957,10.56771,13.3628,10.40251Q13.3299,10.23731,13.281,10.07613Q13.2321,9.914950000000001,13.1677,9.75934Q13.1032,9.60372,13.0238,9.45518Q12.9444,9.30663,12.8509,9.16658Q12.7573,9.026530000000001,12.6504,8.896329999999999Q12.5436,8.76613,12.4245,8.64703Q12.3054,8.52793,12.1752,8.42107Q12.045,8.314219999999999,11.90491,8.22064Q11.76487,8.12706,11.61632,8.04766Q11.46778,7.96826,11.31216,7.90381Q11.15655,7.83935,10.99537,7.79046Q10.83418,7.74156,10.66899,7.7087Q10.50379,7.67584,10.33616,7.65933Q10.16854,7.64282,10.0001,7.64282Q9.831669999999999,7.64282,9.66405,7.65933Q9.49642,7.67584,9.33122,7.7087Q9.16603,7.74156,9.00484,7.79046Q8.84366,7.83935,8.68805,7.90381Q8.53243,7.96826,8.383890000000001,8.04766Q8.23534,8.12706,8.09529,8.22064Q7.95524,8.314219999999999,7.82504,8.42107Q7.69484,8.52793,7.57574,8.64703Q7.45664,8.76613,7.34978,8.896329999999999Q7.24293,9.026530000000001,7.14935,9.16658Q7.05577,9.30663,6.97637,9.45518Q6.89697,9.60372,6.83252,9.75934Q6.76806,9.914950000000001,6.71917,10.07613Q6.67027,10.23731,6.63741,10.40251Q6.60455,10.56771,6.58804,10.73533Q6.57153,10.90296,6.57153,11.07139Q6.57153,11.23983,6.58804,11.40745Q6.60455,11.57508,6.63741,11.74027Q6.67027,11.90547,6.71917,12.06666Q6.76806,12.22784,6.83252,12.38345Q6.89697,12.5391,6.97637,12.6876Q7.05577,12.8362,7.14935,12.9762Q7.24293,13.1163,7.34978,13.2465Q7.45664,13.3767,7.57574,13.4958Q7.69484,13.6149,7.82504,13.7217Q7.95524,13.8286,8.09529,13.9221Q8.23534,14.0157,8.383890000000001,14.0951Q8.53243,14.1745,8.68805,14.239Q8.84366,14.3034,9.00484,14.3523Q9.16603,14.4012,9.33122,14.4341Q9.49642,14.4669,9.66405,14.4835Q9.831669999999999,14.5,10.0001,14.5ZM10.00001,13.1286Q10.10107,13.1286,10.20165,13.1187Q10.30222,13.1088,10.40134,13.089Q10.50046,13.0693,10.59717,13.04Q10.69388,13.0107,10.78725,12.972Q10.88062,12.9333,10.96975,12.8857Q11.05887,12.838,11.1429,12.7819Q11.22693,12.7257,11.30505,12.6616Q11.38317,12.5975,11.45463,12.526Q11.52609,12.45458,11.59021,12.37646Q11.65432,12.29834,11.71046,12.21431Q11.76661,12.13028,11.81425,12.04115Q11.86189,11.95203,11.90057,11.85866Q11.93924,11.76529,11.96858,11.66858Q11.99791,11.57187,12.0176,11.47275Q12.0373,11.37364,12.0473,11.27306Q12.0572,11.17249,12.0572,11.07143Q12.0572,10.97036,12.0473,10.86979Q12.0373,10.76922,12.0176,10.6701Q11.99791,10.57098,11.96858,10.47427Q11.93924,10.377559999999999,11.90057,10.284189999999999Q11.86189,10.19082,11.81425,10.10169Q11.76661,10.01257,11.71047,9.92854Q11.65432,9.84451,11.59021,9.766390000000001Q11.52609,9.68827,11.45463,9.616810000000001Q11.38317,9.54534,11.30505,9.48123Q11.22693,9.41712,11.1429,9.36097Q11.05887,9.304829999999999,10.96974,9.25719Q10.88062,9.20955,10.78725,9.17087Q10.69388,9.132200000000001,10.59717,9.10286Q10.50046,9.07353,10.40134,9.05381Q10.30222,9.034089999999999,10.20165,9.02419Q10.10107,9.01428,10.00001,9.01428Q9.89895,9.01428,9.79838,9.02419Q9.6978,9.034089999999999,9.59868,9.05381Q9.49957,9.07353,9.40286,9.10286Q9.306149999999999,9.132200000000001,9.21278,9.17087Q9.11941,9.20955,9.030280000000001,9.25719Q8.94116,9.304829999999999,8.85713,9.36097Q8.7731,9.41712,8.694980000000001,9.48123Q8.616859999999999,9.54534,8.545390000000001,9.616810000000001Q8.47393,9.68827,8.40982,9.766390000000001Q8.34571,9.84451,8.28956,9.92854Q8.23341,10.01257,8.18577,10.10169Q8.13813,10.19082,8.09946,10.284189999999999Q8.06079,10.377559999999999,8.03145,10.47427Q8.00211,10.57098,7.9824,10.6701Q7.96268,10.76922,7.95278,10.86979Q7.94287,10.97036,7.94287,11.07143Q7.94287,11.17249,7.95278,11.27306Q7.96268,11.37364,7.9824,11.47275Q8.00211,11.57187,8.03145,11.66858Q8.06079,11.76529,8.09946,11.85866Q8.13813,11.95203,8.18577,12.04115Q8.23341,12.13028,8.28956,12.21431Q8.34571,12.29834,8.40982,12.37646Q8.47393,12.45458,8.545390000000001,12.526Q8.616859999999999,12.5975,8.694980000000001,12.6616Q8.7731,12.7257,8.85713,12.7819Q8.94116,12.838,9.030280000000001,12.8857Q9.11941,12.9333,9.21278,12.972Q9.306149999999999,13.0107,9.40286,13.04Q9.49957,13.0693,9.59868,13.089Q9.6978,13.1088,9.79838,13.1187Q9.89895,13.1286,10.00001,13.1286Z\" fill-rule=\"evenodd\" fill=\"#333333\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\"><g><g><rect x=\"1\" y=\"0\" width=\"13\" height=\"1.2000000476837158\" rx=\"0.6000000238418579\" fill=\"#333333\" fill-opacity=\"1\"></rect></g><g><rect x=\"9\" y=\"3\" width=\"5\" height=\"1.2000000476837158\" rx=\"0.6000000238418579\" fill=\"#333333\" fill-opacity=\"1\"></rect></g><g><path d=\"M9.26701,7.57483L6.65883,5.9913L5.15435,3.246066C4.97517,2.9179779,4.52563,2.9179779,4.34539,3.246066L2.84197,5.9913L0.233783,7.57483C-0.0779275,7.76342,-0.0779275,8.23658,0.233783,8.42629L2.84197,10.00871L4.34539,12.75393C4.52457,13.082,4.97411,13.082,5.15435,12.75393L6.65883,10.00871L9.26701,8.42629C9.57767,8.23658,9.57767,7.76342,9.26701,7.57483Z\" fill=\"#333333\" fill-opacity=\"1\"></path><path d=\"M9.26701,8.42629L6.65883,10.00871L5.15435,12.75393C4.97411,13.082,4.52457,13.082,4.34539,12.75393L2.84197,10.00871L0.233783,8.42629C-0.0779275,8.23658,-0.0779275,7.76342,0.233783,7.57483L2.84197,5.9913L4.34539,3.246066C4.52563,2.9179779,4.97517,2.9179779,5.15435,3.246066L6.65883,5.9913L9.26701,7.57483C9.57767,7.76342,9.57767,8.23658,9.26701,8.42629ZM5.76109,6.850099999999999L7.65563,8.000350000000001L5.76119,9.14972L4.7501,10.99467L3.73977,9.14982L1.84517,8.000350000000001L3.73987,6.85L4.7501,5.00533L5.76109,6.850099999999999Z\" fill-rule=\"evenodd\" fill=\"#333333\" fill-opacity=\"1\"></path></g><g><path d=\"M13.86511,10.74489L12.35511,9.79478L11.4841,8.147639999999999C11.38036,7.9507868,11.1201,7.9507868,11.01575,8.147639999999999L10.14535,9.79478L8.635348,10.74489C8.4548841,10.85805,8.4548841,11.14195,8.635348,11.25577L10.14535,12.20522L11.01575,13.852360000000001C11.119489999999999,14.04921,11.37975,14.04921,11.4841,13.852360000000001L12.35511,12.20522L13.86511,11.25577C14.04496,11.14195,14.04496,10.85805,13.86511,10.74489Z\" fill=\"#333333\" fill-opacity=\"1\"></path><path d=\"M13.1442,11.70907L12.35511,12.20522L11.9287,13.01159L11.90636,13.05383L11.4841,13.852360000000001C11.37975,14.04921,11.119489999999999,14.04921,11.01575,13.852360000000001L10.59377,13.05381L10.57136,13.011389999999999L10.14535,12.20522L9.356264,11.70907L9.352733,11.70685L8.635348,11.25577C8.4548841,11.14195,8.4548841,10.85805,8.635348,10.74489L9.352388,10.29372L9.356038,10.29142L10.14535,9.79478L10.571349999999999,8.98861L10.59365,8.946415L11.01575,8.147639999999999C11.1201,7.9507868,11.38036,7.9507868,11.4841,8.147639999999999L11.90627,8.945996L11.9287,8.988412L12.35511,9.79478L13.14442,10.29142L13.14828,10.293849999999999L13.86511,10.74489C14.04496,10.85805,14.04496,11.14195,13.86511,11.25577L13.14784,11.70678L13.1442,11.70907ZM11.44445,11.36032L11.25022,11.72763L11.05617,11.36042L10.48306,11.000070000000001L11.05627,10.6394L11.25021,10.27237L11.44435,10.6395L12.0174,11.000070000000001L11.44445,11.36032Z\" fill-rule=\"evenodd\" fill=\"#333333\" fill-opacity=\"1\"></path></g></g></svg>"

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"14.74\" height=\"14\" viewBox=\"0 0 14.74 14\"><path d=\"M6.992 14q-.171 0-.343-.009-.171-.008-.342-.025t-.34-.043q-.17-.025-.34-.059-.168-.034-.334-.075-.167-.042-.33-.092-.165-.05-.327-.108-.161-.058-.32-.124t-.314-.14q-.155-.073-.306-.154-.152-.081-.299-.17-.147-.088-.29-.183-.143-.096-.28-.198-.138-.103-.271-.212t-.26-.224q-.127-.115-.248-.237-.122-.121-.237-.249-.115-.127-.224-.26t-.211-.27q-.103-.138-.198-.281-.095-.143-.183-.29-.089-.148-.17-.3-.08-.15-.154-.306-.073-.155-.139-.314-.066-.159-.123-.32Q.35 9.195.3 9.03.251 8.866.209 8.7q-.041-.167-.075-.335-.033-.169-.058-.339-.026-.17-.042-.34-.017-.171-.026-.343Q0 7.172 0 7q0-.172.008-.343.009-.172.026-.343.017-.171.042-.341t.059-.339Q.168 5.466.21 5.3q.042-.167.091-.331.05-.164.108-.326.058-.162.124-.32.066-.16.14-.315.073-.155.154-.307.08-.151.169-.299.088-.147.184-.29.095-.143.198-.28.102-.139.21-.272.11-.133.225-.26.116-.127.237-.249.122-.121.25-.237.126-.115.26-.224.132-.11.27-.211.138-.103.281-.198.143-.096.29-.184.148-.088.3-.17.15-.08.306-.154.155-.073.314-.14.159-.065.32-.123.163-.058.327-.108.164-.05.331-.091.167-.042.335-.075.169-.034.339-.06.17-.024.34-.041.172-.017.344-.026Q6.828 0 7 0q.16 0 .321.007.16.008.32.022.16.015.32.037.159.022.316.052.158.029.315.065.156.037.31.08.155.044.308.095.152.05.302.108.15.058.297.122.147.065.291.136.144.071.285.149.14.077.277.161t.27.175q.133.09.261.186.129.096.253.198.124.102.243.21.12.108.234.22.114.113.223.231.109.119.212.241.103.123.201.251.098.128.19.26.091.131.176.267.086.136.165.276.08.14.152.283.073.143.139.29.066.146.125.295.06.15.112.301.052.152.097.306.046.154.084.31.038.156.07.314.03.158.054.316.024.16.04.319h.577a.2.2 0 0 1 .146.336l-1.149 1.233a.2.2 0 0 1-.284.008l-1.292-1.232a.2.2 0 0 1 .138-.345h.657q-.033-.26-.089-.517-.055-.256-.134-.507-.079-.25-.18-.492-.101-.242-.223-.474-.123-.232-.266-.453-.143-.22-.305-.426t-.342-.397q-.18-.19-.377-.364t-.409-.33q-.211-.155-.436-.29-.225-.136-.46-.25-.237-.115-.482-.208-.246-.093-.499-.163-.252-.07-.51-.117-.259-.048-.52-.071Q7.263 1.2 7 1.2q-.142 0-.284.007-.143.007-.284.02-.142.015-.283.036-.14.02-.28.048t-.278.063q-.138.034-.274.076-.137.041-.27.089-.135.048-.266.102-.132.055-.26.116-.13.06-.255.128-.125.067-.248.14-.122.073-.24.152-.119.08-.233.164-.114.085-.224.175-.11.09-.216.186Q3 2.798 2.9 2.9q-.1.1-.196.206-.096.105-.186.215t-.175.225q-.085.114-.164.233-.08.118-.153.24t-.14.248q-.067.125-.128.254-.06.129-.115.26-.055.132-.103.266-.048.134-.09.27-.04.137-.075.275-.035.138-.062.277-.028.14-.049.28-.02.142-.035.283-.014.142-.02.284Q1.2 6.858 1.2 7t.007.285q.007.142.021.283.014.142.035.283.02.14.049.28.027.14.062.278t.076.275q.041.136.09.27.047.134.102.265.054.132.115.26.06.13.128.255.067.126.14.248.074.122.153.24.079.119.164.233.084.114.175.224.09.11.186.216.095.105.196.206.1.1.206.196.106.096.216.186t.224.175q.114.085.233.164.118.08.24.153t.248.14q.126.067.254.128.129.06.26.115.132.055.266.103.134.048.27.09.137.04.275.075.138.035.277.063.14.027.281.048.14.021.283.035.141.014.283.021.143.007.285.007.06 0 .117.012.058.011.113.034.055.022.104.055.049.033.09.075.042.042.075.09.033.05.056.104.022.055.034.113.011.058.011.117 0 .06-.011.117-.012.058-.034.113-.023.054-.056.103-.033.05-.074.091-.042.042-.091.075-.05.033-.104.055-.055.023-.113.034Q7.06 14 7 14h-.008z\" fill-rule=\"evenodd\" fill=\"#2672FF\"></path></svg>"

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FFBE3A\" cx=\"9\" cy=\"9\" r=\"9\"></circle><g transform=\"translate(7.56 2.52)\" fill=\"#FFF\"><rect x=\".36\" width=\"2.16\" height=\"9.36\" rx=\"1.08\"></rect><circle cx=\"1.44\" cy=\"11.88\" r=\"1.44\"></circle></g></g></svg>"

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"16.470703125\" height=\"20\" viewBox=\"0 0 16.470703125 20\"><g><g><path d=\"M2.35294,-1.33717e-13L10.1644,-1.33717e-13C10.8105,-1.33717e-13,11.4282,0.265681,11.8725,0.734719L15.8258,4.90759C16.2398,5.34465,16.4706,5.92378,16.4706,6.52582L16.4706,17.6471C16.4706,18.9466,15.4171,20,14.1176,20L2.35294,20C1.05345,20,0,18.9466,0,17.6471L0,2.35294C0,1.05345,1.05345,-1.33717e-13,2.35294,-1.33717e-13Z\" fill-rule=\"evenodd\" fill=\"#2672FF\" fill-opacity=\"1\"></path></g><g><path d=\"M3.529411792755127,7.647058963775635L4.846861792755127,7.647058963775635L6.184271792755127,13.015318963775634L6.224191792755127,13.015318963775634L7.631461792755127,7.647058963775635L8.839121792755126,7.647058963775635L10.246391792755126,13.015318963775634L10.286321792755128,13.015318963775634L11.623731792755127,7.647058963775635L12.941171792755126,7.647058963775635L10.885161792755127,14.705878963775636L9.647551792755127,14.705878963775636L8.260241792755128,9.396938963775636L8.220321792755126,9.396938963775636L6.823031792755128,14.705878963775636L5.575451792755127,14.705878963775636L3.529411792755127,7.647058963775635Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g><path d=\"M15.58118585510254,4.25974L12.308265855102539,0.931819C11.838675855102538,0.45438,11.23988085510254,0.129982,10.588235855102539,0L10.588235855102539,3.7352C10.588235855102539,4.92108,11.533623855102539,5.88235,12.69989585510254,5.88235L16.470585855102538,5.88235C16.32802585510254,5.26801,16.020065855102537,4.70616,15.58118585510254,4.25974Z\" fill=\"#000000\" fill-opacity=\"0.10000000149011612\"></path></g></g></svg>"

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" version=\"1.1\" width=\"16.470703125\" height=\"20\" viewBox=\"0 0 16.470703125 20\"><g><g><path d=\"M2.35294,-1.33717e-13L10.1644,-1.33717e-13C10.8105,-1.33717e-13,11.4282,0.265681,11.8725,0.734719L15.8258,4.90759C16.2398,5.34465,16.4706,5.92378,16.4706,6.52582L16.4706,17.6471C16.4706,18.9466,15.4171,20,14.1176,20L2.35294,20C1.05345,20,0,18.9466,0,17.6471L0,2.35294C0,1.05345,1.05345,-1.33717e-13,2.35294,-1.33717e-13Z\" fill-rule=\"evenodd\" fill=\"#00BF6F\" fill-opacity=\"1\"></path></g><g><path d=\"M4.878575549285888,6.470588684082031L6.422022549285889,6.470588684082031L8.235292549285889,8.961938684082032L10.04857254928589,6.470588684082031L11.592012549285888,6.470588684082031L8.990822549285888,9.88136868408203L11.76470254928589,13.529408684082032L10.221262549285889,13.529408684082032L8.235292549285889,10.80078868408203L6.249322549285889,13.529408684082032L4.705882549285889,13.529408684082032L7.458172549285889,9.88136868408203L4.878575549285888,6.470588684082031Z\" fill-rule=\"evenodd\" fill=\"#FFFFFF\" fill-opacity=\"1\"></path></g><g><path d=\"M15.58118585510254,4.25974L12.308265855102539,0.931819C11.838675855102538,0.45438,11.23988085510254,0.129982,10.588235855102539,0L10.588235855102539,3.7352C10.588235855102539,4.92108,11.533623855102539,5.88235,12.69989585510254,5.88235L16.470585855102538,5.88235C16.32802585510254,5.26801,16.020065855102537,4.70616,15.58118585510254,4.25974Z\" fill=\"#000000\" fill-opacity=\"0.10000000149011612\"></path></g></g></svg>"

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSceneName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFirstMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInitTaskList; });
// 获取场景名称
function getSceneName(pType) {
  let sceneName = "问卷";
  if (pType === 1) {
    sceneName = "表单";
  } else if (pType === 2) {
    sceneName = "试卷";
  }
  return sceneName;
}

// 获取不同任务的第一条消息,  通过枚举定义 导致数据管道开始到结束的的过程中产生大量代码冗余，必须改2端对应，动态性副作用太大
function getFirstMessage(messageType, pType) {
  let cid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  const typeName = getSceneName(pType);
  const messageMapping = {
    create_project: `请帮我出${typeName}`,
    create_exam_project: "请帮我出考卷",
    create_project_from_text: `请将我的文档转为${typeName}`,
    create_project_from_link: `请将我的链接转为${typeName}`,
    create_project_from_image: `请将我的图片转为${typeName}`,
    create_question: "请帮我出题目",
    create_question_text: "请帮我出题目",
    create_exam_question: "请帮我出题目",
    create_question_from_text: "请帮我通过文本导入",
    create_question_from_link: "请帮我通过链接导入",
    create_question_from_image: "请帮我通过拍照导入",
    check_content: "请帮我检查内容",
    extend_options: `请帮我扩展题目${cid} 的选项`,
    edit_template: `请帮我修改${typeName}`
  };
  return messageMapping[messageType];
}

// 获取编辑页初始化任务列表
function getInitTaskList(pType) {
  let hasQuestion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const sceneName = getSceneName(pType);
  let taskList;
  if (hasQuestion) {
    taskList = [{
      label: "请帮我出题目",
      value: `create_question_text`
    }, {
      label: `请将我的文档转为题目`,
      value: "create_question_from_text"
    }, {
      label: `请将我的图片转为题目`,
      value: "create_question_from_image"
    }, {
      label: `请帮我修改${sceneName}`,
      value: "edit_template"
    }, {
      label: `请帮我检查内容`,
      value: "check_content"
    }];
  } else {
    taskList = [{
      label: `请帮我出${sceneName}`,
      value: `create_project`
    }, {
      label: `请将我的文档转为${sceneName}`,
      value: "create_project_from_text"
    }, {
      label: `请将我的图片转为${sceneName}`,
      value: "create_project_from_image"
    }];
  }
  return taskList;
}

/***/ }),
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),
/* 132 */,
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isNodeServer; });
function isNodeServer() {
  return process !== undefined && Object.prototype.toString.call(process) === '[object process]';
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(41)))

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: serverRequest

// EXTERNAL MODULE: external "@wenjuan/ui/lib/theme-chalk/message.css"
var message_css_ = __webpack_require__(139);

// EXTERNAL MODULE: external "@wenjuan/ui/lib/message"
var message_ = __webpack_require__(36);
var message_default = /*#__PURE__*/__webpack_require__.n(message_);

// EXTERNAL MODULE: external "axios"
var external_axios_ = __webpack_require__(131);
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_);

// EXTERNAL MODULE: external "qs"
var external_qs_ = __webpack_require__(157);
var external_qs_default = /*#__PURE__*/__webpack_require__.n(external_qs_);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(1);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: external "formdata-polyfill"
var external_formdata_polyfill_ = __webpack_require__(178);

// EXTERNAL MODULE: ./node_modules/stream-http/index.js
var stream_http = __webpack_require__(140);
var stream_http_default = /*#__PURE__*/__webpack_require__.n(stream_http);

// EXTERNAL MODULE: ./node_modules/https-browserify/index.js
var https_browserify = __webpack_require__(158);
var https_browserify_default = /*#__PURE__*/__webpack_require__.n(https_browserify);

// CONCATENATED MODULE: ./src/http/config.js


/* harmony default export */ var http_config = ({
  // 自定义的请求头
  headers: {
    post: {
      "Content-Type": "application/json;charset=UTF-8"
    },
    "X-Requested-With": "XMLHttpRequest"
  },
  // 超时设置
  timeout: 40000,
  // 跨域是否带Token
  withCredentials: true,
  // 响应的数据格式 json / blob /document /arraybuffer / text / stream
  responseType: "json",
  // 用于node.js
  httpAgent: new stream_http_default.a.Agent({
    keepAlive: true
  }),
  httpsAgent: new https_browserify_default.a.Agent({
    keepAlive: true
  })
});
// EXTERNAL MODULE: external "@wenjuan/ui/lib/theme-chalk/loading.css"
var loading_css_ = __webpack_require__(176);

// EXTERNAL MODULE: external "@wenjuan/ui/lib/loading"
var loading_ = __webpack_require__(144);
var loading_default = /*#__PURE__*/__webpack_require__.n(loading_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/error/not-found/index.vue?vue&type=template&id=06586890&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "error-page" }, [
    _c("div", { staticClass: "error-header" }, [
      _c("a", { attrs: { href: "/?from=404" } }, [
        _c("img", {
          attrs: {
            src: __webpack_require__(156)
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "page-content" }, [
      _c("div", { staticClass: "float-content" }, [
        _c("div", { staticClass: "not-find-img" }),
        _vm._v(" "),
        _c("div", { staticClass: "tip" }, [_vm._v("这个页面被谁偷走了")]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/?from=404" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !this.isFeishu,
                  expression: "!this.isFeishu"
                }
              ],
              staticClass: "content-btn"
            },
            [_vm._v("返回首页")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !this.isFeishu,
                expression: "!this.isFeishu"
              }
            ],
            staticClass: "auto-jump"
          },
          [_vm._v(_vm._s(_vm.countDown) + "s后自动返回")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./src/components/layout/error/not-found/index.vue?vue&type=template&id=06586890&scoped=true&

// EXTERNAL MODULE: ./src/assets/js/utils/tools.js
var tools = __webpack_require__(5);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/error/not-found/index.vue?vue&type=script&lang=js&

/* harmony default export */ var not_foundvue_type_script_lang_js_ = ({
  data() {
    return {
      // 是否飞书环境
      isFeishu: false,
      // 倒计时
      countDown: 3
    };
  },
  mounted() {
    this.isFeishu = Object(tools["b" /* distinguishUserAgentUtils */])().isFeishu;
    if (!this.isFeishu) {
      // setTimeout(() => {
      //     this.changeTime();
      // }, 1000);
    }
  },
  methods: {
    changeTime() {
      if (this.countDown - 1 === 0) {
        window.location.href = '/?from=404';
      } else {
        this.countDown--;
        setTimeout(() => {
          this.changeTime();
        }, 1000);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/layout/error/not-found/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var error_not_foundvue_type_script_lang_js_ = (not_foundvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/error/not-found/index.vue?vue&type=style&index=0&id=06586890&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/layout/error/not-found/index.vue?vue&type=style&index=0&id=06586890&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/components/layout/error/not-found/index.vue






/* normalize component */

var not_found_component = Object(componentNormalizer["a" /* default */])(
  error_not_foundvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "06586890",
  null
  
)

/* harmony default export */ var not_found = (not_found_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/error/un-auth/index.vue?vue&type=template&id=61473fa8&scoped=true&
var un_authvue_type_template_id_61473fa8_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var un_authvue_type_template_id_61473fa8_scoped_true_staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "error-page" }, [
      _c("div", { staticClass: "bg-img" }),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [_vm._v("抱歉，您无权访问该页面")]),
      _vm._v(" "),
      _c("a", { staticClass: "btn-to-index", attrs: { href: "/" } }, [
        _vm._v("返回首页")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wj-log" })
    ])
  }
]
un_authvue_type_template_id_61473fa8_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./src/components/layout/error/un-auth/index.vue?vue&type=template&id=61473fa8&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/error/un-auth/index.vue?vue&type=script&lang=js&
/* harmony default export */ var un_authvue_type_script_lang_js_ = ({});
// CONCATENATED MODULE: ./src/components/layout/error/un-auth/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var error_un_authvue_type_script_lang_js_ = (un_authvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/layout/error/un-auth/index.vue?vue&type=style&index=0&id=61473fa8&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/layout/error/un-auth/index.vue?vue&type=style&index=0&id=61473fa8&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./src/components/layout/error/un-auth/index.vue






/* normalize component */

var un_auth_component = Object(componentNormalizer["a" /* default */])(
  error_un_authvue_type_script_lang_js_,
  un_authvue_type_template_id_61473fa8_scoped_true_render,
  un_authvue_type_template_id_61473fa8_scoped_true_staticRenderFns,
  false,
  null,
  "61473fa8",
  null
  
)

/* harmony default export */ var un_auth = (un_auth_component.exports);
// CONCATENATED MODULE: ./src/components/layout/error/index.js





let isUse = false;
const pageComponents = {
  default: not_found,
  'not-found': not_found,
  'un-auth': un_auth
};
function useErrorPage() {
  let pageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'not-found';
  let mountElement = arguments.length > 1 ? arguments[1] : undefined;
  if (isUse) return;
  isUse = true;
  let component = pageComponents[pageType] || pageComponents['default'];
  let mountEl = getMountDom(mountElement);
  let pageError = external_vue_default.a.extend(component);
  new pageError({
    mounted() {
      //关闭全局 loading
      let loading = loading_default.a.service({});
      loading.close();
    }
  }).$mount(mountEl);
}
function getMountDom() {
  let mountedEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#wj-page';
  if (typeof mountedEl === 'object') return mountedEl;
  // 不存在该节点，创建遮罩层，反之，直接覆盖
  let mDom = document.querySelector(`${mountedEl}`);
  let body = document.body;
  if (!mDom) {
    /* eslint-disable-next-line */
    let pageId = mountedEl.replace(/(\#|\.)/g, '');
    mDom = document.createElement('div');
    mDom.id = pageId;
    body.appendChild(mDom);
  }
  body.style.overflow = 'hidden';
  return mDom;
}
// EXTERNAL MODULE: ./src/http/httpErrorCode.js
var httpErrorCode = __webpack_require__(26);

// EXTERNAL MODULE: ./src/assets/js/utils/cookie.js
var cookie = __webpack_require__(2);

// EXTERNAL MODULE: external "blueimp-md5"
var external_blueimp_md5_ = __webpack_require__(27);
var external_blueimp_md5_default = /*#__PURE__*/__webpack_require__.n(external_blueimp_md5_);

// CONCATENATED MODULE: ./src/http/request-signature/secret.js
// 旧版签名
const SIGNATURE_DEFAULT = {
  APP_KEY: "sqjDmXVd5LNYf9r4",
  SECRET: "rltfin41xhvwjgyd75s8aq2oebm0369u",
  SITE: "wenjuan_web"
};
const SIGNATURECONF_PWA = {
  APP_KEY: "sqjDmXVd5LNYf9r4",
  SECRET: "rltfin41xhvwjgyd75s8aq2oebm0369u",
  SITE: "pwa"
};

// 新版签名
const SIGNATURE_NEW = {
  APP_KEY: "ZXfC4ZZ",
  SECRET: "wdH4zeNWo9ZXfC4ZZ0WrNxUM24qWy"
};
// EXTERNAL MODULE: ./src/assets/js/utils/use-pwa-signature.js
var use_pwa_signature = __webpack_require__(12);

// CONCATENATED MODULE: ./src/http/request-signature/index.js




// 旧版签名规则
function signatureOld(requestConfig) {
  const {
    method,
    params,
    data,
    url
  } = requestConfig;
  if (method === "get") {
    requestConfig.params = formatParams(params, url);
  } else {
    requestConfig.data = formatParams(data, url);
  }
  return requestConfig;
}

// 新版签名规则 Authorization
function signatureNew(requestConfig) {
  delete requestConfig.data.__SIGNATURE_NEW__;
  const {
    url,
    data = {}
  } = requestConfig;
  const {
    SECRET,
    APP_KEY
  } = SIGNATURE_NEW;
  const keyList = Object.keys(data).sort();
  const valueList = [];
  keyList.forEach(key => {
    valueList.push(data[key]);
  });
  const query = getQuery(url);
  const tempData = JSON.parse(JSON.stringify(data));
  const str = JSON.stringify(tempData);
  requestConfig.headers.Authorization = `wj ${APP_KEY}:${external_blueimp_md5_default()(str + query + SECRET)}`;
  return requestConfig;
}

// 请求数据处理并补充校验字段
function formatParams(_data, url) {
  try {
    const {
      APP_KEY,
      SECRET,
      SITE
    } = Object(use_pwa_signature["isUsedPWASignature"])(url) ? SIGNATURECONF_PWA : SIGNATURE_DEFAULT;
    const webSite = _data && _data.web_site ? _data.web_site : "";
    // 添加校验字段，规则 https://www.wenjuan.com/open/devdocument_v3_3/?chapter=3_2#API-signature-rule
    const checkField = {
      appkey: APP_KEY,
      web_site: webSite || SITE,
      timestamp: new Date().getTime()
    };
    const data = _data || {};
    Object.assign(data, checkField);
    const keyList = Object.keys(data).sort();
    const valueList = [];
    keyList.forEach(key => {
      if (key !== "secret") valueList.push(data[key]);
    });
    data.signature = external_blueimp_md5_default()(valueList.join("") + SECRET);
    return data;
  } catch (e) {
    console.log(e, "pwac error");
  }
}

/**
 * 解析 url 中的参数
 * @param url
 * @returns {String}
 */
function getQuery(url) {
  if (!url || url === "" || typeof url !== "string") {
    return "";
  }
  const paramsStr = url.split("?")[1];
  if (!paramsStr) {
    return "";
  }
  let queryStr = "";
  const params = {};
  const paramsArr = paramsStr.replace(/&|=/g, " ").split(" ");
  for (let i = 0; i < paramsArr.length / 2; i++) {
    const value = paramsArr[i * 2 + 1];
    params[paramsArr[i * 2]] = value === "true" ? true : value === "false" ? false : value;
  }
  const queryArr = Object.keys(params).sort();
  queryArr.forEach(key => {
    queryStr += `${params[key]}`;
  });
  return queryStr;
}

// EXTERNAL MODULE: ./src/assets/js/utils/env-logger.js
var env_logger = __webpack_require__(159);

// EXTERNAL MODULE: ./src/assets/js/utils/env-check.js
var env_check = __webpack_require__(133);

// CONCATENATED MODULE: ./src/assets/js/third_party_stat.js
/* eslint-disable space-infix-ops */
// eslint-disable no-sequences

// 多端统一日志埋点
// import "@/assets/js/track-init.js";


// cookie字符串转json
function cookieStrToJson(jsonStr) {
  let result = "";
  try {
    result = jsonStr ? JSON.parse(JSON.parse(jsonStr.replace(/\\054/g, ","))) : false;
  } catch (error) {
    console.log("埋点数据格式有误");
    result = false;
  }
  return result;
}

// 添加页面来源cookie
function setRefererCookie() {
  const domain = (window.document.referrer || "").replace(/(^https{0,1}:\/\/)|(\/\S*$)/g, "") || "";
  const host = window.location.hostname;
  if (domain.includes(host)) return;
  const cachedReferer = Object(cookie["b" /* get */])("origin_referer") || domain || "default";
  const cachedPath = Object(cookie["b" /* get */])("origin_path") || window.location.pathname;
  Object(cookie["c" /* set */])("origin_referer", cachedReferer, 7) || Object(cookie["c" /* set */])("origin_path", cachedPath, 7);
}

// sdk2期埋点: 根据cookie is_new_regmember 或 track_login_payload 触发埋点
function setupRegisterOrLoginTrack() {
  if (typeof window !== "undefined") {
    try {
      setRefererCookie();
      // 注册埋点
      if (Object(cookie["b" /* get */])("is_new_regmember") === "1" && Object(cookie["b" /* get */])("track_register_payload")) {
        const trackRegPayload = cookieStrToJson(Object(cookie["b" /* get */])("track_register_payload"));
        Object(cookie["a" /* del */])("track_register_payload");
        Object(cookie["a" /* del */])("is_new_regmember");
        Object(cookie["a" /* del */])("utm_source");
        Object(cookie["a" /* del */])("origin_referer");
        if (trackRegPayload) {
          window.zytrack && window.zytrack("custom", "register", trackRegPayload);
        }
      }
      // 登录埋点
      let trackLoginPayload = cookieStrToJson(Object(cookie["b" /* get */])("track_login_payload"));
      if (trackLoginPayload) {
        Object(cookie["a" /* del */])("track_login_payload");
        Object(cookie["a" /* del */])("utm_source");
        Object(cookie["a" /* del */])("origin_referer");
        if (Object.keys(trackLoginPayload).length > 1) {
          window.zytrack && window.zytrack("custom", "login", trackLoginPayload);
        }
        trackLoginPayload = null;
      }
      // 创建项目埋点
      let projectCreatePayload = cookieStrToJson(Object(cookie["b" /* get */])("project_create_payload"));
      if (projectCreatePayload) {
        Object(cookie["a" /* del */])("project_create_payload");
        if (Object.keys(projectCreatePayload).length > 1) {
          window.zytrack && window.zytrack("custom", "project_create", projectCreatePayload);
        }
        projectCreatePayload = null;
      }
      // 发布项目埋点
      let projectPublishPayload = cookieStrToJson(Object(cookie["b" /* get */])("project_publish_payload"));
      if (projectPublishPayload) {
        Object(cookie["a" /* del */])("project_publish_payload");
        if (Object.keys(projectPublishPayload).length > 1) {
          window.zytrack && window.zytrack("custom", "project_publish", projectPublishPayload);
        }
        projectPublishPayload = null;
      }
      // 模板搜索埋点
      let projectSearchPayload = cookieStrToJson(Object(cookie["b" /* get */])("template_search"));
      if (projectSearchPayload) {
        Object(cookie["a" /* del */])("template_search");
        if (Object.keys(projectSearchPayload).length > 1) {
          window.zytrack && window.zytrack("custom", "template_search", projectSearchPayload);
        }
        projectSearchPayload = null;
      }
    } catch (error) {
      console.log("埋点出错");
      console.log(error);
    }
  }
}
// CONCATENATED MODULE: ./src/http/index.js





 // 兼容ios QQ浏览器formdata(__UPLOAD_FORMDATA__)









const isServer = Object(env_check["a" /* isNodeServer */])();

// SSR runtime 日志输出工具 , 运行在SSR期间自动注入，仅在生产环境生效[prod, pre]
const requestLogger = Object(env_logger["a" /* getServerHttpRequestLogger */])();
external_vue_default.a.prototype.$message = message_default.a;
let errorPageRender = false;
let service = external_axios_default.a.create(http_config);
// 参数值
// 不使用拦截器
const UN_INTERCEPTORS = "unInterceptors";
const RED_ERR_MSG = "redErrorMsg";
const CUSTOM_LOGIN_ERROR = "customLoginError";
// 拦截参数 去掉并且标记到config
function recordInterceptorsKey() {
  let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  try {
    const {
      unInterceptors,
      redErrorMsg,
      customLoginError
    } = params;
    if (unInterceptors || redErrorMsg || customLoginError) {
      config[UN_INTERCEPTORS] = unInterceptors || false;
      config[RED_ERR_MSG] = redErrorMsg || false;
      config[CUSTOM_LOGIN_ERROR] = customLoginError || false;
      delete params[UN_INTERCEPTORS];
      delete params[RED_ERR_MSG];
      delete params[CUSTOM_LOGIN_ERROR];
    }
  } catch (e) {
    console.log(e);
  }
}
// 验证是否忽略拦截
function isIgnoreInterceptors() {
  let response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return response.config && response.config[UN_INTERCEPTORS];
}
// 验证是否忽略拦截
function isRedErrorMsg() {
  let response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return response.config && response.config[RED_ERR_MSG];
}
// 验证是否忽略拦截 未登录错误
function isLoginErrorMsg() {
  let response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return response.config && response.config[CUSTOM_LOGIN_ERROR];
}
// 请求拦截器
service.interceptors.request.use(config => {
  var _config$params;
  // 配置参数过滤
  // eslint-disable-next-line no-use-before-define
  handleConfigParams(config);
  const {
    method
  } = config;
  // __SIGNATURE_NEW__ 使用新签名
  const {
    __SIGNATURE_NEW__
  } = config.data || {};
  config = __SIGNATURE_NEW__ ? signatureNew(config) : signatureOld(config);

  // 错误页面，重置请求对象，可不在业务层面处理。
  if (errorPageRender) {
    service = () => Promise.reject("error page!");
  }
  // 记录日志标识 仅在ssr日志用到
  const wjAccessFlag = (_config$params = config.params) === null || _config$params === void 0 ? void 0 : _config$params._wj_access_flag;
  if (wjAccessFlag) {
    // save
    config._wj_access_flag = wjAccessFlag;
    delete config.params._wj_access_flag;
  }
  // 请求记时
  config._request_start_time = Date.now();
  // POST 传参序列化
  if (method === "get") {
    recordInterceptorsKey(config.params, config);
  } else {
    recordInterceptorsKey(config.data, config);
    const {
      __FORMDATA__,
      __XSRF__,
      __UPLOAD_FORMDATA__
    } = config.data;
    if (__FORMDATA__) {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
      delete config.data.__FORMDATA__;
    }
    if (__XSRF__) {
      const secureKey = Object(cookie["b" /* get */])("_xsrf") || "";
      if (secureKey) {
        config.data._xsrf = secureKey;
      }
      delete config.data.__XSRF__;
    }
    if (__UPLOAD_FORMDATA__) {
      config.headers["Content-Type"] = "multipart/form-data";
      delete config.data.__UPLOAD_FORMDATA__;
      const formData = new FormData();
      Object.keys(config.data).forEach(key => {
        formData.append(key, config.data[key]);
      });
      config.data = formData;
    }

    // 兼容样本服务提交
    if (config.data.isChangeContentType) {
      config.headers["Content-Type"] = "application/json";
      config.transformRequest = [data => {
        data = JSON.stringify(data);
        return data;
      }];
      delete config.data.isChangeContentType;
    }
    if (config.headers["Content-Type"] == "application/x-www-form-urlencoded") {
      config.data = external_qs_default.a.stringify(config.data);
    }
  }
  return config;
}, error => Promise.reject(error));
// 响应拦截器
service.interceptors.response.use(response => {
  // eslint-disable-next-line no-shadow
  const {
    data,
    config
  } = response;
  if (config !== null && config !== void 0 && config.unIntercept) {
    return data;
  }
  /* 接口日志 接口请求响应数据 */
  try {
    requestLogger(response);
  } catch (e) {
    console.log(e);
  }

  // 暂时处理 Access denied!
  if (data === null && response.headers["content-type"].includes("text/html")) {
    // 无权限访问
    window.location.href = "/";
    return;
  }

  // 处理业务逻辑错误
  if (data && (data.status_code === 0 || data.data && (data.data.status === -1 || data.data.status === -2))) {
    // 已经处理过的错误页面，后续不再提示，拦截错误出错信息！！！！！
    if (errorPageRender) return;
    let errorCode = data.err_code || data.code;
    const projectStatus = data.data ? data.data.status : 1;
    errorCode = projectStatus === -1 || projectStatus === -2 ? 10004 : errorCode;
    // 重定向到登录页错误码
    if (httpErrorCode["e" /* REDIRECT_LOGIN_ERROR */][errorCode]) {
      // 自定义登录错误时，不跳转页面
      if (isLoginErrorMsg(response)) return data;
      window.location.href = `/login?next=${encodeURIComponent(window.location.pathname)}`;
    } else if (httpErrorCode["d" /* PAGE_ERROR */][errorCode]) {
      // 未授权，展示无权限页面
      if (isLoginErrorMsg(response)) return data;
      // 服务端特殊处理
      !isServer && useErrorPage(httpErrorCode["d" /* PAGE_ERROR */][errorCode]);
      errorPageRender = !isServer;
      return;
    } else if (isRedErrorMsg(response)) {
      data.message = httpErrorCode["a" /* HTTP_RESPONSE_ERROR */][errorCode] || data.msg || data.err_msg || data.message || data.code_msg;
      if (data.message) {
        message_default()({
          message: data.message,
          type: "error",
          duration: 2000
        });
      }
      return Promise.reject();
    } else if (!isIgnoreInterceptors(response)) {
      // 闯关模式错误信息 err_msg 为数组
      if (data.err_msg.constructor === Array) {
        return data;
      }
      data.message = httpErrorCode["a" /* HTTP_RESPONSE_ERROR */][errorCode] || data.msg || data.err_msg || data.message || data.code_msg;
      message_default()({
        message: data.message,
        type: "warning"
      });
    }
  }
  setSdkTrack();
  return data;
}, error => {
  // 记录原始error message
  error.errMsg = error.message;

  // SSR日志打印 接口请求响应数据
  try {
    const {
      response
    } = error;
    requestLogger(response);
  } catch (e) {
    console.log(e);
  }
  if (error && error.response) {
    error.message = httpErrorCode["b" /* HTTP_STATUS_CODE */][error.response.status];
  } else {
    error.message = httpErrorCode["b" /* HTTP_STATUS_CODE */].default;
  }
  if (error.errMsg !== "cancel") {
    message_default()(`${error.message}`);
  }
  // return Promise.resolve(error.response || error);
  return Promise.reject(error.response || error);
});
async function setSdkTrack() {
  setupRegisterOrLoginTrack();
}

// 从 params 或 data 中把参数 unIntercept 去掉，并添加到 config 下
function handleConfigParams(config) {
  const obj = config.method === "get" ? config === null || config === void 0 ? void 0 : config.params : config === null || config === void 0 ? void 0 : config.data;
  const {
    unIntercept
  } = obj || {};
  if (unIntercept) {
    config.unIntercept = unIntercept;
    delete obj.unIntercept;
  }
}

// 拼接环境头，仅在开发环境包装请求头
function envUrl(method, url) {
  var _api$method;
  if (true) {
    return url;
  }
  // 此处验证是否为需要mock的请求
  let apiMap;
  try {
    // eslint-disable-next-line no-undef
    apiMap = FE_MOCK_API_MAP;
  } catch {
    apiMap = {};
  }
  // 暂时简单匹配，等有需求的时候在补充优先级匹配
  const apiKey = Object.keys(apiMap).find(item => url.startsWith(item));
  const api = apiMap[apiKey];
  if (api !== null && api !== void 0 && (_api$method = api.method) !== null && _api$method !== void 0 && _api$method.includes(method) && api.id) {
    let mockApiTarget;
    try {
      // eslint-disable-next-line no-undef
      mockApiTarget = FE_MOCK_API_TARGET;
    } catch {
      mockApiTarget = "";
    }
    const mockId = api.id;
    console.log(
    // eslint-disable-next-line no-undef
    `%c [mock][method:${method}][url:${url}][request to:${mockApiTarget}] `, "color:green");
    if (mockApiTarget.includes("apifox")) {
      return `/fe_mock_api/m1/${mockId}-0-default${url}${api.token ? `?apifoxToken=${api.token}` : ""}`;
    }
    return `/fe_mock_api/mock/${mockId}${url}`;
  }
  let proxyApiTarget;
  try {
    // eslint-disable-next-line no-undef
    proxyApiTarget = FE_PROXY_API_TARGET;
  } catch {
    proxyApiTarget = "";
  }
  console.log(`%c [proxy][method:${method}][url:${url}][request to:${proxyApiTarget}] `, "color:green");
  return `/proxy_api${url}`;
}
/* harmony default export */ var http = __webpack_exports__["a"] = ({
  get: (url, data, configOptions) => service({
    method: "get",
    url: envUrl("get", url),
    params: data,
    ...configOptions
  }),
  post: (url, data, headers, configOptions) => service({
    method: "post",
    url: envUrl("post", url),
    data,
    headers,
    ...configOptions
  }),
  delete: (url, data) => service({
    method: "delete",
    url: envUrl("delete", url),
    data
  }),
  put: (url, data) => service({
    method: "put",
    url: envUrl("put", url),
    data
  }),
  patch: (url, data) => service({
    method: "patch",
    url: envUrl("patch", url),
    data
  }),
  download: (url, data) => service({
    method: "get",
    url: envUrl("get", url),
    params: data,
    responseType: "blob"
  })
});
function serverRequest(_ref) {
  let {
    method,
    url,
    params,
    data
  } = _ref;
  return service({
    method,
    url,
    data,
    params,
    headers: {
      "wj-server-render": "true"
    }
  });
}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui/lib/theme-chalk/message.css");

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var ClientRequest = __webpack_require__(179)
var response = __webpack_require__(153)
var extend = __webpack_require__(184)
var statusCodes = __webpack_require__(185)
var url = __webpack_require__(155)

var http = exports

http.request = function (opts, cb) {
	if (typeof opts === 'string')
		opts = url.parse(opts)
	else
		opts = extend(opts)

	// Normally, the page is loaded from http or https, so not specifying a protocol
	// will result in a (valid) protocol-relative url. However, this won't work if
	// the protocol is something else, like 'file:'
	var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? 'http:' : ''

	var protocol = opts.protocol || defaultProtocol
	var host = opts.hostname || opts.host
	var port = opts.port
	var path = opts.path || '/'

	// Necessary for IPv6 addresses
	if (host && host.indexOf(':') !== -1)
		host = '[' + host + ']'

	// This may be a relative url. The browser should always be able to interpret it correctly.
	opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path
	opts.method = (opts.method || 'GET').toUpperCase()
	opts.headers = opts.headers || {}

	// Also valid opts.auth, opts.mode

	var req = new ClientRequest(opts)
	if (cb)
		req.on('response', cb)
	return req
}

http.get = function get (opts, cb) {
	var req = http.request(opts, cb)
	req.end()
	return req
}

http.ClientRequest = ClientRequest
http.IncomingMessage = response.IncomingMessage

http.Agent = function () {}
http.Agent.defaultMaxSockets = 4

http.globalAgent = new http.Agent()

http.STATUS_CODES = statusCodes

http.METHODS = [
	'CHECKOUT',
	'CONNECT',
	'COPY',
	'DELETE',
	'GET',
	'HEAD',
	'LOCK',
	'M-SEARCH',
	'MERGE',
	'MKACTIVITY',
	'MKCOL',
	'MOVE',
	'NOTIFY',
	'OPTIONS',
	'PATCH',
	'POST',
	'PROPFIND',
	'PROPPATCH',
	'PURGE',
	'PUT',
	'REPORT',
	'SEARCH',
	'SUBSCRIBE',
	'TRACE',
	'UNLOCK',
	'UNSUBSCRIBE'
]
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(17)))

/***/ }),
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui/lib/loading");

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(180)
var ieee754 = __webpack_require__(181)
var isArray = __webpack_require__(182)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(17)))

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream)

exports.writableStream = isFunction(global.WritableStream)

exports.abortController = isFunction(global.AbortController)

exports.blobConstructor = false
try {
	new Blob([new ArrayBuffer(1)])
	exports.blobConstructor = true
} catch (e) {}

// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var xhr
function getXHR () {
	// Cache the xhr value
	if (xhr !== undefined) return xhr

	if (global.XMLHttpRequest) {
		xhr = new global.XMLHttpRequest()
		// If XDomainRequest is available (ie only, where xhr might not work
		// cross domain), use the page location. Otherwise use example.com
		// Note: this doesn't actually make an http request.
		try {
			xhr.open('GET', global.XDomainRequest ? '/' : 'https://example.com')
		} catch(e) {
			xhr = null
		}
	} else {
		// Service workers don't have XHR
		xhr = null
	}
	return xhr
}

function checkTypeSupport (type) {
	var xhr = getXHR()
	if (!xhr) return false
	try {
		xhr.responseType = type
		return xhr.responseType === type
	} catch (e) {}
	return false
}

// For some strange reason, Safari 7.0 reports typeof global.ArrayBuffer === 'object'.
// Safari 7.1 appears to have fixed this bug.
var haveArrayBuffer = typeof global.ArrayBuffer !== 'undefined'
var haveSlice = haveArrayBuffer && isFunction(global.ArrayBuffer.prototype.slice)

// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
exports.arraybuffer = exports.fetch || (haveArrayBuffer && checkTypeSupport('arraybuffer'))

// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
exports.msstream = !exports.fetch && haveSlice && checkTypeSupport('ms-stream')
exports.mozchunkedarraybuffer = !exports.fetch && haveArrayBuffer &&
	checkTypeSupport('moz-chunked-arraybuffer')

// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false)

exports.vbArray = isFunction(global.VBArray)

function isFunction (value) {
	return typeof value === 'function'
}

xhr = null // Help gc

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(17)))

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = require("inherits");

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Buffer, global) {var capability = __webpack_require__(151)
var inherits = __webpack_require__(152)
var stream = __webpack_require__(154)

var rStates = exports.readyStates = {
	UNSENT: 0,
	OPENED: 1,
	HEADERS_RECEIVED: 2,
	LOADING: 3,
	DONE: 4
}

var IncomingMessage = exports.IncomingMessage = function (xhr, response, mode, fetchTimer) {
	var self = this
	stream.Readable.call(self)

	self._mode = mode
	self.headers = {}
	self.rawHeaders = []
	self.trailers = {}
	self.rawTrailers = []

	// Fake the 'close' event, but only once 'end' fires
	self.on('end', function () {
		// The nextTick is necessary to prevent the 'request' module from causing an infinite loop
		process.nextTick(function () {
			self.emit('close')
		})
	})

	if (mode === 'fetch') {
		self._fetchResponse = response

		self.url = response.url
		self.statusCode = response.status
		self.statusMessage = response.statusText
		
		response.headers.forEach(function (header, key){
			self.headers[key.toLowerCase()] = header
			self.rawHeaders.push(key, header)
		})

		if (capability.writableStream) {
			var writable = new WritableStream({
				write: function (chunk) {
					return new Promise(function (resolve, reject) {
						if (self._destroyed) {
							reject()
						} else if(self.push(new Buffer(chunk))) {
							resolve()
						} else {
							self._resumeFetch = resolve
						}
					})
				},
				close: function () {
					global.clearTimeout(fetchTimer)
					if (!self._destroyed)
						self.push(null)
				},
				abort: function (err) {
					if (!self._destroyed)
						self.emit('error', err)
				}
			})

			try {
				response.body.pipeTo(writable).catch(function (err) {
					global.clearTimeout(fetchTimer)
					if (!self._destroyed)
						self.emit('error', err)
				})
				return
			} catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
		}
		// fallback for when writableStream or pipeTo aren't available
		var reader = response.body.getReader()
		function read () {
			reader.read().then(function (result) {
				if (self._destroyed)
					return
				if (result.done) {
					global.clearTimeout(fetchTimer)
					self.push(null)
					return
				}
				self.push(new Buffer(result.value))
				read()
			}).catch(function (err) {
				global.clearTimeout(fetchTimer)
				if (!self._destroyed)
					self.emit('error', err)
			})
		}
		read()
	} else {
		self._xhr = xhr
		self._pos = 0

		self.url = xhr.responseURL
		self.statusCode = xhr.status
		self.statusMessage = xhr.statusText
		var headers = xhr.getAllResponseHeaders().split(/\r?\n/)
		headers.forEach(function (header) {
			var matches = header.match(/^([^:]+):\s*(.*)/)
			if (matches) {
				var key = matches[1].toLowerCase()
				if (key === 'set-cookie') {
					if (self.headers[key] === undefined) {
						self.headers[key] = []
					}
					self.headers[key].push(matches[2])
				} else if (self.headers[key] !== undefined) {
					self.headers[key] += ', ' + matches[2]
				} else {
					self.headers[key] = matches[2]
				}
				self.rawHeaders.push(matches[1], matches[2])
			}
		})

		self._charset = 'x-user-defined'
		if (!capability.overrideMimeType) {
			var mimeType = self.rawHeaders['mime-type']
			if (mimeType) {
				var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/)
				if (charsetMatch) {
					self._charset = charsetMatch[1].toLowerCase()
				}
			}
			if (!self._charset)
				self._charset = 'utf-8' // best guess
		}
	}
}

inherits(IncomingMessage, stream.Readable)

IncomingMessage.prototype._read = function () {
	var self = this

	var resolve = self._resumeFetch
	if (resolve) {
		self._resumeFetch = null
		resolve()
	}
}

IncomingMessage.prototype._onXHRProgress = function () {
	var self = this

	var xhr = self._xhr

	var response = null
	switch (self._mode) {
		case 'text:vbarray': // For IE9
			if (xhr.readyState !== rStates.DONE)
				break
			try {
				// This fails in IE8
				response = new global.VBArray(xhr.responseBody).toArray()
			} catch (e) {}
			if (response !== null) {
				self.push(new Buffer(response))
				break
			}
			// Falls through in IE8	
		case 'text':
			try { // This will fail when readyState = 3 in IE9. Switch mode and wait for readyState = 4
				response = xhr.responseText
			} catch (e) {
				self._mode = 'text:vbarray'
				break
			}
			if (response.length > self._pos) {
				var newData = response.substr(self._pos)
				if (self._charset === 'x-user-defined') {
					var buffer = new Buffer(newData.length)
					for (var i = 0; i < newData.length; i++)
						buffer[i] = newData.charCodeAt(i) & 0xff

					self.push(buffer)
				} else {
					self.push(newData, self._charset)
				}
				self._pos = response.length
			}
			break
		case 'arraybuffer':
			if (xhr.readyState !== rStates.DONE || !xhr.response)
				break
			response = xhr.response
			self.push(new Buffer(new Uint8Array(response)))
			break
		case 'moz-chunked-arraybuffer': // take whole
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING || !response)
				break
			self.push(new Buffer(new Uint8Array(response)))
			break
		case 'ms-stream':
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING)
				break
			var reader = new global.MSStreamReader()
			reader.onprogress = function () {
				if (reader.result.byteLength > self._pos) {
					self.push(new Buffer(new Uint8Array(reader.result.slice(self._pos))))
					self._pos = reader.result.byteLength
				}
			}
			reader.onload = function () {
				self.push(null)
			}
			// reader.onerror = ??? // TODO: this
			reader.readAsArrayBuffer(response)
			break
	}

	// The ms-stream case handles end separately in reader.onload()
	if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
		self.push(null)
	}
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(41), __webpack_require__(150).Buffer, __webpack_require__(17)))

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = require("readable-stream");

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = require("url");

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,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");

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = require("qs");

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var http = __webpack_require__(140)
var url = __webpack_require__(155)

var https = module.exports

for (var key in http) {
  if (http.hasOwnProperty(key)) https[key] = http[key]
}

https.request = function (params, cb) {
  params = validateParams(params)
  return http.request.call(this, params, cb)
}

https.get = function (params, cb) {
  params = validateParams(params)
  return http.get.call(this, params, cb)
}

function validateParams (params) {
  if (typeof params === 'string') {
    params = url.parse(params)
  }
  if (!params.protocol) {
    params.protocol = 'https:'
  }
  if (params.protocol !== 'https:') {
    throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"')
  }
  return params
}


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getServerHttpRequestLogger; });
/* harmony import */ var _assets_js_utils_env_check_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(133);


// 验证是否是node环境
const isNodeEnv = Object(_assets_js_utils_env_check_js__WEBPACK_IMPORTED_MODULE_0__[/* isNodeServer */ "a"])();
function logFormat() {
  let response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    config
  } = response;
  const flag = config._wj_access_flag; // 访问日志 标记
  const requestParams = config.params || config.data; // 请求参数
  const spendTime = Date.now() - config._request_start_time; // 请求计时
  return `[${config.method}] [${config.url}] [${response.status}] [${spendTime}] [${flag}] [{"requestParams":${requestParams ? JSON.stringify(requestParams) : "undefined"}}] [{"response":${JSON.stringify(response.data)}}]`;
}
// SSR服务端注入logger日志工具 记录接口请求响应完整数据
const getServerHttpRequestLogger = () => {
  if (isNodeEnv) {
    var _global;
    const envLogger = (_global = global) === null || _global === void 0 ? void 0 : _global._ssr_logger_request;
    if (envLogger && envLogger.info) {
      return msg => envLogger.info(logFormat(msg));
    }
  }

  // return msg => { console.log(logFormat(msg)); };
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(17)))

/***/ }),
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/index.vue?vue&type=template&id=691397ff&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Transition", { attrs: { name: _vm.transitionName } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }
        ],
        staticClass: "wenwen-ai-wrapper",
        class: "wenwen-ai-" + _vm.displayType
      },
      [
        _c(
          "div",
          { staticClass: "wenwen-ai-body" },
          [
            _c(
              "div",
              {
                staticClass: "ai-head",
                class: { "hide-header": _vm.hideHeader }
              },
              [
                _vm.displayType === "drawer"
                  ? _c("span", { staticClass: "ai-logo" })
                  : _c("div", { staticClass: "ai-logo" }, [
                      _vm.displayType === "m-drawer"
                        ? _c("i", {
                            staticClass: "wd-icon-arrow-left ai-back",
                            on: { click: _vm.handleClose }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "ai-logo-dog" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ai-logo-right" }, [
                        _c("span", { staticClass: "ai-logo-wenwen-text" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ai-logo-wenwen-slogan" }, [
                          _vm._v("问卷网自研AI助手，目前还在学习成长中")
                        ])
                      ])
                    ]),
                _vm._v(" "),
                _vm.displayType !== "m-drawer"
                  ? _c("SvgIcon", {
                      staticClass: "ai-close",
                      attrs: { name: "wenwen-ai/close" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.handleClose.apply(null, arguments)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "Main",
              {
                ref: "chatAiDrawer",
                class: { "full-height": _vm.hideHeader },
                attrs: {
                  visible: _vm.visible,
                  platform: _vm.platform,
                  "page-name": _vm.pageName,
                  "intro-show": false,
                  "display-type": _vm.displayType,
                  "history-enable": _vm.showHistory
                },
                on: {
                  close: _vm.handleClose,
                  select: _vm.handleTaskSelect,
                  scrollMessageTop: _vm.loadMoreHistory
                }
              },
              [
                _c(
                  "template",
                  { slot: "message" },
                  [
                    _vm.isLoadingMore ? _c("HistoryLoading") : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.messageList, function(msgItem) {
                      return _c(msgItem.template, {
                        key: msgItem.id,
                        tag: "component",
                        staticClass: "message-item-wrap",
                        class: { "first-message": msgItem.id == _vm.firstId },
                        attrs: {
                          "data-componentname": msgItem.template,
                          "message-info": msgItem,
                          "p-type": _vm.pType,
                          "project-id": _vm.projectId,
                          "short-id": _vm.shortId,
                          "question-id": _vm.questionId,
                          "project-title": _vm.projectTitle,
                          "page-name": _vm.pageName,
                          platform: _vm.platform,
                          "question-count": _vm.questionCount,
                          "conversation-id": _vm.conversationId,
                          "display-type": _vm.displayType
                        },
                        on: {
                          select: _vm.handleMessageSelect,
                          updateMessage: _vm.handleUpdateMessage,
                          updateInputData: _vm.handleUpdateInputData,
                          addMessage: _vm.addUserMessage,
                          handleResult: _vm.handleChatResult
                        }
                      })
                    }),
                    _vm._v(" "),
                    _c("input", {
                      ref: "uploadFileInput",
                      staticClass: "upload-file-input",
                      staticStyle: { display: "none" },
                      attrs: {
                        type: "file",
                        accept: _vm.fileOption.accept,
                        multiple: _vm.fileOption.multiple
                      },
                      on: { change: _vm.handleFileInputChange }
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "template",
                  { slot: "input" },
                  [
                    _vm.platform === "PC"
                      ? _c("WenwenAiInput", {
                          ref: "wenwenAiInput",
                          attrs: {
                            status: _vm.inputData.status,
                            placeholder: _vm.inputData.placeholder,
                            "menu-list": _vm.inputData.menuList,
                            "hide-menu": _vm.inputData.hideMenu,
                            "is-rich-text": _vm.inputData.isRichText,
                            "max-length": _vm.inputData.maxLength,
                            "prevent-enter": _vm.inputData.preventEnter
                          },
                          on: {
                            select: _vm.handleMessageSelect,
                            interrupt: _vm.handleInterrupt,
                            message: _vm.handleInput,
                            upload: _vm.handleUpload
                          }
                        })
                      : _c("WenwenAiMInput", {
                          ref: "wenwenAiMInput",
                          attrs: {
                            status: _vm.inputData.status,
                            placeholder: _vm.inputData.placeholder,
                            "menu-list": _vm.inputData.menuList,
                            "has-question": _vm.questionCount > 0,
                            "page-name": _vm.pageName,
                            "scene-type": _vm.sceneType,
                            "p-type": _vm.pType,
                            "toast-fn": _vm.inputToastFn
                          },
                          on: {
                            startNewTask: _vm.handleTaskSelect,
                            select: _vm.handleMessageSelect,
                            message: _vm.handleInput,
                            upload: _vm.handleUpload
                          }
                        })
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/index.vue?vue&type=template&id=691397ff&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/message.css"
var message_css_ = __webpack_require__(15);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/message"
var message_ = __webpack_require__(4);
var message_default = /*#__PURE__*/__webpack_require__.n(message_);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(1);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: external "uuid"
var external_uuid_ = __webpack_require__(58);

// EXTERNAL MODULE: ./src/http/wenwen-ai/index.js
var wenwen_ai = __webpack_require__(40);

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/constant.js
var constant = __webpack_require__(6);

// EXTERNAL MODULE: ./src/components/svg-icon/index.vue + 5 modules
var svg_icon = __webpack_require__(11);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/base/input/index.vue?vue&type=template&id=42903b2f&scoped=true&
var inputvue_type_template_id_42903b2f_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.chooseMenuCloseHandler,
          expression: "chooseMenuCloseHandler"
        }
      ],
      class: ["chat-input-wrapper", `chat-input-${_vm.status}`],
      on: {
        click: function($event) {
          return _vm.chooseMenuToggleHandler($event, true)
        }
      }
    },
    [
      _c("div", { staticClass: "chat-input-body" }, [
        _vm.status === "inputting"
          ? _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.messageValue,
                  expression: "messageValue"
                }
              ],
              ref: "chatInput",
              staticClass: "chat-text-area",
              attrs: {
                type: "text",
                row: "2",
                maxlength: _vm.maxLength,
                placeholder: _vm.placeholder
              },
              domProps: { value: _vm.messageValue },
              on: {
                keydown: _vm.inputKeyupHandler,
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.messageValue = $event.target.value
                }
              }
            })
          : _c(
              "div",
              {
                class: [
                  "chat-input-content",
                  {
                    "chat-input-placeholder":
                      _vm.status === "waiting" ||
                      _vm.status === "disabled" ||
                      !_vm.menuVisible
                  }
                ]
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.placeholder))]),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showEllipsis,
                        expression: "showEllipsis"
                      }
                    ]
                  },
                  [_vm._v("...")]
                ),
                _vm._v(" "),
                _vm.showMenu
                  ? _c(
                      "ul",
                      { staticClass: "chat-menu chat-input-menu" },
                      _vm._l(_vm.menuList, function(menu, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            staticClass: "chat-menu-item",
                            on: {
                              click: function($event) {
                                return _vm.chooseMenuClickHandler($event, menu)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(menu.label) +
                                "\n                "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chat-input-foot" },
        [
          _vm.showInterruptMenu
            ? _c(
                "ul",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.interruptMenuCloseHandler,
                      expression: "interruptMenuCloseHandler"
                    }
                  ],
                  staticClass: "chat-menu chat-interrupt-menu"
                },
                [
                  _c(
                    "li",
                    {
                      staticClass: "chat-menu-item",
                      on: {
                        click: function($event) {
                          return _vm.interruptClickHandler($event)
                        }
                      }
                    },
                    [_vm._v("\n                中断任务\n            ")]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("SvgIcon", {
            class: [
              "chat-input-button",
              `chat-input-button-${_vm.buttonStatus}`
            ],
            attrs: { name: _vm.sendSvgName },
            nativeOn: {
              click: function($event) {
                return _vm.sendClickHandler.apply(null, arguments)
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var inputvue_type_template_id_42903b2f_scoped_true_staticRenderFns = []
inputvue_type_template_id_42903b2f_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/input/index.vue?vue&type=template&id=42903b2f&scoped=true&

// CONCATENATED MODULE: ./src/directives/clickoutside.js
const nodeList = [];
const ctx = "@@clickoutsideContext";
let startClick;
let seed = 0;
const on = function () {
  if (typeof document !== "undefined") {
    if (document.addEventListener) {
      return function (element, event, handler) {
        if (element && event && handler) {
          element.addEventListener(event, handler, false);
        }
      };
    }
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent(`on${event}`, handler);
      }
    };
  }
}();

// document.addEventListener('mousedown', e => (startClick = e), false);
// document.addEventListener('mouseup', e => {
//     nodeList.forEach(node => node[ctx].documentHandler(e, startClick));
// }, false);
if (typeof document !== "undefined") {
  on(document, "mousedown", e => startClick = e);
  on(document, "mouseup", e => {
    nodeList.forEach(node => node[ctx].documentHandler(e, startClick));
  });
}
function createDocumentHandler(el, binding, vnode) {
  return function () {
    let mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;
    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
      vnode.context[el[ctx].methodName]();
    } else {
      el[ctx].bindingFn && el[ctx].bindingFn();
    }
  };
}

/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */
/* harmony default export */ var clickoutside = ({
  bind(el, binding, vnode) {
    nodeList.push(el);
    const id = seed++;
    el[ctx] = {
      id,
      documentHandler: createDocumentHandler(el, binding, vnode),
      methodName: binding.expression,
      bindingFn: binding.value
    };
  },
  update(el, binding, vnode) {
    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
    el[ctx].methodName = binding.expression;
    el[ctx].bindingFn = binding.value;
  },
  unbind(el) {
    const len = nodeList.length;
    for (let i = 0; i < len; i++) {
      if (nodeList[i][ctx].id === el[ctx].id) {
        nodeList.splice(i, 1);
        break;
      }
    }
    delete el[ctx];
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/base/input/index.vue?vue&type=script&lang=js&


/* harmony default export */ var inputvue_type_script_lang_js_ = ({
  name: "WenwenAiInput",
  components: {
    SvgIcon: svg_icon["a" /* default */]
  },
  directives: {
    ClickOutside: clickoutside
  },
  props: {
    // choosing: 可选择
    // waiting: 请等待
    // inputting: 可输入
    // disabled: 不可用
    // upload: 上传
    status: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    menuList: {
      type: Array,
      default: () => []
    },
    hideMenu: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 200
    },
    // 富文本，保留换行符
    isRichText: {
      type: Boolean,
      default: false
    },
    // 是否阻止回车键发送消息
    preventEnter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 输入框输入内容
      messageValue: "",
      // menu是否显示
      menuVisible: false,
      // 中断任务 menu是否显示
      showInterruptMenu: false
    };
  },
  computed: {
    sendSvgName() {
      if (this.status === "waiting") {
        return "wenwen-ai/more";
      }
      return "wenwen-ai/send-solid";
    },
    showMenu() {
      return this.status === "choosing" && this.menuList.length > 0 && this.menuVisible && !this.hideMenu;
    },
    buttonStatus() {
      if (["choosing", "disabled", "upload"].includes(this.status) || this.status === "inputting" && this.messageValue === "") return "disabled";
      return this.status;
    },
    showEllipsis() {
      return this.status === "waiting" && !this.menuVisible;
    }
  },
  watch: {
    status(newValue, oldValue) {
      // 输入状态切换为其他状态时，清空输入框内容
      if (oldValue === "inputting" && newValue !== "inputting") {
        this.messageValue = "";
      }
      if (newValue === "inputting") {
        this.$nextTick(() => {
          var _this$$refs$chatInput;
          (_this$$refs$chatInput = this.$refs.chatInput) === null || _this$$refs$chatInput === void 0 ? void 0 : _this$$refs$chatInput.focus();
        });
      }

      // 状态更新时，若上次是等待中，且点开了“中断任务”菜单，需隐藏“中断任务”的菜单
      if (oldValue === "waiting" && this.showInterruptMenu) {
        this.interruptMenuCloseHandler();
      }
    }
  },
  methods: {
    // 点击其他区域，关闭 menu
    chooseMenuCloseHandler() {
      this.menuVisible = false;
    },
    // 点击 menu item
    chooseMenuClickHandler(e, menu) {
      e.stopPropagation();
      this.menuVisible = false;
      this.$emit("select", menu);
    },
    // 点击整个框弹出 menu
    chooseMenuToggleHandler(e, value) {
      e.stopPropagation();
      if (this.status === "inputting") {
        var _this$$refs$chatInput2;
        (_this$$refs$chatInput2 = this.$refs.chatInput) === null || _this$$refs$chatInput2 === void 0 ? void 0 : _this$$refs$chatInput2.focus();
        return;
      }
      if (this.status === "upload") {
        this.$emit("upload");
        return;
      }
      if (this.status !== "choosing") return;
      this.menuVisible = value;
    },
    // 换行并滚动到光标所在行
    mockEnterEvent() {
      const input = this.$refs.chatInput;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const {
        value
      } = input;

      // 在光标位置插入换行符
      input.value = `${value.substring(0, start)}\n${value.substring(end, value.length)}`;
      // 移动光标到换行符之后
      input.setSelectionRange(start + 1, start + 1);
      this.$nextTick(() => {
        // 获取光标所在行
        const lines = input.value.substr(0, input.selectionStart).split("\n");
        const cursorLine = lines.length;

        // 滚动到光标所在行
        const lineHeight = parseInt(window.getComputedStyle(input).lineHeight, 10);
        const {
          offsetHeight
        } = input;
        if (cursorLine > offsetHeight / lineHeight) {
          input.scrollTop = cursorLine * lineHeight - offsetHeight;
        }
      });
    },
    // 输入框点击回车
    inputKeyupHandler(e) {
      if (e.keyCode === 13 && this.status === "inputting") {
        e.preventDefault();
        const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
        if (this.preventEnter || e.ctrlKey || isMac && e.metaKey) {
          this.mockEnterEvent();
        } else {
          this.sendMessage();
        }
      }
    },
    sendMessage() {
      const messageText = this.isRichText ? this.messageValue.replace(/\n{1,}/g, "\n") : this.messageValue.trim();
      if (messageText !== "") {
        this.$emit("message", messageText);
        this.messageValue = "";
      } else {
        this.messageValue = "";
      }
    },
    // 点击发送按钮
    sendClickHandler(event) {
      event.stopPropagation();
      if ([("choosing", "disabled")].includes(this.status)) return;
      if (this.status === "inputting") {
        this.sendMessage();
      }
      if (this.status === "waiting") {
        this.showInterruptMenu = true;
      }
    },
    // 点击其他区域，关闭中断任务 menu
    interruptMenuCloseHandler() {
      this.showInterruptMenu = false;
    },
    // 点击 icon 显示中断任务 menu
    interruptClickHandler() {
      this.showInterruptMenu = false;
      this.$emit("interrupt", this.messageValue);
    },
    focus() {
      var _this$$refs$chatInput3;
      (_this$$refs$chatInput3 = this.$refs.chatInput) === null || _this$$refs$chatInput3 === void 0 ? void 0 : _this$$refs$chatInput3.focus();
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/input/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var base_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/base/input/index.vue?vue&type=style&index=0&id=42903b2f&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/input/index.vue?vue&type=style&index=0&id=42903b2f&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/input/index.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  base_inputvue_type_script_lang_js_,
  inputvue_type_template_id_42903b2f_scoped_true_render,
  inputvue_type_template_id_42903b2f_scoped_true_staticRenderFns,
  false,
  null,
  "42903b2f",
  null
  
)

/* harmony default export */ var input = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/base/m-input/index.vue?vue&type=template&id=354e5726&scoped=true&
var m_inputvue_type_template_id_354e5726_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isCollapse,
            expression: "isCollapse"
          }
        ],
        staticClass: "chat-m-input"
      },
      [
        _c(
          "div",
          { staticClass: "chat-input", style: { height: _vm.textareaHeight } },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.handleCloseMenu,
                    expression: "handleCloseMenu"
                  }
                ],
                staticClass: "input-area",
                on: { click: _vm.handleInputWrapClick }
              },
              [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.messageValue,
                      expression: "messageValue"
                    }
                  ],
                  ref: "textarea",
                  staticClass: "chat-textarea",
                  style: {
                    paddingRight: _vm.textareaRow == 1 ? "34px" : "12px"
                  },
                  attrs: {
                    disabled: _vm.inputDisabled,
                    rows: _vm.textareaRow,
                    placeholder: _vm.placeholder
                  },
                  domProps: { value: _vm.messageValue },
                  on: {
                    click: _vm.handleInputClick,
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.messageValue = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "chat-input-foot",
                    class: { "chat-input-foot-rows": _vm.textareaRow > 1 }
                  },
                  [
                    _c("SvgIcon", {
                      class: [
                        "chat-input-send",
                        `chat-input-send-${_vm.buttonStatus}`
                      ],
                      attrs: { name: _vm.sendSvgName },
                      nativeOn: {
                        click: function($event) {
                          return _vm.sendClickHandler.apply(null, arguments)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.inputDisabled,
                      expression: "inputDisabled"
                    }
                  ],
                  staticClass: "mask-block",
                  on: { click: _vm.handlerInput }
                }),
                _vm._v(" "),
                _vm.showMenu
                  ? _c(
                      "ul",
                      { staticClass: "chat-menu" },
                      _vm._l(_vm.menuList, function(menu, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            staticClass: "chat-menu-item",
                            on: {
                              click: function($event) {
                                return _vm.handleChooseMenu($event, menu)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(menu.label) +
                                "\n                    "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.toolList.length
              ? _c(
                  "div",
                  { staticClass: "input-tool" },
                  [
                    _c("SvgIcon", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.textareaRow > 1,
                          expression: "textareaRow > 1"
                        }
                      ],
                      attrs: { name: "wenwen-ai/collapse" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.allScreenText.apply(null, arguments)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("SvgIcon", {
                      staticClass: "show-tool-btn",
                      attrs: { name: "wenwen-ai/tool" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.showToolContent.apply(null, arguments)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showToolList && _vm.toolList.length,
                expression: "showToolList && toolList.length"
              }
            ],
            staticClass: "tools-content"
          },
          _vm._l(_vm.toolList, function(item) {
            return _c(
              "div",
              {
                key: item.svgName,
                staticClass: "tool-btn",
                on: {
                  click: function($event) {
                    return _vm.clickTool(item)
                  }
                }
              },
              [
                _c("SvgIcon", { attrs: { name: `wenwen-ai/${item.svgName}` } }),
                _vm._v(
                  "\n                " + _vm._s(item.title) + "\n            "
                )
              ],
              1
            )
          }),
          0
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isCollapse,
            expression: "!isCollapse"
          }
        ],
        staticClass: "all-screen",
        style: { height: _vm.innerHeight }
      },
      [
        _c("div", { staticClass: "all-screen-textarea" }, [
          _c(
            "div",
            { staticClass: "text-content" },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.messageValue,
                    expression: "messageValue"
                  }
                ],
                ref: "allTextarea",
                staticClass: "textarea",
                domProps: { value: _vm.messageValue },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.messageValue = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("SvgIcon", {
                staticClass: "collapse-icon",
                attrs: { name: "wenwen-ai/collapse" },
                nativeOn: {
                  click: function($event) {
                    return _vm.allScreenText.apply(null, arguments)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tool-content" },
            [
              _c("SvgIcon", {
                attrs: { name: "wenwen-ai/clear" },
                nativeOn: {
                  click: function($event) {
                    return _vm.clear.apply(null, arguments)
                  }
                }
              }),
              _vm._v(" "),
              _c("SvgIcon", {
                class: [
                  "chat-input-send",
                  `chat-input-send-${_vm.buttonStatus}`
                ],
                attrs: { name: _vm.sendSvgName },
                nativeOn: {
                  click: function($event) {
                    return _vm.sendClickHandler.apply(null, arguments)
                  }
                }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var m_inputvue_type_template_id_354e5726_scoped_true_staticRenderFns = []
m_inputvue_type_template_id_354e5726_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/m-input/index.vue?vue&type=template&id=354e5726&scoped=true&

// EXTERNAL MODULE: ./packages/toast/index.js + 7 modules
var toast = __webpack_require__(14);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/base/m-input/index.vue?vue&type=script&lang=js&



/* harmony default export */ var m_inputvue_type_script_lang_js_ = ({
  name: "WenwenAiMInput",
  components: {
    SvgIcon: svg_icon["a" /* default */]
  },
  directives: {
    ClickOutside: clickoutside
  },
  props: {
    // choosing: 可选择
    // waiting: 请等待
    // inputting: 可输入
    // disabled: 不可用
    // upload: 上传
    status: {
      type: String,
      default: ""
    },
    // 富文本，保留换行符
    isRichText: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String,
      default: "home"
    },
    sceneType: {
      type: String,
      default: ""
    },
    pType: {
      type: Number,
      default: 0
    },
    hasQuestion: {
      type: Boolean,
      default: false
    },
    toastFn: {
      type: Function,
      default: null
    },
    placeholder: {
      type: String,
      default: "请输入"
    },
    menuList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      messageValue: "",
      showToolList: false,
      textareaRow: 1,
      isCollapse: true,
      innerHeight: "",
      startY: 0,
      menuVisible: false // 是否显示菜单
    };
  },

  computed: {
    inputDisabled() {
      return this.status !== "inputting";
    },
    sendSvgName() {
      return "wenwen-ai/send-solid";
    },
    buttonStatus() {
      if (["choosing", "disabled", "upload"].includes(this.status) || this.status === "inputting" && this.messageValue === "") return "disabled";
      return this.status || "disabled";
    },
    isEditPage() {
      return this.pageName === "edit";
    },
    toolList() {
      const titileSuffix = this.isEditPage ? "导入" : "创建";
      const selectvalue = this.isEditPage ? "question" : "project";
      const sceneMenu = ["问卷", "表单", "试卷"];
      const sceneName = sceneMenu[this.pType];
      const menuMapping = {
        lib: [],
        home: ["aiCreate", "textCreate", "photoCreate"],
        create: ["aiCreate", "textCreate", "photoCreate"],
        edit: ["aiCreate", "textCreate", "photoCreate", "modifyProject", "aiGenerateQuestion", "checkContent"],
        // 编辑页没有题目时，不显示“修改答卷”、“内容检查”
        editNoQuestion: ["aiCreate", "textCreate", "photoCreate"]
      };
      const pageType = this.isEditPage && !this.hasQuestion ? "editNoQuestion" : this.pageName;
      return [{
        svgName: "AI-create",
        title: `AI${titileSuffix}`,
        type: "aiCreate",
        selectInfo: {
          label: `请帮我出${sceneName}`,
          value: `create_project`
        }
      }, {
        svgName: "Text-create",
        title: `文本${titileSuffix}`,
        type: "textCreate",
        selectInfo: {
          label: `请帮我通过文本${titileSuffix}`,
          value: `create_${selectvalue}_from_text`
        }
      }, {
        svgName: "Photo-create",
        title: `拍照${titileSuffix}`,
        type: "photoCreate",
        selectInfo: {
          label: `请帮我通过拍照${titileSuffix}`,
          value: `create_${selectvalue}_from_image`
        }
      }, {
        svgName: "Edit-project",
        title: `修改${sceneName}`,
        type: "modifyProject",
        selectInfo: {
          label: `我想要提修改意见`,
          value: `edit_template`
        }
      }, {
        svgName: "AI-question",
        title: "AI出题",
        type: "aiGenerateQuestion",
        selectInfo: {
          label: `请帮我出题目`,
          value: `create_question_text`
        }
      }, {
        svgName: "Check-content",
        title: "内容检查",
        type: "checkContent",
        selectInfo: {
          label: `请帮我检查内容`,
          value: `check_content`
        }
      }].filter(item => (menuMapping[pageType] || []).includes(item.type));
    },
    textareaHeight() {
      return `${this.textareaRow * 20 + 16 + 8 + (this.textareaRow > 1 ? 30 : 0)}px`;
    },
    showMenu() {
      return this.status === "choosing" && this.menuList.length > 0 && this.menuVisible;
    }
  },
  watch: {
    status(newValue, oldValue) {
      // 输入状态切换为其他状态时，清空输入框内容
      if (oldValue === "inputting" && newValue !== "inputting") {
        this.messageValue = "";
      }
      if (newValue === "inputting") {
        this.$nextTick(() => {
          var _this$$refs$chatInput;
          (_this$$refs$chatInput = this.$refs.chatInput) === null || _this$$refs$chatInput === void 0 ? void 0 : _this$$refs$chatInput.focus();
        });
      }

      // 状态更新时，若上次是等待中，且点开了“中断任务”菜单，需隐藏“中断任务”的菜单
      if (oldValue === "waiting" && this.showInterruptMenu) {
        this.interruptMenuCloseHandler();
      }
    },
    // 文本域自适应高度
    messageValue(val, oldval) {
      // 文本被删除时 默认控制文本域行数减1
      if (val.length < oldval.length && this.textareaRow > 1) this.textareaRow -= 1;

      // 有换行符时 文本域行数等于换行符+1
      const matches = val.match(/\n/g);
      if (matches) {
        this.textareaRow = matches.length < 4 ? ((matches === null || matches === void 0 ? void 0 : matches.length) || 0) + 1 : 4;
      } else {
        this.textareaRow = 1;
      }

      // 无论是否有换行符 检测文本域的滚动高度 文本域行数等于 滚动高度/20
      this.$nextTick(() => {
        if (this.$refs.textarea.scrollHeight !== this.$refs.textarea.clientHeight && this.textareaRow < 4) {
          this.textareaRow = Math.min(this.$refs.textarea.scrollHeight / 20, 4);
        }
      });
    }
  },
  mounted() {
    const vm = this;
    this.$refs.allTextarea.addEventListener("focus", () => {
      vm.callback && vm.callback("up");
    });
    this.$refs.allTextarea.addEventListener("blur", e => {
      vm.callback && vm.callback("down", e);
    });
  },
  methods: {
    // 全屏输入框 聚焦失焦 回调函数
    callback(type, e) {
      if (type == "down") {
        if (e.target !== this.$refs.allTextarea) this.isCollapse = true;
        this.$refs.allTextarea.removeEventListener("touchstart", this.getTouchStart);
        this.$refs.allTextarea.removeEventListener("touchmove", this.allScreenScroll, true, {
          passive: false
        });
        document.removeEventListener("touchmove", this.stopScroll);
        return;
      }
      setTimeout(() => {
        this.innerHeight = `${Math.min(window.innerHeight, window.visualViewport.height) + 8}px`;
        // 触摸的起始位置
        this.$refs.allTextarea.addEventListener("touchstart", this.getTouchStart);
        this.$refs.allTextarea.addEventListener("touchmove", this.allScreenScroll, true, {
          passive: false
        });
        document.addEventListener("touchmove", this.stopScroll, {
          passive: false
        });
      }, 100);
    },
    showToolContent() {
      this.showToolList = !this.showToolList;
      // 打开工具栏 对话框自动滚动到底部
      this.$nextTick(() => {
        this.$parent.messageScrollToBottom();
      });
    },
    clickTool(tool) {
      if (this.status === "waiting") {
        toast["a" /* default */].show({
          message: "问问正在执行任务，待任务结束后再点击"
        });
      } else {
        this.$emit("startNewTask", tool.selectInfo.value);
      }
    },
    sendMessage() {
      const messageText = this.isRichText ? this.messageValue.replace(/\n{1,}/g, "\n") : this.messageValue.trim();
      if (messageText !== "") {
        this.$emit("message", messageText);
        this.messageValue = "";
        this.textareaRow = 1;
      } else {
        this.messageValue = "";
      }
    },
    // 点击发送按钮
    sendClickHandler() {
      if ([("choosing", "disabled")].includes(this.status)) return;
      if (this.status === "inputting") {
        this.sendMessage();
        this.isCollapse = true;
      }
      if (this.status === "waiting") {
        this.showInterruptMenu = true;
      }
    },
    allScreenText() {
      this.isCollapse = !this.isCollapse;
      if (!this.isCollapse) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.$nextTick(() => {
          this.$refs.allTextarea.focus();
        });
      }
    },
    clear() {
      var _this$$refs$allTextar;
      (_this$$refs$allTextar = this.$refs.allTextarea) === null || _this$$refs$allTextar === void 0 ? void 0 : _this$$refs$allTextar.focus();
      this.messageValue = "";
    },
    // 禁止滑动
    stopScroll(e) {
      e.preventDefault();
    },
    // 获取触摸初始位置
    getTouchStart(e) {
      console.log(e);
      this.startY = e.touches[0].clientY;
    },
    // 允许全屏文本域滑动
    allScreenScroll(e) {
      console.log(e);
      const client = this.$refs.allTextarea.clientHeight;
      const {
        scrollHeight
      } = this.$refs.allTextarea;
      const {
        scrollTop
      } = this.$refs.allTextarea;
      const touch = e.touches[0];
      const deltaY = touch.clientY - this.startY;
      // 顶部向上拉\底部向下拉 禁止页面滚动
      if (scrollHeight === 0 && deltaY > 0 || scrollHeight - scrollTop <= client && deltaY < 0) {
        e.preventDefault();
      } else {
        e.stopPropagation();
      }
    },
    focus() {
      this.isCollapse = false;
      this.$nextTick(() => {
        var _this$$refs$allTextar2;
        (_this$$refs$allTextar2 = this.$refs.allTextarea) === null || _this$$refs$allTextar2 === void 0 ? void 0 : _this$$refs$allTextar2.focus();
      });
    },
    handlerInput() {
      setTimeout(() => {
        var _this$toastFn;
        if (this.toastFn) return (_this$toastFn = this.toastFn) === null || _this$toastFn === void 0 ? void 0 : _this$toastFn.call(this, {
          status: this.status,
          type: "mobile"
        });
        if (this.status === "waiting") toast["a" /* default */].show({
          message: "问问正在执行任务，待任务结束后再点击"
        });
      }, 300);
    },
    handleInputClick(event) {
      if (this.status !== "inputting") {
        event.preventDefault();
      }
    },
    // 点击其他区域，关闭menu
    handleCloseMenu() {
      this.menuVisible = false;
    },
    // 输入框点击事件
    handleInputWrapClick(e) {
      e.stopPropagation();
      if (this.status === "upload") {
        this.$emit("upload");
        return;
      }
      if (this.status !== "choosing") return;
      this.menuVisible = true;
    },
    handleChooseMenu(e, menu) {
      e.stopPropagation();
      this.menuVisible = false;
      this.$emit("select", menu);
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/m-input/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var base_m_inputvue_type_script_lang_js_ = (m_inputvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/base/m-input/index.vue?vue&type=style&index=0&id=354e5726&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/m-input/index.vue?vue&type=style&index=0&id=354e5726&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/m-input/index.vue






/* normalize component */

var m_input_component = Object(componentNormalizer["a" /* default */])(
  base_m_inputvue_type_script_lang_js_,
  m_inputvue_type_template_id_354e5726_scoped_true_render,
  m_inputvue_type_template_id_354e5726_scoped_true_staticRenderFns,
  false,
  null,
  "354e5726",
  null
  
)

/* harmony default export */ var m_input = (m_input_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/main/index.vue?vue&type=template&id=144fd654&
var mainvue_type_template_id_144fd654_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wenwen-ai-main" }, [
    _c(
      "div",
      { class: ["ai-main", { "has-operation-bar": _vm.historyEnable }] },
      [
        _c(
          "Transition",
          {
            attrs: { name: "chat-fade", mode: "out-in" },
            on: { "after-enter": _vm.chatFadeAfterEnterHandler }
          },
          [
            _vm.introShow
              ? _c(
                  "div",
                  { key: "intro", staticClass: "ai-intro" },
                  [
                    _vm._l(_vm.introList, function(intro, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "wenwen-ai-chat-block intro-block",
                          on: {
                            click: function($event) {
                              return _vm.clickMessageModHandler(intro)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "chat-title" }, [
                            _vm._v(_vm._s(intro.title))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "chat-description" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(intro.description) +
                                "\n                    "
                            )
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.pageName === "edit"
                      ? _c("div", { staticClass: "ai-intro-rule" }, [
                          _c("p", [_vm._v(_vm._s(_vm.editIntroRule.message))]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  target: "_blank",
                                  href: _vm.editIntroRule.linkUrl
                                }
                              },
                              [
                                _vm._v(_vm._s(_vm.editIntroRule.buttonText)),
                                _c("SvgIcon", {
                                  staticClass: "icon-arrow-right",
                                  attrs: { name: "wenwen-ai/arrow-right" }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      : _vm._e()
                  ],
                  2
                )
              : _c(
                  "div",
                  {
                    key: "message",
                    ref: "ai-message",
                    class: [
                      "ai-message",
                      { "ai-message-drawer": _vm.displayType === "drawer" }
                    ]
                  },
                  [_vm._t("message")],
                  2
                )
          ]
        ),
        _vm._v(" "),
        _vm.pageName === "edit" && _vm.platform != "mobile"
          ? _c(
              "div",
              { staticClass: "ai-operation-bar" },
              [
                _vm.historyEnable && _vm.introShow
                  ? _c(
                      "wd-button",
                      {
                        attrs: { size: "small", type: "secondary" },
                        on: { click: _vm.historyHandler }
                      },
                      [_vm._v("历史对话")]
                    )
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "ai-interaction" }, [_vm._t("input")], 2)
  ])
}
var mainvue_type_template_id_144fd654_staticRenderFns = []
mainvue_type_template_id_144fd654_render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/main/index.vue?vue&type=template&id=144fd654&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/button.css"
var button_css_ = __webpack_require__(8);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/button"
var button_ = __webpack_require__(3);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// EXTERNAL MODULE: external "animated-scroll-to"
var external_animated_scroll_to_ = __webpack_require__(195);
var external_animated_scroll_to_default = /*#__PURE__*/__webpack_require__.n(external_animated_scroll_to_);

// EXTERNAL MODULE: ./src/assets/js/event-bus.js
var event_bus = __webpack_require__(24);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/main/index.vue?vue&type=script&lang=js&





/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: "WenwenAiDrawer",
  components: {
    SvgIcon: svg_icon["a" /* default */],
    wdButton: button_default.a
  },
  props: {
    // lib: 模板页; list: 列表页; create: 创建页; edit: 编辑页;
    pageName: {
      type: String,
      default: ""
    },
    // 简介是否显示
    introShow: {
      type: Boolean,
      default: true
    },
    // 简介信息列表
    introList: {
      type: Array,
      default: () => []
    },
    // 是否显示历史记录
    historyEnable: {
      type: Boolean,
      default: false
    },
    displayType: {
      type: String,
      default: "drawer"
    },
    // 判断设备类型
    platform: {
      type: String,
      default: "PC"
    }
  },
  data() {
    return {
      editIntroRule: {
        message: `根据有关要求，请勿发布政治、军事、宗教、民族、人权等敏感内容，谢谢理解`,
        buttonText: `我要提意见`,
        linkUrl: `https://www.wenjuan.com/s/UZBZJvIRHz/`
      },
      messageScrollTop: 0,
      touchStart: 0 // 记录移动端滑动事件初始位置
    };
  },

  computed: {},
  mounted() {
    if (!this.introShow) this.messageScrollHandler("on");
    // 监听 chat 组件的 scrollToBottom 事件
    event_bus["a" /* EventBus */].$on("wenwenAIChatScrollToBottom", () => {
      this.messageScrollToBottom();
    });
  },
  beforeDestroy() {
    this.messageScrollHandler("off");
    // 移除对 chat 组件的 scrollToBottom 事件的监听
    event_bus["a" /* EventBus */].$off("wenwenAIChatScrollToBottom");
  },
  methods: {
    clickMessageModHandler(intro) {
      this.$emit("select", intro.value);
    },
    // 历史对话
    historyHandler() {
      this.$emit("history");
    },
    // 滚动到 message div 底部
    messageScrollToBottom() {
      const aiMessageEl = this.$refs["ai-message"];
      if (!aiMessageEl) return;

      // 默认滚动到最底部
      const {
        scrollHeight
      } = aiMessageEl;
      external_animated_scroll_to_default()(scrollHeight, {
        elementToScroll: aiMessageEl,
        easing: t => t,
        speed: 50,
        maxDuration: 500
      });
    },
    // message scroll 事件监听
    messageScrollHandler(opearate) {
      const aiMessageEl = this.$refs["ai-message"];
      if (opearate === "on") {
        aiMessageEl === null || aiMessageEl === void 0 ? void 0 : aiMessageEl.addEventListener("scroll", this.messageScroll);
        aiMessageEl === null || aiMessageEl === void 0 ? void 0 : aiMessageEl.addEventListener("wheel", this.messageMousewheel);
        // 移动端绑定滑动事件 上滑加载历史记录
        if (this.platform == "mobile") {
          aiMessageEl === null || aiMessageEl === void 0 ? void 0 : aiMessageEl.addEventListener("touchmove", this.messageTouchMove);
          aiMessageEl === null || aiMessageEl === void 0 ? void 0 : aiMessageEl.addEventListener("touchstart", this.messageTouchStart);
        }
      } else {
        this.messageScrollTop = 0;
        aiMessageEl === null || aiMessageEl === void 0 ? void 0 : aiMessageEl.removeEventListener("scroll", this.messageScroll);
        aiMessageEl === null || aiMessageEl === void 0 ? void 0 : aiMessageEl.removeEventListener("wheel", this.messageMousewheel);
        // 移动端解绑滑动事件
        if (this.platform == "mobile") {
          aiMessageEl === null || aiMessageEl === void 0 ? void 0 : aiMessageEl.removeEventListener("touchmove", this.messageTouchMove);
          aiMessageEl === null || aiMessageEl === void 0 ? void 0 : aiMessageEl.removeEventListener("touchstart", this.messageTouchStart);
        }
      }
    },
    messageScroll(e) {
      const {
        scrollTop
      } = e.target;
      this.messageScrollTop = scrollTop;
      if (!this.introShow && scrollTop <= 0) {
        this.$emit("scrollMessageTop");
      }
    },
    messageTouchMove(e) {
      const moveEndY = e.changedTouches[0].pageY;
      const aiMessageEl = this.$refs["ai-message"];
      if (!aiMessageEl) return;
      if (moveEndY > this.touchStart && aiMessageEl.scrollTop <= 0) {
        this.$emit("scrollMessageTop");
      }
    },
    messageTouchStart(e) {
      this.touchStart = e.touches[0].pageY || 0;
    },
    messageMousewheel(e) {
      const aiMessageEl = this.$refs["ai-message"];
      if (!aiMessageEl) return;
      // 有滚动条时不触发 mousewheel 事件
      if (aiMessageEl.scrollHeight > aiMessageEl.clientHeight && this.messageScrollTop > 0) return;
      if (e.wheelDelta) {
        // webkit
        if (this.messageScrollTop <= 0 && e.wheelDelta > 0) {
          this.$emit("scrollMessageTop");
        }
      } else if (e.detail) {
        // firefox
        if (this.messageScrollTop <= 0 && e.detail > 0) {
          this.$emit("scrollMessageTop");
        }
      }
    },
    // chat transition动画结束回调
    chatFadeAfterEnterHandler() {
      this.messageScrollHandler(this.introShow ? "off" : "on");
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/main/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/main/index.vue?vue&type=style&index=0&id=144fd654&prod&lang=scss&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/wenwen-ai/src/main/index.vue?vue&type=style&index=0&id=144fd654&prod&lang=scss&

// CONCATENATED MODULE: ./packages/wenwen-ai/src/main/index.vue






/* normalize component */

var main_component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  mainvue_type_template_id_144fd654_render,
  mainvue_type_template_id_144fd654_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var main = (main_component.exports);
// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/index.js
const conversations_files = __webpack_require__(217);
const modules = {};
conversations_files.keys().forEach(filePath => {
  const file = conversations_files(filePath);
  const componentName = file.default.name;
  modules[componentName] = file.default || file;
});
/* harmony default export */ var conversations = (modules);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/base/history-loading/index.vue?vue&type=template&id=05039410&scoped=true&
var history_loadingvue_type_template_id_05039410_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "history-loading" },
    [
      _c("SvgIcon", {
        staticClass: "loading-icon",
        attrs: { name: "wenwen-ai/history-loading" }
      })
    ],
    1
  )
}
var history_loadingvue_type_template_id_05039410_scoped_true_staticRenderFns = []
history_loadingvue_type_template_id_05039410_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/history-loading/index.vue?vue&type=template&id=05039410&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/base/history-loading/index.vue?vue&type=script&lang=js&

/* harmony default export */ var history_loadingvue_type_script_lang_js_ = ({
  name: "HistoryLoading",
  components: {
    SvgIcon: svg_icon["a" /* default */]
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/history-loading/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var base_history_loadingvue_type_script_lang_js_ = (history_loadingvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/base/history-loading/index.vue?vue&type=style&index=0&id=05039410&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/history-loading/index.vue?vue&type=style&index=0&id=05039410&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/wenwen-ai/src/base/history-loading/index.vue






/* normalize component */

var history_loading_component = Object(componentNormalizer["a" /* default */])(
  base_history_loadingvue_type_script_lang_js_,
  history_loadingvue_type_template_id_05039410_scoped_true_render,
  history_loadingvue_type_template_id_05039410_scoped_true_staticRenderFns,
  false,
  null,
  "05039410",
  null
  
)

/* harmony default export */ var history_loading = (history_loading_component.exports);
// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/tools.js
var tools = __webpack_require__(127);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./src/components/answer-preview-dialog/index.vue?vue&type=template&id=55dc5394&scoped=true&
var answer_preview_dialogvue_type_template_id_55dc5394_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "WdDialog",
    {
      staticClass: "answer-preview-dialog",
      attrs: {
        title: "手机预览",
        visible: _vm.visible,
        "show-close": false,
        width: "280px",
        center: ""
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "qrcode-tip" }, [
        _vm._v("\n        仅供预览请勿传播 将于"),
        _c("span", [_vm._v(_vm._s(_vm.expireTime))]),
        _vm._v("失效\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "qrcode-wrapper" }, [
        _c("div", { staticClass: "qrcode" }, [
          _vm.qrCodeUrl
            ? _c("img", { attrs: { src: _vm.qrCodeUrl } })
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.isExpire
          ? _c("div", { staticClass: "expire-wrapper" }, [
              _c("div", [_vm._v("二维码已过期")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "qrcode-refresh",
                  on: {
                    click: function($event) {
                      return _vm.refreshQRcode()
                    }
                  }
                },
                [
                  _c("SvgIcon", { attrs: { name: "preview-refresh" } }),
                  _vm._v("\n                立即刷新\n            ")
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "WDButton",
        {
          staticClass: "btn",
          attrs: { size: "tertiary", type: "secondary" },
          on: { click: _vm.closeHandler }
        },
        [_vm._v("\n        好的\n    ")]
      )
    ],
    1
  )
}
var answer_preview_dialogvue_type_template_id_55dc5394_scoped_true_staticRenderFns = []
answer_preview_dialogvue_type_template_id_55dc5394_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./src/components/answer-preview-dialog/index.vue?vue&type=template&id=55dc5394&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dialog.css"
var dialog_css_ = __webpack_require__(16);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dialog"
var dialog_ = __webpack_require__(7);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog_);

// EXTERNAL MODULE: external "qrcode"
var external_qrcode_ = __webpack_require__(198);
var external_qrcode_default = /*#__PURE__*/__webpack_require__.n(external_qrcode_);

// CONCATENATED MODULE: ./src/components/answer-preview-dialog/qr-code.js


// 生成二维码
async function generateQRCode(options) {
  const {
    url,
    width,
    margin,
    errorCorrectionLevel
  } = options;
  options = {
    margin: margin || 0,
    width,
    errorCorrectionLevel: errorCorrectionLevel || "L"
  };
  try {
    return await external_qrcode_default.a.toDataURL(url, options);
  } catch (err) {
    console.error(err, "二维码生成错误");
  }
}

// 前端生成二维码-下载二维码
function downloadGenerateQRCode(url) {
  let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "图片";
  if (window.navigator.msSaveOrOpenBlob) {
    // ie
    const bstr = atob(url.split(",")[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const blob = new Blob([u8arr]);
    window.navigator.msSaveOrOpenBlob(blob, `${name}.png`);
  } else {
    // 非ie
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", `${name}.png`);
    a.click();
  }
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/answer-preview-dialog/index.vue?vue&type=script&lang=js&







/* harmony default export */ var answer_preview_dialogvue_type_script_lang_js_ = ({
  name: "AnswerPreviewDialog",
  components: {
    WdDialog: dialog_default.a,
    WDButton: button_default.a,
    SvgIcon: svg_icon["a" /* default */]
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: String,
      default: ""
    },
    surveyUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      expireTime: "",
      qrCodeUrl: "",
      isExpire: false
    };
  },
  mounted() {
    this.getQRCodeUrl();
  },
  methods: {
    // 生成二维码
    async getQRCodeUrl() {
      var _res$data;
      this.isExpire = false;
      const res = await Object(wenwen_ai["a" /* getEncryptedPreviewUrl */])({
        url: `${this.surveyUrl}?test=1`,
        project_id: this.projectId
      });
      const {
        protocol,
        host
      } = window.location;
      const options = {
        url: `${protocol}//${host}${(_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.url}`
      };
      this.qrCodeUrl = await generateQRCode(options);
      this.handleExpireTime();
    },
    // 过去时间控制
    handleExpireTime() {
      const date = new Date();
      date.setMinutes(date.getMinutes() + 15);
      const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
      const min = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
      this.expireTime = `${hours}:${min}`;
      setTimeout(() => {
        this.isExpire = true;
      }, 15 * 60 * 1000);
    },
    refreshQRcode() {
      this.getQRCodeUrl();
    },
    closeHandler() {
      this.$emit("update:visible", false);
    }
  }
});
// CONCATENATED MODULE: ./src/components/answer-preview-dialog/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_answer_preview_dialogvue_type_script_lang_js_ = (answer_preview_dialogvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/answer-preview-dialog/index.vue?vue&type=style&index=0&id=55dc5394&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./src/components/answer-preview-dialog/index.vue?vue&type=style&index=0&id=55dc5394&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./src/components/answer-preview-dialog/index.vue






/* normalize component */

var answer_preview_dialog_component = Object(componentNormalizer["a" /* default */])(
  components_answer_preview_dialogvue_type_script_lang_js_,
  answer_preview_dialogvue_type_template_id_55dc5394_scoped_true_render,
  answer_preview_dialogvue_type_template_id_55dc5394_scoped_true_staticRenderFns,
  false,
  null,
  "55dc5394",
  null
  
)

/* harmony default export */ var answer_preview_dialog = (answer_preview_dialog_component.exports);
// EXTERNAL MODULE: ./src/assets/js/utils/tools.js
var utils_tools = __webpack_require__(5);

// EXTERNAL MODULE: ./src/http/index.js + 19 modules
var http = __webpack_require__(138);

// CONCATENATED MODULE: ./src/http/wenwen-ai/edit.js


/* 删除题目
 * POST api/edit/wenwenai/delete_questions/{pid}/
 * 接口ID：105189245
 * 接口地址：https://app.apifox.com/link/project/1644278/apis/api-105189245
 */
function httpPostDeleteAllQuestions(pid) {
  return http["a" /* default */].post(`/api/edit/wenwenai/delete_questions/${pid}/`, {
    __SIGNATURE_NEW__: true
  });
}
// CONCATENATED MODULE: ./packages/wenwen-ai/src/js/create-project.js



function getCreateClientValue() {
  const ua = navigator.userAgent;
  const {
    isWeixinMiniApp,
    isQQMiniApp,
    isBaiduMiniApp,
    isTouTiaoMiniApp,
    isIosApp,
    isAndroidApp
  } = Object(utils_tools["b" /* distinguishUserAgentUtils */])(ua);
  if (isWeixinMiniApp) {
    return "wenjuan_mini_app";
  }
  if (isQQMiniApp) {
    return "wenjuan_qq_mini_app";
  }
  if (isBaiduMiniApp) {
    return "wenjuan_baidu_mini_app";
  }
  if (isTouTiaoMiniApp) {
    return "wenjuan_toutiao_mini_app";
  }
  if (isIosApp) {
    return "ios";
  }
  if (isAndroidApp) {
    return "Android";
  }
  return "";
}

// 静默创建项目
async function createProjectBySilently(projectData, projectId) {
  try {
    if (projectId) {
      await httpPostDeleteAllQuestions(projectId);
    }
    const data = await createProject(projectData, projectId);
    // TODO console
    console.log("%c createProjectBySilently", "color: green");
    console.log("projectId:", data.projectId);
    console.log("shortId:", data.shortId);
    console.log("surveyUrl:", data.surveyUrl);
    return {
      projectId: data.projectId,
      shortId: data.shortId,
      surveyUrl: data.surveyUrl
    };
  } catch (error) {
    console.log(error);
  }
}
async function createProject(projectData, projectId) {
  return new Promise(async (resolve, reject) => {
    const {
      title,
      pType,
      sceneType,
      projectFuncId,
      questions,
      welcome_message: beginDesc,
      aiSource
    } = projectData;

    // TODO 参数
    const params = {
      p_type: pType <= 0 ? null : pType,
      title,
      folder_id: sessionStorage.getItem("folderId") || "",
      project_json: {
        p_type: pType <= 0 ? "" : Number(pType),
        title,
        type_id: projectFuncId,
        ai_source: aiSource,
        welcome: beginDesc,
        question_list: formatterQuestionData(questions, {
          pType,
          sceneType
        })
      },
      project_id: projectId || undefined,
      import_type: projectId ? "1" : undefined,
      create_client: getCreateClientValue()
    };
    // 创建项目
    const resPost = await Object(wenwen_ai["g" /* httpPostImportQuestion */])(params);
    if (resPost.err_msg) {
      reject({
        error: "createError"
      });
      return;
    }
    const {
      fingerprint
    } = resPost.data;
    // 轮询获取创建结果
    const interval = setInterval(async () => {
      const resGet = await Object(wenwen_ai["d" /* httpGetImportQuestion */])(fingerprint, "1");
      const {
        continue_poll: continuePoll,
        project_id: newProjectId,
        short_id: shortId,
        survey_link: surveyUrl,
        question_list: questionList
      } = resGet.data;
      if (!continuePoll && newProjectId) {
        clearInterval(interval);
        resolve({
          projectId: newProjectId,
          shortId,
          surveyUrl,
          questionList
        });
      }
    }, 1000);
  });
}

/**
 * 格式化题目数据，例如：考试测评分值，默认5分
 * @param {*} questionList 题目列表
 * @param {*} sceneTypeObj 场景数据 {pType, sceneType}
 * @returns
 */
function formatterQuestionData(questionList, sceneTypeObj) {
  console.log("formatterQuestionData before", questionList);
  const resultQuestionList = [];
  questionList.forEach(questionItem => {
    var _questionItem$options;
    // 获取题目默认配置数据
    const defaultQuestionData = detectSceneType(sceneTypeObj).isAssess ? getAssessDefaultQuestionData(questionItem.question_type, sceneTypeObj) : getDefaultQuestionData(questionItem.question_type, sceneTypeObj);

    // 如果AI创建的题型没有映射到真实题型时，这个题目不处理
    if (!defaultQuestionData) return;
    const questionData = {
      title: questionItem.question_content,
      custom_attr: defaultQuestionData.custom_attr,
      en_name: defaultQuestionData.questionType
    };
    resultQuestionList.push({
      ...questionData,
      option_list: defaultQuestionData.option_list || ((_questionItem$options = questionItem.options) === null || _questionItem$options === void 0 ? void 0 : _questionItem$options.map(optionItem => {
        return {
          title: optionItem
        };
      })) || undefined
    });
  });
  return resultQuestionList;
}

// AI返回的题型和真实题型数据映射关系（非测评）
function getDefaultQuestionData(type, sceneTypeObj) {
  const questionTypeMapping = {
    // 单选题
    Multiple_Choice: {
      questionType: "QUESTION_TYPE_SINGLE",
      custom_attr: {
        ...(detectSceneType(sceneTypeObj).isAssess ? {
          total_score: "5"
        } : {})
      }
    },
    // 多选题
    Checkboxes: {
      questionType: "QUESTION_TYPE_MULTIPLE",
      custom_attr: {
        ...(detectSceneType(sceneTypeObj).isAssess ? {
          total_score: "5"
        } : {})
      }
    },
    // 填空题
    Text: {
      questionType: "QUESTION_TYPE_BLANK",
      custom_attr: {
        blank_type: "single"
      },
      option_list: [{
        title: "填空1"
      }]
    },
    // 日期题
    Date: {
      questionType: "QUESTION_TYPE_MULTIPLE_BLANK",
      option_list: [{
        title: "日期"
      }],
      custom_attr: {
        disp_type: "date"
      }
    },
    // 时间题
    Time: {
      questionType: "QUESTION_TYPE_MULTIPLE_BLANK",
      option_list: [{
        title: "时"
      }, {
        title: "分"
      }],
      custom_attr: {
        disp_type: "time"
      }
    },
    // NPS题
    NPS: {
      questionType: "QUESTION_TYPE_SCORE",
      custom_attr: {
        disp_type: "nps_score",
        min_answer_num: 0,
        max_answer_num: 10,
        ...(detectSceneType(sceneTypeObj).isSatis ? {
          is_satis_score: true
        } : {})
      },
      option_list: [{
        title: "选项1"
      }]
    },
    // 打分题
    Rating: {
      questionType: "QUESTION_TYPE_SCORE",
      custom_attr: {
        min_answer_num: 1,
        max_answer_num: 5,
        magnitude_scale: 1,
        // 量级刻度(1 或 0.5)
        ...(detectSceneType(sceneTypeObj).isSatis ? {
          desc_left: "不同意",
          desc_middle: "一般",
          desc_right: "非常同意",
          is_satis_score: true
        } : {})
      },
      option_list: [{
        title: "选项1"
      }]
    },
    // 签名题
    Signature: {
      questionType: "QUESTION_TYPE_MULTIPLE_BLANK",
      custom_attr: {
        disp_type: "signature",
        answer_score: "off",
        ...(detectSceneType(sceneTypeObj).isAssess ? {
          calculation: "manual_score",
          manual_score: "on",
          question_max_score: 0
        } : {})
      },
      option_list: [{
        title: "填空1"
      }]
    },
    // 上传题
    File_upload: {
      questionType: "QUESTION_TYPE_MULTIPLE_BLANK",
      custom_attr: {
        disp_type: "upload_file",
        upload_num: Number(10),
        upload_size: 30,
        upload_limit_setting: 0,
        upload_limit_content_setting: 1,
        ...(detectSceneType(sceneTypeObj).isAssess ? {
          calculation: "manual_score",
          answer_score: "on",
          total_score: 0,
          manual_score: "on"
        } : {})
      },
      option_list: [{
        title: "选择文件上传"
      }]
    },
    // 地址题
    Address: {
      questionType: "QUESTION_TYPE_BLANK_DROPDOWN",
      option_list: detectSceneType(sceneTypeObj).isSatis ? [{
        title: "省份"
      }, {
        title: "城市"
      }] : [{
        title: "省份"
      }, {
        title: "城市"
      }, {
        title: "区/县"
      }, {
        title: "详细地址"
      }],
      custom_attr: {
        drop_type: detectSceneType(sceneTypeObj).isSatis ? "city" : "address",
        disp_type: "address"
      }
    },
    True_or_false: {
      questionType: "QUESTION_TYPE_SINGLE",
      custom_attr: {
        disp_type: "judge",
        ...(detectSceneType(sceneTypeObj).isAssess ? {
          total_score: "5"
        } : {})
      }
    }
  };
  return questionTypeMapping[type];
}

// AI返回的题型和真实题型数据映射关系（测评场景）
// 考试测评只支持 3 种题型
function getAssessDefaultQuestionData(type, sceneTypeObj) {
  const questionTypeMapping = {
    // 单选题
    Multiple_Choice: getDefaultQuestionData("Multiple_Choice", sceneTypeObj),
    // 多选题
    Checkboxes: getDefaultQuestionData("Checkboxes", sceneTypeObj),
    True_or_false: {
      questionType: "QUESTION_TYPE_SINGLE",
      custom_attr: {
        disp_type: "judge",
        ...(detectSceneType(sceneTypeObj).isAssess ? {
          total_score: "5"
        } : {})
      }
    },
    // 填空题
    Text: {
      questionType: "QUESTION_TYPE_BLANK",
      custom_attr: {
        blank_type: "single"
      },
      option_list: [{
        title: "填空1"
      }]
    }
  };
  return questionTypeMapping[type];
}

// 检测项目场景
function detectSceneType(_ref) {
  let {
    pType,
    sceneType
  } = _ref;
  return {
    isSatis: sceneType === "satis",
    isAssess: pType === 2
  };
}

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/index.vue?vue&type=script&lang=js&

















/* harmony default export */ var srcvue_type_script_lang_js_ = ({
  name: "WenwenAi",
  components: {
    SvgIcon: svg_icon["a" /* default */],
    ...conversations,
    Main: main,
    WenwenAiInput: input,
    WenwenAiMInput: m_input,
    HistoryLoading: history_loading
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String,
      default: ""
    },
    // popup: 弹窗; drawer: 抽屉
    displayType: {
      type: String,
      default: "drawer"
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    conversationType: {
      type: String,
      default: ""
    },
    projectId: {
      type: String,
      default: ""
    },
    projectTitle: {
      type: String,
      default: ""
    },
    shortId: {
      type: String,
      default: ""
    },
    pType: {
      type: Number,
      default: 0
    },
    sceneType: {
      type: String,
      default: ""
    },
    extraInfo: {
      type: Object,
      default: () => {
        return {
          optionLimit: 200,
          optionCount: 0,
          questionLimit: 200,
          questionCount: 0,
          currentQuestionId: "",
          questionCid: "",
          libId: "",
          // 模板创建的模板 projectId
          projectFuncId: ""
        };
      }
    },
    // 上传文件方法
    uploadFileFn: {
      type: Function,
      default: () => {}
    },
    // 校验选项扩展是否超过选项个数限制
    checkOptionLimitFn: {
      type: Function,
      default: () => {}
    },
    // 校验每日创建项目数是否超过个数限制
    checkProjectLimit: {
      type: Function,
      default: () => {}
    },
    // 处理AI返回结果
    handleResult: {
      type: Function,
      default: () => {}
    },
    // 判断设备类型
    platform: {
      type: String,
      default: "PC"
    },
    // 输入框的toast 提示函数
    inputToastFn: {
      type: Function,
      default: null
    },
    // 项目的题目数，只有在编辑页需要传
    questionCount: {
      type: Number,
      default: 0
    },
    // 是否隐藏头部
    hideHeader: {
      type: Boolean,
      default: false
    },
    // 是否拦截立即查看跳转事件，使用emit自定义
    customViewNow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      taskType: "",
      // 任务类型
      initTaskList: [],
      // 介绍列表数据
      messageList: [],
      // 消息列表
      inputData: {},
      // 输入框数据
      lastInputData: {},
      // 上次输入框数据
      showHistory: false,
      // 是否显示历史对话按钮
      firstId: "",
      // 第一条消息的id
      page: 0,
      // 当前页数
      pageSize: 20,
      historyList: [],
      // 历史消息列表
      isLoadingMore: false,
      // 是否正在加载更多历史数据
      fileOption: {
        // 上传文件的配置
        accept: ".doc,.docx,.pdf",
        multiple: false,
        callback: "handleUploadMaterial"
      },
      // 是否有文件正在上传
      fileLoading: false,
      currentResultObj: null,
      // 用于存储当次对话后端返回的结果数据，用于用户创建项目失败时，点击再试一次，可以通过上次的项目数据再次触发创建
      questionId: "",
      // 当前题目id
      surveyUrl: "",
      // 答题链接
      mobileInitInfo: {
        id: Object(external_uuid_["v4"])(),
        content: "你好，我是问卷网AI助手问问!我不仅可以创建问卷，也可以为你优化已有问卷，激发创意，构建洞见-- 立即创建您的专属问卷。",
        conversationType: "create_project_from_link",
        messageType: "start",
        source: "system",
        template: "Common"
      },
      aiSource: 1,
      // AI创建来源
      // 初始化定义 currentAiMessage
      currentAiMessage: null
    };
  },
  computed: {
    transitionName() {
      return this.displayType === "drawer" ? "wenwen-ai-drawer-slider" : "wenwen-ai-dialog-fade";
    },
    // 当前用户消息类型
    currentMessageType() {
      var _this$currentAiMessag;
      return (_this$currentAiMessag = this.currentAiMessage) === null || _this$currentAiMessag === void 0 ? void 0 : _this$currentAiMessag.messageType;
    },
    // 聊天条数
    messageCount() {
      return this.messageList.length;
    },
    // 最后一个消息
    lastMessage() {
      return this.messageCount > 0 ? this.messageList[this.messageCount - 1] : null;
    },
    // 是否有更多历史记录
    hasMoreHistory() {
      const count = this.historyList.length;
      return count > 0 && this.page < count / this.pageSize;
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.startConversation(this.conversationType);
          // 获取历史消息记录
          this.getHistoryData();
          const hasQuestion = this.pageName === "edit" && this.questionCount > 0;
          this.initTaskList = Object(tools["b" /* getInitTaskList */])(this.pType, hasQuestion);
        }
      },
      immediate: true
    }
  },
  created() {
    event_bus["a" /* EventBus */].$on("previewAnswerPage", () => {
      this.showPreviewAnswerDialog();
    });
  },
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }
  },
  beforeDestroy() {
    event_bus["a" /* EventBus */].$off("previewAnswerPage");
  },
  destroyed() {
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    // 开始对话
    async startConversation(taskType) {
      var _this$currentAiMessag2;
      if (!taskType || taskType === "m_create_project") {
        this.resetData();
        // 初始化对话
        this.messageList = [{
          template: "ChatInit",
          id: "ChatInit",
          messageType: "init"
        }];
      } else if (((_this$currentAiMessag2 = this.currentAiMessage) === null || _this$currentAiMessag2 === void 0 ? void 0 : _this$currentAiMessag2.status) === constant["d" /* messageStatus */].WAITING) {
        // 如果当前是等待状态且执行任务类型和新类型不同，中断当前对话
        // 如果当前是等待状态且taskType是extend_options，且当前问题id不同，中断当前对话
        if (taskType !== this.taskType || taskType === "extend_options" && this.extraInfo.currentQuestionId !== this.questionId) {
          await this.interruptConversation();
          // 防止点输入框右下角“中断任务”任务类型出错
          this.currentAiMessage.isHistory = true;
          this.handleTaskSelect(taskType);
        }
      } else {
        var _this$lastMessage;
        if (((_this$lastMessage = this.lastMessage) === null || _this$lastMessage === void 0 ? void 0 : _this$lastMessage.status) === constant["d" /* messageStatus */].INIT) {
          // 如果当前是初始化状态，删除loading状态的消息
          this.messageList.splice(this.messageCount - 1, 1);
        }

        // 模板页初始文案-请帮我修改模板
        const label = this.pageName === "lib" ? "请帮我修改模板" : "";
        this.handleTaskSelect(taskType, label, taskType === "");
      }
    },
    // 重置AI消息
    resetData() {
      if (this.currentAiMessage) {
        this.$set(this.currentAiMessage, "hasReplied", true);
      }
      this.currentAiMessage = null;
      this.conversationId = "";
      this.questionId = this.extraInfo.currentQuestionId;
      // 新建会话类型，除编辑页外，都要重置当前projectId
      if (this.pageName !== "edit") {
        this.$emit("update:projectId", "");
      }
    },
    // 检查是否有历史记录
    getHistoryData() {
      const params = this.platform === "PC" ? {
        project_id: this.projectId,
        conversation_id: this.conversationId,
        p_type: this.pType || 0
      } : {};
      Object(wenwen_ai["b" /* httpGetChatHistory */])(params).then(res => {
        if (res !== null && res !== void 0 && res.data) {
          const chatList = (res === null || res === void 0 ? void 0 : res.data) || [];
          this.historyList = chatList;
          this.showHistory = chatList.length > 0;
          this.page = 0;
        }
      });
    },
    // 新增一条消息，并发送给后端，获取回复消息
    async addUserMessage(messageInfo) {
      var _this$currentAiMessag3;
      const {
        messageType = (_this$currentAiMessag3 = this.currentAiMessage) === null || _this$currentAiMessag3 === void 0 ? void 0 : _this$currentAiMessag3.nextMessageType
      } = messageInfo;
      if (messageType === "extend_options" || messageType === "retry" && this.currentAiMessage.conversationType === "extend_options") {
        messageInfo.entityId = this.questionId;
      }
      const userMessage = {
        id: Object(external_uuid_["v4"])(),
        source: "user",
        template: "Common",
        messageType,
        ...messageInfo
      };
      this.messageList.splice(this.messageCount, 0, userMessage);
      // 加一个系统占位消息, loading - 防止请求时间过长，页面出现卡死现象
      this.messageList.splice(this.messageCount, 0, {
        id: Object(external_uuid_["v4"])(),
        template: "Common",
        source: "system",
        status: constant["d" /* messageStatus */].INIT
      });
      if (this.currentAiMessage) {
        this.$set(this.currentAiMessage, "hasReplied", true);
        // 恢复项目
        if (messageType === "recover" && this.currentAiMessage.status === constant["d" /* messageStatus */].WAITING) {
          await this.interruptConversation();
        }
      }
      this.sendUserMessage(messageInfo);
    },
    // 发送用户消息
    sendUserMessage(_ref) {
      var _this$currentAiMessag4;
      let {
        conversationId = this.conversationId,
        conversationType = this.taskType,
        messageType = (_this$currentAiMessag4 = this.currentAiMessage) === null || _this$currentAiMessag4 === void 0 ? void 0 : _this$currentAiMessag4.nextMessageType,
        content,
        file = null,
        link = "",
        entityId = "",
        chatResult
      } = _ref;
      const postData = {
        conversation_id: conversationId,
        conversation_type: conversationType,
        project_id: this.projectId,
        message_type: messageType,
        content,
        entity_id: entityId,
        p_type: this.pType || 0
      };
      if (file) {
        postData.file = file;
      }
      if (link) {
        postData.link = link;
      }
      Object(wenwen_ai["f" /* httpPostConversation */])(postData).then(res => {
        if ((res === null || res === void 0 ? void 0 : res.status_code) === 1) {
          this.sendUserMessageSuccess(res, chatResult);
        } else if (res.error_code === 10110) {
          this.lastMessage.errorType = "audit";
          this.lastMessage.status = constant["d" /* messageStatus */].WARNING;
          this.lastMessage.template = "Warning";
          // 重置输入
          this.handleBackInputData();
        } else {
          this.lastMessage.content = "出错了，请稍后再试";
          this.lastMessage.status = constant["d" /* messageStatus */].WARNING;
          // 重置输入
          this.handleBackInputData();
        }
      });
    },
    // 用户消息返回后，更新当前AI消息
    sendUserMessageSuccess(res) {
      var _nextMessages$;
      let chatResult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      const {
        conversation_id: conversationId,
        conversation_type: conversationType,
        message_type: messageType,
        next_message_config: {
          message,
          message_type: aiMessageType,
          next_message_contents: nextMessages
        } = {},
        result_id: chatResultId,
        action
      } = (res === null || res === void 0 ? void 0 : res.data) || {};
      if (!this.conversationId) {
        this.conversationId = conversationId;
      }
      let template = constant["e" /* msgTemplateMapping */][aiMessageType];
      let aiMessageContent = message;
      let aiMessageStatus = "";
      if (action === "request_ai") {
        aiMessageContent = "";
        aiMessageStatus = constant["d" /* messageStatus */].WAITING;
      } else if (messageType === "recover") {
        aiMessageContent = "";
        aiMessageStatus = constant["d" /* messageStatus */].WAITING;
        template = "Recover";
      }
      this.currentAiMessage = {
        id: Object(external_uuid_["v4"])(),
        template: template || "Common",
        status: aiMessageStatus,
        source: "system",
        conversationType,
        messageType: aiMessageType,
        content: aiMessageContent,
        nextMessageType: nextMessages === null || nextMessages === void 0 ? void 0 : (_nextMessages$ = nextMessages[0]) === null || _nextMessages$ === void 0 ? void 0 : _nextMessages$.message_type,
        chatResultId,
        chatResult
      };
      this.messageList.splice(this.messageCount - 1, 1, this.currentAiMessage);
    },
    // 新增一个系统初始化消息
    addInitMessage() {
      const message = {
        id: Object(external_uuid_["v4"])(),
        template: "Common",
        source: "system",
        content: "我是问问AI，有什么可以帮助你？",
        messageType: "start"
      };
      this.messageList.splice(this.messageCount, 0, message);
      this.handleUpdateInputData();
      Object(wenwen_ai["f" /* httpPostConversation */])({
        project_id: this.projectId,
        content: message.content,
        conversation_type: "start",
        message_type: "start"
      });
    },
    // 中断对话，比如正在创建题目waiting状态，点击扩展选项按钮，中断当前对话
    async interruptConversation() {
      this.currentAiMessage.status = constant["d" /* messageStatus */].INTERRUPT;
      this.currentAiMessage.content = "任务中断";
      await Object(wenwen_ai["f" /* httpPostConversation */])({
        project_id: this.projectId,
        content: "任务中断",
        conversation_type: this.currentAiMessage.conversationType,
        conversation_id: this.conversationId,
        message_type: "abort"
      });
    },
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs.chatAiDrawer.messageScrollToBottom();
      });
    },
    // 显示预览答题页面
    showPreviewAnswerDialog() {
      const el = document.createElement("div");
      document.body.appendChild(el);
      const vm = new external_vue_default.a({
        render: h => h(answer_preview_dialog, {
          props: {
            visible: true,
            projectId: this.projectId,
            surveyUrl: this.surveyUrl
          },
          on: {
            "update:visible": value => {
              if (!value) {
                vm.$nextTick(() => {
                  vm.$destroy();
                });
              }
            }
          }
        })
      }).$mount(el);
    },
    // 处理历史数据
    handleHistoryData() {
      let chatList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      // 如果没有历史聊天记录，直接返回
      if (chatList.length === 0) {
        return [];
      }
      const result = chatList.map(item => {
        const {
          conversation_id: conversationId,
          conversation_type: conversationType,
          message_type: messageType,
          message: content,
          link,
          file,
          role: source,
          status,
          result_id: chatResultId,
          result: chatResult,
          original_result: originalResult
        } = item;
        const template = source === "system" ? constant["e" /* msgTemplateMapping */][messageType] || "Common" : "Common";
        let curMessageStatus = "";
        if (source === "system" && chatResultId) {
          curMessageStatus = status === 1 ? constant["d" /* messageStatus */].SUCCESS : constant["d" /* messageStatus */].WARNING;
        }
        const messageObj = {
          id: Object(external_uuid_["v4"])(),
          conversationId,
          conversationType,
          template,
          status: curMessageStatus,
          source,
          messageType,
          content,
          link,
          file,
          chatResultId,
          chatResult,
          isHistory: true,
          originalResult
        };
        if (messageType === "image_content") {
          // 上传图片，content是图片url
          messageObj.theme = "white";
        } else if (["upload_file", "text_content"].includes(messageType)) {
          var _messageObj$content;
          // 上传文件，显示文件类型图标
          const fileArr = (_messageObj$content = messageObj.content) === null || _messageObj$content === void 0 ? void 0 : _messageObj$content.split(".");
          if (fileArr) {
            const suffix = fileArr[fileArr.length - 1];
            messageObj.titleIcon = constant["f" /* titleIconMapping */][suffix];
          }
          messageObj.theme = "white";
        }
        return messageObj;
      });
      return result.reverse();
    },
    // 获取聊天记录
    loadMoreHistory() {
      // 没有更多数据
      if (!this.hasMoreHistory || this.isLoadingMore) return;
      this.isLoadingMore = true;
      setTimeout(() => {
        const start = this.page * this.pageSize;
        const end = start + this.pageSize;
        const pageData = this.historyList.slice(start, end);
        const historyData = this.handleHistoryData(pageData);
        if ((historyData === null || historyData === void 0 ? void 0 : historyData.length) > 0) {
          var _this$messageList$his;
          this.messageList.splice(0, 0, ...historyData);
          this.firstId = (_this$messageList$his = this.messageList[historyData.length]) === null || _this$messageList$his === void 0 ? void 0 : _this$messageList$his.id;
        }
        this.page += 1;
        this.$nextTick(() => {
          const aiMessageEl = this.$refs.chatAiDrawer.$refs["ai-message"];
          if (!aiMessageEl) return;
          const firstElement = aiMessageEl.querySelector(".first-message");
          if (firstElement) {
            const {
              offsetTop,
              offsetHeight
            } = firstElement;
            aiMessageEl.scrollTop = offsetTop > offsetHeight + 45 ? offsetTop - offsetHeight - 45 : offsetTop;
          }
          this.isLoadingMore = false;
        });
      }, 1000);
    },
    /**
     * 更新当前AI消息
     * @param {Object} item 当前AI消息
     *  */
    handleUpdateMessage(item) {
      Object.keys(item).forEach(key => {
        if (typeof this.currentAiMessage[key] === "undefined") {
          this.$set(this.currentAiMessage, key, item[key]);
        } else {
          this.currentAiMessage[key] = item[key];
        }
      });
    },
    // 各对话框中的btn变化，同步更新input的menuList
    handleUpdateInputData(data) {
      if (this.inputData.status !== "waiting") {
        // 保存上一次的输入框状态
        this.lastInputData = JSON.parse(JSON.stringify(this.inputData));
      }
      if (!data) {
        const menuList = this.initTaskList;
        this.inputData = {
          status: constant["b" /* editorStatus */].CHOOSING,
          placeholder: "",
          menuList
        };
      } else {
        this.inputData = {
          ...data
        };
      }
      this.scrollToBottom();
    },
    // 还原至上一次的输入状态
    handleBackInputData() {
      this.inputData = JSON.parse(JSON.stringify(this.lastInputData));
    },
    // 进行其他任务
    handleRestart() {
      this.resetData();
    },
    // 关闭聊天框
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    // 开始会话
    /**
     * @params {val}    任务类型
     * @params {label}   消息内容
     * @params {isStart}  是否需要一开始需要添加信息，类似mounted中是不是执行 自动插入问题 主要配合_from_all
     */
    handleTaskSelect(val, label) {
      let isStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.resetData();
      this.taskType = val;
      const content = label || Object(tools["a" /* getFirstMessage */])(val, this.pType, this.extraInfo.questionCid);

      // 在模板页面点击模板修改时 entityId 是 this.extraInfo.libId
      const entityId = this.conversationType === "edit_template" ? this.extraInfo.libId : "";
      !isStart && this.addUserMessage({
        conversationType: val,
        messageType: val,
        content,
        entityId
      });
    },
    // 校验文件类型，大小
    checkMaterialFile(file) {
      const checkFileMapping = {
        text_content: {
          fileTypeList: ["doc", "docx", "xls", "xlsx", "pdf"],
          fileTypeError: "请上传Word/Excel/Pdf文档",
          sizeLimitError: "请上传10mb以内的文档"
        },
        upload_file: {
          fileTypeList: ["doc", "docx", "pdf"],
          fileTypeError: "请上传word或pdf材料",
          sizeLimitError: "请上传10mb以内材料"
        }
      };
      const fileArr = file.name.split(".");
      const suffix = fileArr[fileArr.length - 1];
      const {
        messageType
      } = this.currentAiMessage;
      if (checkFileMapping[messageType].fileTypeList.indexOf(suffix) === -1) {
        message_default()({
          type: "error",
          message: checkFileMapping[messageType].fileTypeError,
          duration: 2000
        });
        return false;
      }
      const sizeLimit = file.size / 1024 / 1024 < 10;
      if (!sizeLimit) {
        message_default()({
          type: "error",
          message: checkFileMapping[messageType].sizeLimitError,
          duration: 2000
        });
        return false;
      }
      return true;
    },
    // 上传材料
    handleUploadMaterial(files) {
      if (!files || files.length === 0) return;
      const file = files[0];
      if (!this.checkMaterialFile(file)) {
        this.clearFileInput();
        return;
      }
      const fileArr = file.name.split(".");
      const suffix = fileArr[fileArr.length - 1];
      // 上传成功
      this.addUserMessage({
        id: Object(external_uuid_["v4"])(),
        source: "user",
        messageType: this.currentAiMessage.messageType,
        content: file.name,
        titleIcon: constant["f" /* titleIconMapping */][suffix],
        theme: "white",
        file
      });
    },
    // 重置文件input内容，重置上传状态
    clearFileInput() {
      const fileInput = this.$refs.chatAiDrawer.$el.querySelector(".upload-file-input");
      if (fileInput) fileInput.value = "";
      this.fileLoading = false;
    },
    // 上传图片
    handleUploadImage(fileList) {
      const maxSize = 20;
      const uploadConfig = {
        file: fileList[0],
        maxSize,
        projectId: this.projectId,
        keyType: "create_project_from_image",
        typeReg: /(jpg|png|jpeg|heic|tiff|webp)$/,
        typeErrorHandler: () => {
          message_default()({
            message: "图片格式有误, 仅允许jpg, png, jpeg, heic, tiff, webp的格式文件",
            type: "error"
          });
          this.clearFileInput();
        },
        sizeErrorHandler: () => {
          const errMsg = `图片太大,单张不能超过${maxSize}M`;
          message_default()({
            message: errMsg,
            type: "error"
          });
          this.clearFileInput();
        },
        uploadingHandler: () => {
          if (this.fileLoading) return;
          this.fileLoading = true;
          this.$set(this.currentAiMessage, "hasReplied", true);
          // 加一个系统占位消息
          this.messageList.splice(this.messageCount, 0, {
            id: Object(external_uuid_["v4"])(),
            template: "Common",
            source: "user",
            theme: "white",
            status: constant["d" /* messageStatus */].INIT
          });
        },
        successHandler: key => {
          const {
            status,
            source
          } = this.lastMessage;
          if (status === constant["d" /* messageStatus */].INIT && source === "user") {
            // 删除占位消息
            this.messageList.splice(this.messageCount - 1, 1);
            // uploadImgToQiniuV2 返回的是完整的url，uploadImgToQiniu返回的是key
            // const url = this.projectId ? key : uploadUrlPrefix + key;
            // 设置新的对话内容为用户发送的当个图片
            // 底色白色
            this.addUserMessage({
              content: "",
              theme: "white",
              messageType: "image_content",
              link: `${key}?imageView2/0/format/jpg`
            });
          }
          this.clearFileInput();
        },
        errorHandler: err => {
          const {
            status,
            source
          } = this.lastMessage;
          if (status === constant["d" /* messageStatus */].INIT && source === "user") {
            // pc端给出message提示，避免和移动端toast冲突
            this.platform === "PC" && message_default()({
              message: `图片${fileList[0].name}上传失败`,
              type: "error"
            });
            // 删除占位消息
            this.messageList.splice(this.messageCount - 1, 1);
            this.currentAiMessage.hasReplied = false;
          }
          this.clearFileInput();
        }
      };
      this.uploadFileFn(uploadConfig);
    },
    handleFileInputChange(event) {
      const {
        files
      } = event.target;
      this[this.fileOption.callback](files);
    },
    // 打开文件选择框
    openFileSelectDialog() {
      this.$refs.chatAiDrawer.$el.querySelector(".upload-file-input").click();
    },
    // 上传文件处理
    handleUpload() {
      var _this$currentAiMessag5;
      console.log("上传文件处理", (_this$currentAiMessag5 = this.currentAiMessage) === null || _this$currentAiMessag5 === void 0 ? void 0 : _this$currentAiMessag5.messageType);
      if (this.fileLoading) return;
      const {
        messageType
      } = this.currentAiMessage || {};
      if (messageType === "upload_source") {
        Object.assign(this.fileOption, {
          accept: ".doc,.docx,.pdf",
          multiple: false,
          callback: "handleUploadMaterial"
        });
      } else if (messageType === "text_content") {
        Object.assign(this.fileOption, {
          accept: ".doc,.docx,.xls,.xlsx,.pdf",
          multiple: false,
          callback: "handleUploadMaterial"
        });
      } else if (messageType === "image_content") {
        Object.assign(this.fileOption, {
          accept: ".png,.jpg,.jpeg,.heic,.tiff,.webp",
          multiple: false,
          callback: "handleUploadImage"
        });
      }
      this.$nextTick(() => {
        this.openFileSelectDialog();
      });
    },
    // 选择对话中的可选项
    handleMessageSelect(item) {
      var _this$currentAiMessag6;
      let hasPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (((_this$currentAiMessag6 = this.currentAiMessage) === null || _this$currentAiMessag6 === void 0 ? void 0 : _this$currentAiMessag6.status) === constant["d" /* messageStatus */].WAITING) {
        // loading状态不允许按钮操作
        const msg = "问问正在执行任务，待任务结束后再点击";
        this.platform === "mobile" ? toast["a" /* default */].show({
          message: msg
        }) : this.$message.warning(msg);
        return;
      }
      const {
        label,
        value,
        type
      } = item;
      if (this.messageCount === 0 || ["start", "init"].includes(this.lastMessage.messageType) || type === "newTask") {
        this.handleTaskSelect(value, label);
      } else if (value === "close") {
        this.handleClose();
      } else if (value === "restart") {
        this.handleRestart();
      } else if (["upload", "upload_text"].includes(value)) {
        this.handleUpload(item);
      } else if (value === "retry_check_project_limit") {
        this.currentAiMessage.status = constant["d" /* messageStatus */].WAITING;
        this.currentAiMessage.content = "问问正在处理您的问题...";
        this.createProject(this.currentResultObj);
      } else if (["create_project_from_topic", "create_question", "recover"].includes(value)) {
        // 创建项目、创建题目、恢复可能在历史消息中出现，需要给后端传递conversation_id，conversation_type, entity_id
        const {
          conversationType,
          conversationId,
          chatResultId
        } = item;
        this.addUserMessage({
          conversationType,
          conversationId,
          messageType: value,
          content: label,
          entityId: chatResultId
        });
      } else if (["view_now", "goto_edit_page"].includes(value)) {
        // 前往编辑||立即查看
        window.zytrack && window.zytrack("custom", "WenjuanAI_CreateComplete_GoToEdit", {
          Project_ShortId: this.shortId
        });
        !this.customViewNow && (window.location.href = this.platform == "mobile" ? `/m/edit/${this.projectId}` : `/edit/survey/${this.projectId}`);
        // 向外发射事件，外部可自定义
        this.$emit("select", {
          type: value
        });
      } else if (value === "preview_answer_page") {
        event_bus["a" /* EventBus */].$emit("previewAnswerPage");
        window.zytrack && window.zytrack("custom", "WenjuanAI_CreateComplete_Preview", {
          Project_ShortId: this.shortId
        });
      } else if (value === "focus_input") {
        const inputRef = this.platform === "PC" ? this.$refs.wenwenAiInput : this.$refs.wenwenAiMInput;
        inputRef.messageValue = "请转化以下文本内容：";
        this.$set(this.inputData, "preventEnter", true);
        inputRef.focus();
      } else if (value === "goto_old_text_project_page") {
        // 前往旧版
        this.$emit("select", {
          type: value
        });
      } else {
        const preText = this.inputData.placeholder;
        const messageObj = {
          source: "user",
          content: hasPrefix ? preText + label : label,
          messageType: value
        };
        // 如果是选项扩展-再来一些，则需要判断是否超过选项限制
        if (value === "more_option" && this.checkOptionLimitFn(this.questionId)) {
          return;
        }
        this.addUserMessage(messageObj);
      }
      // 埋点
      this.setGeneralEntranceTrack(value);
    },
    // 点击输入框右下角中断任务
    handleInterrupt() {
      Object(wenwen_ai["f" /* httpPostConversation */])({
        project_id: this.projectId,
        conversation_id: this.conversationId,
        conversation_type: this.currentAiMessage.conversationType,
        content: "任务中断",
        message_type: "recall"
      }).then(res => {
        if ((res === null || res === void 0 ? void 0 : res.status_code) === 1) {
          var _this$currentAiMessag7;
          let i = this.messageCount - 1;
          let removeCount = 0;
          for (; i >= 0; i--) {
            const item = this.messageList[i];
            removeCount += 1;
            if (item.source === "user") {
              break;
            }
          }
          this.messageList.splice(i, removeCount);
          // 更新当前AI消息的状态，取消轮询
          if (((_this$currentAiMessag7 = this.currentAiMessage) === null || _this$currentAiMessag7 === void 0 ? void 0 : _this$currentAiMessag7.status) === constant["d" /* messageStatus */].WAITING) {
            this.currentAiMessage.status = constant["d" /* messageStatus */].WARNING;
            this.currentAiMessage.content = "任务中断";
          }
          if (this.lastMessage.isHistory) {
            this.addInitMessage();
          } else {
            this.currentAiMessage = this.messageList[this.messageCount - 1];
            this.currentAiMessage.hasReplied = false;
          }
        }
      });
    },
    // 输入框发送用户消息
    handleInput(message) {
      this.addUserMessage({
        content: message
      });
    },
    // 处理会话结果
    async handleChatResult(resultObj) {
      const {
        type
      } = resultObj;
      if (this.pageName === "edit") {
        this.handleResult(resultObj, () => {
          if (this.currentAiMessage) {
            this.currentAiMessage.status = constant["d" /* messageStatus */].SUCCESS;
            this.currentAiMessage.content = resultObj === null || resultObj === void 0 ? void 0 : resultObj.message;
            this.currentAiMessage.chatResult = resultObj.chatResult;
          }
        });
        const {
          protocol,
          host
        } = window.location;
        this.surveyUrl = `${protocol}//${host}/s/${this.shortId}`;
        // 埋点
        this.setAiSuccessTrack();
      } else {
        // 创建页，需要处理
        // eslint-disable-next-line no-lonely-if
        if (type === "create_project") {
          await this.createProject(resultObj);
        }
      }
    },
    async createProject(resultObj) {
      const {
        chatResult
      } = resultObj;
      // 如果没有 projectId，则需要绑定对话到项目
      const isNeedBindChatToProject = !this.projectId;
      // 检查当日创建项目是否超限，如果没有有 projectId 时，需要发请求检查是否超限，反之不超限
      const checkProjectLimit = isNeedBindChatToProject ? await this.checkProjectLimit() : false;
      if (checkProjectLimit) {
        // 创建失败时，将对话结果存储，当用户点“再试一次“时，可以获取之前对话结果的数据
        if (!this.currentResultObj) this.currentResultObj = resultObj;
        // 创建已达当日上限
        this.currentAiMessage.status = constant["d" /* messageStatus */].WARNING;
        this.currentAiMessage.content = "已达当日上限";
        this.currentAiMessage.chatResult = chatResult;
        return;
      }
      this.aiSource = this.getAISource();

      // 创建项目
      const {
        projectId,
        shortId,
        surveyUrl
      } = await createProjectBySilently({
        title: chatResult.title,
        welcome_message: chatResult.welcome_message,
        questions: chatResult.questions,
        pType: this.pType,
        sceneType: this.sceneType,
        projectFuncId: this.extraInfo.projectFuncId,
        aiSource: this.aiSource
      }, this.projectId);
      this.$emit("update:projectId", projectId);
      this.$emit("update:shortId", shortId);
      this.surveyUrl = surveyUrl;
      if (isNeedBindChatToProject) {
        // 绑定对话到项目
        const data = await Object(wenwen_ai["e" /* httpPostBindChatToProject */])(projectId, this.conversationId);
        console.log("绑定对话到项目", this.projectId, this.shortId, data);
      }
      if (this.currentAiMessage) {
        this.currentAiMessage.status = constant["d" /* messageStatus */].SUCCESS;
        this.currentAiMessage.content = resultObj === null || resultObj === void 0 ? void 0 : resultObj.message;
        this.currentAiMessage.chatResult = chatResult;
      }

      // 埋点
      this.setAiSuccessTrack();
    },
    // 获取AI交互埋点信息
    getAiTrackInfo() {
      const sceneMapping = {
        0: "Survey",
        1: "Form",
        2: "Exam"
      };
      const createMapping = {
        create_project: "Chat",
        create_exam_project: "Chat",
        create_project_from_text: "Text",
        create_project_from_image: "Picture",
        create_project_from_link: "Link"
      };
      return {
        sceneName: sceneMapping[this.pType || 0],
        createProjectType: createMapping[this.taskType] || "Chat"
      };
    },
    // AI交互成功埋点
    setAiSuccessTrack() {
      const contentMapping = {
        edit_template: "WenjuanAI_TemplateModify_EditComplete",
        create_question: "WenjuanAI_QuestionExtension_Completed",
        create_exam_question: "WenjuanAI_ExamQuestionExtension_Completed",
        extend_options: "WenjuanAI_OptionExtension_Completed",
        check_content: "WenjuanAI_ContentCheck_Completed"
      };
      const {
        createProjectType,
        sceneName
      } = this.getAiTrackInfo(this.aiEntryType);
      const trackContent = createProjectType ? `WenjuanAI_${createProjectType}Create${sceneName}_Complete` : contentMapping[this.taskType];
      if (trackContent) {
        window.zytrack && window.zytrack("custom", trackContent, {
          Project_ShortId: this.shortId
        });
      }
    },
    // 编辑页通用入口埋点
    setGeneralEntranceTrack(type) {
      const contentMapping = {
        create_question: "WenjuanAI_QuestionExtension_EditGeneralEntrance",
        create_exam_question: "WenjuanAI_ExamQuestionExtension_EditGeneralEntrance",
        check_content: "WenjuanAI_ContentCheck_EditGeneralEntrance"
      };
      let trackContent = contentMapping[type];
      if (this.pageName === "edit" && ["create_project", "create_exam_project"].includes(type)) {
        const {
          sceneName
        } = this.getAiTrackInfo(this.aiEntryType);
        trackContent = `WenjuanAI_ChatCreate${sceneName}_EditGeneralEntrance`;
      }
      if (trackContent) {
        window.zytrack && window.zytrack("custom", trackContent, {
          Project_ShortId: this.shortId
        });
      }
    },
    // 如果 conversationType 为 AI文本创建, 则需要根据上一个 message 中用户上传的文件类型判断当前是上传Word、上传Excel、上传PDF、直接输入/粘贴文本哪种方式创建的问卷
    // /textproject 增加一个ai_source字段，ai_source，string
    getAISource() {
      var _lastUserMessage$file, _lastUserMessage$file2, _lastUserMessage$file3, _lastUserMessage$file4;
      if (this.conversationType === "") return -1;
      const currentConversationType = this.conversationType === "m_create_project" ? this.taskType : this.conversationType;
      if (currentConversationType !== "create_project_from_text") return constant["a" /* aiSourceMap */][currentConversationType] || 1;
      const lastUserMessage = this.messageList.slice(-2, -1)[0];
      const fileSuffix = lastUserMessage === null || lastUserMessage === void 0 ? void 0 : (_lastUserMessage$file = lastUserMessage.file) === null || _lastUserMessage$file === void 0 ? void 0 : (_lastUserMessage$file2 = _lastUserMessage$file.name) === null || _lastUserMessage$file2 === void 0 ? void 0 : (_lastUserMessage$file3 = _lastUserMessage$file2.toLowerCase()) === null || _lastUserMessage$file3 === void 0 ? void 0 : (_lastUserMessage$file4 = _lastUserMessage$file3.split(".")) === null || _lastUserMessage$file4 === void 0 ? void 0 : _lastUserMessage$file4.slice(-1)[0];
      return constant["a" /* aiSourceMap */][`create_from_text_by_${constant["c" /* fileTypeMapping */][fileSuffix]}`] || constant["a" /* aiSourceMap */][currentConversationType];
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var wenwen_ai_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/index.vue?vue&type=style&index=0&id=691397ff&prod&lang=scss&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/wenwen-ai/src/index.vue?vue&type=style&index=0&id=691397ff&prod&lang=scss&

// CONCATENATED MODULE: ./packages/wenwen-ai/src/index.vue






/* normalize component */

var src_component = Object(componentNormalizer["a" /* default */])(
  wenwen_ai_srcvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src = __webpack_exports__["a"] = (src_component.exports);

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui/lib/theme-chalk/loading.css");

/***/ }),
/* 177 */,
/* 178 */
/***/ (function(module, exports) {

module.exports = require("formdata-polyfill");

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {var capability = __webpack_require__(151)
var inherits = __webpack_require__(152)
var response = __webpack_require__(153)
var stream = __webpack_require__(154)
var toArrayBuffer = __webpack_require__(183)

var IncomingMessage = response.IncomingMessage
var rStates = response.readyStates

function decideMode (preferBinary, useFetch) {
	if (capability.fetch && useFetch) {
		return 'fetch'
	} else if (capability.mozchunkedarraybuffer) {
		return 'moz-chunked-arraybuffer'
	} else if (capability.msstream) {
		return 'ms-stream'
	} else if (capability.arraybuffer && preferBinary) {
		return 'arraybuffer'
	} else if (capability.vbArray && preferBinary) {
		return 'text:vbarray'
	} else {
		return 'text'
	}
}

var ClientRequest = module.exports = function (opts) {
	var self = this
	stream.Writable.call(self)

	self._opts = opts
	self._body = []
	self._headers = {}
	if (opts.auth)
		self.setHeader('Authorization', 'Basic ' + new Buffer(opts.auth).toString('base64'))
	Object.keys(opts.headers).forEach(function (name) {
		self.setHeader(name, opts.headers[name])
	})

	var preferBinary
	var useFetch = true
	if (opts.mode === 'disable-fetch' || ('requestTimeout' in opts && !capability.abortController)) {
		// If the use of XHR should be preferred. Not typically needed.
		useFetch = false
		preferBinary = true
	} else if (opts.mode === 'prefer-streaming') {
		// If streaming is a high priority but binary compatibility and
		// the accuracy of the 'content-type' header aren't
		preferBinary = false
	} else if (opts.mode === 'allow-wrong-content-type') {
		// If streaming is more important than preserving the 'content-type' header
		preferBinary = !capability.overrideMimeType
	} else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
		// Use binary if text streaming may corrupt data or the content-type header, or for speed
		preferBinary = true
	} else {
		throw new Error('Invalid value for opts.mode')
	}
	self._mode = decideMode(preferBinary, useFetch)
	self._fetchTimer = null

	self.on('finish', function () {
		self._onFinish()
	})
}

inherits(ClientRequest, stream.Writable)

ClientRequest.prototype.setHeader = function (name, value) {
	var self = this
	var lowerName = name.toLowerCase()
	// This check is not necessary, but it prevents warnings from browsers about setting unsafe
	// headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
	// http-browserify did it, so I will too.
	if (unsafeHeaders.indexOf(lowerName) !== -1)
		return

	self._headers[lowerName] = {
		name: name,
		value: value
	}
}

ClientRequest.prototype.getHeader = function (name) {
	var header = this._headers[name.toLowerCase()]
	if (header)
		return header.value
	return null
}

ClientRequest.prototype.removeHeader = function (name) {
	var self = this
	delete self._headers[name.toLowerCase()]
}

ClientRequest.prototype._onFinish = function () {
	var self = this

	if (self._destroyed)
		return
	var opts = self._opts

	var headersObj = self._headers
	var body = null
	if (opts.method !== 'GET' && opts.method !== 'HEAD') {
		if (capability.arraybuffer) {
			body = toArrayBuffer(Buffer.concat(self._body))
		} else if (capability.blobConstructor) {
			body = new global.Blob(self._body.map(function (buffer) {
				return toArrayBuffer(buffer)
			}), {
				type: (headersObj['content-type'] || {}).value || ''
			})
		} else {
			// get utf8 string
			body = Buffer.concat(self._body).toString()
		}
	}

	// create flattened list of headers
	var headersList = []
	Object.keys(headersObj).forEach(function (keyName) {
		var name = headersObj[keyName].name
		var value = headersObj[keyName].value
		if (Array.isArray(value)) {
			value.forEach(function (v) {
				headersList.push([name, v])
			})
		} else {
			headersList.push([name, value])
		}
	})

	if (self._mode === 'fetch') {
		var signal = null
		var fetchTimer = null
		if (capability.abortController) {
			var controller = new AbortController()
			signal = controller.signal
			self._fetchAbortController = controller

			if ('requestTimeout' in opts && opts.requestTimeout !== 0) {
				self._fetchTimer = global.setTimeout(function () {
					self.emit('requestTimeout')
					if (self._fetchAbortController)
						self._fetchAbortController.abort()
				}, opts.requestTimeout)
			}
		}

		global.fetch(self._opts.url, {
			method: self._opts.method,
			headers: headersList,
			body: body || undefined,
			mode: 'cors',
			credentials: opts.withCredentials ? 'include' : 'same-origin',
			signal: signal
		}).then(function (response) {
			self._fetchResponse = response
			self._connect()
		}, function (reason) {
			global.clearTimeout(self._fetchTimer)
			if (!self._destroyed)
				self.emit('error', reason)
		})
	} else {
		var xhr = self._xhr = new global.XMLHttpRequest()
		try {
			xhr.open(self._opts.method, self._opts.url, true)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}

		// Can't set responseType on really old browsers
		if ('responseType' in xhr)
			xhr.responseType = self._mode.split(':')[0]

		if ('withCredentials' in xhr)
			xhr.withCredentials = !!opts.withCredentials

		if (self._mode === 'text' && 'overrideMimeType' in xhr)
			xhr.overrideMimeType('text/plain; charset=x-user-defined')

		if ('requestTimeout' in opts) {
			xhr.timeout = opts.requestTimeout
			xhr.ontimeout = function () {
				self.emit('requestTimeout')
			}
		}

		headersList.forEach(function (header) {
			xhr.setRequestHeader(header[0], header[1])
		})

		self._response = null
		xhr.onreadystatechange = function () {
			switch (xhr.readyState) {
				case rStates.LOADING:
				case rStates.DONE:
					self._onXHRProgress()
					break
			}
		}
		// Necessary for streaming in Firefox, since xhr.response is ONLY defined
		// in onprogress, not in onreadystatechange with xhr.readyState = 3
		if (self._mode === 'moz-chunked-arraybuffer') {
			xhr.onprogress = function () {
				self._onXHRProgress()
			}
		}

		xhr.onerror = function () {
			if (self._destroyed)
				return
			self.emit('error', new Error('XHR error'))
		}

		try {
			xhr.send(body)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}
	}
}

/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */
function statusValid (xhr) {
	try {
		var status = xhr.status
		return (status !== null && status !== 0)
	} catch (e) {
		return false
	}
}

ClientRequest.prototype._onXHRProgress = function () {
	var self = this

	if (!statusValid(self._xhr) || self._destroyed)
		return

	if (!self._response)
		self._connect()

	self._response._onXHRProgress()
}

ClientRequest.prototype._connect = function () {
	var self = this

	if (self._destroyed)
		return

	self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._fetchTimer)
	self._response.on('error', function(err) {
		self.emit('error', err)
	})

	self.emit('response', self._response)
}

ClientRequest.prototype._write = function (chunk, encoding, cb) {
	var self = this

	self._body.push(chunk)
	cb()
}

ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function () {
	var self = this
	self._destroyed = true
	global.clearTimeout(self._fetchTimer)
	if (self._response)
		self._response._destroyed = true
	if (self._xhr)
		self._xhr.abort()
	else if (self._fetchAbortController)
		self._fetchAbortController.abort()
}

ClientRequest.prototype.end = function (data, encoding, cb) {
	var self = this
	if (typeof data === 'function') {
		cb = data
		data = undefined
	}

	stream.Writable.prototype.end.call(self, data, encoding, cb)
}

ClientRequest.prototype.flushHeaders = function () {}
ClientRequest.prototype.setTimeout = function () {}
ClientRequest.prototype.setNoDelay = function () {}
ClientRequest.prototype.setSocketKeepAlive = function () {}

// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var unsafeHeaders = [
	'accept-charset',
	'accept-encoding',
	'access-control-request-headers',
	'access-control-request-method',
	'connection',
	'content-length',
	'cookie',
	'cookie2',
	'date',
	'dnt',
	'expect',
	'host',
	'keep-alive',
	'origin',
	'referer',
	'te',
	'trailer',
	'transfer-encoding',
	'upgrade',
	'via'
]

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(150).Buffer, __webpack_require__(17), __webpack_require__(41)))

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = require("base64-js");

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = require("ieee754");

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = require("isarray");

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = require("to-arraybuffer");

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = require("xtend");

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = require("builtin-status-codes");

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, exports) {

module.exports = require("animated-scroll-to");

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = require("@microsoft/fetch-event-source");

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/image");

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports = require("qrcode");

/***/ }),
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./chat-init.vue": 219,
	"./check-content.vue": 220,
	"./common.vue": 223,
	"./create-project.vue": 224,
	"./create-question.vue": 221,
	"./extend-question-options.vue": 225,
	"./recover.vue": 226,
	"./text-content.vue": 227,
	"./text-result.vue": 222,
	"./upload-image.vue": 228,
	"./warning.vue": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/image.css");

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/chat-init.vue?vue&type=template&id=570754be&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("WenwenAiChat", {
        attrs: {
          type: "system",
          title: _vm.initTitle,
          "loading-manual": "close"
        }
      }),
      _vm._v(" "),
      _vm.pageName != "lib"
        ? _c("WenwenAiChat", {
            attrs: {
              type: "system",
              platform: _vm.platform,
              "button-list": _vm.btnList,
              "button-inline": false,
              "loading-manual": _vm.loadingManual
            },
            on: { select: _vm.handleSelect },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "content-slot" },
                        [
                          _c("SvgIcon", {
                            staticClass: "chat-status-icon",
                            attrs: { name: "wenwen-ai/AI" }
                          }),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.initOperate))])
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              334725684
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/chat-init.vue?vue&type=template&id=570754be&scoped=true&

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/message.mixin.js + 7 modules
var message_mixin = __webpack_require__(22);

// EXTERNAL MODULE: ./src/components/svg-icon/index.vue + 5 modules
var svg_icon = __webpack_require__(11);

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/tools.js
var tools = __webpack_require__(127);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/chat-init.vue?vue&type=script&lang=js&



/* harmony default export */ var chat_initvue_type_script_lang_js_ = ({
  name: "ChatInit",
  components: {
    SvgIcon: svg_icon["a" /* default */]
  },
  mixins: [message_mixin["a" /* default */]],
  props: {
    messageInfo: {
      type: Object,
      default: () => ({})
    },
    pageName: {
      type: String,
      default: "home"
    },
    platform: {
      type: String,
      default: "mobile"
    },
    pType: {
      type: Number,
      default: 0
    },
    // 项目的题目数，只有在编辑页需要传
    questionCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      messageTitle: this.messageInfo.content,
      initTitle: `你好，我是问卷网AI助手问问AI！我可以为你处理各种${this.pType === 2 ? "考试" : this.pType === 1 ? "表单" : "问卷"}相关的问题`,
      initOperate: "你可以对我说"
    };
  },
  computed: {
    // 编辑页的问问ai且项目有题目
    haveQuestion() {
      return this.pageName === "edit" && this.questionCount > 0;
    },
    btnList() {
      if (this.pageName === "lib") return [];
      return Object(tools["b" /* getInitTaskList */])(this.pType, this.haveQuestion);
    }
  },
  watch: {},
  methods: {
    handleSelect(data) {
      this.$emit("select", {
        ...data,
        type: "newTask"
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/chat-init.vue?vue&type=script&lang=js&
 /* harmony default export */ var conversations_chat_initvue_type_script_lang_js_ = (chat_initvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/chat-init.vue?vue&type=style&index=0&id=570754be&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/chat-init.vue?vue&type=style&index=0&id=570754be&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/chat-init.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  conversations_chat_initvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "570754be",
  null
  
)

/* harmony default export */ var chat_init = __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/check-content.vue?vue&type=template&id=f4fc9598&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "WenwenAiChat",
    {
      staticClass: "check-content-wrap",
      attrs: {
        type: "system",
        title: _vm.messageTitle,
        platform: _vm.platform,
        status: _vm.messageStatus,
        "button-list": _vm.btnList,
        "loading-manual": _vm.loadingManual,
        "auto-scroll-to-bottom": _vm.autoScrollToBottom
      },
      on: { select: _vm.handleSelect }
    },
    [
      _vm.suggestion
        ? _c(
            "div",
            {
              staticClass: "content-desc-box",
              attrs: { slot: "content" },
              slot: "content"
            },
            [_c("span", [_vm._v(_vm._s(_vm.suggestion))])]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/check-content.vue?vue&type=template&id=f4fc9598&

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/constant.js
var constant = __webpack_require__(6);

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/message.mixin.js + 7 modules
var message_mixin = __webpack_require__(22);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/check-content.vue?vue&type=script&lang=js&


/* harmony default export */ var check_contentvue_type_script_lang_js_ = ({
  name: "CheckContent",
  mixins: [message_mixin["a" /* default */]],
  props: {
    messageInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    suggestion() {
      return this.messageInfo.originalResult || "";
    },
    messageTitle() {
      return this.messageInfo.content || "问问AI正在检查中...";
    },
    btnList() {
      if (this.isHistoryOrReplied) {
        return [];
      }
      const {
        status,
        errorType
      } = this.messageInfo || {};
      const {
        close,
        recheck
      } = this.operationList;
      if (status === constant["d" /* messageStatus */].WAITING) {
        if (!this.suggestion) {
          this.getStreamResult();
        }
        return [];
      }
      if (status === constant["d" /* messageStatus */].SUCCESS) {
        return [recheck];
      }
      if (status === constant["d" /* messageStatus */].WARNING) {
        if (["overload", "audit"].includes(errorType)) {
          return [close];
        }
        return [recheck];
      }
      if (status === constant["d" /* messageStatus */].INTERRUPT) {
        this.timeInstance && clearTimeout(this.timeInstance);
        return [];
      }
      return [];
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/check-content.vue?vue&type=script&lang=js&
 /* harmony default export */ var conversations_check_contentvue_type_script_lang_js_ = (check_contentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/check-content.vue?vue&type=style&index=0&id=f4fc9598&prod&lang=scss&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/check-content.vue?vue&type=style&index=0&id=f4fc9598&prod&lang=scss&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/check-content.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  conversations_check_contentvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var check_content = __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/create-question.vue?vue&type=template&id=14783ec2&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("WenwenAiChat", {
        attrs: {
          type: "system",
          platform: _vm.platform,
          title: _vm.messageTitle,
          status: _vm.messageStatus,
          "button-list": _vm.btnList,
          "loading-manual": _vm.loadingManual,
          "auto-scroll-to-bottom": _vm.autoScrollToBottom
        },
        on: { select: _vm.handleSelect }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/create-question.vue?vue&type=template&id=14783ec2&

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/constant.js
var constant = __webpack_require__(6);

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/message.mixin.js + 7 modules
var message_mixin = __webpack_require__(22);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/create-question.vue?vue&type=script&lang=js&


/* harmony default export */ var create_questionvue_type_script_lang_js_ = ({
  name: "CreateQuestion",
  mixins: [message_mixin["a" /* default */]],
  props: {
    messageInfo: {
      type: Object,
      default: () => ({})
    },
    questionId: {
      type: String,
      default: ""
    },
    pageName: {
      type: String,
      default: "edit"
    },
    // popup: 弹窗; drawer: 抽屉
    displayType: {
      type: String,
      default: "drawer"
    }
  },
  computed: {
    messageTitle() {
      return this.messageInfo.content || "问问AI正在思考中...";
    },
    btnList() {
      if (this.isHistoryOrReplied) {
        return [];
      }
      const {
        status,
        errorType
      } = this.messageInfo || {};
      const {
        recreate,
        viewNow,
        closeTask,
        close
      } = this.operationList;
      if (status === constant["d" /* messageStatus */].WAITING) {
        this.getCommandResult();
        return [];
      }
      if (status === constant["d" /* messageStatus */].SUCCESS) {
        return this.isPcEditPage ? [closeTask] : [{
          ...viewNow,
          isPrimary: true
        }];
      }
      if (status === constant["d" /* messageStatus */].WARNING) {
        if (["overload", "audit"].includes(errorType)) {
          return [close];
        }
        return [recreate];
      }
      if (status === constant["d" /* messageStatus */].INTERRUPT) {
        this.timeInstance && clearTimeout(this.timeInstance);
        return [];
      }
      return [];
    }
  },
  methods: {
    // 添加题目
    handleChatResult(data) {
      this.$emit("updateMessage", {
        content: "问问AI正在创建中..."
      });
      this.$emit("handleResult", {
        type: "create_question",
        chatResult: data.result,
        message: data.message,
        questionId: this.questionId
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/create-question.vue?vue&type=script&lang=js&
 /* harmony default export */ var conversations_create_questionvue_type_script_lang_js_ = (create_questionvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/create-question.vue?vue&type=style&index=0&id=14783ec2&prod&lang=scss&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/create-question.vue?vue&type=style&index=0&id=14783ec2&prod&lang=scss&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/create-question.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  conversations_create_questionvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var create_question = __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/text-result.vue?vue&type=template&id=5394200e&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-result-wrap" },
    [
      _c(
        "WenwenAiChat",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.content,
              expression: "content"
            }
          ],
          attrs: {
            type: "system",
            "loading-manual": _vm.loadingManual,
            "auto-scroll-to-bottom": _vm.autoScrollToBottom
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "plain-text",
              attrs: { slot: "content" },
              slot: "content"
            },
            [_vm._v(_vm._s(_vm.content))]
          )
        ]
      ),
      _vm._v(" "),
      _c("WenwenAiChat", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.messageInfo.status !== "waiting" || !_vm.content,
            expression: "messageInfo.status !== 'waiting' || !content"
          }
        ],
        attrs: {
          type: "system",
          platform: _vm.platform,
          title: _vm.messageTitle,
          status: _vm.messageStatus,
          "button-list": _vm.btnList,
          "button-inline": false,
          "loading-manual": _vm.loadingManual,
          "auto-scroll-to-bottom": _vm.autoScrollToBottom
        },
        on: { select: _vm.handleSelect }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/text-result.vue?vue&type=template&id=5394200e&

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/constant.js
var constant = __webpack_require__(6);

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/message.mixin.js + 7 modules
var message_mixin = __webpack_require__(22);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/text-result.vue?vue&type=script&lang=js&


/* harmony default export */ var text_resultvue_type_script_lang_js_ = ({
  name: "TextResult",
  mixins: [message_mixin["a" /* default */]],
  props: {
    messageInfo: {
      type: Object,
      default: () => ({})
    },
    pageName: {
      type: String,
      default: "edit"
    },
    pType: {
      type: Number,
      default: 0
    }
  },
  computed: {
    messageTitle() {
      var _this$messageInfo;
      return ((_this$messageInfo = this.messageInfo) === null || _this$messageInfo === void 0 ? void 0 : _this$messageInfo.content) || "问问AI正在思考中...";
    },
    content() {
      var _this$messageInfo2;
      return ((_this$messageInfo2 = this.messageInfo) === null || _this$messageInfo2 === void 0 ? void 0 : _this$messageInfo2.originalResult) || "";
    },
    btnList() {
      const {
        status,
        conversationType,
        errorType,
        isHistory
      } = this.messageInfo || {};
      const {
        advise,
        createProject,
        createQuestion,
        close,
        recreate
      } = this.operationList;
      if (status === constant["d" /* messageStatus */].WAITING) {
        if (!this.content) {
          this.getStreamResult();
        }
        return [];
      }
      if (status === constant["d" /* messageStatus */].SUCCESS) {
        let btnList = [];
        if (conversationType === "create_question_text") {
          if (isHistory && this.pageName !== "edit") {
            // 只有编辑页历史消息中才显示createQuestion
            btnList = [];
          } else if (this.isHistoryOrReplied) {
            btnList = [createQuestion];
          } else {
            btnList = [{
              ...createQuestion,
              isPrimary: true
            }, advise];
          }
        } else if (["create_project", "edit_template"].includes(conversationType)) {
          btnList = this.isHistoryOrReplied ? [createProject] : [{
            ...createProject,
            isPrimary: true
          }, advise];
        }
        return btnList;
      }
      if (status === constant["d" /* messageStatus */].WARNING) {
        if (this.isHistoryOrReplied) {
          return [];
        }
        return ["overload", "audit"].includes(errorType) ? [close] : [recreate];
      }
      return [];
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/text-result.vue?vue&type=script&lang=js&
 /* harmony default export */ var conversations_text_resultvue_type_script_lang_js_ = (text_resultvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/text-result.vue?vue&type=style&index=0&id=5394200e&prod&lang=scss&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/text-result.vue?vue&type=style&index=0&id=5394200e&prod&lang=scss&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/text-result.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  conversations_text_resultvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var text_result = __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/common.vue?vue&type=template&id=7f4c60f6&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("WenwenAiChat", {
    attrs: {
      platform: _vm.platform,
      title: _vm.messageInfo.content,
      "title-icon": _vm.messageInfo.titleIcon,
      type: _vm.messageInfo.source,
      status: _vm.messageInfo.status,
      "loading-manual": _vm.loadingManual,
      "auto-scroll-to-bottom": _vm.autoScrollToBottom,
      "image-url": _vm.messageInfo.link,
      theme: _vm.messageInfo.theme
    }
  })
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/common.vue?vue&type=template&id=7f4c60f6&

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/message.mixin.js + 7 modules
var message_mixin = __webpack_require__(22);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/common.vue?vue&type=script&lang=js&

/* harmony default export */ var commonvue_type_script_lang_js_ = ({
  name: "Common",
  mixins: [message_mixin["a" /* default */]],
  props: {
    messageInfo: {
      type: Object,
      default: () => {}
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/common.vue?vue&type=script&lang=js&
 /* harmony default export */ var conversations_commonvue_type_script_lang_js_ = (commonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/common.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  conversations_commonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var common = __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/create-project.vue?vue&type=template&id=69c21b36&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("WenwenAiChat", {
    attrs: {
      type: "system",
      platform: _vm.platform,
      title: _vm.messageTitle,
      status: _vm.messageStatus,
      "button-list": _vm.btnList,
      "loading-manual": _vm.loadingManual,
      "auto-scroll-to-bottom": _vm.autoScrollToBottom
    },
    on: { select: _vm.handleSelect }
  })
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/create-project.vue?vue&type=template&id=69c21b36&

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/constant.js
var constant = __webpack_require__(6);

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/message.mixin.js + 7 modules
var message_mixin = __webpack_require__(22);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/create-project.vue?vue&type=script&lang=js&


/* harmony default export */ var create_projectvue_type_script_lang_js_ = ({
  name: "CreateProject",
  mixins: [message_mixin["a" /* default */]],
  props: {
    messageInfo: {
      type: Object,
      default: () => ({})
    },
    pageName: {
      type: String,
      default: "edit"
    },
    // popup: 弹窗; drawer: 抽屉
    displayType: {
      type: String,
      default: "drawer"
    }
  },
  computed: {
    messageTitle() {
      return this.messageInfo.content || "问问AI正在思考中...";
    },
    isCreateOrLibPage() {
      return ["create", "lib"].includes(this.pageName);
    },
    btnList() {
      if (this.isHistoryOrReplied) {
        return [];
      }
      const {
        status,
        chatResult,
        errorType
      } = this.messageInfo || {};
      const {
        recreate,
        viewNow,
        close,
        closeTask
      } = this.operationList;
      if (status === constant["d" /* messageStatus */].WAITING) {
        if (!chatResult) this.getCommandResult();
        return [];
      }
      if (status === constant["d" /* messageStatus */].SUCCESS) {
        if (this.isPcEditPage) {
          return [closeTask];
        }
        return [{
          ...viewNow,
          isPrimary: true
        }];
      }
      if (status === constant["d" /* messageStatus */].WARNING) {
        if (["audit", "overload"].includes(errorType)) {
          return [close];
        }
        return [recreate];
      }
      if (status === constant["d" /* messageStatus */].INTERRUPT) {
        this.timeInstance && clearTimeout(this.timeInstance);
        return [];
      }
      return [];
    }
  },
  methods: {
    handleChatResult(data) {
      this.$emit("updateMessage", {
        content: "问问AI正在创建中..."
      });
      this.$emit("handleResult", {
        type: "create_project",
        chatResult: data.result,
        message: data.message
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/create-project.vue?vue&type=script&lang=js&
 /* harmony default export */ var conversations_create_projectvue_type_script_lang_js_ = (create_projectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/create-project.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  conversations_create_projectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var create_project = __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/extend-question-options.vue?vue&type=template&id=9437db16&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("WenwenAiChat", {
    attrs: {
      type: "system",
      platform: _vm.platform,
      status: _vm.messageStatus,
      title: _vm.messageTitle,
      "button-list": _vm.btnList,
      "loading-manual": _vm.loadingManual,
      "auto-scroll-to-bottom": _vm.autoScrollToBottom
    },
    on: { select: _vm.handleSelect }
  })
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/extend-question-options.vue?vue&type=template&id=9437db16&

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/constant.js
var constant = __webpack_require__(6);

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/message.mixin.js + 7 modules
var message_mixin = __webpack_require__(22);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/extend-question-options.vue?vue&type=script&lang=js&


/* harmony default export */ var extend_question_optionsvue_type_script_lang_js_ = ({
  name: "ExtendQuestionOptions",
  mixins: [message_mixin["a" /* default */]],
  props: {
    messageInfo: {
      type: Object,
      default: () => ({})
    },
    questionId: {
      type: String,
      default: ""
    }
  },
  computed: {
    messageTitle() {
      return this.messageInfo.content || "问问AI正在思考中...";
    },
    btnList() {
      if (this.isHistoryOrReplied) {
        return [];
      }
      const {
        status
      } = this.messageInfo || {};
      const {
        createMoreOption,
        advise,
        closeTask
      } = this.operationList;
      if (status === constant["d" /* messageStatus */].WAITING) {
        this.getCommandResult();
        return [];
      }
      if (status === constant["d" /* messageStatus */].SUCCESS) {
        return [{
          ...createMoreOption,
          isPrimary: true
        }, advise, closeTask];
      }
      if (status === constant["d" /* messageStatus */].INTERRUPT) {
        this.timeInstance && clearTimeout(this.timeInstance);
        return [];
      }
      return [];
    }
  },
  methods: {
    handleChatResult(data) {
      this.$emit("updateMessage", {
        content: "问问AI正在扩展中..."
      });
      this.$emit("handleResult", {
        type: "extend_options",
        chatResult: data.result,
        questionId: this.questionId,
        message: data.message
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/extend-question-options.vue?vue&type=script&lang=js&
 /* harmony default export */ var conversations_extend_question_optionsvue_type_script_lang_js_ = (extend_question_optionsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/extend-question-options.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  conversations_extend_question_optionsvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var extend_question_options = __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/recover.vue?vue&type=template&id=11eb6cee&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("WenwenAiChat", {
    attrs: {
      type: "system",
      platform: _vm.platform,
      title: _vm.messageTitle,
      status: _vm.messageStatus,
      "button-list": _vm.btnList,
      "loading-manual": _vm.loadingManual,
      "auto-scroll-to-bottom": _vm.autoScrollToBottom
    },
    on: { select: _vm.handleSelect }
  })
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/recover.vue?vue&type=template&id=11eb6cee&

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/constant.js
var constant = __webpack_require__(6);

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/message.mixin.js + 7 modules
var message_mixin = __webpack_require__(22);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/recover.vue?vue&type=script&lang=js&


/* harmony default export */ var recovervue_type_script_lang_js_ = ({
  name: "Recover",
  mixins: [message_mixin["a" /* default */]],
  props: {
    messageInfo: {
      type: Object,
      default: () => ({})
    },
    pageName: {
      type: String,
      default: "edit"
    }
  },
  data() {
    return {
      messageTitle: this.messageInfo.content,
      btnList: []
    };
  },
  watch: {
    messageInfo: {
      handler(obj) {
        this.messageTitle = this.messageInfo.content;
        const {
          status
        } = obj || {};
        const {
          gotoEditPage,
          previewAnswerPage
        } = this.operationList;
        if (status === constant["d" /* messageStatus */].WAITING) {
          this.btnList = [];
          this.messageTitle = "问问AI正在恢复中...";
          this.handleChatResult(this.messageInfo.chatResult);
        } else if (status === constant["d" /* messageStatus */].SUCCESS || status === constant["d" /* messageStatus */].WARNING) {
          this.messageTitle = status === constant["d" /* messageStatus */].SUCCESS ? "恢复完成" : "出错啦";
          if (this.isHistoryOrReplied || status === constant["d" /* messageStatus */].WARNING) {
            this.btnList = [];
          } else {
            this.btnList = this.pageName === "edit" ? [previewAnswerPage] : [gotoEditPage, previewAnswerPage];
          }
        } else if (status === constant["d" /* messageStatus */].INTERRUPT) {
          this.messageTitle = "任务中断";
          this.btnList = [];
        } else {
          this.btnList = [];
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleChatResult(chatResult) {
      this.$emit("handleResult", {
        type: "create_project",
        chatResult
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/recover.vue?vue&type=script&lang=js&
 /* harmony default export */ var conversations_recovervue_type_script_lang_js_ = (recovervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/recover.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  conversations_recovervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var recover = __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/text-content.vue?vue&type=template&id=301d7e74&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("WenwenAiChat", {
    attrs: {
      platform: _vm.platform,
      title: _vm.messageInfo.content,
      type: _vm.messageInfo.source,
      status: _vm.messageInfo.status,
      "button-list": _vm.btnList,
      "button-inline": false,
      "loading-manual": _vm.loadingManual,
      "auto-scroll-to-bottom": _vm.autoScrollToBottom
    },
    on: { select: _vm.handleSelect }
  })
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/text-content.vue?vue&type=template&id=301d7e74&

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/message.mixin.js + 7 modules
var message_mixin = __webpack_require__(22);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/text-content.vue?vue&type=script&lang=js&

/* harmony default export */ var text_contentvue_type_script_lang_js_ = ({
  name: "TextContent",
  mixins: [message_mixin["a" /* default */]],
  props: {
    messageInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      maxLength: 5000,
      isRichText: true
    };
  },
  computed: {
    hideMenu() {
      return true;
    },
    btnList() {
      const {
        gotoOldTextProjectPage,
        focusInput,
        uploadWordExcel
      } = this.operationList;
      if (this.isHistoryOrReplied) {
        return [];
      }
      const btnList = this.pageName === "edit" && this.platform === "mobile" ? [focusInput, uploadWordExcel] : [uploadWordExcel, focusInput, gotoOldTextProjectPage];
      return btnList;
    }
  },
  methods: {
    handleSelect(item) {
      const {
        value
      } = item;
      this.trackEvent(value);
      this.$emit("select", item);
    },
    trackEvent(key) {
      const trackMapping = {
        focus_input: "WenjuanAI_TextCreate_Input",
        goto_old_text_project_page: "WenjuanAI_TextCreate_GoToOldVersion",
        uploadWordExcel: "WenjuanAI_TextCreate_UploadFile"
      };
      if (trackMapping[key]) {
        window.zytrack && window.zytrack("custom", "WenjuanAI_TextCreate_Input");
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/text-content.vue?vue&type=script&lang=js&
 /* harmony default export */ var conversations_text_contentvue_type_script_lang_js_ = (text_contentvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/text-content.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  conversations_text_contentvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var text_content = __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/upload-image.vue?vue&type=template&id=6fb651a4&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("WenwenAiChat", {
    attrs: {
      type: "system",
      platform: _vm.platform,
      title: _vm.messageInfo.content,
      "button-list": _vm.btnList,
      "image-url": _vm.imgUrl,
      "loading-manual": _vm.loadingManual,
      "auto-scroll-to-bottom": _vm.autoScrollToBottom
    },
    on: { select: _vm.handleSelect }
  })
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/upload-image.vue?vue&type=template&id=6fb651a4&

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/message.mixin.js + 7 modules
var message_mixin = __webpack_require__(22);

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/constant.js
var constant = __webpack_require__(6);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/upload-image.vue?vue&type=script&lang=js&


/* harmony default export */ var upload_imagevue_type_script_lang_js_ = ({
  name: "UploadImage",
  mixins: [message_mixin["a" /* default */]],
  props: {
    messageInfo: {
      type: Object,
      default: () => {}
    },
    pType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      imgUrl: "",
      btnList: []
    };
  },
  computed: {},
  watch: {
    isHistoryOrReplied: {
      handler(val) {
        if (val) {
          this.imgUrl = "";
        } else if (this.pType === 2) {
          this.imgUrl = "https://s1.wenjuan.com/assets/images/edit/image-create-exam.png";
        } else {
          this.imgUrl = "https://s1.wenjuan.com/assets/images/edit/image-create-form.png";
        }
        // 用离散枚举，内外组件重复复场景判断，数据管道中也需要重复做映射
        this.btnList = val ? [] : [{
          label: "拍照/上传图片",
          value: "upload",
          isPrimary: true
        }];
      },
      immediate: true
    }
  },
  methods: {
    // 更新输入框数据
    updateInputData() {
      this.$emit("updateInputData", {
        placeholder: "点击上传图片",
        status: constant["b" /* editorStatus */].UPLOAD,
        menuList: []
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/upload-image.vue?vue&type=script&lang=js&
 /* harmony default export */ var conversations_upload_imagevue_type_script_lang_js_ = (upload_imagevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/upload-image.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  conversations_upload_imagevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var upload_image = __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/warning.vue?vue&type=template&id=42f1a1b7&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("WenwenAiChat", {
    attrs: {
      platform: _vm.platform,
      title: _vm.messageTitle,
      "title-icon": _vm.messageInfo.titleIcon,
      type: _vm.messageInfo.source,
      status: _vm.messageInfo.status,
      "button-list": _vm.btnList,
      "loading-manual": _vm.loadingManual,
      "auto-scroll-to-bottom": _vm.autoScrollToBottom,
      "image-url": _vm.messageInfo.link,
      theme: _vm.messageInfo.theme
    },
    on: { select: _vm.handleSelect }
  })
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/warning.vue?vue&type=template&id=42f1a1b7&

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/constant.js
var constant = __webpack_require__(6);

// EXTERNAL MODULE: ./packages/wenwen-ai/src/js/message.mixin.js + 7 modules
var message_mixin = __webpack_require__(22);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/wenwen-ai/src/conversations/warning.vue?vue&type=script&lang=js&


const titleMapping = {
  audit: "我们换个话题吧"
};
/* harmony default export */ var warningvue_type_script_lang_js_ = ({
  name: "Warning",
  mixins: [message_mixin["a" /* default */]],
  props: {
    messageInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      hideMenu: true
    };
  },
  computed: {
    messageTitle() {
      return titleMapping[this.messageInfo.errorType];
    },
    btnList() {
      const {
        status
      } = this.messageInfo || {};
      if (status === constant["d" /* messageStatus */].WARNING) {
        return [];
      }
      if (status === constant["d" /* messageStatus */].INTERRUPT) {
        this.timeInstance && clearTimeout(this.timeInstance);
        return [];
      }
      return [];
    }
  }
});
// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/warning.vue?vue&type=script&lang=js&
 /* harmony default export */ var conversations_warningvue_type_script_lang_js_ = (warningvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/wenwen-ai/src/conversations/warning.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  conversations_warningvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var warning = __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _src_index_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(166);

_src_index_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = Vue => {
  Vue.component(_src_index_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _src_index_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
};
/* harmony default export */ __webpack_exports__["default"] = (_src_index_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ })
/******/ ])["default"];